import { LabelFieldPair, CardLabel, Dropdown, RemoveableTag, TextInput, TextArea, CardLabelError as CardLabelError$1, UploadFile, Loader, Header, FormComposer, Card, CardText, ActionBar, SubmitBar, Banner, Table, CloseSvg, Label, LinkLabel, EventCalendar, DocumentIcon, CheckBox, RefreshIcon, DateRange, DetailsCard, SearchAction, FilterAction, PopUp, PMBIcon, RadioButtons, Modal, CardSubHeader, PDFSvg, MultiUploadWrapper, CardHeader, CardSectionHeader, StatusTable, Row, LinkButton, Close as Close$c, BreakLine, TelePhone, DisplayPhotos, CheckPoint, ConnectingCheckPoints, Toast, Menu, ButtonSelector, GenericFileIcon, PrivateRoute, LocationSearch, OnGroundEventCard, WhatsNewCard, CardCaption, SearchIconSvg, ViewsIcon, ExternalLinkIcon, DownloadImgIcon, AppContainer, PrevIcon, BackButton, MapMarker, Clock, FilterFormField, SearchField, InboxComposer, DustbinIcon, DatePicker, BreadCrumb } from '@egovernments/digit-ui-react-components';
import React$1, { useMemo, useState, useEffect, Fragment, useCallback, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory, useParams, Link, Switch, Redirect as Redirect$1, Route, useRouteMatch } from 'react-router-dom';
import { Controller, useForm, useFormContext, FormProvider } from 'react-hook-form';
import { useQueryClient } from 'react-query';
import TimePicker from 'react-time-picker';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Bar } from 'recharts';

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule");
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

function isToday(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameDay(dirtyDate, Date.now());
}

const alphabeticalSortFunctionForTenantsBasedOnName = (firstEl, secondEl) => {
  if (firstEl.name.toUpperCase() < secondEl.name.toUpperCase()) {
    return -1;
  }
  if (firstEl.name.toUpperCase() > secondEl.name.toUpperCase()) {
    return 1;
  }
  return 0;
};
const areEqual = (stringA, stringB) => {
  var _stringA$trim, _stringB$trim;
  if (!stringA || !stringB) return false;
  if ((stringA === null || stringA === void 0 ? void 0 : (_stringA$trim = stringA.trim()) === null || _stringA$trim === void 0 ? void 0 : _stringA$trim.toLowerCase()) === (stringB === null || stringB === void 0 ? void 0 : (_stringB$trim = stringB.trim()) === null || _stringB$trim === void 0 ? void 0 : _stringB$trim.toLowerCase())) {
    return true;
  }
  return false;
};
const getFileUrl = async fileStoreId => {
  try {
    var _response$data, _response$data$fileSt;
    const response = await Digit.UploadServices.Filefetch([fileStoreId], Digit.ULBService.getStateId());
    if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$fileSt = _response$data.fileStoreIds) === null || _response$data$fileSt === void 0 ? void 0 : _response$data$fileSt.length) > 0) {
      var _response$data$fileSt2, _response$data$fileSt3;
      const url = (_response$data$fileSt2 = response.data.fileStoreIds[0]) === null || _response$data$fileSt2 === void 0 ? void 0 : _response$data$fileSt2.url;
      if (url.includes(".jpg") || url.includes(".png")) {
        const arr = url.split(",");
        const [original, large, medium, small] = arr;
        return original;
      }
      return (_response$data$fileSt3 = response.data.fileStoreIds[0]) === null || _response$data$fileSt3 === void 0 ? void 0 : _response$data$fileSt3.url;
    }
  } catch (err) {}
};
const openUploadedDocument = async (filestoreId, name) => {
  if (!filestoreId || !filestoreId.length) {
    alert("No Document exists!");
    return;
  }
  const w = window.open("", "_blank");
  const url = await getFileUrl(filestoreId);
  if (window.mSewaApp && window.mSewaApp.isMsewaApp()) {
    window.open(url, "_blank");
    setTimeout(() => {
      window.location.href = url;
    }, 1000);
  } else {
    w.location = url;
    w.document.title = name;
  }
};
const openDocumentLink = (docLink, title) => {
  if (!docLink || !docLink.length) {
    alert("No Document Link exists!");
    return;
  }
  if (window.mSewaApp && window.mSewaApp.isMsewaApp()) {
    window.open(docLink, "_blank");
    setTimeout(() => {
      window.location.href = docLink;
    }, 1000);
  } else {
    const w = window.open("", "_blank");
    w.location = docLink;
    w.document.title = title;
  }
};
const downloadDocument = async (filestoreId, title) => {
  if (!filestoreId || !filestoreId.length) {
    alert("No Document exists!");
    return;
  }
  const fileUrl = await getFileUrl(filestoreId);
  if (fileUrl) {
    Digit.Utils.downloadPDFFromLink(fileUrl);
  }
};
const isNestedArray = documents => {
  if (!documents || !documents.length) return false;
  if (Array.isArray(documents) && documents.length) {
    const firstItem = Array.isArray(documents[0]);
    if (firstItem) {
      return true;
    }
  }
  return false;
};
const reduceDocsArray = documentsArray => {
  if (!documentsArray || !documentsArray.length) return [];
  return documentsArray.reduce((acc, files) => {
    let fileObj = {};
    const [_, {
      file,
      fileStoreId
    }] = files;
    fileObj["fileName"] = file === null || file === void 0 ? void 0 : file.name;
    fileObj["documentType"] = file === null || file === void 0 ? void 0 : file.type;
    fileObj["fileStoreId"] = fileStoreId === null || fileStoreId === void 0 ? void 0 : fileStoreId.fileStoreId;
    acc.push(fileObj);
    return acc;
  }, []);
};
const getFileSize = size => {
  if (size === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(size) / Math.log(k));
  return parseFloat((size / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};
const documentUploadMessage = (t, fileStoreId, editMode) => {
  var _fileStoreId$fileStor;
  if (!fileStoreId) return t(`CS_ACTION_NO_FILEUPLOADED`);
  return editMode ? fileStoreId !== null && fileStoreId !== void 0 && (_fileStoreId$fileStor = fileStoreId.fileStoreId) !== null && _fileStoreId$fileStor !== void 0 && _fileStoreId$fileStor.length ? `1 ${t(`CS_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`) : fileStoreId ? `1 ${t(`CS_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`);
};
const checkValidFileType = fileType => {
  if (!fileType) return false;
  const allowedFileType = /(.*?)(jpg|jpeg|png|image|pdf|msword|openxmlformats)$/i;
  if (allowedFileType.test(fileType)) {
    return true;
  }
  return false;
};
const handleTodaysDate = dateString => {
  let dateObject = new Date(dateString);
  if (isToday(dateObject)) {
    const todaysDate = new Date();
    dateObject = new Date(todaysDate.getFullYear(), todaysDate.getMonth(), todaysDate.getDate(), 23, 59);
  }
  return dateObject.getTime();
};
const convertDateToMaximumPossibleValue = dateObject => {
  return new Date(dateObject.getFullYear(), dateObject.getMonth(), dateObject.getDate(), 23, 59);
};

const SelectULB = ({
  userType,
  t,
  setValue,
  onSelect,
  config,
  data,
  formData,
  register,
  errors,
  setError,
  clearErrors,
  formState,
  control
}) => {
  var _formData$config$key2, _formData$config$key3;
  const ulbs = Digit.SessionStorage.get("ENGAGEMENT_TENANTS");
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const selectedTenat = useMemo(() => {
    if (formData !== null && formData !== void 0 && formData.defaultTenantId) {
      return ulbs === null || ulbs === void 0 ? void 0 : ulbs.find(ulb => (ulb === null || ulb === void 0 ? void 0 : ulb.code) === (formData === null || formData === void 0 ? void 0 : formData.defaultTenantId));
    }
    if (tenantId && ulbs) {
      const filtered = ulbs === null || ulbs === void 0 ? void 0 : ulbs.filter(item => item.code === tenantId);
      return filtered;
    }
    return (userUlbs === null || userUlbs === void 0 ? void 0 : userUlbs.length) === 1 ? userUlbs === null || userUlbs === void 0 ? void 0 : userUlbs[0] : null;
  }, [tenantId, ulbs]);
  const userInfo = Digit.UserService.getUser().info;
  const userUlbs = ulbs.filter(ulb => {
    var _userInfo$roles;
    return userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$roles = userInfo.roles) === null || _userInfo$roles === void 0 ? void 0 : _userInfo$roles.some(role => (role === null || role === void 0 ? void 0 : role.tenantId) === (ulb === null || ulb === void 0 ? void 0 : ulb.code));
  }).sort(alphabeticalSortFunctionForTenantsBasedOnName);
  const dropDownData = Digit.ULBService.getUserUlbs("SUPERUSER").sort(alphabeticalSortFunctionForTenantsBasedOnName);
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(LabelFieldPair, {
    style: {
      alignItems: 'start'
    }
  }, /*#__PURE__*/React$1.createElement(CardLabel, {
    style: {
      fontWeight: "bold"
    }
  }, t("ES_COMMON_ULB") + " *"), /*#__PURE__*/React$1.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React$1.createElement(Controller, {
    name: config.key,
    control: control,
    defaultValue: selectedTenat === null || selectedTenat === void 0 ? void 0 : selectedTenat[0],
    rules: {
      required: true
    },
    render: props => /*#__PURE__*/React$1.createElement(Dropdown, {
      allowMultiselect: true,
      optionKey: "i18nKey",
      option: dropDownData,
      select: e => {
        var _formData$config$key, _formData$config$key$;
        props.onChange([...((formData === null || formData === void 0 ? void 0 : (_formData$config$key = formData[config === null || config === void 0 ? void 0 : config.key]) === null || _formData$config$key === void 0 ? void 0 : (_formData$config$key$ = _formData$config$key.filter) === null || _formData$config$key$ === void 0 ? void 0 : _formData$config$key$.call(_formData$config$key, f => e.code != (f === null || f === void 0 ? void 0 : f.code))) || []), e]);
      },
      keepNull: true,
      selected: props.value,
      disable: (ulbs === null || ulbs === void 0 ? void 0 : ulbs.length) === 1,
      t: t
    })
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "tag-container"
  }, formData && ((_formData$config$key2 = formData[config === null || config === void 0 ? void 0 : config.key]) === null || _formData$config$key2 === void 0 ? void 0 : _formData$config$key2.length) > 0 && (formData === null || formData === void 0 ? void 0 : (_formData$config$key3 = formData[config.key]) === null || _formData$config$key3 === void 0 ? void 0 : _formData$config$key3.map((ulb, index) => {
    return /*#__PURE__*/React$1.createElement(RemoveableTag, {
      key: index,
      text: t(ulb === null || ulb === void 0 ? void 0 : ulb.i18nKey),
      onClick: () => {
        var _formData$config$key4;
        setValue(config.key, formData === null || formData === void 0 ? void 0 : (_formData$config$key4 = formData[config.key]) === null || _formData$config$key4 === void 0 ? void 0 : _formData$config$key4.filter(e => e.i18nKey != ulb.i18nKey));
      }
    });
  }))), errors && errors[config.key] && /*#__PURE__*/React$1.createElement(CardLabelError, null, t(`EVENTS_TENANT_ERROR_REQUIRED`)))));
};

const ULBDropdown = ({
  userType,
  t,
  setValue,
  onSelect,
  config,
  data,
  formData,
  register,
  errors,
  setError,
  clearErrors,
  formState,
  control
}) => {
  const ulbs = Digit.SessionStorage.get("ENGAGEMENT_TENANTS");
  const userInfo = Digit.UserService.getUser().info;
  const userUlbs = ulbs.filter(ulb => {
    var _userInfo$roles;
    return userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$roles = userInfo.roles) === null || _userInfo$roles === void 0 ? void 0 : _userInfo$roles.some(role => (role === null || role === void 0 ? void 0 : role.tenantId) === (ulb === null || ulb === void 0 ? void 0 : ulb.code));
  }).sort(alphabeticalSortFunctionForTenantsBasedOnName);
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(LabelFieldPair, {
    style: {
      alignItems: 'start'
    }
  }, /*#__PURE__*/React$1.createElement(CardLabel, {
    style: {
      fontWeight: "bold"
    }
  }, t("ES_COMMON_ULB") + "*"), /*#__PURE__*/React$1.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React$1.createElement(Controller, {
    name: config.key,
    control: control,
    rules: {
      required: true
    },
    render: ({
      onChange,
      value
    }) => /*#__PURE__*/React$1.createElement(Dropdown, {
      option: userUlbs,
      selected: value,
      disable: (userUlbs === null || userUlbs === void 0 ? void 0 : userUlbs.length) === 1,
      optionKey: "code",
      t: t,
      select: onChange
    })
  }), errors && errors[config === null || config === void 0 ? void 0 : config.key] && /*#__PURE__*/React$1.createElement(CardLabelError, null, t(`EVENTS_TENANT_ERROR_REQUIRED`)))));
};

const DocumentName = ({
  userType,
  t,
  setValue,
  onSelect,
  config,
  data,
  formData,
  register,
  errors,
  setError,
  clearErrors,
  formState,
  control
}) => {
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(LabelFieldPair, {
    style: {
      marginBottom: '20px'
    }
  }, /*#__PURE__*/React$1.createElement(CardLabel, {
    style: {
      fontWeight: "bold"
    }
  }, t("ES_COMMON_DOC_NAME") + " *"), /*#__PURE__*/React$1.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React$1.createElement(TextInput, {
    name: config.key,
    inputRef: register()
  }))));
};

const SelectCategory = ({
  userType,
  t,
  setValue,
  onSelect,
  config,
  data,
  formData,
  register,
  errors,
  setError,
  clearErrors,
  formState,
  control
}) => {
  const stateId = Digit.ULBService.getStateId();
  const [ulbs, setUlbs] = useState(() => {
    return [];
  });
  const currrentUlb = Digit.ULBService.getCurrentUlb() || "pb.amritsar";
  const {
    data: categoryData,
    isLoading
  } = Digit.Hooks.engagement.useMDMS(stateId, "DocumentUploader", ["UlbLevelCategories"], {
    select: d => {
      var _d$DocumentUploader, _d$DocumentUploader$U, _d$DocumentUploader$U2;
      const data = d === null || d === void 0 ? void 0 : (_d$DocumentUploader = d.DocumentUploader) === null || _d$DocumentUploader === void 0 ? void 0 : (_d$DocumentUploader$U = _d$DocumentUploader.UlbLevelCategories) === null || _d$DocumentUploader$U === void 0 ? void 0 : (_d$DocumentUploader$U2 = _d$DocumentUploader$U.filter) === null || _d$DocumentUploader$U2 === void 0 ? void 0 : _d$DocumentUploader$U2.call(_d$DocumentUploader$U, e => e.ulb === currrentUlb.code);
      return data[0].categoryList.map(name => ({
        name
      }));
    }
  });
  useEffect(() => {
    var _formData$ULB, _formData$ULB2;
    formData !== null && formData !== void 0 && (_formData$ULB = formData.ULB) !== null && _formData$ULB !== void 0 && _formData$ULB.length ? setUlbs(formData === null || formData === void 0 ? void 0 : (_formData$ULB2 = formData.ULB) === null || _formData$ULB2 === void 0 ? void 0 : _formData$ULB2.map(e => e === null || e === void 0 ? void 0 : e.code)) : null;
  }, [formData === null || formData === void 0 ? void 0 : formData.ULB]);
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(LabelFieldPair, null, /*#__PURE__*/React$1.createElement(CardLabel, {
    style: {
      fontWeight: "bold"
    }
  }, t("ES_COMMON_DOC_CATEGORY") + "*"), /*#__PURE__*/React$1.createElement(Controller, {
    name: config.key,
    control: control,
    render: props => /*#__PURE__*/React$1.createElement("div", {
      className: "field"
    }, /*#__PURE__*/React$1.createElement(Dropdown, {
      option: categoryData,
      select: props.onChange,
      selected: props.value,
      t: t,
      optionKey: "name"
    }))
  })));
};

const SelectULB$1 = ({
  userType,
  t,
  setValue,
  onSelect,
  config,
  data,
  formData,
  register,
  errors,
  setError,
  clearErrors,
  formState,
  control
}) => {
  var _errors$description, _errors$description2, _errors$description2$;
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(LabelFieldPair, null, /*#__PURE__*/React$1.createElement(CardLabel, {
    style: {
      fontWeight: "bold"
    }
  }, t("ES_COMMON_DOC_DESCRIPTION")), /*#__PURE__*/React$1.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React$1.createElement(TextArea, {
    name: config.key,
    inputRef: register({
      maxLength: 140
    })
  }), (errors === null || errors === void 0 ? void 0 : (_errors$description = errors.description) === null || _errors$description === void 0 ? void 0 : _errors$description.type) && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`ERROR_${errors === null || errors === void 0 ? void 0 : (_errors$description2 = errors.description) === null || _errors$description2 === void 0 ? void 0 : (_errors$description2$ = _errors$description2.type) === null || _errors$description2$ === void 0 ? void 0 : _errors$description2$.toUpperCase()}_140`)))));
};

const EngagementDocUploadDocument = ({
  userType,
  t,
  onSelect,
  setValue,
  config,
  data,
  formData,
  register,
  errors,
  setError,
  clearErrors,
  formState,
  control
}) => {
  const [fileStoreId, setFileStoreId] = useState(() => {
    var _formData$config$key;
    return formData === null || formData === void 0 ? void 0 : (_formData$config$key = formData[config.key]) === null || _formData$config$key === void 0 ? void 0 : _formData$config$key.filestoreId;
  });
  const [fileSize, setFileSize] = useState();
  const [fileType, setFileType] = useState('');
  const [file, setFile] = useState();
  const [urlDisabled, setUrlDisabled] = useState(false);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [controllerProps, setProps] = useState({});
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [imageUploadError, setUploadError] = useState("");
  const selectFile = (e, props) => {
    var _e$target, _e$target$files, _e$target2, _e$target2$files$, _e$target3, _e$target3$files$;
    setFile();
    setFileSize();
    setFileType();
    setUploadError("");
    if (!((_e$target = e.target) !== null && _e$target !== void 0 && (_e$target$files = _e$target.files) !== null && _e$target$files !== void 0 && _e$target$files.length)) return;
    const size = e === null || e === void 0 ? void 0 : (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : (_e$target2$files$ = _e$target2.files[0]) === null || _e$target2$files$ === void 0 ? void 0 : _e$target2$files$.size;
    const type = e === null || e === void 0 ? void 0 : (_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : (_e$target3$files$ = _e$target3.files[0]) === null || _e$target3$files$ === void 0 ? void 0 : _e$target3$files$.type;
    if (size && size / 1024 / 1024 > 5) {
      setUploadError('FILE_SIZE_EXCEEDED');
      return;
    }
    if (type && checkValidFileType(type)) {
      setFileSize(size);
      setFileType(type);
      setProps(props);
      setFile(e.target.files[0]);
      return;
    } else {
      setUploadError('NOT_SUPPORTED_FILE_TYPE');
    }
  };
  useEffect(() => {
    if (file) uploadFile();
  }, [file]);
  useEffect(() => {
    var _controllerProps$onCh;
    if (fileStoreId) ;else setUrlDisabled(false);
    controllerProps === null || controllerProps === void 0 ? void 0 : (_controllerProps$onCh = controllerProps.onChange) === null || _controllerProps$onCh === void 0 ? void 0 : _controllerProps$onCh.call(controllerProps, {
      fileStoreId,
      fileSize,
      fileType
    });
  }, [fileStoreId, controllerProps]);
  const uploadFile = async () => {
    try {
      var _response$data, _response$data$files;
      setIsUploadingImage(true);
      const response = await Digit.UploadServices.Filestorage("engagement", file, Digit.ULBService.getStateId());
      if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
        var _response$data2, _response$data2$files;
        setFileStoreId(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
      } else {
        setError(t("CS_FILE_UPLOAD_ERROR"));
      }
    } catch (err) {} finally {
      setIsUploadingImage(false);
    }
  };
  const location = useLocation();
  const isInEditFormMode = useMemo(() => {
    if (location.pathname.includes('/documents/inbox/update')) return true;
    return false;
  }, [location.pathname]);
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(LabelFieldPair, null, /*#__PURE__*/React$1.createElement(CardLabel, {
    style: {
      fontWeight: "bold"
    }
  }, t("ES_COMMON_DOC_DOCUMENT") + "*"), /*#__PURE__*/React$1.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React$1.createElement(Controller, {
    name: config.key + ".filestoreId",
    control: control,
    render: props => /*#__PURE__*/React$1.createElement(UploadFile, {
      id: "city-engagement-doc",
      onUpload: d => selectFile(d, props),
      onDelete: () => {
        setFileStoreId(null);
        setFileSize(100);
      },
      accept: "image/*, .pdf, .png, .jpeg, .doc",
      showHintBelow: true,
      hintText: t("DOCUMENTS_ATTACH_RESTRICTIONS_SIZE"),
      message: isUploadingImage ? /*#__PURE__*/React$1.createElement(Loader, null) : documentUploadMessage(t, fileStoreId, isInEditFormMode),
      textStyles: {
        width: "100%"
      },
      inputStyles: {
        width: "280px"
      }
    })
  }), fileSize ? `${getFileSize(fileSize)}` : null, imageUploadError ? /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(imageUploadError)) : null)));
};

const config = [{
  head: "",
  body: [{
    type: "form",
    withoutLabel: true,
    component: "EventForm",
    nextStep: "",
    route: "",
    key: "eventData"
  }, {
    type: "text",
    label: "EVENTS_DESCRIPTION_LABEL",
    isMandatory: true,
    description: "EVENTS_DESCRIPTION_TEXT",
    populators: {
      name: "description",
      className: "fullWidth",
      validation: {
        required: true,
        maxLength: 500
      },
      error: 'EVENTS_DESCRIPTION_ERROR_REQUIRED'
    }
  }, {
    type: "date",
    label: "EVENTS_FROM_DATE_LABEL",
    isMandatory: true,
    populators: {
      name: "fromDate",
      className: "fullWidth",
      validation: {
        required: true
      },
      shouldUpdate: true,
      error: "EVENTS_FROM_DATE_ERROR_INVALID"
    }
  }, {
    type: "form",
    key: "SelectToDate",
    withoutLabel: true,
    component: "SelectToDate",
    key: "toDate"
  }, {
    type: "time",
    label: "EVENTS_FROM_TIME_LABEL",
    isMandatory: true,
    populators: {
      name: "fromTime",
      className: "fullWidth",
      validation: {
        required: true
      },
      error: "EVENTS_FROM_TIME_ERROR_REQUIRED"
    }
  }, {
    type: "time",
    label: "EVENTS_TO_TIME_LABEL",
    isMandatory: true,
    populators: {
      name: "toTime",
      className: "fullWidth",
      validation: {
        required: true
      },
      error: "EVENTS_TO_TIME_ERROR_REQUIRED"
    }
  }, {
    type: "text",
    label: "EVENTS_ADDRESS_LABEL",
    isMandatory: true,
    populators: {
      name: "address",
      className: "fullWidth",
      validation: {
        required: true
      },
      error: "EVENTS_ADDRESS_ERROR_REQUIRED"
    }
  }, {
    type: "component",
    component: "SelectEventGeolocation",
    withoutLabel: true,
    key: "geoLocation"
  }, {
    type: "text",
    label: "EVENTS_ORGANIZER_NAME_LABEL",
    populators: {
      name: "organizer",
      className: "fullWidth",
      validation: {
        pattern: /^[A-Za-z ]*$/
      },
      error: "EVENTS_ORGANIZER_ERROR"
    }
  }, {
    type: "number",
    label: "EVENTS_ENTRY_FEE_INR_LABEL",
    populators: {
      name: "fees",
      className: "fullWidth",
      error: "EVENTS_ENTRY_ERROR_REQUIRED"
    }
  }]
}];

const NewEvents = () => {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const onSubmit = data => {
    var _data$tenantId, _data$eventCategory;
    const {
      fromDate,
      toDate,
      fromTime,
      toTime,
      address,
      organizer,
      fees,
      geoLocation = {}
    } = data;
    const details = {
      events: [{
        source: "WEBAPP",
        eventType: "EVENTSONGROUND",
        tenantId: data === null || data === void 0 ? void 0 : (_data$tenantId = data.tenantId) === null || _data$tenantId === void 0 ? void 0 : _data$tenantId.code,
        description: data === null || data === void 0 ? void 0 : data.description,
        name: data === null || data === void 0 ? void 0 : data.name,
        eventcategory: data === null || data === void 0 ? void 0 : (_data$eventCategory = data.eventCategory) === null || _data$eventCategory === void 0 ? void 0 : _data$eventCategory.code,
        eventDetails: {
          fromDate: new Date(`${fromDate} ${fromTime}`).getTime(),
          toDate: new Date(`${toDate} ${toTime}`).getTime(),
          fromTime,
          toTime,
          address,
          organizer,
          fees,
          ...geoLocation
        }
      }]
    };
    history.push("/digit-ui/employee/engagement/event/response", details);
  };
  const [mutationHappened, setMutationHappened, clear] = Digit.Hooks.useSessionStorage("EMPLOYEE_EVENT_MUTATION_HAPPENED", false);
  const [errorInfo, setErrorInfo, clearError] = Digit.Hooks.useSessionStorage("EMPLOYEE_EVENT_ERROR_DATA", false);
  const [successData, setsuccessData, clearSuccessData] = Digit.Hooks.useSessionStorage("EMPLOYEE_EVENT_MUTATION_SUCCESS_DATA", false);
  useEffect(() => {
    setMutationHappened(false);
    clearSuccessData();
    clearError();
  }, []);
  return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(Header, null, t("ES_TITLE_NEW_EVENTS")), /*#__PURE__*/React$1.createElement(FormComposer, {
    config: config,
    onSubmit: onSubmit,
    label: t("EVENTS_CREATE_EVENT")
  }));
};

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

function compareAsc(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
}

function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

function differenceInMilliseconds(dateLeft, dateRight) {
  requiredArgs(2, arguments);
  return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
}

var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function (value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  }
};
var defaultRoundingMethod = 'trunc';
function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}

function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

function isLastDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return endOfDay(date).getTime() === endOfMonth(date).getTime();
}

function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
  var result;
  if (difference < 1) {
    result = 0;
  } else {
    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
      dateLeft.setDate(30);
    }
    dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
    var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign;
    if (isLastDayOfMonth(toDate(dirtyDateLeft)) && difference === 1 && compareAsc(dirtyDateLeft, dateRight) === 1) {
      isLastMonthNotFull = false;
    }
    result = sign * (difference - Number(isLastMonthNotFull));
  }
  return result === 0 ? 0 : result;
}

function differenceInSeconds(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / 1000;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

var locale = {
  code: 'en-US',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}

var formatters = {
  y: function (date, token) {
    var signedYear = date.getUTCFullYear();
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
var formatters$1 = {
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  y: function (date, token, localize) {
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return formatters.y(date, token);
  },
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case 'Q':
        return String(quarter);
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case 'q':
        return String(quarter);
      case 'qq':
        return addLeadingZeros(quarter, 2);
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  M: function (date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return formatters.M(date, token);
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  L: function (date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'L':
        return String(month + 1);
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return formatters.d(date, token);
  },
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case 'e':
        return String(localDayOfWeek);
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case 'c':
        return String(localDayOfWeek);
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      case 'i':
        return String(isoDayOfWeek);
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return formatters.h(date, token);
  },
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return formatters.H(date, token);
  },
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return formatters.m(date, token);
  },
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return formatters.s(date, token);
  },
  S: function (date, token) {
    return formatters.S(date, token);
  },
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case 'XXXX':
      case 'XX':
        return formatTimezone(timezoneOffset);
      case 'XXXXX':
      case 'XXX':
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case 'xxxx':
      case 'xx':
        return formatTimezone(timezoneOffset);
      case 'xxxxx':
      case 'xxx':
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}
function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}
function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale$1 = options.locale || locale;
  var localeFirstWeekContainsDate = locale$1.options && locale$1.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var localeWeekStartsOn = locale$1.options && locale$1.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale$1.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale$1.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong, formatterOptions);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters$1[firstCharacter];
    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }
      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }
      return formatter(utcDate, substring, locale$1.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }
  dirtyObject = dirtyObject || {};
  for (var property in dirtyObject) {
    if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) {
      target[property] = dirtyObject[property];
    }
  }
  return target;
}

function cloneObject(dirtyObject) {
  return assign({}, dirtyObject);
}

var MINUTES_IN_DAY = 1440;
var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var MINUTES_IN_MONTH = 43200;
var MINUTES_IN_TWO_MONTHS = 86400;
function formatDistance$1(dirtyDate, dirtyBaseDate) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  requiredArgs(2, arguments);
  var locale$1 = options.locale || locale;
  if (!locale$1.formatDistance) {
    throw new RangeError('locale must contain formatDistance property');
  }
  var comparison = compareAsc(dirtyDate, dirtyBaseDate);
  if (isNaN(comparison)) {
    throw new RangeError('Invalid time value');
  }
  var localizeOptions = cloneObject(options);
  localizeOptions.addSuffix = Boolean(options.addSuffix);
  localizeOptions.comparison = comparison;
  var dateLeft;
  var dateRight;
  if (comparison > 0) {
    dateLeft = toDate(dirtyBaseDate);
    dateRight = toDate(dirtyDate);
  } else {
    dateLeft = toDate(dirtyDate);
    dateRight = toDate(dirtyBaseDate);
  }
  var seconds = differenceInSeconds(dateRight, dateLeft);
  var offsetInSeconds = (getTimezoneOffsetInMilliseconds(dateRight) - getTimezoneOffsetInMilliseconds(dateLeft)) / 1000;
  var minutes = Math.round((seconds - offsetInSeconds) / 60);
  var months;
  if (minutes < 2) {
    if (options.includeSeconds) {
      if (seconds < 5) {
        return locale$1.formatDistance('lessThanXSeconds', 5, localizeOptions);
      } else if (seconds < 10) {
        return locale$1.formatDistance('lessThanXSeconds', 10, localizeOptions);
      } else if (seconds < 20) {
        return locale$1.formatDistance('lessThanXSeconds', 20, localizeOptions);
      } else if (seconds < 40) {
        return locale$1.formatDistance('halfAMinute', null, localizeOptions);
      } else if (seconds < 60) {
        return locale$1.formatDistance('lessThanXMinutes', 1, localizeOptions);
      } else {
        return locale$1.formatDistance('xMinutes', 1, localizeOptions);
      }
    } else {
      if (minutes === 0) {
        return locale$1.formatDistance('lessThanXMinutes', 1, localizeOptions);
      } else {
        return locale$1.formatDistance('xMinutes', minutes, localizeOptions);
      }
    }
  } else if (minutes < 45) {
    return locale$1.formatDistance('xMinutes', minutes, localizeOptions);
  } else if (minutes < 90) {
    return locale$1.formatDistance('aboutXHours', 1, localizeOptions);
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60);
    return locale$1.formatDistance('aboutXHours', hours, localizeOptions);
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return locale$1.formatDistance('xDays', 1, localizeOptions);
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY);
    return locale$1.formatDistance('xDays', days, localizeOptions);
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH);
    return locale$1.formatDistance('aboutXMonths', months, localizeOptions);
  }
  months = differenceInMonths(dateRight, dateLeft);
  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
    return locale$1.formatDistance('xMonths', nearestMonth, localizeOptions);
  } else {
    var monthsSinceStartOfYear = months % 12;
    var years = Math.floor(months / 12);
    if (monthsSinceStartOfYear < 3) {
      return locale$1.formatDistance('aboutXYears', years, localizeOptions);
    } else if (monthsSinceStartOfYear < 9) {
      return locale$1.formatDistance('overXYears', years, localizeOptions);
    } else {
      return locale$1.formatDistance('almostXYears', years + 1, localizeOptions);
    }
  }
}

function formatDistanceToNow(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  return formatDistance$1(dirtyDate, Date.now(), dirtyOptions);
}

const EditEvents = () => {
  var _data$eventDetails, _data$eventDetails2, _data$eventDetails3, _data$eventDetails4, _data$eventDetails5, _data$eventDetails6, _data$eventDetails7, _data$eventDetails8, _data$eventDetails9;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const {
    id: EventId
  } = useParams();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const {
    isLoading,
    data
  } = Digit.Hooks.events.useInbox(tenantId, {}, {
    eventTypes: "EVENTSONGROUND",
    ids: EventId
  }, {
    select: data => {
      var _data$events;
      return data === null || data === void 0 ? void 0 : (_data$events = data.events) === null || _data$events === void 0 ? void 0 : _data$events[0];
    }
  });
  const [mutationHappened, setMutationHappened, clear] = Digit.Hooks.useSessionStorage("EMPLOYEE_EVENT_MUTATION_HAPPENED", false);
  const [errorInfo, setErrorInfo, clearError] = Digit.Hooks.useSessionStorage("EMPLOYEE_EVENT_ERROR_DATA", false);
  const [successData, setsuccessData, clearSuccessData] = Digit.Hooks.useSessionStorage("EMPLOYEE_EVENT_MUTATION_SUCCESS_DATA", false);
  useEffect(() => {
    setMutationHappened(false);
    clearSuccessData();
    clearError();
  }, []);
  const onSubmit = formData => {
    var _formData$tenantId, _formData$eventCatego;
    const {
      fromDate,
      toDate,
      fromTime,
      toTime,
      address,
      organizer,
      fees,
      geoLocation
    } = formData;
    const details = {
      events: [{
        ...data,
        source: "WEBAPP",
        status: "ACTIVE",
        eventType: "EVENTSONGROUND",
        tenantId: formData === null || formData === void 0 ? void 0 : (_formData$tenantId = formData.tenantId) === null || _formData$tenantId === void 0 ? void 0 : _formData$tenantId.code,
        description: formData === null || formData === void 0 ? void 0 : formData.description,
        name: formData === null || formData === void 0 ? void 0 : formData.name,
        eventcategory: formData === null || formData === void 0 ? void 0 : (_formData$eventCatego = formData.eventCategory) === null || _formData$eventCatego === void 0 ? void 0 : _formData$eventCatego.code,
        eventDetails: {
          ...(data === null || data === void 0 ? void 0 : data.eventDetails),
          fromDate: new Date(`${fromDate} ${fromTime}`).getTime(),
          toDate: new Date(`${toDate} ${toTime}`).getTime(),
          fromTime,
          toTime,
          address,
          organizer,
          fees,
          latitude: geoLocation === null || geoLocation === void 0 ? void 0 : geoLocation.latitude,
          longitude: geoLocation === null || geoLocation === void 0 ? void 0 : geoLocation.longitude
        }
      }]
    };
    history.push("/digit-ui/employee/engagement/event/response?update=true", details);
  };
  if (isLoading) {
    return /*#__PURE__*/React$1.createElement(Loader, null);
  }
  const defaultValues = {
    defaultTenantId: data === null || data === void 0 ? void 0 : data.tenantId,
    name: data === null || data === void 0 ? void 0 : data.name,
    fromDate: format(new Date(data === null || data === void 0 ? void 0 : (_data$eventDetails = data.eventDetails) === null || _data$eventDetails === void 0 ? void 0 : _data$eventDetails.fromDate), 'yyyy-MM-dd'),
    toDate: format(new Date(data === null || data === void 0 ? void 0 : (_data$eventDetails2 = data.eventDetails) === null || _data$eventDetails2 === void 0 ? void 0 : _data$eventDetails2.toDate), 'yyyy-MM-dd'),
    organizer: data === null || data === void 0 ? void 0 : (_data$eventDetails3 = data.eventDetails) === null || _data$eventDetails3 === void 0 ? void 0 : _data$eventDetails3.organizer,
    fees: data === null || data === void 0 ? void 0 : (_data$eventDetails4 = data.eventDetails) === null || _data$eventDetails4 === void 0 ? void 0 : _data$eventDetails4.fees,
    description: data === null || data === void 0 ? void 0 : data.description,
    address: data === null || data === void 0 ? void 0 : (_data$eventDetails5 = data.eventDetails) === null || _data$eventDetails5 === void 0 ? void 0 : _data$eventDetails5.address,
    category: data === null || data === void 0 ? void 0 : data.eventCategory,
    fromTime: format(new Date(data === null || data === void 0 ? void 0 : (_data$eventDetails6 = data.eventDetails) === null || _data$eventDetails6 === void 0 ? void 0 : _data$eventDetails6.fromDate), 'HH:mm'),
    toTime: format(new Date(data === null || data === void 0 ? void 0 : (_data$eventDetails7 = data.eventDetails) === null || _data$eventDetails7 === void 0 ? void 0 : _data$eventDetails7.toDate), 'HH:mm'),
    geoLocation: {
      latitude: data === null || data === void 0 ? void 0 : (_data$eventDetails8 = data.eventDetails) === null || _data$eventDetails8 === void 0 ? void 0 : _data$eventDetails8.latitude,
      longitude: data === null || data === void 0 ? void 0 : (_data$eventDetails9 = data.eventDetails) === null || _data$eventDetails9 === void 0 ? void 0 : _data$eventDetails9.longitude
    }
  };
  return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(Header, null, t("ES_TITLE_EDIT_EVENTS")), /*#__PURE__*/React$1.createElement(FormComposer, {
    defaultValues: defaultValues,
    config: config,
    onSubmit: onSubmit,
    label: t("EVENTS_SAVE_CHANGES")
  }));
};

const BannerPicker = props => {
  var _props$data, _props$data$events, _props$data$events$;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement(Banner, {
    message: t(props.message),
    applicationNumber: props === null || props === void 0 ? void 0 : (_props$data = props.data) === null || _props$data === void 0 ? void 0 : (_props$data$events = _props$data.events) === null || _props$data$events === void 0 ? void 0 : (_props$data$events$ = _props$data$events[0]) === null || _props$data$events$ === void 0 ? void 0 : _props$data$events$.name,
    info: t(`ENGAGEMENT_EVENT_NAME`),
    successful: props.isSuccess
  });
};
const Response = props => {
  var _mutation$data, _mutation$data$events, _successData$events, _event$eventDetails, _event$eventDetails2, _event$eventDetails3, _event$eventDetails4;
  const queryClient = useQueryClient();
  const {
    t
  } = useTranslation();
  const searchParams = Digit.Hooks.useQueryParams();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const mutation = Digit.Hooks.events.useCreateEvent();
  const updateEventMutation = Digit.Hooks.events.useUpdateEvent();
  const [isSuccess, setIsSuccess] = useState(false);
  const {
    state
  } = props.location;
  const [mutationHappened, setMutationHappened, clear] = Digit.Hooks.useSessionStorage("EMPLOYEE_EVENT_MUTATION_HAPPENED", false);
  const [successData, setsuccessData, clearSuccessData] = Digit.Hooks.useSessionStorage("EMPLOYEE_EVENT_MUTATION_SUCCESS_DATA", false);
  const [errorInfo, setErrorInfo, clearError] = Digit.Hooks.useSessionStorage("EMPLOYEE_EVENT_ERROR_DATA", false);
  const onError = (error, variables) => {
    var _error$response, _error$response$data, _error$response$data$;
    setErrorInfo((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : (_error$response$data$ = _error$response$data.Errors[0]) === null || _error$response$data$ === void 0 ? void 0 : _error$response$data$.code) || 'ERROR');
    setMutationHappened(true);
  };
  useEffect(() => {
    if (mutation.data) setsuccessData(mutation.data);
  }, [mutation.data]);
  useEffect(() => {
    if (updateEventMutation.data) setsuccessData(updateEventMutation.data);
  }, [updateEventMutation.data]);
  useEffect(() => {
    const onSuccess = () => {
      setMutationHappened(true);
      queryClient.clear();
    };
    if (!mutationHappened) {
      if (Boolean(searchParams === null || searchParams === void 0 ? void 0 : searchParams.delete) || Boolean(searchParams === null || searchParams === void 0 ? void 0 : searchParams.update)) {
        updateEventMutation.mutate(state, {
          onError,
          onSuccess
        });
        return;
      }
      mutation.mutate(state, {
        onError,
        onSuccess
      });
      return;
    }
    return () => {
      queryClient.clear();
    };
  }, []);
  if (searchParams !== null && searchParams !== void 0 && searchParams.delete || searchParams !== null && searchParams !== void 0 && searchParams.update) {
    if (updateEventMutation.isLoading || updateEventMutation.isIdle && !mutationHappened) {
      return /*#__PURE__*/React$1.createElement(Loader, null);
    }
    return /*#__PURE__*/React$1.createElement(Card, null, /*#__PURE__*/React$1.createElement(BannerPicker, {
      t: t,
      message: searchParams !== null && searchParams !== void 0 && searchParams.update ? updateEventMutation.isSuccess || successData ? 'ENGAGEMENT_EVENT_UPDATED' : `ENGAGEMENT_EVENT_UPDATED_FAILED` : updateEventMutation.isSuccess || successData ? 'ENGAGEMENT_EVENT_DELETED' : 'ENGAGEMENT_EVENT_DELETED_FAILED',
      data: updateEventMutation.data || successData,
      isSuccess: (updateEventMutation === null || updateEventMutation === void 0 ? void 0 : updateEventMutation.isSuccess) || successData,
      isLoading: updateEventMutation.isIdle && !mutationHappened || updateEventMutation.isLoading
    }), /*#__PURE__*/React$1.createElement(CardText, null, searchParams !== null && searchParams !== void 0 && searchParams.update ? updateEventMutation.isSuccess || successData ? t('ENGAGEMENT_EVENT_UPDATED') : t(`ENGAGEMENT_EVENT_UPDATED_FAILED`) : updateEventMutation.isSuccess || successData ? t('ENGAGEMENT_EVENT_DELETED') : t('ENGAGEMENT_EVENT_DELETED_FAILED')), /*#__PURE__*/React$1.createElement(ActionBar, null, /*#__PURE__*/React$1.createElement(Link, {
      to: "/digit-ui/employee"
    }, /*#__PURE__*/React$1.createElement(SubmitBar, {
      label: t("CORE_COMMON_GO_TO_HOME")
    }))));
  }
  if (mutation.isLoading || mutation.isIdle && !mutationHappened) {
    return /*#__PURE__*/React$1.createElement(Loader, null);
  }
  const event = (mutation === null || mutation === void 0 ? void 0 : (_mutation$data = mutation.data) === null || _mutation$data === void 0 ? void 0 : (_mutation$data$events = _mutation$data.events) === null || _mutation$data$events === void 0 ? void 0 : _mutation$data$events[0]) || (successData === null || successData === void 0 ? void 0 : (_successData$events = successData.events) === null || _successData$events === void 0 ? void 0 : _successData$events[0]) || {};
  return /*#__PURE__*/React$1.createElement(Card, null, /*#__PURE__*/React$1.createElement(BannerPicker, {
    t: t,
    message: mutation.isSuccess || successData ? `ENGAGEMENT_EVENT_CREATED_MESSAGE` : `ENGAGEMENT_EVENT_FAILED_MESSAGES`,
    data: mutation.data || successData,
    isSuccess: mutation.isSuccess || successData,
    isLoading: mutation.isIdle && !mutationHappened || mutation.isLoading
  }), /*#__PURE__*/React$1.createElement(CardText, null, mutation.isSuccess || successData ? t(`ENGAGEMENT_EVENT_CREATED_MESSAGES`, {
    eventName: event === null || event === void 0 ? void 0 : event.name,
    fromDate: Digit.DateUtils.ConvertTimestampToDate(event === null || event === void 0 ? void 0 : (_event$eventDetails = event.eventDetails) === null || _event$eventDetails === void 0 ? void 0 : _event$eventDetails.fromDate),
    toDate: Digit.DateUtils.ConvertTimestampToDate(event === null || event === void 0 ? void 0 : (_event$eventDetails2 = event.eventDetails) === null || _event$eventDetails2 === void 0 ? void 0 : _event$eventDetails2.toDate),
    fromTime: mutation.isSuccess ? format(new Date(event === null || event === void 0 ? void 0 : (_event$eventDetails3 = event.eventDetails) === null || _event$eventDetails3 === void 0 ? void 0 : _event$eventDetails3.fromDate), 'HH:mm') : null,
    toTime: mutation.isSuccess ? format(new Date(event === null || event === void 0 ? void 0 : (_event$eventDetails4 = event.eventDetails) === null || _event$eventDetails4 === void 0 ? void 0 : _event$eventDetails4.toDate), 'HH:mm') : null
  }) : null), /*#__PURE__*/React$1.createElement(ActionBar, null, /*#__PURE__*/React$1.createElement(Link, {
    to: "/digit-ui/employee"
  }, /*#__PURE__*/React$1.createElement(SubmitBar, {
    label: t("CORE_COMMON_GO_TO_HOME")
  }))));
};

const ApplicationTable = ({
  t,
  data,
  columns,
  globalSearch,
  onSearch,
  getCellProps,
  pageSizeLimit,
  totalRecords,
  currentPage,
  onNextPage,
  onPrevPage,
  onPageSizeChange
}) => {
  return /*#__PURE__*/React$1.createElement(Table, {
    t: t,
    data: data,
    columns: columns,
    onSearch: onSearch,
    globalSearch: globalSearch,
    manualGlobalFilter: true,
    manualPagination: true,
    pageSizeLimit: pageSizeLimit,
    getCellProps: getCellProps,
    totalRecords: totalRecords,
    currentPage: currentPage,
    onNextPage: onNextPage,
    onPrevPage: onPrevPage,
    onPageSizeChange: onPageSizeChange
  });
};

const DropdownUlb = ({
  ulb,
  onAssignmentChange,
  value,
  t
}) => {
  return /*#__PURE__*/React$1.createElement(Dropdown, {
    option: ulb,
    optionKey: "code",
    selected: value,
    select: onAssignmentChange,
    t: t
  });
};

const Search = ({
  onSearch,
  searchParams,
  searchFields,
  type,
  onClose,
  isInboxPage,
  t
}) => {
  const {
    register,
    handleSubmit,
    formState,
    reset,
    watch,
    control
  } = useForm({
    defaultValues: searchParams
  });
  const mobileView = innerWidth <= 640;
  const ulb = Digit.SessionStorage.get("ENGAGEMENT_TENANTS");
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const userInfo = Digit.UserService.getUser().info;
  const userUlbs = ulb.filter(ulb => {
    var _userInfo$roles;
    return userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$roles = userInfo.roles) === null || _userInfo$roles === void 0 ? void 0 : _userInfo$roles.some(role => (role === null || role === void 0 ? void 0 : role.tenantId) === (ulb === null || ulb === void 0 ? void 0 : ulb.code));
  }).sort(alphabeticalSortFunctionForTenantsBasedOnName);
  const getFields = input => {
    switch (input.type) {
      case "ulb":
        return /*#__PURE__*/React$1.createElement(Controller, {
          rules: {
            required: true
          },
          render: props => /*#__PURE__*/React$1.createElement(DropdownUlb, {
            onAssignmentChange: props.onChange,
            value: props.value,
            ulb: userUlbs,
            t: t
          }),
          name: input.name,
          control: control,
          defaultValue: null
        });
      default:
        return /*#__PURE__*/React$1.createElement(Controller, {
          render: props => /*#__PURE__*/React$1.createElement(TextInput, {
            onChange: props.onChange,
            value: props.value
          }),
          name: input.name,
          control: control,
          defaultValue: null
        });
    }
  };
  const onSubmitInput = data => {
    onSearch(data);
    if (type === "mobile") {
      onClose();
    }
  };
  const clearSearch = () => {
    reset({
      ulb: null,
      eventName: ''
    });
    onSearch({
      ulb: null,
      eventName: ''
    });
  };
  const clearAll = mobileView => {
    const mobileViewStyles = mobileView ? {
      margin: 0
    } : {};
    return /*#__PURE__*/React$1.createElement(LinkLabel, {
      style: {
        display: "inline",
        ...mobileViewStyles
      },
      onClick: clearSearch
    }, t("ES_COMMON_CLEAR_SEARCH"));
  };
  return /*#__PURE__*/React$1.createElement("form", {
    onSubmit: handleSubmit(onSubmitInput)
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "search-container",
    style: {
      width: "auto",
      marginLeft: isInboxPage ? "24px" : "revert"
    }
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "search-complaint-container"
  }, (type === "mobile" || mobileView) && /*#__PURE__*/React$1.createElement("div", {
    className: "complaint-header"
  }, /*#__PURE__*/React$1.createElement("h2", null, t("ES_COMMON_SEARCH_BY")), /*#__PURE__*/React$1.createElement("span", {
    onClick: onClose
  }, /*#__PURE__*/React$1.createElement(CloseSvg, null))), /*#__PURE__*/React$1.createElement("div", {
    className: "complaint-input-container for-pt " + (!isInboxPage ? "for-search" : ""),
    style: {
      width: "100%"
    }
  }, searchFields === null || searchFields === void 0 ? void 0 : searchFields.map((input, index) => {
    var _formState$dirtyField, _formState$errors, _formState$errors$inp;
    return /*#__PURE__*/React$1.createElement("div", {
      key: input.name,
      className: "input-fields"
    }, /*#__PURE__*/React$1.createElement("span", {
      className: "mobile-input"
    }, /*#__PURE__*/React$1.createElement(Label, null, t(input.label) + ` ${input.isMendatory ? "*" : ""}`), getFields(input)), formState !== null && formState !== void 0 && (_formState$dirtyField = formState.dirtyFields) !== null && _formState$dirtyField !== void 0 && _formState$dirtyField[input.name] ? /*#__PURE__*/React$1.createElement("span", {
      style: {
        fontWeight: "700",
        color: "rgba(212, 53, 28)",
        paddingLeft: "8px",
        marginTop: "-20px",
        fontSize: "12px"
      },
      className: "inbox-search-form-error"
    }, formState === null || formState === void 0 ? void 0 : (_formState$errors = formState.errors) === null || _formState$errors === void 0 ? void 0 : (_formState$errors$inp = _formState$errors[input.name]) === null || _formState$errors$inp === void 0 ? void 0 : _formState$errors$inp.message) : null);
  }), type === "desktop" && !mobileView && /*#__PURE__*/React$1.createElement("div", {
    style: {
      maxWidth: "unset",
      marginLeft: "unset",
      marginTop: "55px"
    },
    className: "search-submit-wrapper"
  }, /*#__PURE__*/React$1.createElement(SubmitBar, {
    className: "submit-bar-search",
    label: t("ES_COMMON_SEARCH"),
    submit: true
  }), /*#__PURE__*/React$1.createElement("div", null, clearAll()))))), (type === "mobile" || mobileView) && /*#__PURE__*/React$1.createElement(ActionBar, {
    className: "clear-search-container"
  }, /*#__PURE__*/React$1.createElement("button", {
    className: "clear-search",
    style: {
      flex: 1
    }
  }, clearAll(mobileView)), /*#__PURE__*/React$1.createElement(SubmitBar, {
    disabled: !!Object.keys(formState.errors).length,
    label: t("ES_COMMON_SEARCH"),
    style: {
      flex: 1
    },
    submit: true
  })));
};

const EventLink = ({
  title: _title = "EVENTS_EVENTS_HEADER",
  links,
  icon: _icon = 'calender'
}) => {
  const {
    t
  } = useTranslation();
  const GetLogo = () => /*#__PURE__*/React$1.createElement("div", {
    className: "header",
    style: {
      justifyContent: "flex-start"
    }
  }, /*#__PURE__*/React$1.createElement("span", {
    className: "logo",
    style: {
      backgroundColor: "#fff"
    }
  }, _icon === "calender" ? /*#__PURE__*/React$1.createElement(EventCalendar, null) : _icon === "survey" ? 'surveyIcon' : /*#__PURE__*/React$1.createElement(DocumentIcon, null)), " ", /*#__PURE__*/React$1.createElement("span", {
    className: "text"
  }, t(_title)));
  return /*#__PURE__*/React$1.createElement(Card, {
    className: "employeeCard filter inboxLinks"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "complaint-links-container"
  }, GetLogo(), /*#__PURE__*/React$1.createElement("div", {
    className: "body"
  }, links.map(({
    link,
    text,
    hyperlink: _hyperlink = false,
    accessTo: _accessTo = []
  }, index) => {
    return /*#__PURE__*/React$1.createElement("span", {
      className: "link",
      key: index
    }, _hyperlink ? /*#__PURE__*/React$1.createElement("a", {
      href: link
    }, text) : /*#__PURE__*/React$1.createElement(Link, {
      to: link
    }, text));
  }))));
};

const StatusCount = ({
  status,
  onAssignmentChange,
  searchParams
}) => {
  var _searchParams$eventSt, _searchParams$eventSt2;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement(CheckBox, {
    onChange: e => onAssignmentChange(e, status),
    checked: (searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$eventSt = searchParams.eventStatus) === null || _searchParams$eventSt === void 0 ? void 0 : (_searchParams$eventSt2 = _searchParams$eventSt.filter(event => event === status)) === null || _searchParams$eventSt2 === void 0 ? void 0 : _searchParams$eventSt2.length) > 0 ? true : false,
    label: t(status),
    pageType: 'employee'
  });
};

const statuses = ["ACTIVE", "INACTIVE"];
const Status = ({
  onAssignmentChange,
  searchParams
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement("div", {
    className: "status-container"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "filter-label"
  }, t("ES_INBOX_STATUS")), statuses === null || statuses === void 0 ? void 0 : statuses.map((status, key) => /*#__PURE__*/React$1.createElement(StatusCount, {
    key: key,
    status: status,
    onAssignmentChange: onAssignmentChange,
    searchParams: searchParams
  })));
};

const Filter = ({
  type: _type = "desktop",
  onClose,
  onSearch,
  onFilterChange,
  searchParams
}) => {
  var _data$mseva;
  const {
    t
  } = useTranslation();
  const [localSearchParams, setLocalSearchParams] = useState(() => ({
    ...searchParams
  }));
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const state = tenantId === null || tenantId === void 0 ? void 0 : tenantId.split(".")[0];
  const {
    isLoading,
    data
  } = Digit.Hooks.useCommonMDMS(state, "mseva", ["EventCategories"]);
  const clearAll = () => {
    setLocalSearchParams({
      eventCategory: null,
      eventStatus: [],
      range: {
        startDate: null,
        endDate: new Date(""),
        title: ""
      }
    });
    onFilterChange({
      eventCategory: null,
      eventStatus: [],
      range: {
        startDate: null,
        endDate: new Date(""),
        title: ""
      }
    });
    onClose === null || onClose === void 0 ? void 0 : onClose();
  };
  const applyLocalFilters = () => {
    onFilterChange(localSearchParams);
    onClose === null || onClose === void 0 ? void 0 : onClose();
  };
  const handleChange = data => {
    setLocalSearchParams({
      ...localSearchParams,
      ...data
    });
  };
  const onStatusChange = (e, type) => {
    var _localSearchParams$ev;
    if (e.target.checked) handleChange({
      eventStatus: [...((localSearchParams === null || localSearchParams === void 0 ? void 0 : localSearchParams.eventStatus) || []), type]
    });else handleChange({
      eventStatus: localSearchParams === null || localSearchParams === void 0 ? void 0 : (_localSearchParams$ev = localSearchParams.eventStatus) === null || _localSearchParams$ev === void 0 ? void 0 : _localSearchParams$ev.filter(status => status !== type)
    });
  };
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "filter"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-label"
  }, t("ES_COMMON_FILTER_BY"), ":"), /*#__PURE__*/React.createElement("div", {
    className: "clearAll",
    onClick: clearAll
  }, t("ES_COMMON_CLEAR_ALL")), _type === "desktop" && /*#__PURE__*/React.createElement("span", {
    className: "clear-search",
    onClick: clearAll
  }, /*#__PURE__*/React.createElement(RefreshIcon, null)), _type === "mobile" && /*#__PURE__*/React.createElement("span", {
    onClick: onClose
  }, /*#__PURE__*/React.createElement(CloseSvg, null))), /*#__PURE__*/React.createElement("div", {
    className: "filter-label"
  }, `${t(`EVENTS_CATEGORY_LABEL`)}`), /*#__PURE__*/React.createElement(Dropdown, {
    option: data === null || data === void 0 ? void 0 : (_data$mseva = data.mseva) === null || _data$mseva === void 0 ? void 0 : _data$mseva.EventCategories,
    optionKey: "code",
    t: t,
    selected: localSearchParams === null || localSearchParams === void 0 ? void 0 : localSearchParams.eventCategory,
    select: val => handleChange({
      eventCategory: val
    })
  }), /*#__PURE__*/React.createElement(DateRange, {
    t: t,
    values: localSearchParams === null || localSearchParams === void 0 ? void 0 : localSearchParams.range,
    onFilterChange: handleChange,
    labelClass: "filter-label"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Status, {
    onAssignmentChange: onStatusChange,
    searchParams: localSearchParams
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SubmitBar, {
    style: {
      width: "100%"
    },
    onSubmit: () => applyLocalFilters(),
    label: t("ES_COMMON_APPLY")
  }))));
};

const GetCell = value => /*#__PURE__*/React$1.createElement("span", {
  className: ""
}, value);
const GetStatusCell = value => value === "Active" ? /*#__PURE__*/React$1.createElement("span", {
  className: "sla-cell-success"
}, value) : /*#__PURE__*/React$1.createElement("span", {
  className: "sla-cell-error"
}, value);
const DesktopInbox = ({
  isLoading,
  data,
  t,
  onSearch,
  parentRoute,
  title,
  iconName,
  links,
  globalSearch,
  searchFields,
  searchParams,
  onFilterChange,
  pageSizeLimit,
  totalRecords,
  currentPage,
  onNextPage,
  onPrevPage,
  onPageSizeChange
}) => {
  const columns = React$1.useMemo(() => {
    return [{
      Header: t("EVENTS_EVENT_NAME_LABEL"),
      accessor: "name",
      Cell: ({
        row
      }) => {
        return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement("span", {
          className: "link"
        }, /*#__PURE__*/React$1.createElement(Link, {
          to: `${parentRoute}/event/inbox/event-details/${row.original.id}`
        }, row.original["name"])));
      }
    }, {
      Header: t("EVENTS_EVENT_CATEGORY_LABEL"),
      accessor: row => {
        return GetCell(row !== null && row !== void 0 && row.eventCategory ? t(`MSEVA_EVENTCATEGORIES_${row === null || row === void 0 ? void 0 : row.eventCategory}`) : "");
      }
    }, {
      Header: t("EVENTS_START_DATE_LABEL"),
      accessor: row => {
        var _row$eventDetails, _row$eventDetails2;
        return row !== null && row !== void 0 && (_row$eventDetails = row.eventDetails) !== null && _row$eventDetails !== void 0 && _row$eventDetails.fromDate ? GetCell(format(new Date(row === null || row === void 0 ? void 0 : (_row$eventDetails2 = row.eventDetails) === null || _row$eventDetails2 === void 0 ? void 0 : _row$eventDetails2.fromDate), 'dd/MM/yyyy')) : "";
      }
    }, {
      Header: t("EVENTS_END_DATE_LABEL"),
      accessor: row => {
        var _row$eventDetails3, _row$eventDetails4;
        return row !== null && row !== void 0 && (_row$eventDetails3 = row.eventDetails) !== null && _row$eventDetails3 !== void 0 && _row$eventDetails3.toDate ? GetCell(format(new Date(row === null || row === void 0 ? void 0 : (_row$eventDetails4 = row.eventDetails) === null || _row$eventDetails4 === void 0 ? void 0 : _row$eventDetails4.toDate), "dd/MM/yyyy")) : "";
      }
    }, {
      Header: t("EVENTS_POSTEDBY_LABEL"),
      accessor: row => {
        var _row$user;
        return GetCell((row === null || row === void 0 ? void 0 : (_row$user = row.user) === null || _row$user === void 0 ? void 0 : _row$user.name) || "");
      }
    }, {
      Header: t("EVENTS_STATUS_LABEL"),
      accessor: row => GetStatusCell(t(row === null || row === void 0 ? void 0 : row.status))
    }];
  });
  let result;
  if (isLoading) {
    result = /*#__PURE__*/React$1.createElement(Loader, null);
  } else if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
    result = /*#__PURE__*/React$1.createElement(ApplicationTable, {
      t: t,
      data: data,
      columns: columns,
      globalSearch: globalSearch,
      onSearch: searchParams,
      pageSizeLimit: pageSizeLimit,
      totalRecords: totalRecords,
      currentPage: currentPage,
      onNextPage: onNextPage,
      onPrevPage: onPrevPage,
      onPageSizeChange: onPageSizeChange,
      getCellProps: cellInfo => {
        return {
          style: {
            minWidth: cellInfo.column.Header === t("ES_INBOX_APPLICATION_NO") ? "240px" : "",
            padding: "20px 18px",
            fontSize: "16px"
          }
        };
      }
    });
  }
  return /*#__PURE__*/React$1.createElement("div", {
    className: "inbox-container"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "filters-container"
  }, /*#__PURE__*/React$1.createElement(EventLink, {
    title: title,
    icon: iconName,
    links: links
  }), /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(Filter, {
    onFilterChange: onFilterChange,
    searchParams: searchParams
  }))), /*#__PURE__*/React$1.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React$1.createElement(Search, {
    t: t,
    onSearch: onSearch,
    type: "desktop",
    searchFields: searchFields,
    isInboxPage: true,
    searchParams: searchParams
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "result",
    style: {
      marginLeft: "24px",
      flex: 1
    }
  }, result)));
};

const ApplicationCard = ({
  searchFields,
  searchParams,
  onFilterChange,
  onSearch,
  t,
  data,
  serviceRequestIdKey
}) => {
  const [type, setType] = useState("");
  const [popup, setPopup] = useState(false);
  const [params, setParams] = useState(searchParams);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const history = useHistory();
  useEffect(() => {
    if (type) setPopup(true);
  }, [type]);
  const handlePopupClose = () => {
    setPopup(false);
    setParams(searchParams);
  };
  let result;
  if ((data === null || data === void 0 ? void 0 : data.length) === 0) {
    result = /*#__PURE__*/React$1.createElement(Card, {
      style: {
        marginTop: 20
      }
    }, t("ES_NO_EVENTS").split("\\n").map((text, index) => /*#__PURE__*/React$1.createElement("p", {
      key: index,
      style: {
        textAlign: "center"
      }
    }, text)));
  } else if (data && (data === null || data === void 0 ? void 0 : data.length) > 0) {
    result = /*#__PURE__*/React$1.createElement(DetailsCard, {
      data: data,
      linkPrefix: '/digit-ui/employee/engagement/event/inbox/event-details/',
      serviceRequestIdKey: serviceRequestIdKey
    });
  }
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement("div", {
    className: "searchBox"
  }, onSearch && /*#__PURE__*/React$1.createElement(SearchAction, {
    text: "SEARCH",
    handleActionClick: () => {
      setType("SEARCH");
      setPopup(true);
    }
  }), /*#__PURE__*/React$1.createElement(FilterAction, {
    text: "FILTER",
    handleActionClick: () => {
      setType("FILTER");
      setPopup(true);
    }
  })), result, popup && /*#__PURE__*/React$1.createElement(PopUp, null, type === "FILTER" && /*#__PURE__*/React$1.createElement("div", {
    className: "popup-module"
  }, /*#__PURE__*/React$1.createElement(Filter, {
    onFilterChange: onFilterChange,
    onClose: handlePopupClose,
    onSearch: onSearch,
    type: "mobile",
    searchParams: params
  })), type === "SEARCH" && /*#__PURE__*/React$1.createElement("div", {
    className: "popup-module"
  }, /*#__PURE__*/React$1.createElement(Search, {
    t: t,
    type: "mobile",
    onClose: handlePopupClose,
    onSearch: onSearch,
    searchParams: searchParams,
    searchFields: searchFields
  }))));
};

const GetStatusCell$1 = value => value === "Active" ? /*#__PURE__*/React$1.createElement("span", {
  className: "sla-cell-success"
}, value) : /*#__PURE__*/React$1.createElement("span", {
  className: "sla-cell-error"
}, value);
const MobileInbox = ({
  data,
  t,
  title,
  iconName,
  links,
  searchFields,
  searchParams,
  onFilterChange,
  onSearch,
  isLoading
}) => {
  const getData = () => {
    return data === null || data === void 0 ? void 0 : data.filter(event => {
      var _searchParams$eventSt, _searchParams$eventSt2, _event$name, _searchParams$eventNa, _searchParams$ulb, _searchParams$ulb2, _searchParams$eventCa, _searchParams$range, _event$eventDetails, _searchParams$range2, _searchParams$range3, _event$eventDetails2, _searchParams$range4;
      return ((searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$eventSt = searchParams.eventStatus) === null || _searchParams$eventSt === void 0 ? void 0 : _searchParams$eventSt.length) > 0 ? searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$eventSt2 = searchParams.eventStatus) === null || _searchParams$eventSt2 === void 0 ? void 0 : _searchParams$eventSt2.includes(event.status) : true) && (searchParams !== null && searchParams !== void 0 && searchParams.eventName ? (_event$name = event.name) === null || _event$name === void 0 ? void 0 : _event$name.toUpperCase().startsWith(searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$eventNa = searchParams.eventName) === null || _searchParams$eventNa === void 0 ? void 0 : _searchParams$eventNa.toUpperCase()) : true) && (searchParams !== null && searchParams !== void 0 && (_searchParams$ulb = searchParams.ulb) !== null && _searchParams$ulb !== void 0 && _searchParams$ulb.code ? event.tenantId === (searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$ulb2 = searchParams.ulb) === null || _searchParams$ulb2 === void 0 ? void 0 : _searchParams$ulb2.code) : true) && (searchParams !== null && searchParams !== void 0 && searchParams.eventCategory ? event.eventCategory === (searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$eventCa = searchParams.eventCategory) === null || _searchParams$eventCa === void 0 ? void 0 : _searchParams$eventCa.code) : true) && (isValid(searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$range = searchParams.range) === null || _searchParams$range === void 0 ? void 0 : _searchParams$range.startDate) ? ((_event$eventDetails = event.eventDetails) === null || _event$eventDetails === void 0 ? void 0 : _event$eventDetails.fromDate) >= new Date(searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$range2 = searchParams.range) === null || _searchParams$range2 === void 0 ? void 0 : _searchParams$range2.startDate).getTime() : true) && (isValid(searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$range3 = searchParams.range) === null || _searchParams$range3 === void 0 ? void 0 : _searchParams$range3.endDate) ? ((_event$eventDetails2 = event.eventDetails) === null || _event$eventDetails2 === void 0 ? void 0 : _event$eventDetails2.toDate) <= new Date(searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$range4 = searchParams.range) === null || _searchParams$range4 === void 0 ? void 0 : _searchParams$range4.endDate).getTime() : true);
    }).map(event => {
      var _event$eventDetails3, _event$eventDetails4, _event$user;
      return {
        ["applicationNo"]: event === null || event === void 0 ? void 0 : event.id,
        [t("EVENTS_EVENT_NAME_LABEL")]: event === null || event === void 0 ? void 0 : event.name,
        [t("EVENTS_EVENT_CATEGORY_LABEL")]: t(`MSEVA_EVENTCATEGORIES_${event === null || event === void 0 ? void 0 : event.eventCategory}`),
        [t("EVENTS_START_DATE_LABEL")]: format(new Date(event === null || event === void 0 ? void 0 : (_event$eventDetails3 = event.eventDetails) === null || _event$eventDetails3 === void 0 ? void 0 : _event$eventDetails3.fromDate), 'dd/MM/yyyy'),
        [t("EVENTS_END_DATE_LABEL")]: format(new Date(event === null || event === void 0 ? void 0 : (_event$eventDetails4 = event.eventDetails) === null || _event$eventDetails4 === void 0 ? void 0 : _event$eventDetails4.toDate), 'dd/MM/yyyy'),
        [t("EVENTS_POSTEDBY_LABEL")]: event === null || event === void 0 ? void 0 : (_event$user = event.user) === null || _event$user === void 0 ? void 0 : _event$user.name,
        [t("EVENTS_STATUS_LABEL")]: GetStatusCell$1(t(event === null || event === void 0 ? void 0 : event.status))
      };
    });
  };
  return /*#__PURE__*/React$1.createElement("div", {
    style: {
      padding: 0
    }
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "inbox-container"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "filters-container"
  }, /*#__PURE__*/React$1.createElement(EventLink, {
    title: title,
    icon: iconName,
    links: links
  }), /*#__PURE__*/React$1.createElement(ApplicationCard, {
    t: t,
    data: getData(),
    onFilterChange: onFilterChange,
    isLoading: isLoading,
    onSearch: onSearch,
    searchParams: searchParams,
    searchFields: searchFields,
    serviceRequestIdKey: "applicationNo"
  }))));
};

const Inbox = ({
  tenants,
  parentRoute
}) => {
  var _searchParams$ulb;
  const {
    t
  } = useTranslation();
  Digit.SessionStorage.set("ENGAGEMENT_TENANTS", tenants);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [pageSize, setPageSize] = useState(10);
  const [pageOffset, setPageOffset] = useState(0);
  const [searchParams, setSearchParams] = useState({
    eventStatus: [],
    range: {
      startDate: null,
      endDate: new Date(""),
      title: ""
    },
    ulb: tenants === null || tenants === void 0 ? void 0 : tenants.find(tenant => (tenant === null || tenant === void 0 ? void 0 : tenant.code) === tenantId)
  });
  let isMobile = window.Digit.Utils.browser.isMobile();
  const getSearchFields = () => {
    return [{
      label: t("EVENTS_ULB_LABEL"),
      name: "ulb",
      type: "ulb"
    }, {
      label: t("EVENTS_NAME_LABEL"),
      name: "eventName"
    }];
  };
  const links = [{
    text: t("ES_TITLE_NEW_EVENTS"),
    link: "/digit-ui/employee/engagement/event/inbox/new-event"
  }];
  const {
    data,
    isLoading
  } = Digit.Hooks.events.useInbox(searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$ulb = searchParams.ulb) === null || _searchParams$ulb === void 0 ? void 0 : _searchParams$ulb.code, {}, {
    eventTypes: "EVENTSONGROUND",
    limit: pageSize,
    offset: pageOffset
  }, {
    select: data => ({
      events: data === null || data === void 0 ? void 0 : data.events,
      totalCount: data === null || data === void 0 ? void 0 : data.totalCount
    })
  });
  const onSearch = params => {
    let updatedParams = {
      ...params
    };
    if (!(params !== null && params !== void 0 && params.ulb)) {
      updatedParams = {
        ...params,
        ulb: {
          code: tenantId
        }
      };
    }
    setSearchParams({
      ...searchParams,
      ...updatedParams
    });
  };
  const handleFilterChange = data => {
    setSearchParams({
      ...searchParams,
      ...data
    });
  };
  const globalSearch = (rows, columnIds) => {
    return rows === null || rows === void 0 ? void 0 : rows.filter(row => {
      var _searchParams$eventSt, _searchParams$eventSt2, _row$original, _row$original2, _row$original2$name, _searchParams$ulb2, _searchParams$ulb3, _searchParams$eventCa, _searchParams$range, _row$original$eventDe, _searchParams$range2, _searchParams$range3, _row$original$eventDe2, _searchParams$range4;
      return ((searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$eventSt = searchParams.eventStatus) === null || _searchParams$eventSt === void 0 ? void 0 : _searchParams$eventSt.length) > 0 ? searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$eventSt2 = searchParams.eventStatus) === null || _searchParams$eventSt2 === void 0 ? void 0 : _searchParams$eventSt2.includes((_row$original = row.original) === null || _row$original === void 0 ? void 0 : _row$original.status) : true) && (searchParams !== null && searchParams !== void 0 && searchParams.eventName ? (_row$original2 = row.original) === null || _row$original2 === void 0 ? void 0 : (_row$original2$name = _row$original2.name) === null || _row$original2$name === void 0 ? void 0 : _row$original2$name.toUpperCase().startsWith(searchParams === null || searchParams === void 0 ? void 0 : searchParams.eventName.toUpperCase()) : true) && (searchParams !== null && searchParams !== void 0 && (_searchParams$ulb2 = searchParams.ulb) !== null && _searchParams$ulb2 !== void 0 && _searchParams$ulb2.code ? row.original.tenantId === (searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$ulb3 = searchParams.ulb) === null || _searchParams$ulb3 === void 0 ? void 0 : _searchParams$ulb3.code) : true) && (searchParams !== null && searchParams !== void 0 && searchParams.eventCategory ? row.original.eventCategory === (searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$eventCa = searchParams.eventCategory) === null || _searchParams$eventCa === void 0 ? void 0 : _searchParams$eventCa.code) : true) && (isValid(searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$range = searchParams.range) === null || _searchParams$range === void 0 ? void 0 : _searchParams$range.startDate) ? ((_row$original$eventDe = row.original.eventDetails) === null || _row$original$eventDe === void 0 ? void 0 : _row$original$eventDe.fromDate) >= new Date(searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$range2 = searchParams.range) === null || _searchParams$range2 === void 0 ? void 0 : _searchParams$range2.startDate).getTime() : true) && (isValid(searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$range3 = searchParams.range) === null || _searchParams$range3 === void 0 ? void 0 : _searchParams$range3.endDate) ? ((_row$original$eventDe2 = row.original.eventDetails) === null || _row$original$eventDe2 === void 0 ? void 0 : _row$original$eventDe2.toDate) <= new Date(searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$range4 = searchParams.range) === null || _searchParams$range4 === void 0 ? void 0 : _searchParams$range4.endDate).getTime() : true);
    });
  };
  const fetchNextPage = useCallback(() => {
    setPageOffset(prevPageOffSet => parseInt(prevPageOffSet) + parseInt(pageSize));
  }, [pageSize]);
  const fetchPrevPage = useCallback(() => {
    setPageOffset(prevPageOffSet => parseInt(prevPageOffSet) - parseInt(pageSize));
  }, [pageSize]);
  const handlePageSizeChange = e => {
    setPageSize(prevPageSize => e.target.value);
  };
  if (isMobile) {
    return /*#__PURE__*/React$1.createElement(MobileInbox, {
      data: data === null || data === void 0 ? void 0 : data.events,
      searchParams: searchParams,
      searchFields: getSearchFields(),
      t: t,
      onFilterChange: handleFilterChange,
      onSearch: onSearch,
      isLoading: isLoading,
      title: "EVENTS_EVENTS_HEADER",
      iconName: "calender",
      links: links
    });
  }
  return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(Header, null, t("EVENTS_EVENTS_HEADER"), Number(data === null || data === void 0 ? void 0 : data.totalCount) ? /*#__PURE__*/React$1.createElement("p", {
    className: "inbox-count"
  }, Number(data === null || data === void 0 ? void 0 : data.totalCount)) : null), /*#__PURE__*/React$1.createElement(DesktopInbox, {
    t: t,
    data: data === null || data === void 0 ? void 0 : data.events,
    links: links,
    parentRoute: parentRoute,
    searchParams: searchParams,
    onSearch: onSearch,
    globalSearch: globalSearch,
    searchFields: getSearchFields(),
    onFilterChange: handleFilterChange,
    pageSizeLimit: pageSize,
    totalRecords: data === null || data === void 0 ? void 0 : data.totalCount,
    title: "EVENTS_EVENTS_HEADER",
    iconName: "calender",
    links: links,
    currentPage: parseInt(pageOffset / pageSize),
    onNextPage: fetchNextPage,
    onPrevPage: fetchPrevPage,
    onPageSizeChange: handlePageSizeChange
  }));
};

const ApplicationTable$1 = ({
  t,
  data,
  columns,
  globalSearch,
  onSearch,
  getCellProps,
  pageSizeLimit,
  totalRecords,
  currentPage,
  onNextPage,
  onPrevPage,
  onPageSizeChange
}) => {
  return /*#__PURE__*/React$1.createElement(Table, {
    t: t,
    data: data,
    columns: columns,
    onSearch: onSearch,
    globalSearch: globalSearch,
    manualGlobalFilter: true,
    manualPagination: true,
    pageSizeLimit: pageSizeLimit,
    getCellProps: getCellProps,
    totalRecords: totalRecords,
    currentPage: currentPage,
    onNextPage: onNextPage,
    onPrevPage: onPrevPage,
    onPageSizeChange: onPageSizeChange
  });
};

const DropdownUlb$1 = ({
  ulb,
  onAssignmentChange,
  value,
  t
}) => {
  return /*#__PURE__*/React$1.createElement(Dropdown, {
    option: ulb,
    optionKey: "code",
    selected: value,
    select: onAssignmentChange,
    t: t
  });
};

const Search$1 = ({
  onSearch,
  searchParams,
  searchFields,
  type,
  onClose,
  isInboxPage,
  t
}) => {
  const {
    register,
    handleSubmit,
    formState,
    reset,
    watch,
    control
  } = useForm({
    defaultValues: searchParams
  });
  const mobileView = innerWidth <= 640;
  const ulbs = Digit.SessionStorage.get("ENGAGEMENT_TENANTS");
  const userInfo = Digit.UserService.getUser().info;
  const userUlbs = ulbs.filter(ulb => {
    var _userInfo$roles;
    return userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$roles = userInfo.roles) === null || _userInfo$roles === void 0 ? void 0 : _userInfo$roles.some(role => (role === null || role === void 0 ? void 0 : role.tenantId) === (ulb === null || ulb === void 0 ? void 0 : ulb.code));
  }).sort(alphabeticalSortFunctionForTenantsBasedOnName);
  const getFields = input => {
    switch (input.type) {
      case "ulb":
        return /*#__PURE__*/React$1.createElement(Controller, {
          rules: {
            required: true
          },
          render: props => /*#__PURE__*/React$1.createElement(DropdownUlb$1, {
            onAssignmentChange: props.onChange,
            value: props.value,
            ulb: userUlbs,
            t: t
          }),
          name: input.name,
          control: control,
          defaultValue: null
        });
      case "range":
        return /*#__PURE__*/React$1.createElement(Controller, {
          render: ({
            value,
            onChange
          }) => {
            return /*#__PURE__*/React$1.createElement(DateRange, {
              t: t,
              values: value,
              onFilterChange: value => onChange(value.range),
              labelClass: "filter-label"
            });
          },
          name: input.name,
          control: control,
          defaultValue: null
        });
      default:
        return /*#__PURE__*/React$1.createElement(Controller, {
          render: props => /*#__PURE__*/React$1.createElement(TextInput, {
            onChange: props.onChange,
            value: props.value
          }),
          name: input.name,
          control: control,
          defaultValue: null
        });
    }
  };
  const onSubmitInput = data => {
    onSearch(data);
    if (type === "mobile") {
      onClose();
    }
  };
  const clearSearch = () => {
    reset({
      ulb: null,
      name: ''
    });
    onSearch({
      ulb: null,
      name: ''
    });
  };
  const clearAll = mobileView => {
    const mobileViewStyles = mobileView ? {
      margin: 0
    } : {};
    return /*#__PURE__*/React$1.createElement(LinkLabel, {
      style: {
        display: "inline",
        ...mobileViewStyles
      },
      onClick: clearSearch
    }, t("ES_COMMON_CLEAR_SEARCH"));
  };
  return /*#__PURE__*/React$1.createElement("form", {
    onSubmit: handleSubmit(onSubmitInput)
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "search-container",
    style: {
      width: "auto",
      marginLeft: isInboxPage ? "24px" : "revert"
    }
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "search-complaint-container"
  }, (type === "mobile" || mobileView) && /*#__PURE__*/React$1.createElement("div", {
    className: "complaint-header"
  }, /*#__PURE__*/React$1.createElement("h2", null, t("ES_COMMON_SEARCH_BY")), /*#__PURE__*/React$1.createElement("span", {
    onClick: onClose
  }, /*#__PURE__*/React$1.createElement(CloseSvg, null))), /*#__PURE__*/React$1.createElement("div", {
    className: "complaint-input-container for-pt " + (!isInboxPage ? "for-search" : ""),
    style: {
      width: "100%"
    }
  }, searchFields === null || searchFields === void 0 ? void 0 : searchFields.map((input, index) => {
    var _formState$dirtyField, _formState$errors, _formState$errors$inp;
    return /*#__PURE__*/React$1.createElement("div", {
      key: input.name,
      className: "input-fields"
    }, /*#__PURE__*/React$1.createElement("span", {
      className: "mobile-input"
    }, /*#__PURE__*/React$1.createElement(Label, null, t(input.label) + ` ${input.isMendatory ? "*" : ""}`), getFields(input)), formState !== null && formState !== void 0 && (_formState$dirtyField = formState.dirtyFields) !== null && _formState$dirtyField !== void 0 && _formState$dirtyField[input.name] ? /*#__PURE__*/React$1.createElement("span", {
      style: {
        fontWeight: "700",
        color: "rgba(212, 53, 28)",
        paddingLeft: "8px",
        marginTop: "-20px",
        fontSize: "12px"
      },
      className: "inbox-search-form-error"
    }, formState === null || formState === void 0 ? void 0 : (_formState$errors = formState.errors) === null || _formState$errors === void 0 ? void 0 : (_formState$errors$inp = _formState$errors[input.name]) === null || _formState$errors$inp === void 0 ? void 0 : _formState$errors$inp.message) : null);
  }), type === "desktop" && !mobileView && /*#__PURE__*/React$1.createElement("div", {
    style: {
      maxWidth: "unset",
      marginLeft: "unset",
      marginTop: "55px"
    },
    className: "search-submit-wrapper"
  }, /*#__PURE__*/React$1.createElement(SubmitBar, {
    className: "submit-bar-search",
    label: t("ES_COMMON_SEARCH"),
    submit: true
  }), /*#__PURE__*/React$1.createElement("div", null, clearAll()))))), (type === "mobile" || mobileView) && /*#__PURE__*/React$1.createElement(ActionBar, {
    className: "clear-search-container"
  }, /*#__PURE__*/React$1.createElement("button", {
    className: "clear-search",
    style: {
      flex: 1
    }
  }, clearAll(mobileView)), /*#__PURE__*/React$1.createElement(SubmitBar, {
    disabled: !!Object.keys(formState.errors).length,
    label: t("ES_COMMON_SEARCH"),
    style: {
      flex: 1
    },
    submit: true
  })));
};

const EventLink$1 = ({
  title: _title = "CS_HEADER_PUBLIC_BRDCST",
  links,
  icon: _icon = 'calender'
}) => {
  const {
    t
  } = useTranslation();
  const GetLogo = () => /*#__PURE__*/React$1.createElement("div", {
    className: "header",
    style: {
      justifyContent: "flex-start"
    }
  }, /*#__PURE__*/React$1.createElement("span", {
    className: "logo",
    style: {
      backgroundColor: "#fff"
    }
  }, /*#__PURE__*/React$1.createElement(PMBIcon, null)), " ", /*#__PURE__*/React$1.createElement("span", {
    className: "text"
  }, t(_title)));
  return /*#__PURE__*/React$1.createElement(Card, {
    className: "employeeCard filter inboxLinks"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "complaint-links-container"
  }, GetLogo(), /*#__PURE__*/React$1.createElement("div", {
    className: "body"
  }, links.map(({
    link,
    text,
    hyperlink: _hyperlink = false,
    accessTo: _accessTo = []
  }, index) => {
    return /*#__PURE__*/React$1.createElement("span", {
      className: "link",
      key: index
    }, _hyperlink ? /*#__PURE__*/React$1.createElement("a", {
      href: link
    }, text) : /*#__PURE__*/React$1.createElement(Link, {
      to: link
    }, text));
  }))));
};

const StatusCount$1 = ({
  status,
  onAssignmentChange,
  searchParams
}) => {
  var _searchParams$eventSt, _searchParams$eventSt2;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement(CheckBox, {
    onChange: e => onAssignmentChange(e, status),
    checked: (searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$eventSt = searchParams.eventStatus) === null || _searchParams$eventSt === void 0 ? void 0 : (_searchParams$eventSt2 = _searchParams$eventSt.filter(event => event === status)) === null || _searchParams$eventSt2 === void 0 ? void 0 : _searchParams$eventSt2.length) > 0 ? true : false,
    label: t(status),
    pageType: 'employee'
  });
};

const statuses$1 = ["ACTIVE", "INACTIVE"];
const Status$1 = ({
  onAssignmentChange,
  searchParams
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement("div", {
    className: "status-container"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "filter-label"
  }, t("ES_INBOX_STATUS")), statuses$1 === null || statuses$1 === void 0 ? void 0 : statuses$1.map((status, key) => /*#__PURE__*/React$1.createElement(StatusCount$1, {
    key: key,
    status: status,
    onAssignmentChange: onAssignmentChange,
    searchParams: searchParams
  })));
};

const Filter$1 = ({
  type: _type = "desktop",
  onClose,
  onSearch,
  onFilterChange,
  searchParams
}) => {
  const {
    t
  } = useTranslation();
  const [localSearchParams, setLocalSearchParams] = useState(() => ({
    ...searchParams
  }));
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const state = tenantId === null || tenantId === void 0 ? void 0 : tenantId.split(".")[0];
  const {
    isLoading,
    data
  } = Digit.Hooks.useCommonMDMS(state, "mseva", ["EventCategories"]);
  const clearAll = () => {
    setLocalSearchParams({
      eventCategory: null,
      eventStatus: [],
      range: {
        startDate: null,
        endDate: new Date(""),
        title: ""
      }
    });
    onFilterChange({
      eventCategory: null,
      eventStatus: [],
      range: {
        startDate: null,
        endDate: new Date(""),
        title: ""
      }
    });
    onClose === null || onClose === void 0 ? void 0 : onClose();
  };
  const applyLocalFilters = () => {
    onFilterChange(localSearchParams);
    onClose === null || onClose === void 0 ? void 0 : onClose();
  };
  const handleChange = useCallback(data => {
    setLocalSearchParams(prevLocalSearchParams => ({
      ...prevLocalSearchParams,
      ...data
    }));
  }, []);
  const onStatusChange = (e, type) => {
    var _localSearchParams$ev;
    if (e.target.checked) handleChange({
      eventStatus: [...((localSearchParams === null || localSearchParams === void 0 ? void 0 : localSearchParams.eventStatus) || []), type]
    });else handleChange({
      eventStatus: localSearchParams === null || localSearchParams === void 0 ? void 0 : (_localSearchParams$ev = localSearchParams.eventStatus) === null || _localSearchParams$ev === void 0 ? void 0 : _localSearchParams$ev.filter(status => status !== type)
    });
  };
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "filter"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-label"
  }, t("ES_COMMON_FILTER_BY"), ":"), /*#__PURE__*/React.createElement("div", {
    className: "clearAll",
    onClick: clearAll
  }, t("ES_COMMON_CLEAR_ALL")), _type === "desktop" && /*#__PURE__*/React.createElement("span", {
    className: "clear-search",
    onClick: clearAll
  }, /*#__PURE__*/React.createElement(RefreshIcon, null)), _type === "mobile" && /*#__PURE__*/React.createElement("span", {
    onClick: onClose
  }, /*#__PURE__*/React.createElement(CloseSvg, null))), /*#__PURE__*/React.createElement(DateRange, {
    t: t,
    values: localSearchParams === null || localSearchParams === void 0 ? void 0 : localSearchParams.range,
    onFilterChange: handleChange,
    labelClass: "filter-label"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Status$1, {
    onAssignmentChange: onStatusChange,
    searchParams: localSearchParams
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SubmitBar, {
    style: {
      width: "100%"
    },
    onSubmit: () => applyLocalFilters(),
    label: t("ES_COMMON_APPLY")
  }))));
};

const GetCell$1 = value => /*#__PURE__*/React$1.createElement("span", {
  className: ""
}, value);
const GetStatusCell$2 = value => value === "Active" ? /*#__PURE__*/React$1.createElement("span", {
  className: "sla-cell-success"
}, value) : /*#__PURE__*/React$1.createElement("span", {
  className: "sla-cell-error"
}, value);
const DesktopInbox$1 = ({
  isLoading,
  data,
  t,
  onSearch,
  parentRoute,
  title,
  iconName,
  links,
  globalSearch,
  searchFields,
  searchParams,
  onFilterChange,
  pageSizeLimit,
  totalRecords,
  currentPage,
  onNextPage,
  onPrevPage,
  onPageSizeChange
}) => {
  const columns = React$1.useMemo(() => {
    return [{
      Header: t("EVENTS_MESSAGE_LABEL"),
      accessor: "name",
      Cell: ({
        row
      }) => {
        return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement("span", {
          className: "link"
        }, /*#__PURE__*/React$1.createElement(Link, {
          to: `${parentRoute}/messages/inbox/details/${row.original.id}`
        }, row.original["name"])));
      }
    }, {
      Header: t("EVENTS_POSTING_DATE_LABEL"),
      accessor: row => {
        var _row$auditDetails, _row$auditDetails2;
        return row !== null && row !== void 0 && (_row$auditDetails = row.auditDetails) !== null && _row$auditDetails !== void 0 && _row$auditDetails.createdTime ? GetCell$1(format(new Date(row === null || row === void 0 ? void 0 : (_row$auditDetails2 = row.auditDetails) === null || _row$auditDetails2 === void 0 ? void 0 : _row$auditDetails2.createdTime), 'dd/MM/yyyy')) : "";
      }
    }, {
      Header: t("EVENTS_START_DATE_LABEL"),
      accessor: row => {
        var _row$eventDetails, _row$eventDetails2;
        return row !== null && row !== void 0 && (_row$eventDetails = row.eventDetails) !== null && _row$eventDetails !== void 0 && _row$eventDetails.fromDate ? GetCell$1(format(new Date(row === null || row === void 0 ? void 0 : (_row$eventDetails2 = row.eventDetails) === null || _row$eventDetails2 === void 0 ? void 0 : _row$eventDetails2.fromDate), 'dd/MM/yyyy')) : "";
      }
    }, {
      Header: t("EVENTS_END_DATE_LABEL"),
      accessor: row => {
        var _row$eventDetails3, _row$eventDetails4;
        return row !== null && row !== void 0 && (_row$eventDetails3 = row.eventDetails) !== null && _row$eventDetails3 !== void 0 && _row$eventDetails3.toDate ? GetCell$1(format(new Date(row === null || row === void 0 ? void 0 : (_row$eventDetails4 = row.eventDetails) === null || _row$eventDetails4 === void 0 ? void 0 : _row$eventDetails4.toDate), "dd/MM/yyyy")) : "";
      }
    }, {
      Header: t("EVENTS_POSTEDBY_LABEL"),
      accessor: row => {
        var _row$user;
        return GetCell$1((row === null || row === void 0 ? void 0 : (_row$user = row.user) === null || _row$user === void 0 ? void 0 : _row$user.name) || "");
      }
    }, {
      Header: t("EVENTS_STATUS_LABEL"),
      accessor: row => GetStatusCell$2(t(row === null || row === void 0 ? void 0 : row.status))
    }];
  });
  let result;
  if (isLoading) {
    result = /*#__PURE__*/React$1.createElement(Loader, null);
  } else if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
    result = /*#__PURE__*/React$1.createElement(ApplicationTable$1, {
      t: t,
      data: data,
      columns: columns,
      globalSearch: globalSearch,
      onSearch: searchParams,
      pageSizeLimit: pageSizeLimit,
      totalRecords: totalRecords,
      currentPage: currentPage,
      onNextPage: onNextPage,
      onPrevPage: onPrevPage,
      onPageSizeChange: onPageSizeChange,
      getCellProps: cellInfo => {
        return {
          style: {
            minWidth: cellInfo.column.Header === t("ES_INBOX_APPLICATION_NO") ? "240px" : "",
            padding: "20px 18px",
            fontSize: "16px"
          }
        };
      }
    });
  }
  return /*#__PURE__*/React$1.createElement("div", {
    className: "inbox-container"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "filters-container"
  }, /*#__PURE__*/React$1.createElement(EventLink$1, {
    title: title,
    icon: iconName,
    links: links
  }), /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(Filter$1, {
    onFilterChange: onFilterChange,
    searchParams: searchParams
  }))), /*#__PURE__*/React$1.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React$1.createElement(Search$1, {
    t: t,
    onSearch: onSearch,
    type: "desktop",
    searchFields: searchFields,
    isInboxPage: true,
    searchParams: searchParams
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "result",
    style: {
      marginLeft: "24px",
      flex: 1
    }
  }, result)));
};

const ApplicationCard$1 = ({
  searchFields,
  searchParams,
  onFilterChange,
  onSearch,
  t,
  data,
  responseData
}) => {
  const [type, setType] = useState("");
  const [popup, setPopup] = useState(false);
  const [params, setParams] = useState(searchParams);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const history = useHistory();
  useEffect(() => {
    if (type) setPopup(true);
  }, [type]);
  const handlePopupClose = () => {
    setPopup(false);
    setParams(searchParams);
  };
  const redirectToDetailsPage = data => {
    const details = responseData === null || responseData === void 0 ? void 0 : responseData.find(item => {
      var _item$user;
      return areEqual(item === null || item === void 0 ? void 0 : (_item$user = item.user) === null || _item$user === void 0 ? void 0 : _item$user.name, data["Posted By"]) && areEqual(item.name, data["Title"]);
    });
    if (details) {
      history.push(`/digit-ui/employee/engagement/messages/inbox/details/${details === null || details === void 0 ? void 0 : details.id}`);
    }
  };
  let result;
  if ((data === null || data === void 0 ? void 0 : data.length) === 0) {
    result = /*#__PURE__*/React$1.createElement(Card, {
      style: {
        marginTop: 20
      }
    }, t("ES_NO_PUBLIC_MESSAGES").split("\\n").map((text, index) => /*#__PURE__*/React$1.createElement("p", {
      key: index,
      style: {
        textAlign: "center"
      }
    }, text)));
  } else if (data && (data === null || data === void 0 ? void 0 : data.length) > 0) {
    result = /*#__PURE__*/React$1.createElement(DetailsCard, {
      data: data,
      handleSelect: () => {},
      handleDetailCardClick: redirectToDetailsPage
    });
  }
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement("div", {
    className: "searchBox"
  }, onSearch && /*#__PURE__*/React$1.createElement(SearchAction, {
    text: "SEARCH",
    handleActionClick: () => {
      setType("SEARCH");
      setPopup(true);
    }
  }), /*#__PURE__*/React$1.createElement(FilterAction, {
    text: "FILTER",
    handleActionClick: () => {
      setType("FILTER");
      setPopup(true);
    }
  })), result, popup && /*#__PURE__*/React$1.createElement(PopUp, null, type === "FILTER" && /*#__PURE__*/React$1.createElement("div", {
    className: "popup-module"
  }, /*#__PURE__*/React$1.createElement(Filter$1, {
    onFilterChange: onFilterChange,
    onClose: handlePopupClose,
    onSearch: onSearch,
    type: "mobile",
    searchParams: params
  })), type === "SEARCH" && /*#__PURE__*/React$1.createElement("div", {
    className: "popup-module"
  }, /*#__PURE__*/React$1.createElement(Search$1, {
    t: t,
    type: "mobile",
    onClose: handlePopupClose,
    onSearch: onSearch,
    searchParams: searchParams,
    searchFields: searchFields
  }))));
};

const GetStatusCell$3 = value => value === "Active" ? /*#__PURE__*/React$1.createElement("span", {
  className: "sla-cell-success"
}, value) : /*#__PURE__*/React$1.createElement("span", {
  className: "sla-cell-error"
}, value);
const MobileInbox$1 = ({
  data,
  t,
  title,
  iconName,
  links,
  searchFields,
  searchParams,
  onFilterChange,
  onSearch,
  isLoading
}) => {
  const getData = () => {
    return data === null || data === void 0 ? void 0 : data.filter(event => {
      var _searchParams$eventSt, _searchParams$eventSt2, _event$name, _searchParams$eventNa, _searchParams$ulb, _searchParams$ulb2, _searchParams$eventCa, _searchParams$range, _event$eventDetails, _searchParams$range2, _searchParams$range3, _event$eventDetails2, _searchParams$range4;
      return ((searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$eventSt = searchParams.eventStatus) === null || _searchParams$eventSt === void 0 ? void 0 : _searchParams$eventSt.length) > 0 ? searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$eventSt2 = searchParams.eventStatus) === null || _searchParams$eventSt2 === void 0 ? void 0 : _searchParams$eventSt2.includes(event.status) : true) && (searchParams !== null && searchParams !== void 0 && searchParams.eventName ? (_event$name = event.name) === null || _event$name === void 0 ? void 0 : _event$name.toUpperCase().startsWith(searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$eventNa = searchParams.eventName) === null || _searchParams$eventNa === void 0 ? void 0 : _searchParams$eventNa.toUpperCase()) : true) && (searchParams !== null && searchParams !== void 0 && (_searchParams$ulb = searchParams.ulb) !== null && _searchParams$ulb !== void 0 && _searchParams$ulb.code ? event.tenantId === (searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$ulb2 = searchParams.ulb) === null || _searchParams$ulb2 === void 0 ? void 0 : _searchParams$ulb2.code) : true) && (searchParams !== null && searchParams !== void 0 && searchParams.eventCategory ? event.eventCategory === (searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$eventCa = searchParams.eventCategory) === null || _searchParams$eventCa === void 0 ? void 0 : _searchParams$eventCa.code) : true) && (isValid(searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$range = searchParams.range) === null || _searchParams$range === void 0 ? void 0 : _searchParams$range.startDate) ? ((_event$eventDetails = event.eventDetails) === null || _event$eventDetails === void 0 ? void 0 : _event$eventDetails.fromDate) >= new Date(searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$range2 = searchParams.range) === null || _searchParams$range2 === void 0 ? void 0 : _searchParams$range2.startDate).getTime() : true) && (isValid(searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$range3 = searchParams.range) === null || _searchParams$range3 === void 0 ? void 0 : _searchParams$range3.endDate) ? ((_event$eventDetails2 = event.eventDetails) === null || _event$eventDetails2 === void 0 ? void 0 : _event$eventDetails2.toDate) <= new Date(searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$range4 = searchParams.range) === null || _searchParams$range4 === void 0 ? void 0 : _searchParams$range4.endDate).getTime() : true);
    }).map(event => {
      var _event$auditDetails, _event$eventDetails3, _event$eventDetails4, _event$user;
      return {
        [t("PUBLIC_BRDCST_TITLE_LABEL")]: event === null || event === void 0 ? void 0 : event.name,
        [t("EVENTS_POSTING_DATE_LABEL")]: format(new Date(event === null || event === void 0 ? void 0 : (_event$auditDetails = event.auditDetails) === null || _event$auditDetails === void 0 ? void 0 : _event$auditDetails.createdTime), 'dd/MM/yyyy'),
        [t("EVENTS_START_DATE_LABEL")]: format(new Date(event === null || event === void 0 ? void 0 : (_event$eventDetails3 = event.eventDetails) === null || _event$eventDetails3 === void 0 ? void 0 : _event$eventDetails3.fromDate), 'dd/MM/yyyy'),
        [t("EVENTS_END_DATE_LABEL")]: format(new Date(event === null || event === void 0 ? void 0 : (_event$eventDetails4 = event.eventDetails) === null || _event$eventDetails4 === void 0 ? void 0 : _event$eventDetails4.toDate), 'dd/MM/yyyy'),
        [t("EVENTS_POSTEDBY_LABEL")]: event === null || event === void 0 ? void 0 : (_event$user = event.user) === null || _event$user === void 0 ? void 0 : _event$user.name,
        [t("EVENTS_STATUS_LABEL")]: GetStatusCell$3(t(event === null || event === void 0 ? void 0 : event.status))
      };
    });
  };
  return /*#__PURE__*/React$1.createElement("div", {
    style: {
      padding: 0
    }
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "inbox-container"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "filters-container"
  }, /*#__PURE__*/React$1.createElement(EventLink$1, {
    title: title,
    icon: iconName,
    links: links
  }), /*#__PURE__*/React$1.createElement(ApplicationCard$1, {
    t: t,
    data: getData(),
    onFilterChange: onFilterChange,
    isLoading: isLoading,
    onSearch: onSearch,
    searchParams: searchParams,
    searchFields: searchFields,
    responseData: data
  }))));
};

const Inbox$1 = ({
  tenants,
  parentRoute
}) => {
  var _searchParams$ulb;
  const {
    t
  } = useTranslation();
  Digit.SessionStorage.set("ENGAGEMENT_TENANTS", tenants);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [pageSize, setPageSize] = useState(10);
  const [pageOffset, setPageOffset] = useState(0);
  const [searchParams, setSearchParams] = useState({
    eventStatus: [],
    name: '',
    range: {
      startDate: null,
      endDate: new Date(""),
      title: ""
    },
    ulb: tenants === null || tenants === void 0 ? void 0 : tenants.find(tenant => (tenant === null || tenant === void 0 ? void 0 : tenant.code) === tenantId)
  });
  let isMobile = window.Digit.Utils.browser.isMobile();
  const {
    data,
    isLoading
  } = Digit.Hooks.events.useInbox(searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$ulb = searchParams.ulb) === null || _searchParams$ulb === void 0 ? void 0 : _searchParams$ulb.code, {}, {
    status: "ACTIVE,INACTIVE",
    eventTypes: "BROADCAST",
    limit: pageSize,
    offset: pageOffset
  }, {
    select: data => ({
      events: data === null || data === void 0 ? void 0 : data.events,
      totalCount: data === null || data === void 0 ? void 0 : data.totalCount
    })
  });
  const onSearch = params => {
    let updatedParams = {
      ...params
    };
    if (!(params !== null && params !== void 0 && params.ulb)) {
      updatedParams = {
        ...params,
        ulb: {
          code: tenantId
        }
      };
    }
    setSearchParams(prevParams => ({
      ...prevParams,
      ...updatedParams
    }));
  };
  const handleFilterChange = data => {
    setSearchParams(prevParams => ({
      ...prevParams,
      ...data
    }));
  };
  const globalSearch = (rows, columnIds) => {
    return rows === null || rows === void 0 ? void 0 : rows.filter(row => {
      var _searchParams$eventSt, _searchParams$eventSt2, _row$original, _row$original2, _row$original2$name, _searchParams$ulb2, _searchParams$ulb3, _searchParams$eventCa, _searchParams$range, _row$original$eventDe, _searchParams$range2, _searchParams$range3, _row$original$eventDe2, _searchParams$range4;
      return ((searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$eventSt = searchParams.eventStatus) === null || _searchParams$eventSt === void 0 ? void 0 : _searchParams$eventSt.length) > 0 ? searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$eventSt2 = searchParams.eventStatus) === null || _searchParams$eventSt2 === void 0 ? void 0 : _searchParams$eventSt2.includes((_row$original = row.original) === null || _row$original === void 0 ? void 0 : _row$original.status) : true) && (searchParams !== null && searchParams !== void 0 && searchParams.name ? (_row$original2 = row.original) === null || _row$original2 === void 0 ? void 0 : (_row$original2$name = _row$original2.name) === null || _row$original2$name === void 0 ? void 0 : _row$original2$name.toUpperCase().startsWith(searchParams === null || searchParams === void 0 ? void 0 : searchParams.name.toUpperCase()) : true) && (searchParams !== null && searchParams !== void 0 && (_searchParams$ulb2 = searchParams.ulb) !== null && _searchParams$ulb2 !== void 0 && _searchParams$ulb2.code ? row.original.tenantId === (searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$ulb3 = searchParams.ulb) === null || _searchParams$ulb3 === void 0 ? void 0 : _searchParams$ulb3.code) : true) && (searchParams !== null && searchParams !== void 0 && searchParams.eventCategory ? row.original.eventCategory === (searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$eventCa = searchParams.eventCategory) === null || _searchParams$eventCa === void 0 ? void 0 : _searchParams$eventCa.code) : true) && (isValid(searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$range = searchParams.range) === null || _searchParams$range === void 0 ? void 0 : _searchParams$range.startDate) ? ((_row$original$eventDe = row.original.eventDetails) === null || _row$original$eventDe === void 0 ? void 0 : _row$original$eventDe.fromDate) >= new Date(searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$range2 = searchParams.range) === null || _searchParams$range2 === void 0 ? void 0 : _searchParams$range2.startDate).getTime() : true) && (isValid(searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$range3 = searchParams.range) === null || _searchParams$range3 === void 0 ? void 0 : _searchParams$range3.endDate) ? ((_row$original$eventDe2 = row.original.eventDetails) === null || _row$original$eventDe2 === void 0 ? void 0 : _row$original$eventDe2.toDate) <= new Date(searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$range4 = searchParams.range) === null || _searchParams$range4 === void 0 ? void 0 : _searchParams$range4.endDate).getTime() : true);
    });
  };
  const getSearchFields = () => {
    return [{
      label: t("EVENTS_ULB_LABEL"),
      name: "ulb",
      type: "ulb"
    }, {
      label: t("EVENTS_MESSAGE_LABEL"),
      name: "name"
    }];
  };
  const links = [{
    text: t("NEW_PUBLIC_MESSAGE_BUTTON_LABEL"),
    link: "/digit-ui/employee/engagement/messages/inbox/create"
  }];
  const fetchNextPage = useCallback(() => {
    setPageOffset(prevPageOffSet => parseInt(prevPageOffSet) + parseInt(pageSize));
  }, [pageSize]);
  const fetchPrevPage = useCallback(() => {
    setPageOffset(prevPageOffSet => parseInt(prevPageOffSet) - parseInt(pageSize));
  }, [pageSize]);
  const handlePageSizeChange = e => {
    setPageSize(prevPageSize => e.target.value);
  };
  if (isMobile) {
    return /*#__PURE__*/React$1.createElement(MobileInbox$1, {
      data: data === null || data === void 0 ? void 0 : data.events,
      searchParams: searchParams,
      searchFields: getSearchFields(),
      t: t,
      onFilterChange: handleFilterChange,
      onSearch: onSearch,
      isLoading: isLoading,
      title: "EVENTS_PUBLIC_MESSAGE_NOTICE_HEADER",
      iconName: "calender",
      links: links
    });
  }
  return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(Header, null, t("EVENTS_PUBLIC_MESSAGE_NOTICE_HEADER"), Number(data === null || data === void 0 ? void 0 : data.length) ? /*#__PURE__*/React$1.createElement("p", {
    className: "inbox-count"
  }, Number(data === null || data === void 0 ? void 0 : data.length)) : null), /*#__PURE__*/React$1.createElement(DesktopInbox$1, {
    t: t,
    data: data === null || data === void 0 ? void 0 : data.events,
    links: links,
    parentRoute: parentRoute,
    searchParams: searchParams,
    onSearch: onSearch,
    globalSearch: globalSearch,
    searchFields: getSearchFields(),
    onFilterChange: handleFilterChange,
    pageSizeLimit: pageSize,
    totalRecords: data === null || data === void 0 ? void 0 : data.totalCount,
    currentPage: parseInt(pageOffset / pageSize),
    onNextPage: fetchNextPage,
    onPrevPage: fetchPrevPage,
    onPageSizeChange: handlePageSizeChange,
    title: "EVENTS_PUBLIC_MESSAGE_NOTICE_HEADER",
    links: links,
    isLoading: isLoading
  }));
};

const config$1 = [{
  head: "",
  body: [{
    type: "form",
    withoutLabel: true,
    component: "MessageForm",
    nextStep: "",
    route: "",
    key: "messageData"
  }]
}];

const NewEvents$1 = () => {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [mutationHappened, setMutationHappened, clear] = Digit.Hooks.useSessionStorage("EMPLOYEE_MSG_MUTATION_HAPPENED", false);
  const [errorInfo, setErrorInfo, clearError] = Digit.Hooks.useSessionStorage("EMPLOYEE_MSG_ERROR_DATA", false);
  const [successData, setsuccessData, clearSuccessData] = Digit.Hooks.useSessionStorage("EMPLOYEE_MSG_MUTATION_SUCCESS_DATA", false);
  useEffect(() => {
    setMutationHappened(false);
    clearSuccessData();
    clearError();
  }, []);
  const onSubmit = data => {
    var _data$tenantId, _convertDateToMaximum, _convertDateToMaximum2;
    const {
      fromDate,
      toDate,
      description,
      name,
      documents
    } = data;
    const details = {
      events: [{
        recepient: null,
        source: "WEBAPP",
        eventType: "BROADCAST",
        tenantId: data === null || data === void 0 ? void 0 : (_data$tenantId = data.tenantId) === null || _data$tenantId === void 0 ? void 0 : _data$tenantId.code,
        description,
        name,
        eventDetails: {
          documents,
          fromDate: (_convertDateToMaximum = convertDateToMaximumPossibleValue(new Date(`${fromDate}`))) === null || _convertDateToMaximum === void 0 ? void 0 : _convertDateToMaximum.getTime(),
          toDate: (_convertDateToMaximum2 = convertDateToMaximumPossibleValue(new Date(`${toDate}`))) === null || _convertDateToMaximum2 === void 0 ? void 0 : _convertDateToMaximum2.getTime()
        }
      }]
    };
    history.push("/digit-ui/employee/engagement/messages/response", details);
  };
  return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(Header, null, t("ADD_NEW_PUBLIC_MESSAGE")), /*#__PURE__*/React$1.createElement(FormComposer, {
    config: config$1,
    onSubmit: onSubmit,
    label: t("ACTION_ADD_NEW_MESSAGE")
  }));
};

const BannerPicker$1 = props => {
  var _props$data, _props$data$events, _props$data$events$;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement(Banner, {
    message: t(props.message),
    applicationNumber: props === null || props === void 0 ? void 0 : (_props$data = props.data) === null || _props$data === void 0 ? void 0 : (_props$data$events = _props$data.events) === null || _props$data$events === void 0 ? void 0 : (_props$data$events$ = _props$data$events[0]) === null || _props$data$events$ === void 0 ? void 0 : _props$data$events$.name,
    successful: props.isSuccess
  });
};
const Response$1 = props => {
  const queryClient = useQueryClient();
  const {
    t
  } = useTranslation();
  const searchParams = Digit.Hooks.useQueryParams();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const mutation = Digit.Hooks.events.useCreateEvent();
  const updateEventMutation = Digit.Hooks.events.useUpdateEvent();
  const {
    state
  } = props.location;
  const [mutationHappened, setMutationHappened, clear] = Digit.Hooks.useSessionStorage("EMPLOYEE_MSG_MUTATION_HAPPENED", false);
  const [successData, setsuccessData, clearSuccessData] = Digit.Hooks.useSessionStorage("EMPLOYEE_MSG_MUTATION_SUCCESS_DATA", false);
  const [errorInfo, setErrorInfo, clearError] = Digit.Hooks.useSessionStorage("EMPLOYEE_MSG_ERROR_DATA", false);
  useEffect(() => {
    if (updateEventMutation.data) setsuccessData(updateEventMutation.data);
  }, [updateEventMutation.data]);
  useEffect(() => {
    if (mutation.data) setsuccessData(mutation.data);
  }, [mutation.data]);
  const onError = (error, variables) => {
    var _error$response, _error$response$data, _error$response$data$;
    setErrorInfo((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : (_error$response$data$ = _error$response$data.Errors[0]) === null || _error$response$data$ === void 0 ? void 0 : _error$response$data$.code) || 'ERROR');
    setMutationHappened(true);
  };
  useEffect(() => {
    const onSuccess = () => {
      setMutationHappened(true);
      queryClient.clear();
    };
    if (!mutationHappened) {
      if (Boolean(searchParams === null || searchParams === void 0 ? void 0 : searchParams.delete) || Boolean(searchParams === null || searchParams === void 0 ? void 0 : searchParams.update)) {
        updateEventMutation.mutate(state, {
          onError,
          onSuccess
        });
        return;
      }
      mutation.mutate(state, {
        onError,
        onSuccess
      });
    }
  }, []);
  if (searchParams !== null && searchParams !== void 0 && searchParams.delete || searchParams !== null && searchParams !== void 0 && searchParams.update) {
    if (updateEventMutation.isLoading || updateEventMutation.isIdle && !mutationHappened) {
      return /*#__PURE__*/React$1.createElement(Loader, null);
    }
    return /*#__PURE__*/React$1.createElement(Card, null, /*#__PURE__*/React$1.createElement(BannerPicker$1, {
      t: t,
      message: searchParams !== null && searchParams !== void 0 && searchParams.update ? updateEventMutation.isSuccess || successData ? 'ENGAGEMENT_PUBLIC_BRDCST_UPDATED' : 'ENG_PUBLIC_BRDCST_UPDATION_FAILED' : updateEventMutation.isSuccess || successData ? 'ENGAGEMENT_PUBLIC_BRDCST_DELETED' : 'ENGAGEMENT_PUBLIC_BRDCST_DELETION_FAILED',
      data: updateEventMutation.data || successData,
      isSuccess: (updateEventMutation === null || updateEventMutation === void 0 ? void 0 : updateEventMutation.isSuccess) || successData,
      isLoading: updateEventMutation.isIdle && !mutationHappened || updateEventMutation.isLoading
    }), /*#__PURE__*/React$1.createElement(CardText, null, searchParams !== null && searchParams !== void 0 && searchParams.update ? t(`ENGAGEMENT_PUBLIC_BRDCST_MESSAGES`) : t(`ENGAGEMENT_PUBLIC_BRDCST_MESSAGES`)), /*#__PURE__*/React$1.createElement(ActionBar, null, /*#__PURE__*/React$1.createElement(Link, {
      to: "/digit-ui/employee"
    }, /*#__PURE__*/React$1.createElement(SubmitBar, {
      label: t("CORE_COMMON_GO_TO_HOME")
    }))));
  }
  if (mutation.isLoading || mutation.isIdle && !mutationHappened) {
    return /*#__PURE__*/React$1.createElement(Loader, null);
  }
  return /*#__PURE__*/React$1.createElement(Card, null, /*#__PURE__*/React$1.createElement(BannerPicker$1, {
    t: t,
    message: mutation.isSuccess || successData ? `ENGAGEMENT_BROADCAST_MESSAGE_CREATED` : `ENGAGEMENT_BROADCAST_MESSAGE_FAILED`,
    data: mutation.data || successData,
    isSuccess: mutation.isSuccess || successData,
    isLoading: mutation.isIdle && !mutationHappened || mutation.isLoading
  }), /*#__PURE__*/React$1.createElement(ActionBar, null, /*#__PURE__*/React$1.createElement(Link, {
    to: "/digit-ui/employee"
  }, /*#__PURE__*/React$1.createElement(SubmitBar, {
    label: t("CORE_COMMON_GO_TO_HOME")
  }))));
};

const EditMessage = () => {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const {
    id: MessageId
  } = useParams();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const {
    isLoading,
    data
  } = Digit.Hooks.events.useInbox(tenantId, {}, {
    eventTypes: "BROADCAST",
    ids: MessageId
  }, {
    select: data => {
      var _data$events;
      return data === null || data === void 0 ? void 0 : (_data$events = data.events) === null || _data$events === void 0 ? void 0 : _data$events[0];
    }
  });
  const [mutationHappened, setMutationHappened, clear] = Digit.Hooks.useSessionStorage("EMPLOYEE_MSG_MUTATION_HAPPENED", false);
  const [errorInfo, setErrorInfo, clearError] = Digit.Hooks.useSessionStorage("EMPLOYEE_MSG_ERROR_DATA", false);
  const [successData, setsuccessData, clearSuccessData] = Digit.Hooks.useSessionStorage("EMPLOYEE_MSG_MUTATION_SUCCESS_DATA", false);
  useEffect(() => {
    setMutationHappened(false);
    clearSuccessData();
    clearError();
  }, []);
  const onSubmit = formData => {
    var _formData$tenantId;
    const {
      fromDate,
      toDate,
      description,
      name,
      documents
    } = formData;
    const finalDocuments = isNestedArray(documents) ? reduceDocsArray(documents) : documents;
    const details = {
      events: [{
        ...data,
        source: "WEBAPP",
        status: "ACTIVE",
        eventType: "BROADCAST",
        tenantId: formData === null || formData === void 0 ? void 0 : (_formData$tenantId = formData.tenantId) === null || _formData$tenantId === void 0 ? void 0 : _formData$tenantId.code,
        description,
        name,
        eventDetails: {
          documents: finalDocuments,
          fromDate: handleTodaysDate(`${fromDate}`),
          toDate: handleTodaysDate(`${toDate}`)
        }
      }]
    };
    history.push("/digit-ui/employee/engagement/messages/response?update=true", details);
  };
  const defaultValues = useMemo(() => {
    var _data$eventDetails, _data$eventDetails2, _data$eventDetails3;
    const documents = data === null || data === void 0 ? void 0 : (_data$eventDetails = data.eventDetails) === null || _data$eventDetails === void 0 ? void 0 : _data$eventDetails.documents;
    return {
      name: data === null || data === void 0 ? void 0 : data.name,
      description: data === null || data === void 0 ? void 0 : data.description,
      documents: documents === null || documents === void 0 ? void 0 : documents.map(e => [e.fileName, {
        file: {
          name: e.fileName,
          type: e.documentType
        },
        fileStoreId: {
          fileStoreId: e.fileStoreId,
          tenantId
        }
      }]),
      fromDate: data ? format(new Date(data === null || data === void 0 ? void 0 : (_data$eventDetails2 = data.eventDetails) === null || _data$eventDetails2 === void 0 ? void 0 : _data$eventDetails2.fromDate), 'yyyy-MM-dd') : null,
      toDate: data ? format(new Date(data === null || data === void 0 ? void 0 : (_data$eventDetails3 = data.eventDetails) === null || _data$eventDetails3 === void 0 ? void 0 : _data$eventDetails3.toDate), 'yyyy-MM-dd') : null
    };
  }, [data]);
  if (isLoading) {
    return /*#__PURE__*/React$1.createElement(Loader, null);
  }
  return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(Header, null, t("EDIT_NEW_PUBLIC_MESSAGE")), /*#__PURE__*/React$1.createElement(FormComposer, {
    defaultValues: defaultValues,
    config: config$1,
    onSubmit: onSubmit,
    label: t("ACTION_EDIT_MESSAGE")
  }));
};

const configPTApproverApplication = ({
  t,
  action,
  approvers,
  selectedApprover,
  setSelectedApprover,
  selectFile,
  uploadedFile,
  setUploadedFile,
  assigneeLabel,
  businessService
}) => {
  var _action$assigneeRoles;
  return {
    label: {
      heading: `WF_${action === null || action === void 0 ? void 0 : action.action}_APPLICATION`,
      submit: `WF_${businessService}_${action === null || action === void 0 ? void 0 : action.action}`,
      cancel: "ES_PT_COMMON_CANCEL"
    },
    form: [{
      body: [{
        label: action.isTerminateState || (action === null || action === void 0 ? void 0 : action.action) === "SENDBACKTOCITIZEN" ? null : t(assigneeLabel || `WF_ROLE_${(_action$assigneeRoles = action.assigneeRoles) === null || _action$assigneeRoles === void 0 ? void 0 : _action$assigneeRoles[0]}`),
        type: "dropdown",
        populators: action.isTerminateState || (action === null || action === void 0 ? void 0 : action.action) === "SENDBACKTOCITIZEN" ? null : /*#__PURE__*/React$1.createElement(Dropdown, {
          option: approvers,
          autoComplete: "off",
          optionKey: "name",
          id: "fieldInspector",
          select: setSelectedApprover,
          selected: selectedApprover
        })
      }, {
        label: t("ES_PT_ACTION_COMMENTS"),
        type: "textarea",
        populators: {
          name: "comments"
        }
      }, {
        label: `${t("ES_PT_ATTACH_FILE")}${action.docUploadRequired ? " *" : ""}`,
        populators: /*#__PURE__*/React$1.createElement(UploadFile, {
          id: "workflow-doc",
          onUpload: selectFile,
          onDelete: () => {
            setUploadedFile(null);
          },
          showHint: true,
          hintText: t("PT_ATTACH_RESTRICTIONS_SIZE"),
          message: uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`ES_PT_ACTION_NO_FILEUPLOADED`)
        })
      }]
    }]
  };
};

const configPTAssessProperty = ({
  t,
  action,
  financialYears,
  selectedFinancialYear,
  setSelectedFinancialYear
}) => {
  return {
    label: {
      heading: `WF_${action.action}_APPLICATION`,
      submit: `WF_PT.CREATE_${action.action}`,
      cancel: "ES_PT_COMMON_CANCEL"
    },
    form: [{
      body: [{
        label: t("ES_PT_FINANCIAL_YEARS"),
        isMandatory: true,
        type: "radio",
        populators: /*#__PURE__*/React$1.createElement(RadioButtons, {
          options: financialYears,
          optionsKey: "name",
          onSelect: setSelectedFinancialYear,
          selectedOption: selectedFinancialYear
        })
      }]
    }]
  };
};

const configTLApproverApplication = ({
  t,
  action,
  approvers,
  selectedApprover,
  setSelectedApprover,
  selectFile,
  uploadedFile,
  setUploadedFile,
  assigneeLabel,
  businessService
}) => {
  let checkCondtions = true;
  if ((action === null || action === void 0 ? void 0 : action.action) == "SENDBACKTOCITIZEN" || (action === null || action === void 0 ? void 0 : action.action) == "APPROVE") checkCondtions = false;
  if (action.isTerminateState) checkCondtions = false;
  return {
    label: {
      heading: `WF_${action === null || action === void 0 ? void 0 : action.action}_APPLICATION`,
      submit: `WF_${businessService === null || businessService === void 0 ? void 0 : businessService.toUpperCase()}_${action === null || action === void 0 ? void 0 : action.action}`,
      cancel: "WF_EMPLOYEE_NEWTL_CANCEL"
    },
    form: [{
      body: [{
        label: !checkCondtions ? null : t("WF_ASSIGNEE_NAME_LABEL"),
        placeholder: !checkCondtions ? null : t("WF_ASSIGNEE_NAME_PLACEHOLDER"),
        type: "dropdown",
        populators: !checkCondtions ? null : /*#__PURE__*/React$1.createElement(Dropdown, {
          option: approvers,
          autoComplete: "off",
          optionKey: "name",
          id: "fieldInspector",
          select: setSelectedApprover,
          selected: selectedApprover
        })
      }, {
        label: t("WF_COMMON_COMMENTS"),
        type: "textarea",
        populators: {
          name: "comments"
        }
      }, {
        label: t("TL_APPROVAL_CHECKLIST_BUTTON_UP_FILE"),
        populators: /*#__PURE__*/React$1.createElement(UploadFile, {
          id: "workflow-doc",
          onUpload: selectFile,
          onDelete: () => {
            setUploadedFile(null);
          },
          message: uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`)
        })
      }]
    }]
  };
};

const configBPAREGApproverApplication = ({
  t,
  action,
  approvers,
  selectedApprover,
  setSelectedApprover,
  selectFile,
  uploadedFile,
  setUploadedFile,
  assigneeLabel,
  businessService,
  error
}) => {
  return {
    label: {
      heading: `WF_${action === null || action === void 0 ? void 0 : action.action}_APPLICATION`,
      submit: `WF_${businessService === null || businessService === void 0 ? void 0 : businessService.toUpperCase()}_${action === null || action === void 0 ? void 0 : action.action}`,
      cancel: "WF_EMPLOYEE_BPAREG_CANCEL"
    },
    form: [{
      body: [{
        label: t("WF_COMMON_COMMENTS"),
        type: "textarea",
        populators: {
          name: "comments"
        }
      }, {
        label: t("BPA_APPROVAL_CHECKLIST_BUTTON_UP_FILE"),
        populators: /*#__PURE__*/React$1.createElement(UploadFile, {
          id: "workflow-doc",
          onUpload: selectFile,
          onDelete: () => {
            setUploadedFile(null);
          },
          message: uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`),
          accept: "image/*, .pdf, .png, .jpeg, .jpg",
          iserror: error
        })
      }]
    }]
  };
};

const configBPAApproverApplication = ({
  t,
  action,
  approvers,
  selectedApprover,
  setSelectedApprover,
  selectFile,
  uploadedFile,
  setUploadedFile,
  assigneeLabel,
  businessService,
  error
}) => {
  let isCommentRequired = false;
  if ((action === null || action === void 0 ? void 0 : action.action) == "REVOCATE" || (action === null || action === void 0 ? void 0 : action.action) == "REJECT") {
    isCommentRequired = true;
  }
  return {
    label: {
      heading: `WF_${action === null || action === void 0 ? void 0 : action.action}_APPLICATION`,
      submit: `WF_${businessService}_${action === null || action === void 0 ? void 0 : action.action}`,
      cancel: "BPA_CITIZEN_CANCEL_BUTTON"
    },
    form: [{
      body: [{
        label: t("WF_COMMON_COMMENTS"),
        type: "textarea",
        isMandatory: isCommentRequired,
        populators: {
          name: "comments"
        }
      }, {
        label: `${t("WF_APPROVAL_UPLOAD_HEAD")}`,
        populators: /*#__PURE__*/React$1.createElement(UploadFile, {
          id: "workflow-doc",
          onUpload: selectFile,
          onDelete: () => {
            setUploadedFile(null);
          },
          message: uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`),
          accept: "image/*, .pdf, .png, .jpeg, .jpg",
          iserror: error
        })
      }]
    }]
  };
};

const configNOCApproverApplication = ({
  t,
  action,
  approvers,
  selectedApprover,
  setSelectedApprover,
  selectFile,
  uploadedFile,
  setUploadedFile,
  assigneeLabel,
  businessService,
  error
}) => {
  var _action$assigneeRoles;
  let isCommentRequired = false;
  if ((action === null || action === void 0 ? void 0 : action.action) == "REVOCATE" || (action === null || action === void 0 ? void 0 : action.action) == "REJECT") {
    isCommentRequired = true;
  }
  let isRejectOrRevocate = false;
  if ((action === null || action === void 0 ? void 0 : action.action) == "APPROVE" || (action === null || action === void 0 ? void 0 : action.action) == "REJECT" || action.action == "AUTO_APPROVE" || action.action == "AUTO_REJECT") {
    isRejectOrRevocate = true;
  }
  return {
    label: {
      heading: `WF_${action === null || action === void 0 ? void 0 : action.action}_APPLICATION`,
      submit: `WF_${businessService}_${action === null || action === void 0 ? void 0 : action.action}`,
      cancel: "CORE_LOGOUTPOPUP_CANCEL"
    },
    form: [{
      body: [{
        label: action.isTerminateState || isRejectOrRevocate ? null : t(assigneeLabel || `WF_ROLE_${(_action$assigneeRoles = action.assigneeRoles) === null || _action$assigneeRoles === void 0 ? void 0 : _action$assigneeRoles[0]}`),
        type: "dropdown",
        populators: action.isTerminateState || isRejectOrRevocate ? null : /*#__PURE__*/React$1.createElement(Dropdown, {
          option: approvers,
          autoComplete: "off",
          optionKey: "name",
          id: "fieldInspector",
          select: setSelectedApprover,
          selected: selectedApprover
        })
      }, {
        label: t("WF_COMMON_COMMENTS"),
        type: "textarea",
        isMandatory: isCommentRequired,
        populators: {
          name: "comments"
        }
      }, {
        label: `${t("WF_APPROVAL_UPLOAD_HEAD")}`,
        populators: /*#__PURE__*/React$1.createElement(UploadFile, {
          id: "workflow-doc",
          onUpload: selectFile,
          onDelete: () => {
            setUploadedFile(null);
          },
          showHint: true,
          message: uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`),
          accept: "image/*, .pdf, .png, .jpeg, .jpg",
          iserror: error
        })
      }]
    }]
  };
};

const Heading = props => {
  return /*#__PURE__*/React$1.createElement("h1", {
    className: "heading-m"
  }, props.label);
};
const Close = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React$1.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn = props => {
  return /*#__PURE__*/React$1.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React$1.createElement(Close, null));
};
const ActionModal = ({
  t,
  action,
  tenantId,
  state,
  id,
  closeModal,
  submitAction,
  actionData,
  applicationData,
  businessService,
  moduleCode
}) => {
  var _action$assigneeRoles, _action$assigneeRoles2;
  const {
    data: approverData,
    isLoading: PTALoading
  } = Digit.Hooks.useEmployeeSearch(tenantId, {
    roles: action === null || action === void 0 ? void 0 : (_action$assigneeRoles = action.assigneeRoles) === null || _action$assigneeRoles === void 0 ? void 0 : (_action$assigneeRoles2 = _action$assigneeRoles.map) === null || _action$assigneeRoles2 === void 0 ? void 0 : _action$assigneeRoles2.call(_action$assigneeRoles, e => ({
      code: e
    })),
    isActive: true
  }, {
    enabled: !(action !== null && action !== void 0 && action.isTerminateState)
  });
  const {
    isLoading: financialYearsLoading,
    data: financialYearsData
  } = Digit.Hooks.pt.useMDMS(tenantId, businessService, "FINANCIAL_YEARLS", {}, {
    details: {
      tenantId: Digit.ULBService.getStateId(),
      moduleDetails: [{
        moduleName: "egf-master",
        masterDetails: [{
          name: "FinancialYear",
          filter: "[?(@.module == 'PT')]"
        }]
      }]
    }
  });
  const [config, setConfig] = useState({});
  const [defaultValues, setDefaultValues] = useState({});
  const [approvers, setApprovers] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState(null);
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const [financialYears, setFinancialYears] = useState([]);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(null);
  const [disableActionSubmit, setDisableActionSubmit] = useState(false);
  useEffect(() => {
    if (financialYearsData && financialYearsData["egf-master"]) {
      var _financialYearsData$e;
      setFinancialYears((_financialYearsData$e = financialYearsData["egf-master"]) === null || _financialYearsData$e === void 0 ? void 0 : _financialYearsData$e["FinancialYear"]);
    }
  }, [financialYearsData]);
  useEffect(() => {
    var _approverData$Employe;
    setApprovers(approverData === null || approverData === void 0 ? void 0 : (_approverData$Employe = approverData.Employees) === null || _approverData$Employe === void 0 ? void 0 : _approverData$Employe.map(employee => {
      var _employee$user;
      return {
        uuid: employee === null || employee === void 0 ? void 0 : employee.uuid,
        name: employee === null || employee === void 0 ? void 0 : (_employee$user = employee.user) === null || _employee$user === void 0 ? void 0 : _employee$user.name
      };
    }));
  }, [approverData]);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("PT", file, Digit.ULBService.getStateId());
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  function submit(data) {
    if (!(action !== null && action !== void 0 && action.showFinancialYearsModal)) {
      let workflow = {
        action: action === null || action === void 0 ? void 0 : action.action,
        comments: data === null || data === void 0 ? void 0 : data.comments,
        businessService,
        moduleName: moduleCode
      };
      workflow["assignes"] = action !== null && action !== void 0 && action.isTerminateState || !selectedApprover ? [] : [selectedApprover];
      if (uploadedFile) workflow["documents"] = [{
        documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
        fileName: file === null || file === void 0 ? void 0 : file.name,
        fileStoreId: uploadedFile
      }];
      submitAction({
        Property: {
          ...applicationData,
          workflow
        }
      });
    } else {
      submitAction({
        customFunctionToExecute: action === null || action === void 0 ? void 0 : action.customFunctionToExecute,
        Assessment: {
          financialYear: selectedFinancialYear === null || selectedFinancialYear === void 0 ? void 0 : selectedFinancialYear.name,
          propertyId: applicationData === null || applicationData === void 0 ? void 0 : applicationData.propertyId,
          tenantId,
          source: applicationData === null || applicationData === void 0 ? void 0 : applicationData.source,
          channel: applicationData === null || applicationData === void 0 ? void 0 : applicationData.channel,
          assessmentDate: Date.now()
        }
      });
    }
  }
  useEffect(() => {
    if (action) {
      if (action !== null && action !== void 0 && action.showFinancialYearsModal) {
        setConfig(configPTAssessProperty({
          t,
          action,
          financialYears,
          selectedFinancialYear,
          setSelectedFinancialYear
        }));
      } else {
        setConfig(configPTApproverApplication({
          t,
          action,
          approvers,
          selectedApprover,
          setSelectedApprover,
          selectFile,
          uploadedFile,
          setUploadedFile,
          businessService
        }));
      }
    }
  }, [action, approvers, financialYears, selectedFinancialYear, uploadedFile]);
  return action && config.form ? /*#__PURE__*/React$1.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React$1.createElement(Heading, {
      label: t(config.label.heading)
    }),
    headerBarEnd: /*#__PURE__*/React$1.createElement(CloseBtn, {
      onClick: closeModal
    }),
    actionCancelLabel: t(config.label.cancel),
    actionCancelOnSubmit: closeModal,
    actionSaveLabel: t(config.label.submit),
    actionSaveOnSubmit: () => {},
    isDisabled: !action.showFinancialYearsModal ? PTALoading || (action === null || action === void 0 ? void 0 : action.docUploadRequired) && !uploadedFile : !selectedFinancialYear,
    formId: "modal-action"
  }, financialYearsLoading ? /*#__PURE__*/React$1.createElement(Loader, null) : /*#__PURE__*/React$1.createElement(FormComposer, {
    config: config.form,
    noBoxShadow: true,
    inline: true,
    childrenAtTheBottom: true,
    onSubmit: submit,
    defaultValues: defaultValues,
    formId: "modal-action"
  })) : /*#__PURE__*/React$1.createElement(Loader, null);
};

const Heading$1 = props => {
  return /*#__PURE__*/React$1.createElement("h1", {
    className: "heading-m"
  }, props.label);
};
const Close$1 = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React$1.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$1 = props => {
  return /*#__PURE__*/React$1.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React$1.createElement(Close$1, null));
};
const ActionModal$1 = ({
  t,
  action,
  tenantId,
  state,
  id,
  closeModal,
  submitAction,
  actionData,
  applicationData,
  businessService,
  moduleCode
}) => {
  var _action$assigneeRoles, _action$assigneeRoles2;
  const {
    data: approverData,
    isLoading: PTALoading
  } = Digit.Hooks.useEmployeeSearch(tenantId, {
    roles: action === null || action === void 0 ? void 0 : (_action$assigneeRoles = action.assigneeRoles) === null || _action$assigneeRoles === void 0 ? void 0 : (_action$assigneeRoles2 = _action$assigneeRoles.map) === null || _action$assigneeRoles2 === void 0 ? void 0 : _action$assigneeRoles2.call(_action$assigneeRoles, e => ({
      code: e
    })),
    isActive: true
  }, {
    enabled: !(action !== null && action !== void 0 && action.isTerminateState)
  });
  const {
    isLoading: financialYearsLoading,
    data: financialYearsData
  } = Digit.Hooks.pt.useMDMS(tenantId, businessService, "FINANCIAL_YEARLS", {}, {
    details: {
      tenantId: Digit.ULBService.getStateId(),
      moduleDetails: [{
        moduleName: "egf-master",
        masterDetails: [{
          name: "FinancialYear",
          filter: "[?(@.module == 'TL')]"
        }]
      }]
    }
  });
  const [config, setConfig] = useState({});
  const [defaultValues, setDefaultValues] = useState({});
  const [approvers, setApprovers] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState({});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const [financialYears, setFinancialYears] = useState([]);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(null);
  useEffect(() => {
    if (financialYearsData && financialYearsData["egf-master"]) {
      var _financialYearsData$e;
      setFinancialYears((_financialYearsData$e = financialYearsData["egf-master"]) === null || _financialYearsData$e === void 0 ? void 0 : _financialYearsData$e["FinancialYear"]);
    }
  }, [financialYearsData]);
  useEffect(() => {
    var _approverData$Employe;
    setApprovers(approverData === null || approverData === void 0 ? void 0 : (_approverData$Employe = approverData.Employees) === null || _approverData$Employe === void 0 ? void 0 : _approverData$Employe.map(employee => {
      var _employee$user;
      return {
        uuid: employee === null || employee === void 0 ? void 0 : employee.uuid,
        name: employee === null || employee === void 0 ? void 0 : (_employee$user = employee.user) === null || _employee$user === void 0 ? void 0 : _employee$user.name
      };
    }));
  }, [approverData]);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("PT", file, Digit.ULBService.getStateId());
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  function submit(data) {
    applicationData = {
      ...applicationData,
      action: action === null || action === void 0 ? void 0 : action.action,
      comment: data === null || data === void 0 ? void 0 : data.comments,
      assignee: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
      wfDocuments: uploadedFile ? [{
        documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
        fileName: file === null || file === void 0 ? void 0 : file.name,
        fileStoreId: uploadedFile
      }] : null
    };
    submitAction({
      Licenses: [applicationData]
    });
  }
  useEffect(() => {
    if (action) {
      setConfig(configTLApproverApplication({
        t,
        action,
        approvers,
        selectedApprover,
        setSelectedApprover,
        selectFile,
        uploadedFile,
        setUploadedFile,
        businessService
      }));
    }
  }, [action, approvers, financialYears, selectedFinancialYear, uploadedFile]);
  return action && config.form ? /*#__PURE__*/React$1.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React$1.createElement(Heading$1, {
      label: t(config.label.heading)
    }),
    headerBarEnd: /*#__PURE__*/React$1.createElement(CloseBtn$1, {
      onClick: closeModal
    }),
    actionCancelLabel: t(config.label.cancel),
    actionCancelOnSubmit: closeModal,
    actionSaveLabel: t(config.label.submit),
    actionSaveOnSubmit: () => {},
    formId: "modal-action"
  }, financialYearsLoading ? /*#__PURE__*/React$1.createElement(Loader, null) : /*#__PURE__*/React$1.createElement(FormComposer, {
    config: config.form,
    noBoxShadow: true,
    inline: true,
    childrenAtTheBottom: true,
    onSubmit: submit,
    defaultValues: defaultValues,
    formId: "modal-action"
  })) : /*#__PURE__*/React$1.createElement(Loader, null);
};

const Heading$2 = props => {
  return /*#__PURE__*/React$1.createElement("h1", {
    style: {
      marginLeft: "22px"
    },
    className: "heading-m BPAheading-m"
  }, props.label);
};
const Close$2 = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React$1.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$2 = props => {
  return /*#__PURE__*/React$1.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React$1.createElement(Close$2, null));
};
const ActionModal$2 = ({
  t,
  action,
  tenantId,
  state,
  id,
  closeModal,
  submitAction,
  actionData,
  applicationData,
  businessService,
  moduleCode
}) => {
  var _action$assigneeRoles, _action$assigneeRoles2;
  const {
    data: approverData,
    isLoading: PTALoading
  } = Digit.Hooks.useEmployeeSearch(tenantId, {
    roles: action === null || action === void 0 ? void 0 : (_action$assigneeRoles = action.assigneeRoles) === null || _action$assigneeRoles === void 0 ? void 0 : (_action$assigneeRoles2 = _action$assigneeRoles.map) === null || _action$assigneeRoles2 === void 0 ? void 0 : _action$assigneeRoles2.call(_action$assigneeRoles, e => ({
      code: e
    })),
    isActive: true
  }, {
    enabled: !(action !== null && action !== void 0 && action.isTerminateState)
  });
  const [config, setConfig] = useState({});
  const [defaultValues, setDefaultValues] = useState({});
  const [approvers, setApprovers] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState({});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const mobileView = Digit.Utils.browser.isMobile() ? true : false;
  useEffect(() => {
    var _approverData$Employe;
    setApprovers(approverData === null || approverData === void 0 ? void 0 : (_approverData$Employe = approverData.Employees) === null || _approverData$Employe === void 0 ? void 0 : _approverData$Employe.map(employee => {
      var _employee$user;
      return {
        uuid: employee === null || employee === void 0 ? void 0 : employee.uuid,
        name: employee === null || employee === void 0 ? void 0 : (_employee$user = employee.user) === null || _employee$user === void 0 ? void 0 : _employee$user.name
      };
    }));
  }, [approverData]);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("OBPS", file, Digit.ULBService.getStateId() || (tenantId === null || tenantId === void 0 ? void 0 : tenantId.split(".")[0]));
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  function submit(data) {
    applicationData = {
      ...applicationData,
      action: action === null || action === void 0 ? void 0 : action.action,
      comment: data === null || data === void 0 ? void 0 : data.comments,
      assignee: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
      wfDocuments: uploadedFile ? [{
        documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
        fileName: file === null || file === void 0 ? void 0 : file.name,
        fileStoreId: uploadedFile
      }] : null
    };
    submitAction({
      Licenses: [applicationData]
    }, false, {
      isStakeholder: true,
      bpa: false
    });
  }
  useEffect(() => {
    if (action) {
      setConfig(configBPAREGApproverApplication({
        t,
        action,
        approvers,
        selectedApprover,
        setSelectedApprover,
        selectFile,
        uploadedFile,
        setUploadedFile,
        businessService,
        error
      }));
    }
  }, [action, approvers, uploadedFile, error]);
  return action && config.form ? /*#__PURE__*/React$1.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React$1.createElement(Heading$2, {
      label: t(config.label.heading)
    }),
    headerBarEnd: /*#__PURE__*/React$1.createElement(CloseBtn$2, {
      onClick: closeModal
    }),
    actionCancelLabel: t(config.label.cancel),
    actionCancelOnSubmit: closeModal,
    actionSaveLabel: t(config.label.submit),
    actionSaveOnSubmit: () => {},
    formId: "modal-action",
    isOBPSFlow: true,
    popupStyles: mobileView ? {
      width: "720px"
    } : {},
    style: !mobileView ? {
      height: "45px",
      width: "107px",
      paddingLeft: "0px",
      paddingRight: "0px"
    } : {
      height: "45px",
      width: "44%"
    },
    popupModuleMianStyles: mobileView ? {
      paddingLeft: "5px"
    } : {}
  }, PTALoading ? /*#__PURE__*/React$1.createElement(Loader, null) : /*#__PURE__*/React$1.createElement(FormComposer, {
    config: config.form,
    cardStyle: {
      marginLeft: "0px",
      marginRight: "0px",
      marginTop: "-25px"
    },
    className: "BPAemployeeCard",
    noBoxShadow: true,
    inline: true,
    childrenAtTheBottom: true,
    onSubmit: submit,
    defaultValues: defaultValues,
    formId: "modal-action"
  })) : /*#__PURE__*/React$1.createElement(Loader, null);
};

const Heading$3 = props => {
  return /*#__PURE__*/React$1.createElement("h1", {
    style: {
      marginLeft: "22px"
    },
    className: "heading-m BPAheading-m"
  }, props.label);
};
const Close$3 = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React$1.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$3 = props => {
  return /*#__PURE__*/React$1.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React$1.createElement(Close$3, null));
};
const ActionModal$3 = ({
  t,
  action,
  tenantId,
  state,
  id,
  closeModal,
  submitAction,
  actionData,
  applicationDetails,
  applicationData,
  businessService,
  moduleCode,
  workflowDetails
}) => {
  var _applicationData, _applicationData$land, _applicationData$land2, _applicationData2, _applicationData2$lan, _applicationData2$lan2, _workflowDetails$data, _workflowDetails$data2, _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data5, _workflowDetails$data6, _applicationData4;
  const mutation1 = Digit.Hooks.obps.useObpsAPI((_applicationData = applicationData) !== null && _applicationData !== void 0 && (_applicationData$land = _applicationData.landInfo) !== null && _applicationData$land !== void 0 && (_applicationData$land2 = _applicationData$land.address) !== null && _applicationData$land2 !== void 0 && _applicationData$land2.city ? (_applicationData2 = applicationData) === null || _applicationData2 === void 0 ? void 0 : (_applicationData2$lan = _applicationData2.landInfo) === null || _applicationData2$lan === void 0 ? void 0 : (_applicationData2$lan2 = _applicationData2$lan.address) === null || _applicationData2$lan2 === void 0 ? void 0 : _applicationData2$lan2.city : tenantId, false);
  const {
    data: approverData,
    isLoading: PTALoading
  } = Digit.Hooks.useEmployeeSearch(tenantId, {
    roles: workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.initialActionState) === null || _workflowDetails$data2 === void 0 ? void 0 : (_workflowDetails$data3 = _workflowDetails$data2.nextActions) === null || _workflowDetails$data3 === void 0 ? void 0 : (_workflowDetails$data4 = _workflowDetails$data3.filter(ele => (ele === null || ele === void 0 ? void 0 : ele.action) == (action === null || action === void 0 ? void 0 : action.action))) === null || _workflowDetails$data4 === void 0 ? void 0 : (_workflowDetails$data5 = _workflowDetails$data4[0]) === null || _workflowDetails$data5 === void 0 ? void 0 : (_workflowDetails$data6 = _workflowDetails$data5.assigneeRoles) === null || _workflowDetails$data6 === void 0 ? void 0 : _workflowDetails$data6.map(role => ({
      code: role
    })),
    isActive: true
  }, {
    enabled: !(action !== null && action !== void 0 && action.isTerminateState)
  });
  const queryClient = useQueryClient();
  const [config, setConfig] = useState({});
  const [defaultValues, setDefaultValues] = useState({});
  const [approvers, setApprovers] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState({});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(null);
  const mobileView = Digit.Utils.browser.isMobile() ? true : false;
  useEffect(() => {
    var _approverData$Employe;
    setApprovers(approverData === null || approverData === void 0 ? void 0 : (_approverData$Employe = approverData.Employees) === null || _approverData$Employe === void 0 ? void 0 : _approverData$Employe.map(employee => {
      var _employee$user;
      return {
        uuid: employee === null || employee === void 0 ? void 0 : employee.uuid,
        name: employee === null || employee === void 0 ? void 0 : (_employee$user = employee.user) === null || _employee$user === void 0 ? void 0 : _employee$user.name
      };
    }));
  }, [approverData]);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("OBPS", file, Digit.ULBService.getStateId() || (tenantId === null || tenantId === void 0 ? void 0 : tenantId.split(".")[0]));
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  const getInspectionDocs = docs => {
    let refinedDocs = [];
    docs && docs.map((doc, ind) => {
      refinedDocs.push({
        "documentType": (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", "."),
        "fileStoreId": doc.fileStoreId,
        "fileStore": doc.fileStoreId,
        "fileName": "",
        "dropDownValues": {
          "value": (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", ".")
        }
      });
    });
    return refinedDocs;
  };
  const getQuestion = data => {
    let refinedQues = [];
    var i;
    for (i = 0; i < (data === null || data === void 0 ? void 0 : data.questionLength); i++) {
      var _data;
      refinedQues.push({
        "remarks": data[`Remarks_${i}`],
        "question": data === null || data === void 0 ? void 0 : data.questionList[i].question,
        "value": data === null || data === void 0 ? void 0 : (_data = data[`question_${i}`]) === null || _data === void 0 ? void 0 : _data.code
      });
    }
    return refinedQues;
  };
  const getfeildInspection = data => {
    var _data$additionalDetai, _data$additionalDetai2;
    let formdata = [],
      inspectionOb = [];
    if ((data === null || data === void 0 ? void 0 : (_data$additionalDetai = data.additionalDetails) === null || _data$additionalDetai === void 0 ? void 0 : (_data$additionalDetai2 = _data$additionalDetai.fieldinspection_pending) === null || _data$additionalDetai2 === void 0 ? void 0 : _data$additionalDetai2.length) > 0) {
      var _data$additionalDetai3;
      inspectionOb = data === null || data === void 0 ? void 0 : (_data$additionalDetai3 = data.additionalDetails) === null || _data$additionalDetai3 === void 0 ? void 0 : _data$additionalDetai3.fieldinspection_pending;
    }
    if (data.status == "FIELDINSPECTION_INPROGRESS") {
      var _formdata;
      formdata = JSON.parse(sessionStorage.getItem("INSPECTION_DATA"));
      ((_formdata = formdata) === null || _formdata === void 0 ? void 0 : _formdata.length) > 0 && formdata.map((ob, ind) => {
        inspectionOb.push({
          docs: getInspectionDocs(ob.Documents),
          date: ob.InspectionDate,
          questions: getQuestion(ob),
          time: ob === null || ob === void 0 ? void 0 : ob.InspectionTime
        });
      });
      inspectionOb = inspectionOb.filter(ob => ob.docs && ob.docs.length > 0);
    } else {
      sessionStorage.removeItem("INSPECTION_DATA");
    }
    let fieldinspection_pending = [...inspectionOb];
    return fieldinspection_pending;
  };
  const getDocuments = applicationData => {
    let documentsformdata = JSON.parse(sessionStorage.getItem("BPA_DOCUMENTS"));
    let documentList = [];
    documentsformdata.map(doc => {
      var _doc$uploadedDocument, _doc$uploadedDocument2, _doc$uploadedDocument3, _doc$uploadedDocument4, _doc$uploadedDocument5, _doc$newUploadedDocs;
      if ((doc === null || doc === void 0 ? void 0 : (_doc$uploadedDocument = doc.uploadedDocuments) === null || _doc$uploadedDocument === void 0 ? void 0 : (_doc$uploadedDocument2 = _doc$uploadedDocument[0]) === null || _doc$uploadedDocument2 === void 0 ? void 0 : (_doc$uploadedDocument3 = _doc$uploadedDocument2.values) === null || _doc$uploadedDocument3 === void 0 ? void 0 : _doc$uploadedDocument3.length) > 0) documentList = [...documentList, ...(doc === null || doc === void 0 ? void 0 : (_doc$uploadedDocument4 = doc.uploadedDocuments) === null || _doc$uploadedDocument4 === void 0 ? void 0 : (_doc$uploadedDocument5 = _doc$uploadedDocument4[0]) === null || _doc$uploadedDocument5 === void 0 ? void 0 : _doc$uploadedDocument5.values)];
      if ((doc === null || doc === void 0 ? void 0 : (_doc$newUploadedDocs = doc.newUploadedDocs) === null || _doc$newUploadedDocs === void 0 ? void 0 : _doc$newUploadedDocs.length) > 0) documentList = [...documentList, ...(doc === null || doc === void 0 ? void 0 : doc.newUploadedDocs)];
    });
    return documentList;
  };
  const getPendingApprovals = () => {
    var _result;
    const approvals = Digit.SessionStorage.get("OBPS_APPROVAL_CHECKS");
    const newApprovals = Digit.SessionStorage.get("OBPS_NEW_APPROVALS");
    let result = approvals === null || approvals === void 0 ? void 0 : approvals.reduce((acc, approval) => approval !== null && approval !== void 0 && approval.checked ? acc.push(approval === null || approval === void 0 ? void 0 : approval.label) && acc : acc, []);
    result = (_result = result) === null || _result === void 0 ? void 0 : _result.concat(newApprovals !== null ? newApprovals.filter(ob => ob.label !== "").map(approval => approval === null || approval === void 0 ? void 0 : approval.label) : []);
    return result;
  };
  function submit(data) {
    var _applicationData3, _data$comments, _data$comments2, _applicationDetails$n;
    applicationData = {
      ...applicationData,
      documents: getDocuments(),
      additionalDetails: {
        ...((_applicationData3 = applicationData) === null || _applicationData3 === void 0 ? void 0 : _applicationData3.additionalDetails),
        fieldinspection_pending: getfeildInspection(applicationData),
        pendingapproval: getPendingApprovals()
      },
      workflow: {
        action: action === null || action === void 0 ? void 0 : action.action,
        comment: (data === null || data === void 0 ? void 0 : (_data$comments = data.comments) === null || _data$comments === void 0 ? void 0 : _data$comments.length) > 0 ? data === null || data === void 0 ? void 0 : data.comments : null,
        comments: (data === null || data === void 0 ? void 0 : (_data$comments2 = data.comments) === null || _data$comments2 === void 0 ? void 0 : _data$comments2.length) > 0 ? data === null || data === void 0 ? void 0 : data.comments : null,
        assignee: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
        assignes: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
        varificationDocuments: uploadedFile ? [{
          documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      },
      action: action === null || action === void 0 ? void 0 : action.action,
      comment: data === null || data === void 0 ? void 0 : data.comments,
      assignee: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
      wfDocuments: uploadedFile ? [{
        documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
        fileName: file === null || file === void 0 ? void 0 : file.name,
        fileStoreId: uploadedFile
      }] : null
    };
    const nocDetails = applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$n = applicationDetails.nocData) === null || _applicationDetails$n === void 0 ? void 0 : _applicationDetails$n.map(noc => {
      const uploadedDocuments = Digit.SessionStorage.get(noc === null || noc === void 0 ? void 0 : noc.nocType) || [];
      return {
        Noc: {
          ...noc,
          documents: [...(noc !== null && noc !== void 0 && noc.documents ? noc === null || noc === void 0 ? void 0 : noc.documents : []), ...(uploadedDocuments ? uploadedDocuments : [])]
        }
      };
    });
    let nocData = [];
    if (nocDetails) {
      nocDetails.map(noc => {
        var _noc$Noc, _noc$Noc$applicationS, _noc$Noc2, _noc$Noc2$application, _noc$Noc3, _noc$Noc3$application, _noc$Noc4, _noc$Noc4$application, _noc$Noc5, _noc$Noc5$application;
        if ((noc === null || noc === void 0 ? void 0 : (_noc$Noc = noc.Noc) === null || _noc$Noc === void 0 ? void 0 : (_noc$Noc$applicationS = _noc$Noc.applicationStatus) === null || _noc$Noc$applicationS === void 0 ? void 0 : _noc$Noc$applicationS.toUpperCase()) != "APPROVED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc2 = noc.Noc) === null || _noc$Noc2 === void 0 ? void 0 : (_noc$Noc2$application = _noc$Noc2.applicationStatus) === null || _noc$Noc2$application === void 0 ? void 0 : _noc$Noc2$application.toUpperCase()) != "AUTO_APPROVED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc3 = noc.Noc) === null || _noc$Noc3 === void 0 ? void 0 : (_noc$Noc3$application = _noc$Noc3.applicationStatus) === null || _noc$Noc3$application === void 0 ? void 0 : _noc$Noc3$application.toUpperCase()) != "REJECTED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc4 = noc.Noc) === null || _noc$Noc4 === void 0 ? void 0 : (_noc$Noc4$application = _noc$Noc4.applicationStatus) === null || _noc$Noc4$application === void 0 ? void 0 : _noc$Noc4$application.toUpperCase()) != "AUTO_REJECTED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc5 = noc.Noc) === null || _noc$Noc5 === void 0 ? void 0 : (_noc$Noc5$application = _noc$Noc5.applicationStatus) === null || _noc$Noc5$application === void 0 ? void 0 : _noc$Noc5$application.toUpperCase()) != "VOIDED") {
          nocData.push(noc);
        }
      });
    }
    submitAction({
      BPA: applicationData
    }, (nocData === null || nocData === void 0 ? void 0 : nocData.length) > 0 ? nocData : false, {
      isStakeholder: false,
      bpa: true
    });
  }
  useEffect(() => {
    if (action) {
      setConfig(configBPAApproverApplication({
        t,
        action,
        approvers,
        selectedApprover,
        setSelectedApprover,
        selectFile,
        uploadedFile,
        setUploadedFile,
        businessService,
        assigneeLabel: "WF_ASSIGNEE_NAME_LABEL",
        error
      }));
    }
  }, [action, approvers, selectedFinancialYear, uploadedFile, error]);
  return action && config.form ? /*#__PURE__*/React$1.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React$1.createElement(Heading$3, {
      label: t(config.label.heading)
    }),
    headerBarEnd: /*#__PURE__*/React$1.createElement(CloseBtn$3, {
      onClick: closeModal
    }),
    actionCancelLabel: t(config.label.cancel),
    actionCancelOnSubmit: closeModal,
    actionSaveLabel: t(config.label.submit),
    actionSaveOnSubmit: () => {},
    formId: "modal-action",
    isOBPSFlow: true,
    popupStyles: mobileView ? {
      width: "720px"
    } : {},
    style: !mobileView ? {
      minHeight: "45px",
      height: "auto",
      width: "107px",
      paddingLeft: "0px",
      paddingRight: "0px"
    } : {
      minHeight: "45px",
      height: "auto",
      width: "44%"
    },
    popupModuleMianStyles: mobileView ? {
      paddingLeft: "5px"
    } : {},
    isDisabled: ((_applicationData4 = applicationData) === null || _applicationData4 === void 0 ? void 0 : _applicationData4.status) === "UPLOAD_DIGI_SIGN_LETTER" && file === null ? true : false
  }, PTALoading ? /*#__PURE__*/React$1.createElement(Loader, null) : /*#__PURE__*/React$1.createElement(FormComposer, {
    config: config.form,
    cardStyle: {
      marginLeft: "0px",
      marginRight: "0px",
      marginTop: "-25px"
    },
    className: "BPAemployeeCard",
    noBoxShadow: true,
    inline: true,
    childrenAtTheBottom: true,
    onSubmit: submit,
    defaultValues: defaultValues,
    formId: "modal-action"
  })) : /*#__PURE__*/React$1.createElement(Loader, null);
};

const Heading$4 = props => {
  return /*#__PURE__*/React$1.createElement("h1", {
    style: {
      marginLeft: "22px"
    },
    className: "heading-m BPAheading-m"
  }, props.label);
};
const Close$4 = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React$1.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$4 = props => {
  return /*#__PURE__*/React$1.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React$1.createElement(Close$4, null));
};
const ActionModal$4 = ({
  t,
  action,
  tenantId,
  state,
  id,
  closeModal,
  submitAction,
  actionData,
  applicationDetails,
  applicationData,
  businessService,
  moduleCode,
  workflowDetails
}) => {
  var _applicationData, _applicationData$land, _applicationData$land2, _applicationData2, _applicationData2$lan, _applicationData2$lan2, _workflowDetails$data, _workflowDetails$data2, _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data5, _workflowDetails$data6;
  const mutation1 = Digit.Hooks.obps.useObpsAPI((_applicationData = applicationData) !== null && _applicationData !== void 0 && (_applicationData$land = _applicationData.landInfo) !== null && _applicationData$land !== void 0 && (_applicationData$land2 = _applicationData$land.address) !== null && _applicationData$land2 !== void 0 && _applicationData$land2.city ? (_applicationData2 = applicationData) === null || _applicationData2 === void 0 ? void 0 : (_applicationData2$lan = _applicationData2.landInfo) === null || _applicationData2$lan === void 0 ? void 0 : (_applicationData2$lan2 = _applicationData2$lan.address) === null || _applicationData2$lan2 === void 0 ? void 0 : _applicationData2$lan2.city : tenantId, false);
  const {
    data: approverData,
    isLoading: PTALoading
  } = Digit.Hooks.useEmployeeSearch(tenantId, {
    roles: workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.initialActionState) === null || _workflowDetails$data2 === void 0 ? void 0 : (_workflowDetails$data3 = _workflowDetails$data2.nextActions) === null || _workflowDetails$data3 === void 0 ? void 0 : (_workflowDetails$data4 = _workflowDetails$data3.filter(ele => (ele === null || ele === void 0 ? void 0 : ele.action) == (action === null || action === void 0 ? void 0 : action.action))) === null || _workflowDetails$data4 === void 0 ? void 0 : (_workflowDetails$data5 = _workflowDetails$data4[0]) === null || _workflowDetails$data5 === void 0 ? void 0 : (_workflowDetails$data6 = _workflowDetails$data5.assigneeRoles) === null || _workflowDetails$data6 === void 0 ? void 0 : _workflowDetails$data6.map(role => ({
      code: role
    })),
    isActive: true
  }, {
    enabled: !(action !== null && action !== void 0 && action.isTerminateState)
  });
  const queryClient = useQueryClient();
  const [config, setConfig] = useState({});
  const [defaultValues, setDefaultValues] = useState({});
  const [approvers, setApprovers] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState({});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(null);
  const mobileView = Digit.Utils.browser.isMobile() ? true : false;
  useEffect(() => {
    var _approverData$Employe;
    setApprovers(approverData === null || approverData === void 0 ? void 0 : (_approverData$Employe = approverData.Employees) === null || _approverData$Employe === void 0 ? void 0 : _approverData$Employe.map(employee => {
      var _employee$user;
      return {
        uuid: employee === null || employee === void 0 ? void 0 : employee.uuid,
        name: employee === null || employee === void 0 ? void 0 : (_employee$user = employee.user) === null || _employee$user === void 0 ? void 0 : _employee$user.name
      };
    }));
  }, [approverData]);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("OBPS", file, Digit.ULBService.getStateId() || (tenantId === null || tenantId === void 0 ? void 0 : tenantId.split(".")[0]));
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  const getInspectionDocs = docs => {
    let refinedDocs = [];
    docs && docs.map((doc, ind) => {
      refinedDocs.push({
        "documentType": (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", "."),
        "fileStoreId": doc.fileStoreId,
        "fileStore": doc.fileStoreId,
        "fileName": "",
        "dropDownValues": {
          "value": (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", ".")
        }
      });
    });
    return refinedDocs;
  };
  const getQuestion = data => {
    let refinedQues = [];
    var i;
    for (i = 0; i < (data === null || data === void 0 ? void 0 : data.questionLength); i++) {
      var _data;
      refinedQues.push({
        "remarks": data[`Remarks_${i}`],
        "question": data === null || data === void 0 ? void 0 : data.questionList[i].question,
        "value": data === null || data === void 0 ? void 0 : (_data = data[`question_${i}`]) === null || _data === void 0 ? void 0 : _data.code
      });
    }
    return refinedQues;
  };
  const getfeildInspection = data => {
    var _data$additionalDetai, _data$additionalDetai2;
    let formdata = [],
      inspectionOb = [];
    if ((data === null || data === void 0 ? void 0 : (_data$additionalDetai = data.additionalDetails) === null || _data$additionalDetai === void 0 ? void 0 : (_data$additionalDetai2 = _data$additionalDetai.fieldinspection_pending) === null || _data$additionalDetai2 === void 0 ? void 0 : _data$additionalDetai2.length) > 0) {
      var _data$additionalDetai3;
      inspectionOb = data === null || data === void 0 ? void 0 : (_data$additionalDetai3 = data.additionalDetails) === null || _data$additionalDetai3 === void 0 ? void 0 : _data$additionalDetai3.fieldinspection_pending;
    }
    if (data.status == "FIELDINSPECTION_INPROGRESS") {
      var _formdata;
      formdata = JSON.parse(sessionStorage.getItem("INSPECTION_DATA"));
      ((_formdata = formdata) === null || _formdata === void 0 ? void 0 : _formdata.length) > 0 && formdata.map((ob, ind) => {
        inspectionOb.push({
          docs: getInspectionDocs(ob.Documents),
          date: ob.InspectionDate,
          questions: getQuestion(ob),
          time: ob === null || ob === void 0 ? void 0 : ob.InspectionTime
        });
      });
      inspectionOb = inspectionOb.filter(ob => ob.docs && ob.docs.length > 0);
    } else {
      sessionStorage.removeItem("INSPECTION_DATA");
    }
    let fieldinspection_pending = [...inspectionOb];
    return fieldinspection_pending;
  };
  const getDocuments = applicationData => {
    let documentsformdata = JSON.parse(sessionStorage.getItem("BPA_DOCUMENTS"));
    let documentList = [];
    documentsformdata.map(doc => {
      var _doc$uploadedDocument, _doc$uploadedDocument2, _doc$uploadedDocument3, _doc$uploadedDocument4, _doc$uploadedDocument5, _doc$newUploadedDocs;
      if ((doc === null || doc === void 0 ? void 0 : (_doc$uploadedDocument = doc.uploadedDocuments) === null || _doc$uploadedDocument === void 0 ? void 0 : (_doc$uploadedDocument2 = _doc$uploadedDocument[0]) === null || _doc$uploadedDocument2 === void 0 ? void 0 : (_doc$uploadedDocument3 = _doc$uploadedDocument2.values) === null || _doc$uploadedDocument3 === void 0 ? void 0 : _doc$uploadedDocument3.length) > 0) documentList = [...documentList, ...(doc === null || doc === void 0 ? void 0 : (_doc$uploadedDocument4 = doc.uploadedDocuments) === null || _doc$uploadedDocument4 === void 0 ? void 0 : (_doc$uploadedDocument5 = _doc$uploadedDocument4[0]) === null || _doc$uploadedDocument5 === void 0 ? void 0 : _doc$uploadedDocument5.values)];
      if ((doc === null || doc === void 0 ? void 0 : (_doc$newUploadedDocs = doc.newUploadedDocs) === null || _doc$newUploadedDocs === void 0 ? void 0 : _doc$newUploadedDocs.length) > 0) documentList = [...documentList, ...(doc === null || doc === void 0 ? void 0 : doc.newUploadedDocs)];
    });
    return documentList;
  };
  const getPendingApprovals = () => {
    var _result;
    const approvals = Digit.SessionStorage.get("OBPS_APPROVAL_CHECKS");
    const newApprovals = Digit.SessionStorage.get("OBPS_NEW_APPROVALS");
    let result = approvals === null || approvals === void 0 ? void 0 : approvals.reduce((acc, approval) => approval !== null && approval !== void 0 && approval.checked ? acc.push(approval === null || approval === void 0 ? void 0 : approval.label) && acc : acc, []);
    result = (_result = result) === null || _result === void 0 ? void 0 : _result.concat(newApprovals !== null ? newApprovals.filter(ob => ob.label !== "").map(approval => approval === null || approval === void 0 ? void 0 : approval.label) : []);
    return result;
  };
  function submit(data) {
    var _applicationData3, _data$comments, _data$comments2, _applicationDetails$n;
    applicationData = {
      ...applicationData,
      documents: getDocuments(),
      additionalDetails: {
        ...((_applicationData3 = applicationData) === null || _applicationData3 === void 0 ? void 0 : _applicationData3.additionalDetails),
        fieldinspection_pending: getfeildInspection(applicationData),
        pendingapproval: getPendingApprovals()
      },
      workflow: {
        action: action === null || action === void 0 ? void 0 : action.action,
        comment: (data === null || data === void 0 ? void 0 : (_data$comments = data.comments) === null || _data$comments === void 0 ? void 0 : _data$comments.length) > 0 ? data === null || data === void 0 ? void 0 : data.comments : null,
        comments: (data === null || data === void 0 ? void 0 : (_data$comments2 = data.comments) === null || _data$comments2 === void 0 ? void 0 : _data$comments2.length) > 0 ? data === null || data === void 0 ? void 0 : data.comments : null,
        assignee: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
        assignes: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
        varificationDocuments: uploadedFile ? [{
          documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      },
      action: action === null || action === void 0 ? void 0 : action.action,
      comment: data === null || data === void 0 ? void 0 : data.comments,
      assignee: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
      wfDocuments: uploadedFile ? [{
        documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
        fileName: file === null || file === void 0 ? void 0 : file.name,
        fileStoreId: uploadedFile
      }] : null
    };
    const nocDetails = applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$n = applicationDetails.nocData) === null || _applicationDetails$n === void 0 ? void 0 : _applicationDetails$n.map(noc => {
      const uploadedDocuments = Digit.SessionStorage.get(noc === null || noc === void 0 ? void 0 : noc.nocType) || [];
      return {
        Noc: {
          ...noc,
          documents: [...(noc !== null && noc !== void 0 && noc.documents ? noc === null || noc === void 0 ? void 0 : noc.documents : []), ...(uploadedDocuments ? uploadedDocuments : [])]
        }
      };
    });
    if (nocDetails) {
      nocDetails.map(noc => {
        var _noc$Noc, _noc$Noc$applicationS, _noc$Noc2, _noc$Noc2$application, _noc$Noc3, _noc$Noc3$application, _noc$Noc4, _noc$Noc4$application, _noc$Noc5, _noc$Noc5$application;
        if ((noc === null || noc === void 0 ? void 0 : (_noc$Noc = noc.Noc) === null || _noc$Noc === void 0 ? void 0 : (_noc$Noc$applicationS = _noc$Noc.applicationStatus) === null || _noc$Noc$applicationS === void 0 ? void 0 : _noc$Noc$applicationS.toUpperCase()) != "APPROVED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc2 = noc.Noc) === null || _noc$Noc2 === void 0 ? void 0 : (_noc$Noc2$application = _noc$Noc2.applicationStatus) === null || _noc$Noc2$application === void 0 ? void 0 : _noc$Noc2$application.toUpperCase()) != "AUTO_APPROVED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc3 = noc.Noc) === null || _noc$Noc3 === void 0 ? void 0 : (_noc$Noc3$application = _noc$Noc3.applicationStatus) === null || _noc$Noc3$application === void 0 ? void 0 : _noc$Noc3$application.toUpperCase()) != "REJECTED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc4 = noc.Noc) === null || _noc$Noc4 === void 0 ? void 0 : (_noc$Noc4$application = _noc$Noc4.applicationStatus) === null || _noc$Noc4$application === void 0 ? void 0 : _noc$Noc4$application.toUpperCase()) != "AUTO_REJECTED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc5 = noc.Noc) === null || _noc$Noc5 === void 0 ? void 0 : (_noc$Noc5$application = _noc$Noc5.applicationStatus) === null || _noc$Noc5$application === void 0 ? void 0 : _noc$Noc5$application.toUpperCase()) != "VOIDED") ;
      });
    }
    submitAction({
      PermissionOfSubdivision: applicationData
    });
  }
  useEffect(() => {
    if (action) {
      setConfig(configBPAApproverApplication({
        t,
        action,
        approvers,
        selectedApprover,
        setSelectedApprover,
        selectFile,
        uploadedFile,
        setUploadedFile,
        businessService,
        assigneeLabel: "WF_ASSIGNEE_NAME_LABEL",
        error
      }));
    }
  }, [action, approvers, selectedFinancialYear, uploadedFile, error]);
  return action && config.form ? /*#__PURE__*/React$1.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React$1.createElement(Heading$4, {
      label: t(config.label.heading)
    }),
    headerBarEnd: /*#__PURE__*/React$1.createElement(CloseBtn$4, {
      onClick: closeModal
    }),
    actionCancelLabel: t(config.label.cancel),
    actionCancelOnSubmit: closeModal,
    actionSaveLabel: t(config.label.submit),
    actionSaveOnSubmit: () => {},
    formId: "modal-action",
    isOBPSFlow: true,
    popupStyles: mobileView ? {
      width: "720px"
    } : {},
    style: !mobileView ? {
      minHeight: "45px",
      height: "auto",
      width: "107px",
      paddingLeft: "0px",
      paddingRight: "0px"
    } : {
      minHeight: "45px",
      height: "auto",
      width: "44%"
    },
    popupModuleMianStyles: mobileView ? {
      paddingLeft: "5px"
    } : {}
  }, PTALoading ? /*#__PURE__*/React$1.createElement(Loader, null) : /*#__PURE__*/React$1.createElement(FormComposer, {
    config: config.form,
    cardStyle: {
      marginLeft: "0px",
      marginRight: "0px",
      marginTop: "-25px"
    },
    className: "BPAemployeeCard",
    noBoxShadow: true,
    inline: true,
    childrenAtTheBottom: true,
    onSubmit: submit,
    defaultValues: defaultValues,
    formId: "modal-action"
  })) : /*#__PURE__*/React$1.createElement(Loader, null);
};

const Heading$5 = props => {
  return /*#__PURE__*/React$1.createElement("h1", {
    style: {
      marginLeft: "22px"
    },
    className: "heading-m BPAheading-m"
  }, props.label);
};
const Close$5 = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React$1.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$5 = props => {
  return /*#__PURE__*/React$1.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React$1.createElement(Close$5, null));
};
const ActionModal$5 = ({
  t,
  action,
  tenantId,
  state,
  id,
  closeModal,
  submitAction,
  actionData,
  applicationData,
  businessService,
  moduleCode
}) => {
  var _action$assigneeRoles, _action$assigneeRoles2;
  const {
    data: approverData,
    isLoading: PTALoading
  } = Digit.Hooks.useEmployeeSearch(tenantId, {
    roles: action === null || action === void 0 ? void 0 : (_action$assigneeRoles = action.assigneeRoles) === null || _action$assigneeRoles === void 0 ? void 0 : (_action$assigneeRoles2 = _action$assigneeRoles.map) === null || _action$assigneeRoles2 === void 0 ? void 0 : _action$assigneeRoles2.call(_action$assigneeRoles, e => ({
      code: e
    })),
    isActive: true
  }, {
    enabled: !(action !== null && action !== void 0 && action.isTerminateState)
  });
  const queryClient = useQueryClient();
  const [config, setConfig] = useState({});
  const [defaultValues, setDefaultValues] = useState({});
  const [approvers, setApprovers] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState({});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const mobileView = Digit.Utils.browser.isMobile() ? true : false;
  const history = useHistory();
  useEffect(() => {
    var _approverData$Employe;
    setApprovers(approverData === null || approverData === void 0 ? void 0 : (_approverData$Employe = approverData.Employees) === null || _approverData$Employe === void 0 ? void 0 : _approverData$Employe.map(employee => {
      var _employee$user;
      return {
        uuid: employee === null || employee === void 0 ? void 0 : employee.uuid,
        name: employee === null || employee === void 0 ? void 0 : (_employee$user = employee.user) === null || _employee$user === void 0 ? void 0 : _employee$user.name
      };
    }));
  }, [approverData]);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("NOC", file, Digit.ULBService.getStateId() || (tenantId === null || tenantId === void 0 ? void 0 : tenantId.split(".")[0]));
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  function submit(data) {
    var _applicationData, _applicationData$docu, _applicationData2;
    let enteredDocs = JSON.parse(sessionStorage.getItem("NewNOCDocs"));
    let newDocs = ((_applicationData = applicationData) === null || _applicationData === void 0 ? void 0 : (_applicationData$docu = _applicationData.documents) === null || _applicationData$docu === void 0 ? void 0 : _applicationData$docu.length) > 0 ? [...((_applicationData2 = applicationData) === null || _applicationData2 === void 0 ? void 0 : _applicationData2.documents)] : [];
    enteredDocs.map((d, index) => {
      newDocs.push(d);
    });
    applicationData = {
      ...applicationData,
      workflow: {
        action: action === null || action === void 0 ? void 0 : action.action,
        comment: data !== null && data !== void 0 && data.comments ? data === null || data === void 0 ? void 0 : data.comments : null,
        assignee: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
        documents: uploadedFile ? [{
          documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      },
      documents: newDocs
    };
    submitAction({
      Noc: applicationData
    }, false, {
      isNoc: true
    });
  }
  useEffect(() => {
    if (action) {
      setConfig(configNOCApproverApplication({
        t,
        action,
        approvers,
        selectedApprover,
        setSelectedApprover,
        selectFile,
        uploadedFile,
        setUploadedFile,
        businessService,
        assigneeLabel: "WF_ASSIGNEE_NAME_LABEL",
        error
      }));
    }
  }, [action, approvers, uploadedFile, error]);
  return action && config.form ? /*#__PURE__*/React$1.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React$1.createElement(Heading$5, {
      label: t(config.label.heading)
    }),
    headerBarEnd: /*#__PURE__*/React$1.createElement(CloseBtn$5, {
      onClick: closeModal
    }),
    actionCancelLabel: t(config.label.cancel),
    actionCancelOnSubmit: closeModal,
    actionSaveLabel: t(config.label.submit),
    actionSaveOnSubmit: () => {},
    formId: "modal-action",
    isOBPSFlow: true,
    popupStyles: mobileView ? {
      width: "720px"
    } : {},
    style: !mobileView ? {
      height: "45px",
      width: "107px",
      paddingLeft: "0px",
      paddingRight: "0px"
    } : {
      height: "45px",
      width: "44%"
    },
    popupModuleMianStyles: mobileView ? {
      paddingLeft: "5px"
    } : {}
  }, PTALoading ? /*#__PURE__*/React$1.createElement(Loader, null) : /*#__PURE__*/React$1.createElement(FormComposer, {
    config: config.form,
    cardStyle: {
      marginLeft: "0px",
      marginRight: "0px",
      marginTop: "-25px"
    },
    className: "BPAemployeeCard",
    noBoxShadow: true,
    inline: true,
    childrenAtTheBottom: true,
    onSubmit: submit,
    defaultValues: defaultValues,
    formId: "modal-action"
  })) : /*#__PURE__*/React$1.createElement(Loader, null);
};

const ActionModal$6 = props => {
  if (props !== null && props !== void 0 && props.businessService.includes("PT")) {
    return /*#__PURE__*/React$1.createElement(ActionModal, props);
  }
  if (props !== null && props !== void 0 && props.businessService.includes("NewTL") || props !== null && props !== void 0 && props.businessService.includes("TL") || props !== null && props !== void 0 && props.businessService.includes("EDITRENEWAL") || props !== null && props !== void 0 && props.businessService.includes("DIRECTRENEWAL")) {
    return /*#__PURE__*/React$1.createElement(ActionModal$1, props);
  }
  if (props !== null && props !== void 0 && props.moduleCode.includes("BPAREG")) {
    return /*#__PURE__*/React$1.createElement(ActionModal$2, props);
  }
  if (props !== null && props !== void 0 && props.moduleCode.includes("BPA")) {
    return /*#__PURE__*/React$1.createElement(ActionModal$3, props);
  }
  if (props !== null && props !== void 0 && props.moduleCode.includes("NOC")) {
    return /*#__PURE__*/React$1.createElement(ActionModal$5, props);
  }
  if (props !== null && props !== void 0 && props.moduleCode.includes("BPA_FORM11")) {
    return /*#__PURE__*/React$1.createElement(ActionModal$4, props);
  }
};

function DocumentsPreview({
  documents,
  svgStyles = {},
  isSendBackFlow = false,
  isHrLine = false,
  titleStyles
}) {
  const {
    t
  } = useTranslation();
  const isStakeholderApplication = window.location.href.includes("stakeholder");
  return /*#__PURE__*/React$1.createElement("div", {
    style: {
      marginTop: "19px"
    }
  }, !isStakeholderApplication && (documents === null || documents === void 0 ? void 0 : documents.map((document, index) => {
    var _document$values;
    return /*#__PURE__*/React$1.createElement(React$1.Fragment, {
      key: index
    }, document !== null && document !== void 0 && document.title ? /*#__PURE__*/React$1.createElement(CardSubHeader, {
      style: titleStyles ? titleStyles : {
        marginTop: "32px",
        marginBottom: "8px",
        color: "#505A5F",
        fontSize: "24px"
      }
    }, t(document === null || document === void 0 ? void 0 : document.title)) : null, /*#__PURE__*/React$1.createElement("div", {
      style: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "flex-start"
      }
    }, document !== null && document !== void 0 && document.values && (document === null || document === void 0 ? void 0 : document.values.length) > 0 ? document === null || document === void 0 ? void 0 : (_document$values = document.values) === null || _document$values === void 0 ? void 0 : _document$values.map((value, index) => {
      var _value$documentType;
      return /*#__PURE__*/React$1.createElement("a", {
        target: "_",
        href: value === null || value === void 0 ? void 0 : value.url,
        style: {
          minWidth: "80px",
          marginRight: "10px",
          maxWidth: "100px",
          height: "auto",
          minWidth: "100px"
        },
        key: index
      }, /*#__PURE__*/React$1.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React$1.createElement(PDFSvg, null)), /*#__PURE__*/React$1.createElement("p", {
        style: {
          marginTop: "8px",
          fontWeight: "bold",
          textAlign: "center",
          color: "#505A5F"
        }
      }, t(value === null || value === void 0 ? void 0 : value.title)), isSendBackFlow ? value !== null && value !== void 0 && (_value$documentType = value.documentType) !== null && _value$documentType !== void 0 && _value$documentType.includes("NOC") ? /*#__PURE__*/React$1.createElement("p", {
        style: {
          textAlign: "center"
        }
      }, t(value === null || value === void 0 ? void 0 : value.documentType.split(".")[1])) : /*#__PURE__*/React$1.createElement("p", {
        style: {
          textAlign: "center"
        }
      }, t(value === null || value === void 0 ? void 0 : value.documentType)) : "");
    }) : !window.location.href.includes("citizen") && /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement("p", null, t("BPA_NO_DOCUMENTS_UPLOADED_LABEL")))), isHrLine && (documents === null || documents === void 0 ? void 0 : documents.length) != index + 1 ? /*#__PURE__*/React$1.createElement("hr", {
      style: {
        color: "#D6D5D4",
        backgroundColor: "#D6D5D4",
        height: "2px",
        marginTop: "20px",
        marginBottom: "20px"
      }
    }) : null);
  })), isStakeholderApplication && (documents === null || documents === void 0 ? void 0 : documents.map((document, index) => {
    var _document$values2;
    return /*#__PURE__*/React$1.createElement(React$1.Fragment, {
      key: index
    }, document !== null && document !== void 0 && document.title ? /*#__PURE__*/React$1.createElement(CardSubHeader, {
      style: {
        marginTop: "32px",
        marginBottom: "8px",
        color: "#505A5F",
        fontSize: "24px"
      }
    }, t(document === null || document === void 0 ? void 0 : document.title)) : null, /*#__PURE__*/React$1.createElement("div", null, document !== null && document !== void 0 && document.values && (document === null || document === void 0 ? void 0 : document.values.length) > 0 ? document === null || document === void 0 ? void 0 : (_document$values2 = document.values) === null || _document$values2 === void 0 ? void 0 : _document$values2.map((value, index) => /*#__PURE__*/React$1.createElement("a", {
      target: "_",
      href: value === null || value === void 0 ? void 0 : value.url,
      style: {
        minWidth: svgStyles !== null && svgStyles !== void 0 && svgStyles.minWidth ? svgStyles === null || svgStyles === void 0 ? void 0 : svgStyles.minWidth : "160px",
        marginRight: "20px"
      },
      key: index
    }, /*#__PURE__*/React$1.createElement("div", {
      style: {
        maxWidth: "940px",
        padding: "8px",
        borderRadius: "4px",
        border: "1px solid #D6D5D4",
        background: "#FAFAFA"
      }
    }, /*#__PURE__*/React$1.createElement("p", {
      style: {
        marginTop: "8px",
        fontWeight: "bold",
        marginBottom: "10px"
      }
    }, t(value === null || value === void 0 ? void 0 : value.title)), value !== null && value !== void 0 && value.docInfo ? /*#__PURE__*/React$1.createElement("div", {
      style: {
        fontSize: "12px",
        color: "#505A5F",
        fontWeight: 400,
        lineHeight: "15px",
        marginBottom: "10px"
      }
    }, `${t(value === null || value === void 0 ? void 0 : value.docInfo)}`) : null, /*#__PURE__*/React$1.createElement(PDFSvg, null), /*#__PURE__*/React$1.createElement("p", {
      style: {
        marginTop: "8px",
        fontSize: "16px",
        lineHeight: "19px",
        color: "#505A5F",
        fontWeight: "400",
        textAlign: "center",
        color: "#505A5F"
      }
    }, `${t(value === null || value === void 0 ? void 0 : value.title)}`)))) : !window.location.href.includes("citizen") && /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement("p", null, t("BPA_NO_DOCUMENTS_UPLOADED_LABEL")))));
  })));
}

const BPADocuments = ({
  t,
  formData,
  applicationData,
  docs,
  bpaActionsDetails
}) => {
  var _bpaActionsDetails$da, _formData$documents;
  const applicationStatus = (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) || "";
  const actions = (bpaActionsDetails === null || bpaActionsDetails === void 0 ? void 0 : (_bpaActionsDetails$da = bpaActionsDetails.data) === null || _bpaActionsDetails$da === void 0 ? void 0 : _bpaActionsDetails$da.nextActions) || [];
  const stateId = Digit.ULBService.getStateId();
  const [documents, setDocuments] = useState((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.documents) || []);
  const [error, setError] = useState(null);
  const [bpaTaxDocuments, setBpaTaxDocuments] = useState([]);
  const [enableSubmit, setEnableSubmit] = useState(true);
  const [checkRequiredFields, setCheckRequiredFields] = useState(false);
  const [checkEnablingDocs, setCheckEnablingDocs] = useState(false);
  const {
    isLoading: bpaDocsLoading,
    data: bpaDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "BPA", ["DocTypeMapping"]);
  const {
    isLoading: commonDocsLoading,
    data: commonDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "common-masters", ["DocumentType"]);
  useEffect(() => {
    var _bpaDocs$BPA, _filtredBpaDocs, _filtredBpaDocs$, _filtredBpaDocs$$docT;
    let filtredBpaDocs = [];
    if (bpaDocs !== null && bpaDocs !== void 0 && (_bpaDocs$BPA = bpaDocs.BPA) !== null && _bpaDocs$BPA !== void 0 && _bpaDocs$BPA.DocTypeMapping) {
      var _bpaDocs$BPA2, _bpaDocs$BPA2$DocType;
      filtredBpaDocs = bpaDocs === null || bpaDocs === void 0 ? void 0 : (_bpaDocs$BPA2 = bpaDocs.BPA) === null || _bpaDocs$BPA2 === void 0 ? void 0 : (_bpaDocs$BPA2$DocType = _bpaDocs$BPA2.DocTypeMapping) === null || _bpaDocs$BPA2$DocType === void 0 ? void 0 : _bpaDocs$BPA2$DocType.filter(data => {
        var _applicationData$addi, _applicationData$addi2;
        return data.WFState == (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) ? applicationData === null || applicationData === void 0 ? void 0 : applicationData.status :  data.RiskType == (applicationData === null || applicationData === void 0 ? void 0 : applicationData.riskType) && data.ServiceType == (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$addi = applicationData.additionalDetails) === null || _applicationData$addi === void 0 ? void 0 : _applicationData$addi.serviceType) && data.applicationType == (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$addi2 = applicationData.additionalDetails) === null || _applicationData$addi2 === void 0 ? void 0 : _applicationData$addi2.applicationType);
      });
    }
    let documentsList = [];
    (_filtredBpaDocs = filtredBpaDocs) === null || _filtredBpaDocs === void 0 ? void 0 : (_filtredBpaDocs$ = _filtredBpaDocs[0]) === null || _filtredBpaDocs$ === void 0 ? void 0 : (_filtredBpaDocs$$docT = _filtredBpaDocs$.docTypes) === null || _filtredBpaDocs$$docT === void 0 ? void 0 : _filtredBpaDocs$$docT.forEach(doc => {
      var _commonDocs$commonMa, _commonDocs$commonMa$, _docs$, _docs$$values;
      let code = doc.code;
      doc.dropdownData = [];
      doc.uploadedDocuments = [];
      commonDocs === null || commonDocs === void 0 ? void 0 : (_commonDocs$commonMa = commonDocs["common-masters"]) === null || _commonDocs$commonMa === void 0 ? void 0 : (_commonDocs$commonMa$ = _commonDocs$commonMa.DocumentType) === null || _commonDocs$commonMa$ === void 0 ? void 0 : _commonDocs$commonMa$.forEach(value => {
        let values = value.code.slice(0, code.length);
        if (code === values) {
          doc.hasDropdown = true;
          value.i18nKey = value.code;
          doc.dropdownData.push(value);
        }
      });
      doc.uploadedDocuments[0] = {};
      doc.uploadedDocuments[0].values = [];
      docs === null || docs === void 0 ? void 0 : (_docs$ = docs[0]) === null || _docs$ === void 0 ? void 0 : (_docs$$values = _docs$.values) === null || _docs$$values === void 0 ? void 0 : _docs$$values.map(upDocs => {
        if (code === (upDocs === null || upDocs === void 0 ? void 0 : upDocs.documentType)) {
          doc.uploadedDocuments[0].values.push(upDocs);
        }
      });
      documentsList.push(doc);
    });
    sessionStorage.setItem("BPA_DOCUMENTS", JSON.stringify(documentsList));
    setBpaTaxDocuments(documentsList);
  }, [!bpaDocsLoading, !commonDocsLoading]);
  useEffect(() => {
    let count = 0;
    bpaTaxDocuments.map(doc => {
      let isRequired = false;
      documents.map(data => {
        if (doc.required && doc.code == `${data.documentType.split('.')[0]}.${data.documentType.split('.')[1]}`) {
          isRequired = true;
        }
      });
      if (!isRequired && doc.required) {
        count = count + 1;
      }
    });
    if ((count == "0" || count == 0) && documents.length > 0) setEnableSubmit(false);else setEnableSubmit(true);
  }, [documents, checkRequiredFields]);
  useEffect(() => {
    if (applicationStatus === "DOC_VERIFICATION_INPROGRESS" && (actions === null || actions === void 0 ? void 0 : actions.length) > 0) setCheckEnablingDocs(true);else setCheckEnablingDocs(false);
  }, [applicationData, bpaActionsDetails]);
  return /*#__PURE__*/React$1.createElement("div", null, bpaTaxDocuments === null || bpaTaxDocuments === void 0 ? void 0 : bpaTaxDocuments.map((document, index) => {
    return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(SelectDocument, {
      key: index,
      index: index,
      document: document,
      t: t,
      error: error,
      setError: setError,
      setDocuments: setDocuments,
      documents: documents,
      setCheckRequiredFields: setCheckRequiredFields,
      applicationStatus: applicationStatus,
      actions: actions,
      bpaTaxDocuments: bpaTaxDocuments,
      checkEnablingDocs: checkEnablingDocs
    }));
  }));
};
function SelectDocument({
  t,
  document: doc,
  setDocuments,
  error,
  setError,
  documents,
  setCheckRequiredFields,
  index,
  applicationStatus,
  actions,
  bpaTaxDocuments,
  checkEnablingDocs
}) {
  var _doc$dropdownData, _doc$uploadedDocument;
  const filteredDocument = documents === null || documents === void 0 ? void 0 : documents.filter(item => {
    var _item$documentType;
    return item === null || item === void 0 ? void 0 : (_item$documentType = item.documentType) === null || _item$documentType === void 0 ? void 0 : _item$documentType.includes(doc === null || doc === void 0 ? void 0 : doc.code);
  })[0];
  const tenantId = Digit.ULBService.getStateId();
  const [selectedDocument, setSelectedDocument] = useState(filteredDocument ? {
    ...filteredDocument,
    active: true,
    code: filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.documentType,
    i18nKey: filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.documentType
  } : (doc === null || doc === void 0 ? void 0 : (_doc$dropdownData = doc.dropdownData) === null || _doc$dropdownData === void 0 ? void 0 : _doc$dropdownData.length) === 1 ? doc === null || doc === void 0 ? void 0 : doc.dropdownData[0] : {});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(() => (filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.fileStoreId) || null);
  const [selectArrayFiles, SetSelectArrayFiles] = useState([]);
  const handleSelectDocument = value => setSelectedDocument(value);
  const allowedFileTypes = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
  function selectfiles(e) {
    e && setFile(e.file);
  }
  useEffect(() => {
    if (selectedDocument !== null && selectedDocument !== void 0 && selectedDocument.code) {
      setDocuments(prev => {
        var _documents$find;
        const filteredDocumentsByDocumentType = prev === null || prev === void 0 ? void 0 : prev.filter(item => (item === null || item === void 0 ? void 0 : item.documentType) !== (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code));
        if ((uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.length) === 0 || uploadedFile === null) return filteredDocumentsByDocumentType;
        const filteredDocumentsByFileStoreId = filteredDocumentsByDocumentType === null || filteredDocumentsByDocumentType === void 0 ? void 0 : filteredDocumentsByDocumentType.filter(item => (item === null || item === void 0 ? void 0 : item.fileStoreId) !== uploadedFile);
        return [...filteredDocumentsByFileStoreId, {
          documentType: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code,
          fileStoreId: uploadedFile,
          documentUid: uploadedFile,
          fileName: (file === null || file === void 0 ? void 0 : file.name) || "",
          id: documents ? (_documents$find = documents.find(x => x.documentType === (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code))) === null || _documents$find === void 0 ? void 0 : _documents$find.id : undefined
        }];
      });
    }
  }, [uploadedFile, selectedDocument]);
  useEffect(() => {
    (async () => {
      if (selectArrayFiles.length > 0) {
        sessionStorage.removeItem("BPA_DOCUMENTS");
        doc.newUploadedDocs = [];
        selectArrayFiles.map(newDoc => {
          if (selectedDocument !== null && selectedDocument !== void 0 && selectedDocument.code) {
            var _newDoc$fileStoreId, _newDoc$fileStoreId2, _newDoc$fileStoreId3;
            doc.newUploadedDocs.push({
              documentType: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code,
              fileStoreId: newDoc === null || newDoc === void 0 ? void 0 : (_newDoc$fileStoreId = newDoc.fileStoreId) === null || _newDoc$fileStoreId === void 0 ? void 0 : _newDoc$fileStoreId.fileStoreId,
              documentUid: newDoc === null || newDoc === void 0 ? void 0 : (_newDoc$fileStoreId2 = newDoc.fileStoreId) === null || _newDoc$fileStoreId2 === void 0 ? void 0 : _newDoc$fileStoreId2.fileStoreId,
              tenantId: newDoc === null || newDoc === void 0 ? void 0 : (_newDoc$fileStoreId3 = newDoc.fileStoreId) === null || _newDoc$fileStoreId3 === void 0 ? void 0 : _newDoc$fileStoreId3.tenantId
            });
          }
        });
        bpaTaxDocuments[index] = doc;
        sessionStorage.setItem("BPA_DOCUMENTS", JSON.stringify(bpaTaxDocuments));
      }
    })();
  }, [selectArrayFiles, selectedDocument]);
  useEffect(() => {
  }, [file]);
  const getData = (index, state) => {
    let data = Object.fromEntries(state);
    let newArr = Object.values(data);
    if (Object.keys(data).length !== 0) SetSelectArrayFiles(newArr);
    selectfiles(newArr[newArr.length - 1]);
  };
  return /*#__PURE__*/React$1.createElement("div", {
    style: {
      marginBottom: "24px",
      maxWidth: "950px",
      minWidth: "280px",
      background: "#FAFAFA",
      borderRadius: "4px",
      border: "1px solid #D6D5D4",
      padding: "8px"
    }
  }, /*#__PURE__*/React$1.createElement(CardSubHeader, {
    style: {
      marginBottom: "8px",
      paddingBottom: "9px",
      color: "#0B0C0C",
      fontSize: "16px",
      lineHeight: "19px"
    }
  }, `${t(doc === null || doc === void 0 ? void 0 : doc.code)}`), (doc === null || doc === void 0 ? void 0 : (_doc$uploadedDocument = doc.uploadedDocuments) === null || _doc$uploadedDocument === void 0 ? void 0 : _doc$uploadedDocument.length) && /*#__PURE__*/React$1.createElement(DocumentsPreview, {
    documents: doc === null || doc === void 0 ? void 0 : doc.uploadedDocuments,
    svgStyles: {
      width: "100px",
      height: "100px",
      viewBox: "0 0 25 25",
      minWidth: "100px"
    }
  }), checkEnablingDocs ? /*#__PURE__*/React$1.createElement("div", {
    style: {
      marginTop: "20px"
    }
  }, "]]      ", /*#__PURE__*/React$1.createElement(LabelFieldPair, {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React$1.createElement(CardLabel, {
    style: {
      marginTop: "-10px",
      width: "100%"
    }
  }, doc !== null && doc !== void 0 && doc.required ? `${t(doc === null || doc === void 0 ? void 0 : doc.code)}* ` : `${t(doc === null || doc === void 0 ? void 0 : doc.code)}`), /*#__PURE__*/React$1.createElement(Dropdown, {
    className: "form-field",
    t: t,
    isMandatory: false,
    option: doc === null || doc === void 0 ? void 0 : doc.dropdownData,
    selected: selectedDocument,
    optionKey: "i18nKey",
    select: handleSelectDocument,
    style: {
      width: "100%"
    }
  })), /*#__PURE__*/React$1.createElement(LabelFieldPair, {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React$1.createElement(CardLabel, {
    className: "card-label-smaller",
    style: {
      width: "100%"
    }
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "field",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React$1.createElement(MultiUploadWrapper, {
    module: "BPA",
    tenantId: tenantId,
    getFormState: e => getData(index, e),
    t: t,
    allowedFileTypesRegex: allowedFileTypes,
    allowedMaxSizeInMB: 5,
    acceptFiles: "image/*, .pdf, .png, .jpeg, .jpg"
  })))) : null);
}

const getDocuments = fiDocuments => {
  const returnDocuments = [{
    title: "BPA_DOCUMENT_DETAILS_LABEL",
    values: fiDocuments === null || fiDocuments === void 0 ? void 0 : fiDocuments.map(doc => {
      var _doc$documentType;
      return {
        title: doc === null || doc === void 0 ? void 0 : (_doc$documentType = doc.documentType) === null || _doc$documentType === void 0 ? void 0 : _doc$documentType.replaceAll('.', '_'),
        documentType: doc === null || doc === void 0 ? void 0 : doc.documentType,
        documentUid: doc === null || doc === void 0 ? void 0 : doc.documentUid,
        fileStoreId: doc === null || doc === void 0 ? void 0 : doc.fileStoreId,
        id: doc === null || doc === void 0 ? void 0 : doc.id,
        url: doc === null || doc === void 0 ? void 0 : doc.url
      };
    })
  }];
  return returnDocuments;
};
function InspectionReport({
  fiReport,
  isCitizen = false
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement("div", {
    style: {
      marginTop: "10px"
    }
  }, isCitizen ? /*#__PURE__*/React$1.createElement(CardHeader, {
    style: {
      fontSize: "24px"
    }
  }, `${t(`BPA_FI_REPORT`)}`) : /*#__PURE__*/React$1.createElement(CardSectionHeader, {
    style: {
      fontSize: "24px"
    }
  }, `${t(`BPA_FI_REPORT`)}`), fiReport.map((fiData, index) => {
    var _fiData$date, _fiData$date2, _fiData$date3, _fiData$questions, _fiData$questions2;
    return /*#__PURE__*/React$1.createElement("div", {
      style: {
        background: "#FAFAFA",
        border: "1px solid #D6D5D4",
        padding: "8px",
        borderRadius: "4px",
        maxWidth: "950px",
        minWidth: "280px",
        marginBottom: "24px"
      }
    }, /*#__PURE__*/React$1.createElement(StatusTable, null, /*#__PURE__*/React$1.createElement(CardSectionHeader, {
      style: {
        fontSize: "20px"
      }
    }, (fiReport === null || fiReport === void 0 ? void 0 : fiReport.length) == 1 ? `${t(`BPA_FI_REPORT`)}` : `${t(`BPA_FI_REPORT`)} - ${index + 1}`), /*#__PURE__*/React$1.createElement(Row, {
      className: "border-none",
      label: `${t(`BPA_FI_DATE_LABEL`)}`,
      text: fiData !== null && fiData !== void 0 && fiData.date ? fiData.date.includes("-") ? `${(_fiData$date = fiData.date) === null || _fiData$date === void 0 ? void 0 : _fiData$date.split("-")[2]}/${(_fiData$date2 = fiData.date) === null || _fiData$date2 === void 0 ? void 0 : _fiData$date2.split("-")[1]}/${(_fiData$date3 = fiData.date) === null || _fiData$date3 === void 0 ? void 0 : _fiData$date3.split("-")[0]}` : fiData === null || fiData === void 0 ? void 0 : fiData.date : "NA"
    }), /*#__PURE__*/React$1.createElement(Row, {
      className: "border-none",
      label: `${t(`BPA_FI_TIME_LABEL`)}`,
      text: fiData !== null && fiData !== void 0 && fiData.time ? fiData === null || fiData === void 0 ? void 0 : fiData.time : "NA"
    }), (fiData === null || fiData === void 0 ? void 0 : (_fiData$questions = fiData.questions) === null || _fiData$questions === void 0 ? void 0 : _fiData$questions.length) && (fiData === null || fiData === void 0 ? void 0 : (_fiData$questions2 = fiData.questions) === null || _fiData$questions2 === void 0 ? void 0 : _fiData$questions2.map(qstn => /*#__PURE__*/React$1.createElement("div", {
      style: {
        background: "white",
        border: "1px solid #D6D5D4",
        padding: "8px",
        borderRadius: "4px",
        marginTop: "10px"
      }
    }, /*#__PURE__*/React$1.createElement(Row, {
      className: "border-none",
      label: `${t(`${qstn.question}`)}`,
      text: qstn !== null && qstn !== void 0 && qstn.value ? qstn === null || qstn === void 0 ? void 0 : qstn.value : "NA"
    }), /*#__PURE__*/React$1.createElement(Row, {
      className: "border-none",
      label: `${t(`BPA_ENTER_REMARKS`)}`,
      text: qstn.remarks ? qstn.remarks : "NA"
    })))), /*#__PURE__*/React$1.createElement(DocumentsPreview, {
      documents: getDocuments(fiData === null || fiData === void 0 ? void 0 : fiData.docs),
      svgStyles: {
        width: "100px",
        height: "100px",
        viewBox: "0 0 25 25",
        minWidth: "100px"
      }
    })));
  })));
}

function SelectDocument$1({
  t,
  document: doc,
  setNocDocuments,
  setError,
  nocDocuments
}) {
  const filteredDocument = nocDocuments === null || nocDocuments === void 0 ? void 0 : nocDocuments.filter(item => {
    var _item$documentType;
    return item === null || item === void 0 ? void 0 : (_item$documentType = item.documentType) === null || _item$documentType === void 0 ? void 0 : _item$documentType.includes(doc === null || doc === void 0 ? void 0 : doc.code);
  })[0];
  const tenantId = Digit.ULBService.getStateId();
  const [selectedDocument, setSelectedDocument] = useState();
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(() => (filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.fileStoreId) || null);
  const allowedFileTypes = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
  function selectfile(e) {
    e && setFile(e.file);
  }
  useEffect(() => {
    var _doc$dropdownData, _doc$dropdownData$;
    if (doc !== null && doc !== void 0 && (_doc$dropdownData = doc.dropdownData) !== null && _doc$dropdownData !== void 0 && (_doc$dropdownData$ = _doc$dropdownData[0]) !== null && _doc$dropdownData$ !== void 0 && _doc$dropdownData$.code) {
      setNocDocuments(prev => {
        var _doc$dropdownData3;
        const filteredDocumentsByDocumentType = prev === null || prev === void 0 ? void 0 : prev.filter(item => {
          var _doc$dropdownData2, _doc$dropdownData2$;
          return (item === null || item === void 0 ? void 0 : item.documentType) !== (doc === null || doc === void 0 ? void 0 : (_doc$dropdownData2 = doc.dropdownData) === null || _doc$dropdownData2 === void 0 ? void 0 : (_doc$dropdownData2$ = _doc$dropdownData2[0]) === null || _doc$dropdownData2$ === void 0 ? void 0 : _doc$dropdownData2$.code);
        });
        if ((uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.length) === 0 || uploadedFile === null) {
          return filteredDocumentsByDocumentType;
        }
        const filteredDocumentsByFileStoreId = filteredDocumentsByDocumentType === null || filteredDocumentsByDocumentType === void 0 ? void 0 : filteredDocumentsByDocumentType.filter(item => (item === null || item === void 0 ? void 0 : item.fileStoreId) !== uploadedFile);
        return [...filteredDocumentsByFileStoreId, {
          documentType: doc === null || doc === void 0 ? void 0 : (_doc$dropdownData3 = doc.dropdownData) === null || _doc$dropdownData3 === void 0 ? void 0 : _doc$dropdownData3[0].code,
          fileStoreId: uploadedFile,
          documentUid: uploadedFile,
          fileName: (file === null || file === void 0 ? void 0 : file.name) || ""
        }];
      });
    }
  }, [uploadedFile]);
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _response$data, _response$data$files;
            setUploadedFile(null);
            const response = await Digit.UploadServices.Filestorage("PT", file, Digit.ULBService.getStateId());
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  const getData = state => {
    let data = Object.fromEntries(state);
    let newArr = Object.values(data);
    selectfile(newArr[newArr.length - 1]);
  };
  return /*#__PURE__*/React$1.createElement("div", {
    style: {}
  }, /*#__PURE__*/React$1.createElement(LabelFieldPair, {
    style: {
      width: "98%",
      marginRight: "10px"
    }
  }, /*#__PURE__*/React$1.createElement(CardLabel, {
    style: {
      width: "100%"
    }
  }, doc !== null && doc !== void 0 && doc.required ? `${t("TL_BUTTON_UPLOAD FILE")}*` : `${t("TL_BUTTON_UPLOAD FILE")}`), /*#__PURE__*/React$1.createElement("div", {
    className: "field",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React$1.createElement(MultiUploadWrapper, {
    module: "NOC",
    tenantId: tenantId,
    getFormState: e => getData(e),
    t: t,
    allowedFileTypesRegex: allowedFileTypes,
    allowedMaxSizeInMB: 5,
    acceptFiles: "image/*, .pdf, .png, .jpeg, .jpg"
  }))));
}
const NOCDocuments = ({
  t,
  noc,
  docs,
  isNoc,
  applicationData,
  NOCdata,
  bpaActionsDetails
}) => {
  var _bpaActionsDetails$da;
  const tenantId = Digit.ULBService.getStateId();
  const stateId = Digit.ULBService.getStateId();
  const bpaApplicationStatus = (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) || "";
  const actions = (bpaActionsDetails === null || bpaActionsDetails === void 0 ? void 0 : (_bpaActionsDetails$da = bpaActionsDetails.data) === null || _bpaActionsDetails$da === void 0 ? void 0 : _bpaActionsDetails$da.nextActions) || [];
  const {
    isLoading: nocDocsLoading,
    data: nocDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "NOC", ["DocumentTypeMapping"], {
    enabled: isNoc
  });
  const {
    isLoading: bpaDocsLoading,
    data: bpaDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "BPA", ["DocTypeMapping"], {
    enabled: !isNoc
  });
  const {
    isLoading: commonDocsLoading,
    data: commonDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "common-masters", ["DocumentType"]);
  const [commonDocMaping, setCommonDocMaping] = useState([]);
  const [nocTaxDocuments, setNocTaxDocuments] = useState([]);
  const [checkEnablingDocs, setCheckEnablingDocs] = useState(false);
  const [nocDocuments, setNocDocuments] = Digit.Hooks.useSessionStorage(noc === null || noc === void 0 ? void 0 : noc.nocType, []);
  const [error, setError] = useState(null);
  const isEmployee = window.location.href.includes("/employee/");
  useEffect(() => {
    var _commonDocs$commonMa;
    setCommonDocMaping(commonDocs === null || commonDocs === void 0 ? void 0 : (_commonDocs$commonMa = commonDocs["common-masters"]) === null || _commonDocs$commonMa === void 0 ? void 0 : _commonDocs$commonMa.DocumentType);
  }, [commonDocs]);
  useEffect(() => {
    var _filteredData, _filteredData$, _filteredData$$docTyp;
    let documents = [];
    let filteredData;
    if (isNoc) {
      var _nocDocs$NOC, _nocDocs$NOC$Document;
      filteredData = nocDocs === null || nocDocs === void 0 ? void 0 : (_nocDocs$NOC = nocDocs.NOC) === null || _nocDocs$NOC === void 0 ? void 0 : (_nocDocs$NOC$Document = _nocDocs$NOC.DocumentTypeMapping) === null || _nocDocs$NOC$Document === void 0 ? void 0 : _nocDocs$NOC$Document.filter(data => {
        return (data === null || data === void 0 ? void 0 : data.applicationType) === (noc === null || noc === void 0 ? void 0 : noc.applicationType) && (data === null || data === void 0 ? void 0 : data.nocType) === (noc === null || noc === void 0 ? void 0 : noc.nocType);
      });
    } else {
      var _bpaDocs$BPA, _bpaDocs$BPA$DocTypeM;
      filteredData = bpaDocs === null || bpaDocs === void 0 ? void 0 : (_bpaDocs$BPA = bpaDocs.BPA) === null || _bpaDocs$BPA === void 0 ? void 0 : (_bpaDocs$BPA$DocTypeM = _bpaDocs$BPA.DocTypeMapping) === null || _bpaDocs$BPA$DocTypeM === void 0 ? void 0 : _bpaDocs$BPA$DocTypeM.filter(data => {
        var _applicationData$addi, _applicationData$addi2;
        return data.WFState == (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) && data.RiskType == (applicationData === null || applicationData === void 0 ? void 0 : applicationData.riskType) && data.ServiceType == (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$addi = applicationData.additionalDetails) === null || _applicationData$addi === void 0 ? void 0 : _applicationData$addi.serviceType) && data.applicationType == (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$addi2 = applicationData.additionalDetails) === null || _applicationData$addi2 === void 0 ? void 0 : _applicationData$addi2.applicationType);
      });
    }
    if ((_filteredData = filteredData) !== null && _filteredData !== void 0 && (_filteredData$ = _filteredData[0]) !== null && _filteredData$ !== void 0 && (_filteredData$$docTyp = _filteredData$.docTypes) !== null && _filteredData$$docTyp !== void 0 && _filteredData$$docTyp[0]) {
      filteredData[0].docTypes[0].nocType = filteredData[0].nocType;
      filteredData[0].docTypes[0].additionalDetails = {
        submissionDetails: noc === null || noc === void 0 ? void 0 : noc.additionalDetails,
        applicationStatus: noc === null || noc === void 0 ? void 0 : noc.applicationStatus,
        appNumberLink: noc === null || noc === void 0 ? void 0 : noc.applicationNo,
        nocNo: noc === null || noc === void 0 ? void 0 : noc.nocNo
      };
      documents.push(filteredData[0].docTypes[0]);
    }
    let documentsList = [];
    if (documents && documents.length > 0) {
      documents.map(doc => {
        let code = doc.documentType;
        doc.dropdownData = [];
        commonDocMaping === null || commonDocMaping === void 0 ? void 0 : commonDocMaping.forEach(value => {
          let values = value.code.slice(0, code === null || code === void 0 ? void 0 : code.length);
          if (code === values) {
            doc.hasDropdown = true;
            doc.dropdownData.push(value);
          }
        });
        documentsList.push(doc);
      });
      setNocTaxDocuments(documentsList);
    }
  }, [nocDocs, commonDocMaping]);
  useEffect(() => {
    if (bpaApplicationStatus === 'NOC_VERIFICATION_INPROGRESS' && (actions === null || actions === void 0 ? void 0 : actions.length) > 0) setCheckEnablingDocs(true);else setCheckEnablingDocs(false);
  }, [applicationData, bpaActionsDetails]);
  return /*#__PURE__*/React$1.createElement("div", {
    style: {
      border: "1px solid #D6D5D4",
      padding: "16px 0px 16px 8px",
      background: "#FAFAFA",
      borderRadius: "5px",
      marginBottom: "24px",
      maxWidth: "950px"
    }
  }, /*#__PURE__*/React$1.createElement(StatusTable, null, /*#__PURE__*/React$1.createElement(Row, {
    label: isEmployee ? `${t(`BPA_${noc === null || noc === void 0 ? void 0 : noc.nocType}_HEADER`)}` : t(`BPA_${noc === null || noc === void 0 ? void 0 : noc.nocType}_HEADER`),
    labelStyle: {
      fontSize: "20px",
      width: "150%"
    }
  }), NOCdata && NOCdata.map((noc, index) => {
    if (noc !== null && noc !== void 0 && noc.value) {
      if ((noc === null || noc === void 0 ? void 0 : noc.field) == "STATUS") {
        return /*#__PURE__*/React$1.createElement(Row, {
          className: "border-none",
          label: isEmployee ? `${t(noc === null || noc === void 0 ? void 0 : noc.title)}` : t(noc === null || noc === void 0 ? void 0 : noc.title),
          text: noc !== null && noc !== void 0 && noc.value ? t(noc === null || noc === void 0 ? void 0 : noc.value) : t("CS_NA"),
          textStyle: (noc === null || noc === void 0 ? void 0 : noc.value) == "APPROVED" || (noc === null || noc === void 0 ? void 0 : noc.value) == "AUTO_APPROVED" ? {
            color: "#00703C"
          } : {
            color: "#D4351C"
          }
        });
      } else {
        return /*#__PURE__*/React$1.createElement(Row, {
          className: "border-none",
          label: isEmployee ? `${t(noc === null || noc === void 0 ? void 0 : noc.title)}` : t(noc === null || noc === void 0 ? void 0 : noc.title),
          text: noc !== null && noc !== void 0 && noc.value ? t(noc === null || noc === void 0 ? void 0 : noc.value) : t("CS_NA")
        });
      }
    }
  })), /*#__PURE__*/React$1.createElement(DocumentsPreview, {
    documents: docs,
    svgStyles: {
      width: "80px",
      height: "100px",
      viewBox: "0 0 25 25",
      minWidth: "80px"
    }
  }), checkEnablingDocs && (nocTaxDocuments === null || nocTaxDocuments === void 0 ? void 0 : nocTaxDocuments.map((document, index) => {
    return /*#__PURE__*/React$1.createElement(SelectDocument$1, {
      key: index,
      document: document,
      t: t,
      error: error,
      setError: setError,
      setNocDocuments: setNocDocuments,
      nocDocuments: nocDocuments,
      checkEnablingDocs: checkEnablingDocs
    });
  })));
};

const PermissionCheck = ({
  permissions,
  t
}) => {
  const [approvalChecks, setApprovalChecks, clearApprovals] = Digit.Hooks.useSessionStorage("OBPS_APPROVAL_CHECKS", permissions === null || permissions === void 0 ? void 0 : permissions.map(permission => ({
    label: permission,
    checked: false
  })));
  const [newApprovals, setNewApprovals, clearNewApprovals] = Digit.Hooks.useSessionStorage('OBPS_NEW_APPROVALS', []);
  useEffect(() => {
    return () => {
      Digit.SessionStorage.del("OBPS_NEW_APPROVALS");
      Digit.SessionStorage.del("OBPS_APPROVAL_CHECKS");
    };
  }, []);
  const handleAdd = () => {
    setNewApprovals([...newApprovals, {
      label: ''
    }]);
  };
  const handleRemove = index => {
    const values = [...newApprovals];
    values.splice(index, 1);
    setNewApprovals([...values]);
  };
  const handleChange = (event, index) => {
    setNewApprovals(() => {
      return newApprovals === null || newApprovals === void 0 ? void 0 : newApprovals.map((approval, id) => {
        if (index === id) {
          var _event$target;
          return {
            label: event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value
          };
        }
        return approval;
      });
    });
  };
  const handleCheck = (event, label, index) => {
    const isChecked = event.target.checked;
    setApprovalChecks(() => {
      return approvalChecks === null || approvalChecks === void 0 ? void 0 : approvalChecks.map((approval, id) => {
        if (index === id) {
          return {
            ...approval,
            checked: isChecked
          };
        }
        return approval;
      });
    });
  };
  return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(CardSubHeader, {
    style: {
      marginBottom: "16px",
      fontSize: "24px"
    }
  }, t("BPA_PERMIT_CONDITIONS")), approvalChecks === null || approvalChecks === void 0 ? void 0 : approvalChecks.map((permission, index) => /*#__PURE__*/React$1.createElement(CheckBox, {
    key: index,
    styles: {
      margin: "20px 0 40px",
      maxWidth: "70%"
    },
    label: permission === null || permission === void 0 ? void 0 : permission.label,
    checked: permission === null || permission === void 0 ? void 0 : permission.checked,
    onChange: event => handleCheck(event, permission === null || permission === void 0 ? void 0 : permission.label, index),
    isLabelFirst: true,
    index: index
  })), newApprovals === null || newApprovals === void 0 ? void 0 : newApprovals.map((approval, index) => /*#__PURE__*/React$1.createElement("div", null, " ", /*#__PURE__*/React$1.createElement(TextInput, {
    key: index,
    value: approval === null || approval === void 0 ? void 0 : approval.label,
    onChange: event => handleChange(event, index),
    textInputStyle: {
      maxWidth: "830px",
      width: "830px"
    },
    placeholder: "Enter permit conditions.........."
  }), /*#__PURE__*/React$1.createElement(LinkButton, {
    label: /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement("span", null, /*#__PURE__*/React$1.createElement(Close$c, {
      style: {
        float: "right",
        position: "relative",
        bottom: "32px",
        marginTop: "-21px",
        marginRight: "35%"
      }
    }))),
    style: {},
    onClick: e => handleRemove(index)
  }))), /*#__PURE__*/React$1.createElement(LinkButton, {
    style: {
      color: "#1F4A7C",
      maxWidth: "10%",
      marginRight: "3%"
    },
    label: t(`BPA_ADD_MORE`),
    onClick: handleAdd
  }));
};

function PropertyDocuments({
  documents,
  svgStyles = {},
  isSendBackFlow = false
}) {
  const {
    t
  } = useTranslation();
  const [filesArray, setFilesArray] = useState(() => []);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [pdfFiles, setPdfFiles] = useState({});
  useEffect(() => {
    var _acc;
    let acc = [];
    documents === null || documents === void 0 ? void 0 : documents.forEach((element, index, array) => {
      acc = [...acc, ...(element.values ? element.values : [])];
    });
    setFilesArray((_acc = acc) === null || _acc === void 0 ? void 0 : _acc.map(value => value === null || value === void 0 ? void 0 : value.fileStoreId));
  }, [documents]);
  useEffect(() => {
    if (filesArray !== null && filesArray !== void 0 && filesArray.length) {
      Digit.UploadServices.Filefetch(filesArray, Digit.ULBService.getStateId()).then(res => {
        setPdfFiles(res === null || res === void 0 ? void 0 : res.data);
      });
    }
  }, [filesArray]);
  const checkLocation = window.location.href.includes("employee/tl") || window.location.href.includes("/obps");
  const isStakeholderApplication = window.location.href.includes("stakeholder");
  return /*#__PURE__*/React$1.createElement("div", {
    style: {
      marginTop: "19px"
    }
  }, !isStakeholderApplication && (documents === null || documents === void 0 ? void 0 : documents.map((document, index) => {
    var _document$values;
    return /*#__PURE__*/React$1.createElement(React$1.Fragment, {
      key: index
    }, document !== null && document !== void 0 && document.title ? /*#__PURE__*/React$1.createElement(CardSubHeader, {
      style: checkLocation ? {
        marginTop: "32px",
        marginBottom: "18px",
        color: "#0B0C0C, 100%",
        fontSize: "24px",
        lineHeight: "30px"
      } : {
        marginTop: "32px",
        marginBottom: "8px",
        color: "#505A5F",
        fontSize: "24px"
      }
    }, t(document === null || document === void 0 ? void 0 : document.title)) : null, /*#__PURE__*/React$1.createElement("div", {
      style: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "flex-start"
      }
    }, document !== null && document !== void 0 && document.values && (document === null || document === void 0 ? void 0 : document.values.length) > 0 ? document === null || document === void 0 ? void 0 : (_document$values = document.values) === null || _document$values === void 0 ? void 0 : _document$values.map((value, index) => {
      var _pdfFiles$value$fileS, _value$documentType;
      return /*#__PURE__*/React$1.createElement("a", {
        target: "_",
        href: (_pdfFiles$value$fileS = pdfFiles[value.fileStoreId]) === null || _pdfFiles$value$fileS === void 0 ? void 0 : _pdfFiles$value$fileS.split(",")[0],
        style: {
          minWidth: "80px",
          marginRight: "10px",
          maxWidth: "100px",
          height: "auto"
        },
        key: index
      }, /*#__PURE__*/React$1.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React$1.createElement(PDFSvg, null)), /*#__PURE__*/React$1.createElement("p", {
        style: checkLocation ? {
          marginTop: "8px",
          fontWeight: "bold",
          fontSize: "16px",
          lineHeight: "19px",
          color: "#505A5F",
          textAlign: "center"
        } : {
          marginTop: "8px",
          fontWeight: "bold"
        }
      }, t(value === null || value === void 0 ? void 0 : value.title)), isSendBackFlow ? value !== null && value !== void 0 && (_value$documentType = value.documentType) !== null && _value$documentType !== void 0 && _value$documentType.includes("NOC") ? /*#__PURE__*/React$1.createElement("p", {
        style: {
          textAlign: "center"
        }
      }, t(value === null || value === void 0 ? void 0 : value.documentType.split(".")[1])) : /*#__PURE__*/React$1.createElement("p", {
        style: {
          textAlign: "center"
        }
      }, t(value === null || value === void 0 ? void 0 : value.documentType)) : "");
    }) : !window.location.href.includes("citizen") && /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement("p", null, t("BPA_NO_DOCUMENTS_UPLOADED_LABEL")))));
  })), isStakeholderApplication && (documents === null || documents === void 0 ? void 0 : documents.map((document, index) => {
    var _document$values2;
    return /*#__PURE__*/React$1.createElement(React$1.Fragment, {
      key: index
    }, document !== null && document !== void 0 && document.title ? /*#__PURE__*/React$1.createElement(CardSubHeader, {
      style: {
        marginTop: "32px",
        marginBottom: "8px",
        color: "#505A5F",
        fontSize: "24px"
      }
    }, t(document === null || document === void 0 ? void 0 : document.title)) : null, /*#__PURE__*/React$1.createElement("div", null, document !== null && document !== void 0 && document.values && (document === null || document === void 0 ? void 0 : document.values.length) > 0 ? document === null || document === void 0 ? void 0 : (_document$values2 = document.values) === null || _document$values2 === void 0 ? void 0 : _document$values2.map((value, index) => {
      var _pdfFiles$value$fileS2;
      return /*#__PURE__*/React$1.createElement("a", {
        target: "_",
        href: (_pdfFiles$value$fileS2 = pdfFiles[value.fileStoreId]) === null || _pdfFiles$value$fileS2 === void 0 ? void 0 : _pdfFiles$value$fileS2.split(",")[0],
        style: {
          minWidth: svgStyles !== null && svgStyles !== void 0 && svgStyles.minWidth ? svgStyles === null || svgStyles === void 0 ? void 0 : svgStyles.minWidth : "160px",
          marginRight: "20px"
        },
        key: index
      }, /*#__PURE__*/React$1.createElement("div", {
        style: {
          maxWidth: "940px",
          padding: "8px",
          borderRadius: "4px",
          border: "1px solid #D6D5D4",
          background: "#FAFAFA"
        }
      }, /*#__PURE__*/React$1.createElement("p", {
        style: {
          marginTop: "8px",
          fontWeight: "bold",
          marginBottom: "10px"
        }
      }, t(value === null || value === void 0 ? void 0 : value.title)), value !== null && value !== void 0 && value.docInfo ? /*#__PURE__*/React$1.createElement("div", {
        style: {
          fontSize: "12px",
          color: "#505A5F",
          fontWeight: 400,
          lineHeight: "15px",
          marginBottom: "10px"
        }
      }, `${t(value === null || value === void 0 ? void 0 : value.docInfo)}`) : null, /*#__PURE__*/React$1.createElement(PDFSvg, null), /*#__PURE__*/React$1.createElement("p", {
        style: {
          marginTop: "8px",
          fontSize: "16px",
          lineHeight: "19px",
          color: "#505A5F",
          fontWeight: "400"
        }
      }, `${t(value === null || value === void 0 ? void 0 : value.title)}`)));
    }) : !window.location.href.includes("citizen") && /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement("p", null, t("BPA_NO_DOCUMENTS_UPLOADED_LABEL")))));
  })));
}

function PropertyEstimates({
  taxHeadEstimatesCalculation
}) {
  const {
    taxHeadEstimates
  } = taxHeadEstimatesCalculation;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement("div", {
    style: {
      marginTop: "40px"
    }
  }, /*#__PURE__*/React$1.createElement(StatusTable, null, /*#__PURE__*/React$1.createElement(Row, {
    label: t("ES_PT_TITLE_TAX_HEADS"),
    text: t("ES_PT_TITLE_AMOUNT"),
    className: "border-none",
    textStyle: {
      fontWeight: "bold"
    }
  }), /*#__PURE__*/React$1.createElement(BreakLine, {
    style: {
      margin: "16px 0",
      width: "40%"
    }
  }), taxHeadEstimates === null || taxHeadEstimates === void 0 ? void 0 : taxHeadEstimates.map((estimate, index) => {
    return /*#__PURE__*/React$1.createElement(Row, {
      key: t(estimate.taxHeadCode),
      label: t(estimate.taxHeadCode),
      text: `₹ ${estimate.estimateAmount}` || "N/A",
      last: index === (taxHeadEstimates === null || taxHeadEstimates === void 0 ? void 0 : taxHeadEstimates.length) - 1,
      className: "border-none",
      textStyle: {
        color: "#505A5F"
      },
      labelStyle: {
        color: "#505A5F"
      }
    });
  }), /*#__PURE__*/React$1.createElement(BreakLine, {
    style: {
      margin: "16px 0",
      width: "40%"
    }
  }), /*#__PURE__*/React$1.createElement(Row, {
    label: t("ES_PT_TITLE_TOTAL_DUE_AMOUNT"),
    text: `₹ ${taxHeadEstimatesCalculation === null || taxHeadEstimatesCalculation === void 0 ? void 0 : taxHeadEstimatesCalculation.totalAmount}` || "N/A",
    className: "border-none",
    textStyle: {
      fontSize: "24px",
      fontWeight: "bold"
    }
  })));
}

function PropertyFloors({
  floors
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, floors.map(floor => {
    var _floor$values;
    return /*#__PURE__*/React$1.createElement("div", {
      key: t(floor === null || floor === void 0 ? void 0 : floor.title),
      style: {
        marginTop: "19px"
      }
    }, /*#__PURE__*/React$1.createElement(CardSubHeader, {
      style: {
        marginBottom: "8px",
        color: "#505A5F",
        fontSize: "24px"
      }
    }, t(floor === null || floor === void 0 ? void 0 : floor.title)), floor === null || floor === void 0 ? void 0 : (_floor$values = floor.values) === null || _floor$values === void 0 ? void 0 : _floor$values.map((value, index) => {
      var _value$values;
      return /*#__PURE__*/React$1.createElement(React$1.Fragment, {
        key: index
      }, /*#__PURE__*/React$1.createElement(CardSectionHeader, {
        style: {
          marginBottom: "16px",
          color: "#505A5F",
          fontSize: "16px",
          marginTop: index !== 0 ? "16px" : "revert"
        }
      }, t(value.title)), /*#__PURE__*/React$1.createElement(StatusTable, {
        style: {
          position: "relative",
          padding: "8px"
        }
      }, /*#__PURE__*/React$1.createElement("div", {
        style: {
          border: "1px solid #D6D5D4",
          padding: "16px",
          marginTop: "8px",
          borderRadius: "4px",
          background: "#FAFAFA",
          maxWidth: "100%"
        }
      }, value === null || value === void 0 ? void 0 : (_value$values = value.values) === null || _value$values === void 0 ? void 0 : _value$values.map((value, index) => {
        var _value$values2;
        if (value.map === true && value.value !== "N/A") {
          return /*#__PURE__*/React$1.createElement(Row, {
            key: t(value.title),
            label: t(value.title),
            text: /*#__PURE__*/React$1.createElement("img", {
              src: t(value.value),
              alt: ""
            })
          });
        }
        return /*#__PURE__*/React$1.createElement(Row, {
          key: t(value.title),
          label: t(value.title),
          text: t(value.value) || "N/A",
          last: index === (value === null || value === void 0 ? void 0 : (_value$values2 = value.values) === null || _value$values2 === void 0 ? void 0 : _value$values2.length) - 1,
          caption: value.caption,
          className: "border-none"
        });
      }))));
    }));
  }));
}

function PropertyOwners({
  owners
}) {
  const {
    t
  } = useTranslation();
  const checkOwnerLength = (owners === null || owners === void 0 ? void 0 : owners.length) || 1;
  let cardStyles = {
    marginTop: "19px"
  };
  let statusTableStyles = {
    position: "relative",
    padding: "8px"
  };
  let rowContainerStyle = {
    justifyContent: "space-between",
    fontSize: "16px",
    lineHeight: "19px",
    color: "#0B0C0C"
  };
  if ( Number(checkOwnerLength) > 1) {
    cardStyles = {
      marginTop: "19px",
      background: "#FAFAFA",
      border: "1px solid #D6D5D4",
      borderRadius: "4px",
      padding: "8px",
      lineHeight: "19px",
      maxWidth: "600px",
      minWidth: "280px"
    };
  } else if ( !(Number(checkOwnerLength) > 1)) {
    cardStyles = {
      marginTop: "19px",
      lineHeight: "19px",
      maxWidth: "600px",
      minWidth: "280px"
    };
    statusTableStyles = {
      position: "relative",
      marginTop: "19px"
    };
  }
  if (window.location.href.includes("obps")) {
    cardStyles = {
      ...cardStyles,
      maxWidth: "950px"
    };
    cardStyles = {
      ...cardStyles,
      maxWidth: "950px"
    };
    rowContainerStyle = {};
  }
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, owners.map((owner, index) => {
    var _owner$values;
    return /*#__PURE__*/React$1.createElement("div", {
      key: t(owner === null || owner === void 0 ? void 0 : owner.title),
      style: cardStyles
    }, /*#__PURE__*/React$1.createElement(CardSubHeader, {
      style:  Number(checkOwnerLength) > 1 ? {
        marginBottom: "8px",
        paddingBottom: "9px",
        color: "#0B0C0C",
        fontSize: "16px",
        lineHeight: "19px"
      } : {
        marginBottom: "8px",
        color: "#505A5F",
        fontSize: "24px"
      }
    },  Number(checkOwnerLength) > 1 ? `${t(owner === null || owner === void 0 ? void 0 : owner.title)} ${index + 1}` : t(owner === null || owner === void 0 ? void 0 : owner.title)), /*#__PURE__*/React$1.createElement(React$1.Fragment, {
      key: index
    }, /*#__PURE__*/React$1.createElement(StatusTable, {
      style: statusTableStyles
    }, /*#__PURE__*/React$1.createElement("div", {
      style: {
        maxWidth: "640px",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        width: "auto"
      }
    }), owner === null || owner === void 0 ? void 0 : (_owner$values = owner.values) === null || _owner$values === void 0 ? void 0 : _owner$values.map((value, index) => {
      var _value$values;
      if (value.map === true && value.value !== "N/A") {
        return /*#__PURE__*/React$1.createElement(Row, {
          key: t(value.title),
          label: t(value.title),
          text: /*#__PURE__*/React$1.createElement("img", {
            src: t(value.value),
            alt: ""
          })
        });
      }
      return /*#__PURE__*/React$1.createElement("span", null, /*#__PURE__*/React$1.createElement(Row, {
        key: t(value.title),
        label:  `${t(value.title)}`,
        text: t(value.value) || "N/A",
        last: index === (value === null || value === void 0 ? void 0 : (_value$values = value.values) === null || _value$values === void 0 ? void 0 : _value$values.length) - 1,
        caption: value.caption,
        className: "border-none",
        textStyle: value.textStyle,
        rowContainerStyle: rowContainerStyle
      }));
    }))));
  }));
}

const ScruntinyDetails = ({
  scrutinyDetails,
  paymentsList: _paymentsList = []
}) => {
  var _scrutinyDetails$valu, _scrutinyDetails$perm, _scrutinyDetails$scru;
  const {
    t
  } = useTranslation();
  const getTextValues = data => {
    if (data !== null && data !== void 0 && data.value && data !== null && data !== void 0 && data.isTransLate) return /*#__PURE__*/React$1.createElement("span", {
      style: {
        color: "#00703C"
      }
    }, t(data === null || data === void 0 ? void 0 : data.value));else if (data !== null && data !== void 0 && data.value && data !== null && data !== void 0 && data.isTransLate) return t(data === null || data === void 0 ? void 0 : data.value);else if (data !== null && data !== void 0 && data.value) return data === null || data === void 0 ? void 0 : data.value;else t("NA");
  };
  return /*#__PURE__*/React$1.createElement(Fragment, null, !(scrutinyDetails !== null && scrutinyDetails !== void 0 && scrutinyDetails.isChecklist) && /*#__PURE__*/React$1.createElement("div", {
    style: {
      background: "#FAFAFA",
      border: "1px solid #D6D5D4",
      padding: "8px",
      borderRadius: "4px",
      maxWidth: "950px",
      minWidth: "280px"
    }
  }, /*#__PURE__*/React$1.createElement(StatusTable, null, /*#__PURE__*/React$1.createElement("div", null, scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$valu = scrutinyDetails.values) === null || _scrutinyDetails$valu === void 0 ? void 0 : _scrutinyDetails$valu.map((value, index) => {
    if (value !== null && value !== void 0 && value.isUnit) return /*#__PURE__*/React$1.createElement(Row, {
      className: "border-none",
      textStyle: (value === null || value === void 0 ? void 0 : value.value) === "Paid" ? {
        color: "darkgreen"
      } : (value === null || value === void 0 ? void 0 : value.value) === "Unpaid" ? {
        color: "red"
      } : {},
      key: `${value.title}`,
      label: `${t(`${value.title}`)}`,
      text: value !== null && value !== void 0 && value.value ? `${getTextValues(value)} ${t(value === null || value === void 0 ? void 0 : value.isUnit)}` : t("NA"),
      labelStyle: value !== null && value !== void 0 && value.isHeader ? {
        fontSize: "20px"
      } : {}
    });else if (value !== null && value !== void 0 && value.isHeader && !(value !== null && value !== void 0 && value.isUnit)) return /*#__PURE__*/React$1.createElement(CardSubHeader, {
      style: {
        fontSize: "20px",
        paddingBottom: "10px"
      }
    }, t(value === null || value === void 0 ? void 0 : value.title));else if (value !== null && value !== void 0 && value.isSubTitle && !(value !== null && value !== void 0 && value.isUnit)) return /*#__PURE__*/React$1.createElement(CardSubHeader, {
      style: {
        fontSize: "20px",
        paddingBottom: "10px",
        margin: "0px"
      }
    }, t(value === null || value === void 0 ? void 0 : value.title));else return /*#__PURE__*/React$1.createElement(Row, {
      className: "border-none",
      textStyle: (value === null || value === void 0 ? void 0 : value.value) === "Paid" ? {
        color: "darkgreen"
      } : (value === null || value === void 0 ? void 0 : value.value) === "Unpaid" ? {
        color: "red"
      } : {},
      key: `${value.title}`,
      label: `${t(`${value.title}`)}`,
      text: getTextValues(value),
      labelStyle: value !== null && value !== void 0 && value.isHeader ? {
        fontSize: "20px"
      } : {}
    });
  }), scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$perm = scrutinyDetails.permit) === null || _scrutinyDetails$perm === void 0 ? void 0 : _scrutinyDetails$perm.map((value, ind) => {
    return /*#__PURE__*/React$1.createElement(CardLabel, {
      style: {
        fontWeight: "400"
      }
    }, value === null || value === void 0 ? void 0 : value.title);
  })), /*#__PURE__*/React$1.createElement("div", null, scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$scru = scrutinyDetails.scruntinyDetails) === null || _scrutinyDetails$scru === void 0 ? void 0 : _scrutinyDetails$scru.map((report, index) => {
    return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(Row, {
      className: "border-none",
      label: `${t(report === null || report === void 0 ? void 0 : report.title)}`,
      labelStyle: {
        width: "150%"
      }
    }), report !== null && report !== void 0 && report.value ? /*#__PURE__*/React$1.createElement("a", {
      href: report === null || report === void 0 ? void 0 : report.value,
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/React$1.createElement(PDFSvg, null)) : /*#__PURE__*/React$1.createElement("span", null, t("NA")), /*#__PURE__*/React$1.createElement("p", {
      style: {
        margin: "8px 0px",
        fontWeight: "bold",
        fontSize: "16px",
        lineHeight: "19px",
        color: "#505A5F"
      }
    }, t(report === null || report === void 0 ? void 0 : report.text)));
  })))));
};

const SubOccupancyTable = ({
  edcrDetails,
  applicationData
}) => {
  var _edcrDetails$values, _edcrDetails$subOccup, _edcrDetails$subOccup2, _edcrDetails$subOccup3, _edcrDetails$subOccup4;
  const {
    t
  } = useTranslation();
  const isMobile = window.Digit.Utils.browser.isMobile();
  const tableHeader = [{
    name: "BPA_TABLE_COL_FLOOR",
    id: "Floor"
  }, {
    name: "BPA_TABLE_COL_LEVEL",
    id: "Level"
  }, {
    name: "BPA_TABLE_COL_OCCUPANCY",
    id: "Occupancy"
  }, {
    name: "BPA_TABLE_COL_BUILDUPAREA",
    id: "BuildupArea"
  }, {
    name: "BPA_TABLE_COL_FLOORAREA",
    id: "FloorArea"
  }, {
    name: "BPA_TABLE_COL_CARPETAREA",
    id: "CarpetArea"
  }];
  const accessData = plot => {
    const name = plot;
    return (originalRow, rowIndex, columns) => {
      return originalRow[name];
    };
  };
  const tableColumns = useMemo(() => {
    return tableHeader.map(ob => ({
      Header: t(`${ob.name}`),
      accessor: accessData(ob.id),
      id: ob.id
    }));
  });
  function getFloorData(block) {
    var _block$building;
    let floors = [];
    block === null || block === void 0 ? void 0 : (_block$building = block.building) === null || _block$building === void 0 ? void 0 : _block$building.floors.map(ob => {
      var _ob$occupancies, _ob$occupancies$, _ob$occupancies2, _ob$occupancies2$, _ob$occupancies3, _ob$occupancies3$, _ob$occupancies4, _ob$occupancies4$;
      floors.push({
        Floor: t(`BPA_FLOOR_NAME_${ob.number}`),
        Level: ob.number,
        Occupancy: t(`${(_ob$occupancies = ob.occupancies) === null || _ob$occupancies === void 0 ? void 0 : (_ob$occupancies$ = _ob$occupancies[0]) === null || _ob$occupancies$ === void 0 ? void 0 : _ob$occupancies$.type}`),
        BuildupArea: (_ob$occupancies2 = ob.occupancies) === null || _ob$occupancies2 === void 0 ? void 0 : (_ob$occupancies2$ = _ob$occupancies2[0]) === null || _ob$occupancies2$ === void 0 ? void 0 : _ob$occupancies2$.builtUpArea,
        FloorArea: ((_ob$occupancies3 = ob.occupancies) === null || _ob$occupancies3 === void 0 ? void 0 : (_ob$occupancies3$ = _ob$occupancies3[0]) === null || _ob$occupancies3$ === void 0 ? void 0 : _ob$occupancies3$.floorArea) || 0,
        CarpetArea: ((_ob$occupancies4 = ob.occupancies) === null || _ob$occupancies4 === void 0 ? void 0 : (_ob$occupancies4$ = _ob$occupancies4[0]) === null || _ob$occupancies4$ === void 0 ? void 0 : _ob$occupancies4$.CarpetArea) || 0,
        key: t(`BPA_FLOOR_NAME_${ob.number}`)
      });
    });
    return floors;
  }
  const stringReplaceAll = (str = "", searcher = "", replaceWith = "") => {
    if (searcher == "") return str;
    while (str.includes(searcher)) {
      str = str.replace(searcher, replaceWith);
    }
    return str;
  };
  function getSubOccupancyValues(index) {
    var _applicationData$land;
    let values = applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$land = applicationData.landInfo) === null || _applicationData$land === void 0 ? void 0 : _applicationData$land.unit;
    let returnValue = "";
    if ((values === null || values === void 0 ? void 0 : values.length) > 0) {
      var _values$index, _values$index$usageCa;
      let splitArray = (_values$index = values[index]) === null || _values$index === void 0 ? void 0 : (_values$index$usageCa = _values$index.usageCategory) === null || _values$index$usageCa === void 0 ? void 0 : _values$index$usageCa.split(',');
      if (splitArray !== null && splitArray !== void 0 && splitArray.length) {
        const returnValueArray = splitArray.map(data => data ? `${t(`BPA_SUBOCCUPANCYTYPE_${stringReplaceAll(data === null || data === void 0 ? void 0 : data.toUpperCase(), "-", "_")}`)}` : "NA");
        returnValue = returnValueArray.join(', ');
      }
    }
    return returnValue ? returnValue : "NA";
  }
  return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement("div", {
    style: {
      background: "#FAFAFA",
      border: "1px solid #D6D5D4",
      padding: "8px",
      borderRadius: "4px",
      maxWidth: "950px",
      minWidth: "280px"
    }
  }, /*#__PURE__*/React$1.createElement(StatusTable, null, edcrDetails === null || edcrDetails === void 0 ? void 0 : (_edcrDetails$values = edcrDetails.values) === null || _edcrDetails$values === void 0 ? void 0 : _edcrDetails$values.map((value, index) => {
    if (value !== null && value !== void 0 && value.isHeader) return /*#__PURE__*/React$1.createElement(CardSubHeader, {
      style: {
        fontSize: "20px",
        paddingBottom: "10px"
      }
    }, t(value === null || value === void 0 ? void 0 : value.title));else return /*#__PURE__*/React$1.createElement(Row, {
      className: "border-none",
      labelStyle: {
        width: "100%",
        fontSize: "20px"
      },
      key: `${value.title}`,
      label: `${t(`${value.title}`)}`,
      text: value !== null && value !== void 0 && value.value ? value === null || value === void 0 ? void 0 : value.value : ""
    });
  })), edcrDetails === null || edcrDetails === void 0 ? void 0 : (_edcrDetails$subOccup = edcrDetails.subOccupancyTableDetails) === null || _edcrDetails$subOccup === void 0 ? void 0 : (_edcrDetails$subOccup2 = _edcrDetails$subOccup[0]) === null || _edcrDetails$subOccup2 === void 0 ? void 0 : (_edcrDetails$subOccup3 = _edcrDetails$subOccup2.value) === null || _edcrDetails$subOccup3 === void 0 ? void 0 : (_edcrDetails$subOccup4 = _edcrDetails$subOccup3.planDetail) === null || _edcrDetails$subOccup4 === void 0 ? void 0 : _edcrDetails$subOccup4.blocks.map((block, index) => {
    var _edcrDetails$subOccup5, _edcrDetails$subOccup6, _edcrDetails$subOccup7, _edcrDetails$subOccup8, _edcrDetails$subOccup9;
    return /*#__PURE__*/React$1.createElement("div", {
      key: index,
      style: (edcrDetails === null || edcrDetails === void 0 ? void 0 : (_edcrDetails$subOccup5 = edcrDetails.subOccupancyTableDetails) === null || _edcrDetails$subOccup5 === void 0 ? void 0 : (_edcrDetails$subOccup6 = _edcrDetails$subOccup5[0]) === null || _edcrDetails$subOccup6 === void 0 ? void 0 : (_edcrDetails$subOccup7 = _edcrDetails$subOccup6.value) === null || _edcrDetails$subOccup7 === void 0 ? void 0 : (_edcrDetails$subOccup8 = _edcrDetails$subOccup7.planDetail) === null || _edcrDetails$subOccup8 === void 0 ? void 0 : (_edcrDetails$subOccup9 = _edcrDetails$subOccup8.blocks) === null || _edcrDetails$subOccup9 === void 0 ? void 0 : _edcrDetails$subOccup9.length) > 0 ? {
        marginBottom: "30px",
        background: "#FAFAFA",
        border: "1px solid #D6D5D4",
        padding: "8px",
        borderRadius: "4px",
        maxWidth: "950px",
        minWidth: "280px"
      } : {
        marginBottom: "30px"
      }
    }, /*#__PURE__*/React$1.createElement(CardSubHeader, {
      style: {
        marginBottom: "8px",
        paddingBottom: "9px",
        color: "#0B0C0C",
        fontSize: "18px",
        lineHeight: "19px"
      }
    }, t("BPA_BLOCK_SUBHEADER"), " ", index + 1), /*#__PURE__*/React$1.createElement(StatusTable, null, /*#__PURE__*/React$1.createElement(Row, {
      className: "border-none",
      textStyle: {
        wordBreak: "break-word"
      },
      label: `${t("BPA_SUB_OCCUPANCY_LABEL")}`,
      text: getSubOccupancyValues(index)
    })), /*#__PURE__*/React$1.createElement("div", {
      style: window.location.href.includes("citizen") || isMobile ? {
        overflow: "scroll"
      } : {
        maxWidth: "950px",
        maxHeight: "280px"
      }
    }, /*#__PURE__*/React$1.createElement(Table, {
      className: "customTable table-fixed-first-column table-border-style",
      t: t,
      disableSort: false,
      autoSort: true,
      manualPagination: false,
      isPaginationRequired: false,
      initSortId: "S N ",
      data: getFloorData(block),
      columns: tableColumns,
      getCellProps: cellInfo => {
        return {
          style: {}
        };
      }
    })));
  })));
};

const Reason = ({
  headComment,
  otherComment
}) => /*#__PURE__*/React$1.createElement("div", {
  className: "checkpoint-comments-wrap"
}, /*#__PURE__*/React$1.createElement("h4", null, headComment), /*#__PURE__*/React$1.createElement("p", null, otherComment));

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var purify = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
     module.exports = factory() ;
  })(commonjsGlobal, function () {

    function _typeof(obj) {
      "@babel/helpers - typeof";

      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
      return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
      if (typeof Reflect === "undefined" || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if (typeof Proxy === "function") return true;
      try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        return true;
      } catch (e) {
        return false;
      }
    }
    function _construct(Parent, args, Class) {
      if (_isNativeReflectConstruct()) {
        _construct = Reflect.construct;
      } else {
        _construct = function _construct(Parent, args, Class) {
          var a = [null];
          a.push.apply(a, args);
          var Constructor = Function.bind.apply(Parent, a);
          var instance = new Constructor();
          if (Class) _setPrototypeOf(instance, Class.prototype);
          return instance;
        };
      }
      return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
      return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
      if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
      if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
      if (!o) return;
      if (typeof o === "string") return _arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor) n = o.constructor.name;
      if (n === "Map" || n === "Set") return Array.from(o);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
      return arr2;
    }
    function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty,
      setPrototypeOf = Object.setPrototypeOf,
      isFrozen = Object.isFrozen,
      getPrototypeOf = Object.getPrototypeOf,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze,
      seal = Object.seal,
      create = Object.create;
    var _ref = typeof Reflect !== 'undefined' && Reflect,
      apply = _ref.apply,
      construct = _ref.construct;
    if (!apply) {
      apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
      };
    }
    if (!freeze) {
      freeze = function freeze(x) {
        return x;
      };
    }
    if (!seal) {
      seal = function seal(x) {
        return x;
      };
    }
    if (!construct) {
      construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
      };
    }
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
      return function (thisArg) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        return apply(func, thisArg, args);
      };
    }
    function unconstruct(func) {
      return function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        return construct(func, args);
      };
    }
    function addToSet(set, array, transformCaseFunc) {
      var _transformCaseFunc;
      transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
      if (setPrototypeOf) {
        setPrototypeOf(set, null);
      }
      var l = array.length;
      while (l--) {
        var element = array[l];
        if (typeof element === 'string') {
          var lcElement = transformCaseFunc(element);
          if (lcElement !== element) {
            if (!isFrozen(array)) {
              array[l] = lcElement;
            }
            element = lcElement;
          }
        }
        set[element] = true;
      }
      return set;
    }
    function clone(object) {
      var newObject = create(null);
      var property;
      for (property in object) {
        if (apply(hasOwnProperty, object, [property]) === true) {
          newObject[property] = object[property];
        }
      }
      return newObject;
    }
    function lookupGetter(object, prop) {
      while (object !== null) {
        var desc = getOwnPropertyDescriptor(object, prop);
        if (desc) {
          if (desc.get) {
            return unapply(desc.get);
          }
          if (typeof desc.value === 'function') {
            return unapply(desc.value);
          }
        }
        object = getPrototypeOf(object);
      }
      function fallbackValue(element) {
        console.warn('fallback value for', element);
        return null;
      }
      return fallbackValue;
    }
    var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);
    var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
    var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);
    var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
    var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']);
    var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
    var text = freeze(['#text']);
    var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
    var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
    var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
    var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm);
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/);
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/);
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i);
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g);
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
      return typeof window === 'undefined' ? null : window;
    };
    var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
      if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
        return null;
      }
      var suffix = null;
      var ATTR_NAME = 'data-tt-policy-suffix';
      if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
        suffix = document.currentScript.getAttribute(ATTR_NAME);
      }
      var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
      try {
        return trustedTypes.createPolicy(policyName, {
          createHTML: function createHTML(html) {
            return html;
          },
          createScriptURL: function createScriptURL(scriptUrl) {
            return scriptUrl;
          }
        });
      } catch (_) {
        console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
        return null;
      }
    };
    function createDOMPurify() {
      var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
      var DOMPurify = function DOMPurify(root) {
        return createDOMPurify(root);
      };
      DOMPurify.version = '2.5.6';
      DOMPurify.removed = [];
      if (!window || !window.document || window.document.nodeType !== 9) {
        DOMPurify.isSupported = false;
        return DOMPurify;
      }
      var originalDocument = window.document;
      var document = window.document;
      var DocumentFragment = window.DocumentFragment,
        HTMLTemplateElement = window.HTMLTemplateElement,
        Node = window.Node,
        Element = window.Element,
        NodeFilter = window.NodeFilter,
        _window$NamedNodeMap = window.NamedNodeMap,
        NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
        HTMLFormElement = window.HTMLFormElement,
        DOMParser = window.DOMParser,
        trustedTypes = window.trustedTypes;
      var ElementPrototype = Element.prototype;
      var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
      var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
      var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
      var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
      if (typeof HTMLTemplateElement === 'function') {
        var template = document.createElement('template');
        if (template.content && template.content.ownerDocument) {
          document = template.content.ownerDocument;
        }
      }
      var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
      var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
      var _document = document,
        implementation = _document.implementation,
        createNodeIterator = _document.createNodeIterator,
        createDocumentFragment = _document.createDocumentFragment,
        getElementsByTagName = _document.getElementsByTagName;
      var importNode = originalDocument.importNode;
      var documentMode = {};
      try {
        documentMode = clone(document).documentMode ? document.documentMode : {};
      } catch (_) {}
      var hooks = {};
      DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
      var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
        ERB_EXPR$1 = ERB_EXPR,
        TMPLIT_EXPR$1 = TMPLIT_EXPR,
        DATA_ATTR$1 = DATA_ATTR,
        ARIA_ATTR$1 = ARIA_ATTR,
        IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE$1 = ATTR_WHITESPACE,
        CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
      var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
      var ALLOWED_TAGS = null;
      var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
      var ALLOWED_ATTR = null;
      var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
      var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
        tagNameCheck: {
          writable: true,
          configurable: false,
          enumerable: true,
          value: null
        },
        attributeNameCheck: {
          writable: true,
          configurable: false,
          enumerable: true,
          value: null
        },
        allowCustomizedBuiltInElements: {
          writable: true,
          configurable: false,
          enumerable: true,
          value: false
        }
      }));
      var FORBID_TAGS = null;
      var FORBID_ATTR = null;
      var ALLOW_ARIA_ATTR = true;
      var ALLOW_DATA_ATTR = true;
      var ALLOW_UNKNOWN_PROTOCOLS = false;
      var ALLOW_SELF_CLOSE_IN_ATTR = true;
      var SAFE_FOR_TEMPLATES = false;
      var SAFE_FOR_XML = true;
      var WHOLE_DOCUMENT = false;
      var SET_CONFIG = false;
      var FORCE_BODY = false;
      var RETURN_DOM = false;
      var RETURN_DOM_FRAGMENT = false;
      var RETURN_TRUSTED_TYPE = false;
      var SANITIZE_DOM = true;
      var SANITIZE_NAMED_PROPS = false;
      var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
      var KEEP_CONTENT = true;
      var IN_PLACE = false;
      var USE_PROFILES = {};
      var FORBID_CONTENTS = null;
      var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
      var DATA_URI_TAGS = null;
      var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
      var URI_SAFE_ATTRIBUTES = null;
      var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
      var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
      var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
      var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
      var NAMESPACE = HTML_NAMESPACE;
      var IS_EMPTY_INPUT = false;
      var ALLOWED_NAMESPACES = null;
      var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
      var PARSER_MEDIA_TYPE;
      var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
      var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
      var transformCaseFunc;
      var CONFIG = null;
      var formElement = document.createElement('form');
      var isRegexOrFunction = function isRegexOrFunction(testValue) {
        return testValue instanceof RegExp || testValue instanceof Function;
      };
      var _parseConfig = function _parseConfig(cfg) {
        if (CONFIG && CONFIG === cfg) {
          return;
        }
        if (!cfg || _typeof(cfg) !== 'object') {
          cfg = {};
        }
        cfg = clone(cfg);
        PARSER_MEDIA_TYPE = SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
        transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
        ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
        ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
        ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
        URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
        DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
        FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
        FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
        FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
        USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
        ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false;
        ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false;
        ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false;
        ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false;
        SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false;
        SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false;
        WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false;
        RETURN_DOM = cfg.RETURN_DOM || false;
        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false;
        RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false;
        FORCE_BODY = cfg.FORCE_BODY || false;
        SANITIZE_DOM = cfg.SANITIZE_DOM !== false;
        SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false;
        KEEP_CONTENT = cfg.KEEP_CONTENT !== false;
        IN_PLACE = cfg.IN_PLACE || false;
        IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
        NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
        CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
        if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
          CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
        }
        if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
          CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
        }
        if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
          CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
        }
        if (SAFE_FOR_TEMPLATES) {
          ALLOW_DATA_ATTR = false;
        }
        if (RETURN_DOM_FRAGMENT) {
          RETURN_DOM = true;
        }
        if (USE_PROFILES) {
          ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
          ALLOWED_ATTR = [];
          if (USE_PROFILES.html === true) {
            addToSet(ALLOWED_TAGS, html$1);
            addToSet(ALLOWED_ATTR, html);
          }
          if (USE_PROFILES.svg === true) {
            addToSet(ALLOWED_TAGS, svg$1);
            addToSet(ALLOWED_ATTR, svg);
            addToSet(ALLOWED_ATTR, xml);
          }
          if (USE_PROFILES.svgFilters === true) {
            addToSet(ALLOWED_TAGS, svgFilters);
            addToSet(ALLOWED_ATTR, svg);
            addToSet(ALLOWED_ATTR, xml);
          }
          if (USE_PROFILES.mathMl === true) {
            addToSet(ALLOWED_TAGS, mathMl$1);
            addToSet(ALLOWED_ATTR, mathMl);
            addToSet(ALLOWED_ATTR, xml);
          }
        }
        if (cfg.ADD_TAGS) {
          if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
            ALLOWED_TAGS = clone(ALLOWED_TAGS);
          }
          addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
        }
        if (cfg.ADD_ATTR) {
          if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
            ALLOWED_ATTR = clone(ALLOWED_ATTR);
          }
          addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
        }
        if (cfg.ADD_URI_SAFE_ATTR) {
          addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
        }
        if (cfg.FORBID_CONTENTS) {
          if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
            FORBID_CONTENTS = clone(FORBID_CONTENTS);
          }
          addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
        }
        if (KEEP_CONTENT) {
          ALLOWED_TAGS['#text'] = true;
        }
        if (WHOLE_DOCUMENT) {
          addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
        }
        if (ALLOWED_TAGS.table) {
          addToSet(ALLOWED_TAGS, ['tbody']);
          delete FORBID_TAGS.tbody;
        }
        if (freeze) {
          freeze(cfg);
        }
        CONFIG = cfg;
      };
      var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
      var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'annotation-xml']);
      var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
      var ALL_SVG_TAGS = addToSet({}, svg$1);
      addToSet(ALL_SVG_TAGS, svgFilters);
      addToSet(ALL_SVG_TAGS, svgDisallowed);
      var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
      addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
      var _checkValidNamespace = function _checkValidNamespace(element) {
        var parent = getParentNode(element);
        if (!parent || !parent.tagName) {
          parent = {
            namespaceURI: NAMESPACE,
            tagName: 'template'
          };
        }
        var tagName = stringToLowerCase(element.tagName);
        var parentTagName = stringToLowerCase(parent.tagName);
        if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
          return false;
        }
        if (element.namespaceURI === SVG_NAMESPACE) {
          if (parent.namespaceURI === HTML_NAMESPACE) {
            return tagName === 'svg';
          }
          if (parent.namespaceURI === MATHML_NAMESPACE) {
            return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
          }
          return Boolean(ALL_SVG_TAGS[tagName]);
        }
        if (element.namespaceURI === MATHML_NAMESPACE) {
          if (parent.namespaceURI === HTML_NAMESPACE) {
            return tagName === 'math';
          }
          if (parent.namespaceURI === SVG_NAMESPACE) {
            return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
          }
          return Boolean(ALL_MATHML_TAGS[tagName]);
        }
        if (element.namespaceURI === HTML_NAMESPACE) {
          if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
            return false;
          }
          if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
            return false;
          }
          return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
        }
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
          return true;
        }
        return false;
      };
      var _forceRemove = function _forceRemove(node) {
        arrayPush(DOMPurify.removed, {
          element: node
        });
        try {
          node.parentNode.removeChild(node);
        } catch (_) {
          try {
            node.outerHTML = emptyHTML;
          } catch (_) {
            node.remove();
          }
        }
      };
      var _removeAttribute = function _removeAttribute(name, node) {
        try {
          arrayPush(DOMPurify.removed, {
            attribute: node.getAttributeNode(name),
            from: node
          });
        } catch (_) {
          arrayPush(DOMPurify.removed, {
            attribute: null,
            from: node
          });
        }
        node.removeAttribute(name);
        if (name === 'is' && !ALLOWED_ATTR[name]) {
          if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
            try {
              _forceRemove(node);
            } catch (_) {}
          } else {
            try {
              node.setAttribute(name, '');
            } catch (_) {}
          }
        }
      };
      var _initDocument = function _initDocument(dirty) {
        var doc;
        var leadingWhitespace;
        if (FORCE_BODY) {
          dirty = '<remove></remove>' + dirty;
        } else {
          var matches = stringMatch(dirty, /^[\r\n\t ]+/);
          leadingWhitespace = matches && matches[0];
        }
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
          dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
        }
        var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
        if (NAMESPACE === HTML_NAMESPACE) {
          try {
            doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
          } catch (_) {}
        }
        if (!doc || !doc.documentElement) {
          doc = implementation.createDocument(NAMESPACE, 'template', null);
          try {
            doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
          } catch (_) {}
        }
        var body = doc.body || doc.documentElement;
        if (dirty && leadingWhitespace) {
          body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
        }
        if (NAMESPACE === HTML_NAMESPACE) {
          return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
        }
        return WHOLE_DOCUMENT ? doc.documentElement : body;
      };
      var _createIterator = function _createIterator(root) {
        return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
      };
      var _isClobbered = function _isClobbered(elm) {
        return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
      };
      var _isNode = function _isNode(object) {
        return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
      };
      var _executeHook = function _executeHook(entryPoint, currentNode, data) {
        if (!hooks[entryPoint]) {
          return;
        }
        arrayForEach(hooks[entryPoint], function (hook) {
          hook.call(DOMPurify, currentNode, data, CONFIG);
        });
      };
      var _sanitizeElements = function _sanitizeElements(currentNode) {
        var content;
        _executeHook('beforeSanitizeElements', currentNode, null);
        if (_isClobbered(currentNode)) {
          _forceRemove(currentNode);
          return true;
        }
        if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
          _forceRemove(currentNode);
          return true;
        }
        var tagName = transformCaseFunc(currentNode.nodeName);
        _executeHook('uponSanitizeElement', currentNode, {
          tagName: tagName,
          allowedTags: ALLOWED_TAGS
        });
        if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
          _forceRemove(currentNode);
          return true;
        }
        if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
          _forceRemove(currentNode);
          return true;
        }
        if (currentNode.nodeType === 7) {
          _forceRemove(currentNode);
          return true;
        }
        if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
          _forceRemove(currentNode);
          return true;
        }
        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
          if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
            if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
            if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
          }
          if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
            var parentNode = getParentNode(currentNode) || currentNode.parentNode;
            var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
            if (childNodes && parentNode) {
              var childCount = childNodes.length;
              for (var i = childCount - 1; i >= 0; --i) {
                var childClone = cloneNode(childNodes[i], true);
                childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                parentNode.insertBefore(childClone, getNextSibling(currentNode));
              }
            }
          }
          _forceRemove(currentNode);
          return true;
        }
        if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
          _forceRemove(currentNode);
          return true;
        }
        if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
          _forceRemove(currentNode);
          return true;
        }
        if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
          content = currentNode.textContent;
          content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
          content = stringReplace(content, ERB_EXPR$1, ' ');
          content = stringReplace(content, TMPLIT_EXPR$1, ' ');
          if (currentNode.textContent !== content) {
            arrayPush(DOMPurify.removed, {
              element: currentNode.cloneNode()
            });
            currentNode.textContent = content;
          }
        }
        _executeHook('afterSanitizeElements', currentNode, null);
        return false;
      };
      var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
        if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
          return false;
        }
        if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
          if (_basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;else {
            return false;
          }
        } else if (URI_SAFE_ATTRIBUTES[lcName]) ;else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;else if (value) {
          return false;
        }
        return true;
      };
      var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
        return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
      };
      var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
        var attr;
        var value;
        var lcName;
        var l;
        _executeHook('beforeSanitizeAttributes', currentNode, null);
        var attributes = currentNode.attributes;
        if (!attributes) {
          return;
        }
        var hookEvent = {
          attrName: '',
          attrValue: '',
          keepAttr: true,
          allowedAttributes: ALLOWED_ATTR
        };
        l = attributes.length;
        while (l--) {
          attr = attributes[l];
          var _attr = attr,
            name = _attr.name,
            namespaceURI = _attr.namespaceURI;
          value = name === 'value' ? attr.value : stringTrim(attr.value);
          lcName = transformCaseFunc(name);
          hookEvent.attrName = lcName;
          hookEvent.attrValue = value;
          hookEvent.keepAttr = true;
          hookEvent.forceKeepAttr = undefined;
          _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
          value = hookEvent.attrValue;
          if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
            _removeAttribute(name, currentNode);
            continue;
          }
          if (hookEvent.forceKeepAttr) {
            continue;
          }
          _removeAttribute(name, currentNode);
          if (!hookEvent.keepAttr) {
            continue;
          }
          if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
            _removeAttribute(name, currentNode);
            continue;
          }
          if (SAFE_FOR_TEMPLATES) {
            value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
            value = stringReplace(value, ERB_EXPR$1, ' ');
            value = stringReplace(value, TMPLIT_EXPR$1, ' ');
          }
          var lcTag = transformCaseFunc(currentNode.nodeName);
          if (!_isValidAttribute(lcTag, lcName, value)) {
            continue;
          }
          if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
            _removeAttribute(name, currentNode);
            value = SANITIZE_NAMED_PROPS_PREFIX + value;
          }
          if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
            if (namespaceURI) ;else {
              switch (trustedTypes.getAttributeType(lcTag, lcName)) {
                case 'TrustedHTML':
                  {
                    value = trustedTypesPolicy.createHTML(value);
                    break;
                  }
                case 'TrustedScriptURL':
                  {
                    value = trustedTypesPolicy.createScriptURL(value);
                    break;
                  }
              }
            }
          }
          try {
            if (namespaceURI) {
              currentNode.setAttributeNS(namespaceURI, name, value);
            } else {
              currentNode.setAttribute(name, value);
            }
            if (_isClobbered(currentNode)) {
              _forceRemove(currentNode);
            } else {
              arrayPop(DOMPurify.removed);
            }
          } catch (_) {}
        }
        _executeHook('afterSanitizeAttributes', currentNode, null);
      };
      var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
        var shadowNode;
        var shadowIterator = _createIterator(fragment);
        _executeHook('beforeSanitizeShadowDOM', fragment, null);
        while (shadowNode = shadowIterator.nextNode()) {
          _executeHook('uponSanitizeShadowNode', shadowNode, null);
          if (_sanitizeElements(shadowNode)) {
            continue;
          }
          if (shadowNode.content instanceof DocumentFragment) {
            _sanitizeShadowDOM(shadowNode.content);
          }
          _sanitizeAttributes(shadowNode);
        }
        _executeHook('afterSanitizeShadowDOM', fragment, null);
      };
      DOMPurify.sanitize = function (dirty) {
        var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var body;
        var importedNode;
        var currentNode;
        var oldNode;
        var returnNode;
        IS_EMPTY_INPUT = !dirty;
        if (IS_EMPTY_INPUT) {
          dirty = '<!-->';
        }
        if (typeof dirty !== 'string' && !_isNode(dirty)) {
          if (typeof dirty.toString === 'function') {
            dirty = dirty.toString();
            if (typeof dirty !== 'string') {
              throw typeErrorCreate('dirty is not a string, aborting');
            }
          } else {
            throw typeErrorCreate('toString is not a function');
          }
        }
        if (!DOMPurify.isSupported) {
          if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
            if (typeof dirty === 'string') {
              return window.toStaticHTML(dirty);
            }
            if (_isNode(dirty)) {
              return window.toStaticHTML(dirty.outerHTML);
            }
          }
          return dirty;
        }
        if (!SET_CONFIG) {
          _parseConfig(cfg);
        }
        DOMPurify.removed = [];
        if (typeof dirty === 'string') {
          IN_PLACE = false;
        }
        if (IN_PLACE) {
          if (dirty.nodeName) {
            var tagName = transformCaseFunc(dirty.nodeName);
            if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
              throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
            }
          }
        } else if (dirty instanceof Node) {
          body = _initDocument('<!---->');
          importedNode = body.ownerDocument.importNode(dirty, true);
          if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
            body = importedNode;
          } else if (importedNode.nodeName === 'HTML') {
            body = importedNode;
          } else {
            body.appendChild(importedNode);
          }
        } else {
          if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && dirty.indexOf('<') === -1) {
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
          }
          body = _initDocument(dirty);
          if (!body) {
            return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
          }
        }
        if (body && FORCE_BODY) {
          _forceRemove(body.firstChild);
        }
        var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
        while (currentNode = nodeIterator.nextNode()) {
          if (currentNode.nodeType === 3 && currentNode === oldNode) {
            continue;
          }
          if (_sanitizeElements(currentNode)) {
            continue;
          }
          if (currentNode.content instanceof DocumentFragment) {
            _sanitizeShadowDOM(currentNode.content);
          }
          _sanitizeAttributes(currentNode);
          oldNode = currentNode;
        }
        oldNode = null;
        if (IN_PLACE) {
          return dirty;
        }
        if (RETURN_DOM) {
          if (RETURN_DOM_FRAGMENT) {
            returnNode = createDocumentFragment.call(body.ownerDocument);
            while (body.firstChild) {
              returnNode.appendChild(body.firstChild);
            }
          } else {
            returnNode = body;
          }
          if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) {
            returnNode = importNode.call(originalDocument, returnNode, true);
          }
          return returnNode;
        }
        var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
        if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
          serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
        }
        if (SAFE_FOR_TEMPLATES) {
          serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
          serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
          serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
        }
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
      };
      DOMPurify.setConfig = function (cfg) {
        _parseConfig(cfg);
        SET_CONFIG = true;
      };
      DOMPurify.clearConfig = function () {
        CONFIG = null;
        SET_CONFIG = false;
      };
      DOMPurify.isValidAttribute = function (tag, attr, value) {
        if (!CONFIG) {
          _parseConfig({});
        }
        var lcTag = transformCaseFunc(tag);
        var lcName = transformCaseFunc(attr);
        return _isValidAttribute(lcTag, lcName, value);
      };
      DOMPurify.addHook = function (entryPoint, hookFunction) {
        if (typeof hookFunction !== 'function') {
          return;
        }
        hooks[entryPoint] = hooks[entryPoint] || [];
        arrayPush(hooks[entryPoint], hookFunction);
      };
      DOMPurify.removeHook = function (entryPoint) {
        if (hooks[entryPoint]) {
          return arrayPop(hooks[entryPoint]);
        }
      };
      DOMPurify.removeHooks = function (entryPoint) {
        if (hooks[entryPoint]) {
          hooks[entryPoint] = [];
        }
      };
      DOMPurify.removeAllHooks = function () {
        hooks = {};
      };
      return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
  });
});

const SafeHtml = ({
  html,
  tag: _tag = "div",
  style: _style = {},
  className: _className = ""
}) => {
  const sanitizedHtml = purify.sanitize(html);
  const Tag = _tag;
  return /*#__PURE__*/React$1.createElement(Tag, {
    className: _className,
    style: _style,
    dangerouslySetInnerHTML: {
      __html: sanitizedHtml
    }
  });
};

const TLCaption = ({
  data,
  OpenImage
}) => {
  var _data$wfComment, _data$thumbnailsToSho, _data$thumbnailsToSho2;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement("div", null, data.date && /*#__PURE__*/React$1.createElement("p", null, data.date), /*#__PURE__*/React$1.createElement("p", null, data.name), data.mobileNumber && /*#__PURE__*/React$1.createElement(TelePhone, {
    mobile: data.mobileNumber
  }), data.source && /*#__PURE__*/React$1.createElement("p", null, t("ES_APPLICATION_DETAILS_APPLICATION_CHANNEL_" + data.source.toUpperCase())), data.comment && /*#__PURE__*/React$1.createElement(Reason, {
    otherComment: data === null || data === void 0 ? void 0 : data.otherComment,
    headComment: data === null || data === void 0 ? void 0 : data.comment
  }), data !== null && data !== void 0 && data.wfComment ? /*#__PURE__*/React$1.createElement("div", null, data === null || data === void 0 ? void 0 : (_data$wfComment = data.wfComment) === null || _data$wfComment === void 0 ? void 0 : _data$wfComment.map(e => /*#__PURE__*/React$1.createElement("div", {
    className: "TLComments",
    style: {
      backgroundColor: "aliceblue"
    }
  }, /*#__PURE__*/React$1.createElement("h3", null, t("WF_COMMON_COMMENTS")), /*#__PURE__*/React$1.createElement("i", null, /*#__PURE__*/React$1.createElement(SafeHtml, {
    html: e
  }))))) : null, (data === null || data === void 0 ? void 0 : (_data$thumbnailsToSho = data.thumbnailsToShow) === null || _data$thumbnailsToSho === void 0 ? void 0 : (_data$thumbnailsToSho2 = _data$thumbnailsToSho.thumbs) === null || _data$thumbnailsToSho2 === void 0 ? void 0 : _data$thumbnailsToSho2.length) > 0 ? /*#__PURE__*/React$1.createElement("div", {
    className: "TLComments",
    style: {
      backgroundColor: "aliceblue"
    }
  }, /*#__PURE__*/React$1.createElement("h3", null, t("CS_COMMON_ATTACHMENTS")), /*#__PURE__*/React$1.createElement(DisplayPhotos, {
    srcs: data === null || data === void 0 ? void 0 : data.thumbnailsToShow.thumbs,
    onClick: (src, index) => {
      OpenImage(src, index, data === null || data === void 0 ? void 0 : data.thumbnailsToShow);
    }
  })) : null);
};

function TLTradeAccessories({
  units
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, units.map((unit, index) => {
    var _unit$values;
    return (
      /*#__PURE__*/
      React$1.createElement("div", {
        key: t(unit === null || unit === void 0 ? void 0 : unit.title),
        style: {
          marginTop: "19px",
          background: "#FAFAFA",
          border: "1px solid #D6D5D4",
          borderRadius: "4px",
          padding: "8px",
          lineHeight: "19px",
          maxWidth: "600px",
          minWidth: "280px"
        }
      }, /*#__PURE__*/React$1.createElement(CardSubHeader, {
        style: {
          marginBottom: "8px",
          paddingBottom: "9px",
          color: "#0B0C0C",
          fontSize: "16px",
          lineHeight: "19px"
        }
      }, `${t(unit === null || unit === void 0 ? void 0 : unit.title)} ${index + 1}`), /*#__PURE__*/React$1.createElement(React$1.Fragment, {
        key: index
      }, /*#__PURE__*/React$1.createElement(StatusTable, {
        style: {
          position: "relative",
          marginTop: "19px"
        }
      }, /*#__PURE__*/React$1.createElement("div", {
        style: {
          position: "absolute",
          maxWidth: "640px",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          width: "auto"
        }
      }), unit === null || unit === void 0 ? void 0 : (_unit$values = unit.values) === null || _unit$values === void 0 ? void 0 : _unit$values.map((value, index) => {
        var _value$values;
        if (value.map === true && value.value !== "N/A") {
          return /*#__PURE__*/React$1.createElement(Row, {
            key: t(value.title),
            label: t(value.title),
            text: /*#__PURE__*/React$1.createElement("img", {
              src: t(value.value),
              alt: ""
            })
          });
        }
        return /*#__PURE__*/React$1.createElement(Row, {
          key: t(value.title),
          label: `${t(value.title)}:`,
          text: t(value.value) || "N/A",
          last: index === (value === null || value === void 0 ? void 0 : (_value$values = value.values) === null || _value$values === void 0 ? void 0 : _value$values.length) - 1,
          caption: value.caption,
          className: "border-none",
          rowContainerStyle: {
            justifyContent: "space-between",
            fontSize: "16px",
            lineHeight: "19px",
            color: "#0B0C0C"
          }
        });
      }))))
    );
  }));
}

function TLTradeUnits({
  units
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, units.map((unit, index) => {
    var _unit$values;
    return (
      /*#__PURE__*/
      React$1.createElement("div", {
        key: t(unit === null || unit === void 0 ? void 0 : unit.title),
        style: {
          marginTop: "19px",
          background: "#FAFAFA",
          border: "1px solid #D6D5D4",
          borderRadius: "4px",
          padding: "8px",
          lineHeight: "19px",
          maxWidth: "600px",
          minWidth: "280px"
        }
      }, /*#__PURE__*/React$1.createElement(CardSubHeader, {
        style: {
          marginBottom: "9px",
          paddingBottom: "9px",
          color: "#0B0C0C",
          fontSize: "16px",
          lineHeight: "19px"
        }
      }, `${t(unit === null || unit === void 0 ? void 0 : unit.title)} ${index + 1}`), /*#__PURE__*/React$1.createElement(React$1.Fragment, {
        key: index
      }, /*#__PURE__*/React$1.createElement(StatusTable, {
        style: {
          position: "relative",
          marginTop: "19px"
        }
      }, /*#__PURE__*/React$1.createElement("div", {
        style: {
          position: "absolute",
          maxWidth: "640px",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          width: "auto"
        }
      }), unit === null || unit === void 0 ? void 0 : (_unit$values = unit.values) === null || _unit$values === void 0 ? void 0 : _unit$values.map((value, index) => {
        var _value$values;
        if (value.map === true && value.value !== "N/A") {
          return /*#__PURE__*/React$1.createElement(Row, {
            key: t(value.title),
            label: t(value.title),
            text: /*#__PURE__*/React$1.createElement("img", {
              src: t(value.value),
              alt: ""
            })
          });
        }
        return /*#__PURE__*/React$1.createElement(Row, {
          key: t(value.title),
          label: `${t(value.title)}:`,
          text: t(value.value) || "NA",
          last: index === (value === null || value === void 0 ? void 0 : (_value$values = value.values) === null || _value$values === void 0 ? void 0 : _value$values.length) - 1,
          caption: value.caption,
          className: "border-none",
          rowContainerStyle: {
            justifyContent: "space-between",
            fontSize: "16px",
            lineHeight: "19px",
            color: "#0B0C0C"
          }
        });
      }))))
    );
  }));
}

const ProfessionalsAddressMapper = ({
  data,
  t
}) => {
  const erKeys = Object.keys(data).filter(key => key.startsWith("er") && !key.includes("engineerUuid") && !key.includes("erplotArea"));
  const stringKeys = Object.keys(data).filter(key => !key.startsWith("er") && !key.includes("engineerUuid") && typeof data[key] === "string" && data[key] !== null);
  return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement("div", {
    style: {
      marginTop: "19px",
      background: "#FAFAFA",
      border: "1px solid #D6D5D4",
      borderRadius: "4px",
      padding: "8px",
      lineHeight: "19px",
      maxWidth: "960px",
      minWidth: "280px"
    }
  }, /*#__PURE__*/React$1.createElement(CardSubHeader, null, t("CORE_COMMON_PRIVATE_PROFESSIONAL_INFORMATION")), /*#__PURE__*/React$1.createElement(StatusTable, null, stringKeys.map((key, index) => /*#__PURE__*/React$1.createElement(Row, {
    key: index,
    className: "border-none",
    label: t(`CORE_COMMON_${key.toUpperCase()}`),
    text: data[key] || ""
  })))), /*#__PURE__*/React$1.createElement("div", {
    style: {
      marginTop: "19px",
      background: "#FAFAFA",
      border: "1px solid #D6D5D4",
      borderRadius: "4px",
      padding: "8px",
      lineHeight: "19px",
      maxWidth: "960px",
      minWidth: "280px"
    }
  }, /*#__PURE__*/React$1.createElement(CardSubHeader, null, t("CORE_COMMON_STRUCTURAL_ENGINEER_INFORMATION")), /*#__PURE__*/React$1.createElement(StatusTable, null, erKeys.map((key, index) => /*#__PURE__*/React$1.createElement(Row, {
    key: index,
    className: "border-none",
    label: t(`CORE_COMMON_${key.slice(2).toUpperCase()}`),
    text: data[key] || ""
  })))));
};

function ApplicationDetailsContent({
  applicationDetails,
  workflowDetails,
  isDataLoading,
  applicationData,
  businessService,
  timelineStatusPrefix,
  showTimeLine = true,
  statusAttribute = "status",
  paymentsList
}) {
  var _applicationDetails$a, _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data5, _workflowDetails$data6, _workflowDetails$data7, _workflowDetails$data8, _workflowDetails$data9, _workflowDetails$data10, _workflowDetails$data11, _workflowDetails$data12;
  const {
    t
  } = useTranslation();
  function OpenImage(imageSource, index, thumbnailsToShow) {
    var _thumbnailsToShow$ful;
    window.open(thumbnailsToShow === null || thumbnailsToShow === void 0 ? void 0 : (_thumbnailsToShow$ful = thumbnailsToShow.fullImage) === null || _thumbnailsToShow$ful === void 0 ? void 0 : _thumbnailsToShow$ful[0], "_blank");
  }
  const getTimelineCaptions = checkpoint => {
    if (checkpoint.state === "OPEN" || checkpoint.status === "INITIATED" && !window.location.href.includes("/obps/")) {
      var _applicationData$audi;
      const caption = {
        date: Digit.DateUtils.ConvertTimestampToDate(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$audi = applicationData.auditDetails) === null || _applicationData$audi === void 0 ? void 0 : _applicationData$audi.createdTime),
        source: (applicationData === null || applicationData === void 0 ? void 0 : applicationData.channel) || ""
      };
      return /*#__PURE__*/React$1.createElement(TLCaption, {
        data: caption
      });
    } else if (window.location.href.includes("/obps/") || window.location.href.includes("/noc/")) {
      var _checkpoint$auditDeta, _checkpoint$assignes, _checkpoint$assignes$, _checkpoint$assignes2, _checkpoint$assignes3;
      const caption = {
        date: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$auditDeta = checkpoint.auditDetails) === null || _checkpoint$auditDeta === void 0 ? void 0 : _checkpoint$auditDeta.lastModified,
        name: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes = checkpoint.assignes) === null || _checkpoint$assignes === void 0 ? void 0 : (_checkpoint$assignes$ = _checkpoint$assignes[0]) === null || _checkpoint$assignes$ === void 0 ? void 0 : _checkpoint$assignes$.name,
        mobileNumber: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes2 = checkpoint.assignes) === null || _checkpoint$assignes2 === void 0 ? void 0 : (_checkpoint$assignes3 = _checkpoint$assignes2[0]) === null || _checkpoint$assignes3 === void 0 ? void 0 : _checkpoint$assignes3.mobileNumber,
        comment: t(checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.comment),
        wfComment: checkpoint.wfComment,
        thumbnailsToShow: checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.thumbnailsToShow
      };
      return /*#__PURE__*/React$1.createElement(TLCaption, {
        data: caption,
        OpenImage: OpenImage
      });
    } else {
      var _Digit$DateUtils, _applicationData$audi2, _checkpoint$assignes4, _checkpoint$assignes5, _checkpoint$assignes6, _checkpoint$assignes7;
      const caption = {
        date: (_Digit$DateUtils = Digit.DateUtils) === null || _Digit$DateUtils === void 0 ? void 0 : _Digit$DateUtils.ConvertTimestampToDate(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$audi2 = applicationData.auditDetails) === null || _applicationData$audi2 === void 0 ? void 0 : _applicationData$audi2.lastModifiedTime),
        name: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes4 = checkpoint.assignes) === null || _checkpoint$assignes4 === void 0 ? void 0 : (_checkpoint$assignes5 = _checkpoint$assignes4[0]) === null || _checkpoint$assignes5 === void 0 ? void 0 : _checkpoint$assignes5.name,
        wfComment: checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.wfComment,
        mobileNumber: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes6 = checkpoint.assignes) === null || _checkpoint$assignes6 === void 0 ? void 0 : (_checkpoint$assignes7 = _checkpoint$assignes6[0]) === null || _checkpoint$assignes7 === void 0 ? void 0 : _checkpoint$assignes7.mobileNumber
      };
      return /*#__PURE__*/React$1.createElement(TLCaption, {
        data: caption
      });
    }
  };
  const getTranslatedValues = (dataValue, isNotTranslated) => {
    if (dataValue) {
      return !isNotTranslated ? t(dataValue) : dataValue;
    } else {
      return t("NA");
    }
  };
  const checkLocation = window.location.href.includes("employee/tl") || window.location.href.includes("employee/obps") || window.location.href.includes("employee/noc");
  const isNocLocation = window.location.href.includes("employee/noc");
  const isBPALocation = window.location.href.includes("employee/obps");
  const getRowStyles = () => {
    if (window.location.href.includes("employee/obps") || window.location.href.includes("employee/noc")) {
      return {
        justifyContent: "space-between",
        fontSize: "16px",
        lineHeight: "19px",
        color: "#0B0C0C"
      };
    } else if (checkLocation) {
      return {
        justifyContent: "space-between",
        fontSize: "16px",
        lineHeight: "19px",
        color: "#0B0C0C"
      };
    } else {
      return {};
    }
  };
  const getTableStyles = () => {
    if (window.location.href.includes("employee/obps") || window.location.href.includes("employee/noc")) {
      return {
        position: "relative",
        marginTop: "19px"
      };
    } else if (checkLocation) {
      return {
        position: "relative",
        marginTop: "19px"
      };
    } else {
      return {};
    }
  };
  const getMainDivStyles = () => {
    if (window.location.href.includes("employee/obps") || window.location.href.includes("employee/noc")) {
      return {
        lineHeight: "19px",
        maxWidth: "950px",
        minWidth: "280px"
      };
    } else if (checkLocation) {
      return {
        lineHeight: "19px",
        maxWidth: "600px",
        minWidth: "280px"
      };
    } else {
      return {};
    }
  };
  const getTextValue = value => {
    if (value !== null && value !== void 0 && value.skip) return value.value;else if (value !== null && value !== void 0 && value.isUnit) return value !== null && value !== void 0 && value.value ? `${getTranslatedValues(value === null || value === void 0 ? void 0 : value.value, value === null || value === void 0 ? void 0 : value.isNotTranslated)} ${t(value === null || value === void 0 ? void 0 : value.isUnit)}` : t("N/A");else return value !== null && value !== void 0 && value.value ? getTranslatedValues(value === null || value === void 0 ? void 0 : value.value, value === null || value === void 0 ? void 0 : value.isNotTranslated) : t("N/A");
  };
  return /*#__PURE__*/React$1.createElement(Card, {
    style: {
      position: "relative"
    },
    className: "employeeCard-override"
  }, applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a = applicationDetails.applicationDetails) === null || _applicationDetails$a === void 0 ? void 0 : _applicationDetails$a.map((detail, index) => {
    var _detail$values, _detail$additionalDet, _applicationDetails$a2, _applicationDetails$a3, _applicationDetails$a4, _detail$additionalDet2, _applicationDetails$a5, _applicationDetails$a6, _detail$values4, _detail$additionalDet3, _detail$additionalDet4, _detail$additionalDet5, _detail$additionalDet6, _detail$additionalDet7, _detail$additionalDet8, _detail$additionalDet9, _detail$additionalDet10, _detail$additionalDet11, _workflowDetails$data, _workflowDetails$data2, _detail$additionalDet12, _detail$additionalDet13, _detail$additionalDet14, _detail$additionalDet15, _detail$additionalDet16, _detail$additionalDet17, _detail$additionalDet18, _detail$additionalDet19, _detail$additionalDet20, _detail$additionalDet21, _detail$additionalDet22, _detail$additionalDet23, _detail$additionalDet24;
    return /*#__PURE__*/React$1.createElement(React$1.Fragment, {
      key: index
    }, /*#__PURE__*/React$1.createElement("div", {
      style: getMainDivStyles()
    }, (index === 0 || index === 9) && detail.asSectionHeader ? /*#__PURE__*/React$1.createElement(CardSubHeader, {
      style: {
        marginBottom: "16px",
        fontSize: "24px"
      }
    }) : /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(CardSectionHeader, {
      style: index == 0 && checkLocation ? {
        marginBottom: "16px",
        fontSize: "24px"
      } : {
        marginBottom: "16px",
        marginTop: "32px",
        fontSize: "24px"
      }
    }, isNocLocation ? `${t(detail.title)}` : t(detail.title))), /*#__PURE__*/React$1.createElement(StatusTable, {
      style: getTableStyles()
    }, (detail === null || detail === void 0 ? void 0 : detail.title) && !(detail !== null && detail !== void 0 && detail.title.includes("NOC")) && (detail === null || detail === void 0 ? void 0 : (_detail$values = detail.values) === null || _detail$values === void 0 ? void 0 : _detail$values.map((value, index) => {
      var _detail$values3;
      if (value.map === true && value.value !== "N/A") {
        return /*#__PURE__*/React$1.createElement(Row, {
          key: t(value.title),
          label: t(value.title),
          text: /*#__PURE__*/React$1.createElement("img", {
            src: t(value.value),
            alt: ""
          })
        });
      }
      if ((value === null || value === void 0 ? void 0 : value.isLink) == true) {
        var _detail$values2;
        return /*#__PURE__*/React$1.createElement(Row, {
          key: t(value.title),
          label: window.location.href.includes("tl") ? /*#__PURE__*/React$1.createElement("div", {
            style: {
              width: "200%"
            }
          }, /*#__PURE__*/React$1.createElement(Link, {
            to: value === null || value === void 0 ? void 0 : value.to
          }, /*#__PURE__*/React$1.createElement("span", {
            className: "link",
            style: {
              color: "#1F4A7C"
            }
          }, t(value === null || value === void 0 ? void 0 : value.title)))) : isNocLocation || isBPALocation ? `${t(value.title)}` : t(value.title),
          text: /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(Link, {
            to: value === null || value === void 0 ? void 0 : value.to
          }, /*#__PURE__*/React$1.createElement("span", {
            className: "link",
            style: {
              color: "#1F4A7C"
            }
          }, value === null || value === void 0 ? void 0 : value.value))),
          last: index === (detail === null || detail === void 0 ? void 0 : (_detail$values2 = detail.values) === null || _detail$values2 === void 0 ? void 0 : _detail$values2.length) - 1,
          caption: value.caption,
          className: "border-none",
          rowContainerStyle: getRowStyles()
        });
      }
      return /*#__PURE__*/React$1.createElement(Row, {
        key: t(value.title),
        label: isNocLocation || isBPALocation ? `${t(value.title)}` : t(value.title),
        text: getTextValue(value),
        last: index === (detail === null || detail === void 0 ? void 0 : (_detail$values3 = detail.values) === null || _detail$values3 === void 0 ? void 0 : _detail$values3.length) - 1,
        caption: value.caption,
        className: "border-none",
        rowContainerStyle: getRowStyles()
      });
    })))), (detail === null || detail === void 0 ? void 0 : detail.belowComponent) && /*#__PURE__*/React$1.createElement(detail.belowComponent, null), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet = detail.additionalDetails) === null || _detail$additionalDet === void 0 ? void 0 : _detail$additionalDet.inspectionReport) && /*#__PURE__*/React$1.createElement(ScruntinyDetails, {
      scrutinyDetails: detail === null || detail === void 0 ? void 0 : detail.additionalDetails,
      paymentsList: paymentsList
    }), (applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a2 = applicationDetails.applicationData) === null || _applicationDetails$a2 === void 0 ? void 0 : (_applicationDetails$a3 = _applicationDetails$a2.additionalDetails) === null || _applicationDetails$a3 === void 0 ? void 0 : (_applicationDetails$a4 = _applicationDetails$a3.fieldinspection_pending) === null || _applicationDetails$a4 === void 0 ? void 0 : _applicationDetails$a4.length) > 0 && (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet2 = detail.additionalDetails) === null || _detail$additionalDet2 === void 0 ? void 0 : _detail$additionalDet2.fiReport) && /*#__PURE__*/React$1.createElement(InspectionReport, {
      fiReport: applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a5 = applicationDetails.applicationData) === null || _applicationDetails$a5 === void 0 ? void 0 : (_applicationDetails$a6 = _applicationDetails$a5.additionalDetails) === null || _applicationDetails$a6 === void 0 ? void 0 : _applicationDetails$a6.fieldinspection_pending
    }), (detail === null || detail === void 0 ? void 0 : detail.isprofessionalDetail) && /*#__PURE__*/React$1.createElement(ProfessionalsAddressMapper, {
      data: detail === null || detail === void 0 ? void 0 : (_detail$values4 = detail.values) === null || _detail$values4 === void 0 ? void 0 : _detail$values4[0],
      t: t
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet3 = detail.additionalDetails) === null || _detail$additionalDet3 === void 0 ? void 0 : _detail$additionalDet3.floors) && /*#__PURE__*/React$1.createElement(PropertyFloors, {
      floors: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet4 = detail.additionalDetails) === null || _detail$additionalDet4 === void 0 ? void 0 : _detail$additionalDet4.floors
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet5 = detail.additionalDetails) === null || _detail$additionalDet5 === void 0 ? void 0 : _detail$additionalDet5.owners) && /*#__PURE__*/React$1.createElement(PropertyOwners, {
      owners: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet6 = detail.additionalDetails) === null || _detail$additionalDet6 === void 0 ? void 0 : _detail$additionalDet6.owners
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet7 = detail.additionalDetails) === null || _detail$additionalDet7 === void 0 ? void 0 : _detail$additionalDet7.units) && /*#__PURE__*/React$1.createElement(TLTradeUnits, {
      units: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet8 = detail.additionalDetails) === null || _detail$additionalDet8 === void 0 ? void 0 : _detail$additionalDet8.units
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet9 = detail.additionalDetails) === null || _detail$additionalDet9 === void 0 ? void 0 : _detail$additionalDet9.accessories) && /*#__PURE__*/React$1.createElement(TLTradeAccessories, {
      units: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet10 = detail.additionalDetails) === null || _detail$additionalDet10 === void 0 ? void 0 : _detail$additionalDet10.accessories
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet11 = detail.additionalDetails) === null || _detail$additionalDet11 === void 0 ? void 0 : _detail$additionalDet11.permissions) && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.nextActions) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.length) > 0 && /*#__PURE__*/React$1.createElement(PermissionCheck, {
      applicationData: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData,
      t: t,
      permissions: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet12 = detail.additionalDetails) === null || _detail$additionalDet12 === void 0 ? void 0 : _detail$additionalDet12.permissions
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet13 = detail.additionalDetails) === null || _detail$additionalDet13 === void 0 ? void 0 : _detail$additionalDet13.obpsDocuments) && /*#__PURE__*/React$1.createElement(BPADocuments, {
      t: t,
      applicationData: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData,
      docs: detail.additionalDetails.obpsDocuments,
      bpaActionsDetails: workflowDetails
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet14 = detail.additionalDetails) === null || _detail$additionalDet14 === void 0 ? void 0 : _detail$additionalDet14.noc) && /*#__PURE__*/React$1.createElement(NOCDocuments, {
      t: t,
      isNoc: true,
      NOCdata: detail.values,
      applicationData: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData,
      docs: detail.additionalDetails.noc,
      noc: (_detail$additionalDet15 = detail.additionalDetails) === null || _detail$additionalDet15 === void 0 ? void 0 : _detail$additionalDet15.data,
      bpaActionsDetails: workflowDetails
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet16 = detail.additionalDetails) === null || _detail$additionalDet16 === void 0 ? void 0 : _detail$additionalDet16.scruntinyDetails) && /*#__PURE__*/React$1.createElement(ScruntinyDetails, {
      scrutinyDetails: detail === null || detail === void 0 ? void 0 : detail.additionalDetails
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet17 = detail.additionalDetails) === null || _detail$additionalDet17 === void 0 ? void 0 : _detail$additionalDet17.buildingExtractionDetails) && /*#__PURE__*/React$1.createElement(ScruntinyDetails, {
      scrutinyDetails: detail === null || detail === void 0 ? void 0 : detail.additionalDetails
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet18 = detail.additionalDetails) === null || _detail$additionalDet18 === void 0 ? void 0 : _detail$additionalDet18.subOccupancyTableDetails) && /*#__PURE__*/React$1.createElement(SubOccupancyTable, {
      edcrDetails: detail === null || detail === void 0 ? void 0 : detail.additionalDetails,
      applicationData: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet19 = detail.additionalDetails) === null || _detail$additionalDet19 === void 0 ? void 0 : _detail$additionalDet19.documentsWithUrl) && /*#__PURE__*/React$1.createElement(DocumentsPreview, {
      documents: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet20 = detail.additionalDetails) === null || _detail$additionalDet20 === void 0 ? void 0 : _detail$additionalDet20.documentsWithUrl
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet21 = detail.additionalDetails) === null || _detail$additionalDet21 === void 0 ? void 0 : _detail$additionalDet21.documents) && /*#__PURE__*/React$1.createElement(PropertyDocuments, {
      documents: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet22 = detail.additionalDetails) === null || _detail$additionalDet22 === void 0 ? void 0 : _detail$additionalDet22.documents
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet23 = detail.additionalDetails) === null || _detail$additionalDet23 === void 0 ? void 0 : _detail$additionalDet23.taxHeadEstimatesCalculation) && /*#__PURE__*/React$1.createElement(PropertyEstimates, {
      taxHeadEstimatesCalculation: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet24 = detail.additionalDetails) === null || _detail$additionalDet24 === void 0 ? void 0 : _detail$additionalDet24.taxHeadEstimatesCalculation
    }));
  }), showTimeLine && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data3 = workflowDetails.data) === null || _workflowDetails$data3 === void 0 ? void 0 : (_workflowDetails$data4 = _workflowDetails$data3.timeline) === null || _workflowDetails$data4 === void 0 ? void 0 : _workflowDetails$data4.length) > 0 && /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(BreakLine, null), ((workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.isLoading) || isDataLoading) && /*#__PURE__*/React$1.createElement(Loader, null), !(workflowDetails !== null && workflowDetails !== void 0 && workflowDetails.isLoading) && !isDataLoading && /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(CardSectionHeader, {
    style: {
      marginBottom: "16px",
      marginTop: "32px"
    }
  }, t("ES_APPLICATION_DETAILS_APPLICATION_TIMELINE")), workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data5 = workflowDetails.data) !== null && _workflowDetails$data5 !== void 0 && _workflowDetails$data5.timeline && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data6 = workflowDetails.data) === null || _workflowDetails$data6 === void 0 ? void 0 : (_workflowDetails$data7 = _workflowDetails$data6.timeline) === null || _workflowDetails$data7 === void 0 ? void 0 : _workflowDetails$data7.length) === 1 ? /*#__PURE__*/React$1.createElement(CheckPoint, {
    isCompleted: true,
    label: t(`${timelineStatusPrefix}${workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data8 = workflowDetails.data) === null || _workflowDetails$data8 === void 0 ? void 0 : (_workflowDetails$data9 = _workflowDetails$data8.timeline[0]) === null || _workflowDetails$data9 === void 0 ? void 0 : _workflowDetails$data9.state}`),
    customChild: getTimelineCaptions(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data10 = workflowDetails.data) === null || _workflowDetails$data10 === void 0 ? void 0 : _workflowDetails$data10.timeline[0])
  }) : /*#__PURE__*/React$1.createElement(ConnectingCheckPoints, null, (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data11 = workflowDetails.data) === null || _workflowDetails$data11 === void 0 ? void 0 : _workflowDetails$data11.timeline) && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data12 = workflowDetails.data) === null || _workflowDetails$data12 === void 0 ? void 0 : _workflowDetails$data12.timeline.map((checkpoint, index, arr) => {
    return /*#__PURE__*/React$1.createElement(React$1.Fragment, {
      key: index
    }, /*#__PURE__*/React$1.createElement(CheckPoint, {
      keyValue: index,
      isCompleted: index === 0,
      info: checkpoint.comment,
      label: t(`${timelineStatusPrefix}${(checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.performedAction) === "REOPEN" ? checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.performedAction : checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint[statusAttribute]}`),
      customChild: getTimelineCaptions(checkpoint)
    }));
  }))))));
}

function ApplicationDetailsToast({
  t,
  showToast,
  closeToast,
  businessService
}) {
  var _showToast$error, _showToast$error2, _showToast$error3, _showToast$error4, _showToast$error5, _showToast$error6, _showToast$error7, _showToast$error8, _showToast$action2, _showToast$error9, _showToast$error10, _showToast$error11, _showToast$error12, _showToast$error13, _showToast$error14, _showToast$error15, _showToast$error16, _showToast$action4;
  if (businessService !== null && businessService !== void 0 && businessService.includes("NewTL") || businessService !== null && businessService !== void 0 && businessService.includes("TL") || businessService !== null && businessService !== void 0 && businessService.includes("EDITRENEWAL")) {
    var _showToast$action;
    let label = "";
    switch (showToast === null || showToast === void 0 ? void 0 : (_showToast$action = showToast.action) === null || _showToast$action === void 0 ? void 0 : _showToast$action.action) {
      case "SENDBACK":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error = showToast.error) === null || _showToast$error === void 0 ? void 0 : _showToast$error.message : t("TL_SENDBACK_CHECKLIST_MESSAGE_HEAD");
        break;
      case "FORWARD":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error2 = showToast.error) === null || _showToast$error2 === void 0 ? void 0 : _showToast$error2.message : t("TL_FORWARD_SUCCESS_MESSAGE_MAIN");
        break;
      case "APPROVE":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error3 = showToast.error) === null || _showToast$error3 === void 0 ? void 0 : _showToast$error3.message : t("TL_APPROVAL_CHECKLIST_MESSAGE_HEAD");
        break;
      case "SENDBACKTOCITIZEN":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error4 = showToast.error) === null || _showToast$error4 === void 0 ? void 0 : _showToast$error4.message : t("TL_SENDBACK_TOCITIZEN_CHECKLIST_MESSAGE_HEAD");
        break;
      case "REJECT":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error5 = showToast.error) === null || _showToast$error5 === void 0 ? void 0 : _showToast$error5.message : t("TL_APPROVAL_REJ_MESSAGE_HEAD");
        break;
      case "RESUBMIT":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error6 = showToast.error) === null || _showToast$error6 === void 0 ? void 0 : _showToast$error6.message : t("TL_APPLICATION_RESUBMIT_SUCCESS_MESSAGE_MAIN");
        break;
      case "CANCEL":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error7 = showToast.error) === null || _showToast$error7 === void 0 ? void 0 : _showToast$error7.message : t("TL_TL_CANCELLED_MESSAGE_HEAD");
        break;
      default:
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error8 = showToast.error) === null || _showToast$error8 === void 0 ? void 0 : _showToast$error8.message : t(`ES_${businessService}_${showToast === null || showToast === void 0 ? void 0 : (_showToast$action2 = showToast.action) === null || _showToast$action2 === void 0 ? void 0 : _showToast$action2.action}_UPDATE_SUCCESS`);
    }
    return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, showToast && /*#__PURE__*/React$1.createElement(Toast, {
      error: showToast.key === "error",
      label: label,
      onClose: closeToast
    }));
  } else if (businessService !== null && businessService !== void 0 && businessService.includes("BPA") || businessService !== null && businessService !== void 0 && businessService.includes("BPA_LOW") || businessService !== null && businessService !== void 0 && businessService.includes("BPA_OC")) {
    var _showToast$action3;
    const getMessage = (messages = []) => {
      let returnValue = messages[0];
      if ((messages === null || messages === void 0 ? void 0 : messages.length) == 2) returnValue = businessService !== null && businessService !== void 0 && businessService.includes("BPA_OC") ? t(messages[1]) : t(messages[0]);else returnValue = t(messages[0]);
      return returnValue;
    };
    let label = "";
    switch (showToast === null || showToast === void 0 ? void 0 : (_showToast$action3 = showToast.action) === null || _showToast$action3 === void 0 ? void 0 : _showToast$action3.action) {
      case "REVOCATE":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error9 = showToast.error) === null || _showToast$error9 === void 0 ? void 0 : _showToast$error9.message : getMessage(["BPA_APPROVAL_REVOCATED_MESSAGE_HEAD", "BPA_APPROVAL_OC_REVOCATED_MESSAGE_HEAD"]);
        break;
      case "VERIFY_AND_FORWARD":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error10 = showToast.error) === null || _showToast$error10 === void 0 ? void 0 : _showToast$error10.message : getMessage(["BPA_FORWARD_SUCCESS_MESSAGE_MAIN"]);
        break;
      case "SEND_BACK_TO_CITIZEN":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error11 = showToast.error) === null || _showToast$error11 === void 0 ? void 0 : _showToast$error11.message : getMessage(["BPA_SENDBACK_SUCCESS_MESSAGE_MAIN"]);
        break;
      case "APPROVE":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error12 = showToast.error) === null || _showToast$error12 === void 0 ? void 0 : _showToast$error12.message : getMessage(["BPA_APPROVAL_CHECKLIST_MESSAGE_HEAD"]);
        break;
      case "REJECT":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error13 = showToast.error) === null || _showToast$error13 === void 0 ? void 0 : _showToast$error13.message : getMessage(["BPA_APPROVAL_REJECTED_MESSAGE_HEAD", "BPA_OC_APPROVAL_REJECTED_MESSAGE_HEAD"]);
        break;
      case "FORWARD":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error14 = showToast.error) === null || _showToast$error14 === void 0 ? void 0 : _showToast$error14.message : getMessage(["BPA_FORWARD_SUCCESS_MESSAGE_MAIN"]);
        break;
      case "SEND_BACK_FOR_DOCUMENT_VERIFICATION":
      case "SEND_BACK_FOR_FIELD_INSPECTION":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error15 = showToast.error) === null || _showToast$error15 === void 0 ? void 0 : _showToast$error15.message : getMessage(["BPA_SENDBACK_SUCCESS_MESSAGE_MAIN"]);
        break;
      default:
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error16 = showToast.error) === null || _showToast$error16 === void 0 ? void 0 : _showToast$error16.message : t(`ES_${businessService}_${showToast === null || showToast === void 0 ? void 0 : (_showToast$action4 = showToast.action) === null || _showToast$action4 === void 0 ? void 0 : _showToast$action4.action}_UPDATE_SUCCESS`);
    }
    return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, showToast && /*#__PURE__*/React$1.createElement(Toast, {
      error: showToast.key === "error",
      label: label,
      onClose: closeToast
    }));
  } else {
    var _showToast$error17, _showToast$action5;
    const label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error17 = showToast.error) === null || _showToast$error17 === void 0 ? void 0 : _showToast$error17.message : `ES_${businessService}_${showToast === null || showToast === void 0 ? void 0 : (_showToast$action5 = showToast.action) === null || _showToast$action5 === void 0 ? void 0 : _showToast$action5.action}_UPDATE_SUCCESS`;
    return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, showToast && /*#__PURE__*/React$1.createElement(Toast, {
      error: showToast.key === "error",
      label: t(label),
      onClose: closeToast
    }));
  }
}

function ApplicationDetailsActionBar({
  workflowDetails,
  displayMenu,
  onActionSelect,
  setDisplayMenu,
  businessService,
  forcedActionPrefix,
  ActionBarStyle = {},
  MenuStyle = {},
  applicationDetails
}) {
  var _user, _user$info, _user$info$roles, _applicationDetails$a, _workflowDetails$data, _workflowDetails$data2, _workflowDetails$data3, _actions$, _actions$$redirection, _workflowDetails$data4, _workflowDetails$data5, _actions$2, _actions$3, _actions$4;
  const {
    t
  } = useTranslation();
  let user = Digit.UserService.getUser();
  if (window.location.href.includes("/obps") || window.location.href.includes("/noc")) {
    const userInfos = sessionStorage.getItem("Digit.citizen.userRequestObject");
    const userInfo = userInfos ? JSON.parse(userInfos) : {};
    user = userInfo === null || userInfo === void 0 ? void 0 : userInfo.value;
  }
  const userRoles = (_user = user) === null || _user === void 0 ? void 0 : (_user$info = _user.info) === null || _user$info === void 0 ? void 0 : (_user$info$roles = _user$info.roles) === null || _user$info$roles === void 0 ? void 0 : _user$info$roles.map(e => e.code);
  let isSingleButton = false;
  let isMenuBotton = false;
  let isbelow = (applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a = applicationDetails.applicationData) === null || _applicationDetails$a === void 0 ? void 0 : _applicationDetails$a.plotArea) < 2500;
  const isTCP = userRoles.includes("TCP_HQ");
  let actions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.actionState) === null || _workflowDetails$data2 === void 0 ? void 0 : (_workflowDetails$data3 = _workflowDetails$data2.nextActions) === null || _workflowDetails$data3 === void 0 ? void 0 : _workflowDetails$data3.filter(e => {
    if (isbelow && isTCP && e.action === "SEND_TO_STP" && businessService === "BPA") {
      return false;
    } else if (!isbelow && isTCP && (e.action === "APPROVE" || e.action === "APPROVAL_LETTER_GENERATE" || e.action === "REJECT") && businessService === "BPA") {
      return false;
    }
    return userRoles.some(role => {
      var _e$roles;
      return (_e$roles = e.roles) === null || _e$roles === void 0 ? void 0 : _e$roles.includes(role);
    }) || !e.roles;
  });
  if ((window.location.href.includes("/obps") || window.location.href.includes("/noc")) && (actions === null || actions === void 0 ? void 0 : actions.length) == 1 || actions !== null && actions !== void 0 && (_actions$ = actions[0]) !== null && _actions$ !== void 0 && (_actions$$redirection = _actions$.redirectionUrl) !== null && _actions$$redirection !== void 0 && _actions$$redirection.pathname.includes("/pt/property-details/") && (actions === null || actions === void 0 ? void 0 : actions.length) == 1) {
    isMenuBotton = false;
    isSingleButton = true;
  } else if ((actions === null || actions === void 0 ? void 0 : actions.length) > 0) {
    isMenuBotton = true;
    isSingleButton = false;
  }
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, !(workflowDetails !== null && workflowDetails !== void 0 && workflowDetails.isLoading) && isMenuBotton && !isSingleButton && /*#__PURE__*/React$1.createElement(ActionBar, {
    style: {
      ...ActionBarStyle
    }
  }, displayMenu && workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data4 = workflowDetails.data) !== null && _workflowDetails$data4 !== void 0 && (_workflowDetails$data5 = _workflowDetails$data4.actionState) !== null && _workflowDetails$data5 !== void 0 && _workflowDetails$data5.nextActions ? /*#__PURE__*/React$1.createElement(Menu, {
    localeKeyPrefix: forcedActionPrefix || `WF_EMPLOYEE_${businessService === null || businessService === void 0 ? void 0 : businessService.toUpperCase()}`,
    options: actions,
    optionKey: "action",
    t: t,
    onSelect: onActionSelect,
    style: MenuStyle
  }) : null, /*#__PURE__*/React$1.createElement(SubmitBar, {
    label: t("WF_TAKE_ACTION"),
    onSubmit: () => setDisplayMenu(!displayMenu)
  })), !(workflowDetails !== null && workflowDetails !== void 0 && workflowDetails.isLoading) && !isMenuBotton && isSingleButton && /*#__PURE__*/React$1.createElement(ActionBar, {
    style: {
      ...ActionBarStyle
    }
  }, /*#__PURE__*/React$1.createElement("button", {
    style: {
      color: "#FFFFFF",
      fontSize: "19px"
    },
    className: "submit-bar",
    name: actions === null || actions === void 0 ? void 0 : (_actions$2 = actions[0]) === null || _actions$2 === void 0 ? void 0 : _actions$2.action,
    value: actions === null || actions === void 0 ? void 0 : (_actions$3 = actions[0]) === null || _actions$3 === void 0 ? void 0 : _actions$3.action,
    onClick: e => {
      onActionSelect((actions === null || actions === void 0 ? void 0 : actions[0]) || {});
    }
  }, t(`${forcedActionPrefix || `WF_EMPLOYEE_${businessService === null || businessService === void 0 ? void 0 : businessService.toUpperCase()}`}_${actions === null || actions === void 0 ? void 0 : (_actions$4 = actions[0]) === null || _actions$4 === void 0 ? void 0 : _actions$4.action}`))));
}

const Close$6 = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React$1.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$6 = props => {
  return /*#__PURE__*/React$1.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React$1.createElement(Close$6, null));
};
function ApplicationDetailsWarningPopup({
  action,
  workflowDetails,
  businessService,
  isWarningPop,
  closeWarningPopup
}) {
  const {
    t
  } = useTranslation();
  const isMobile = window.Digit.Utils.browser.isMobile();
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React$1.createElement("h1", {
      className: "heading-m"
    }, t("PT_DUES_ARE_PENDING")),
    headerBarEnd: /*#__PURE__*/React$1.createElement(CloseBtn$6, {
      onClick: () => {
        closeWarningPopup();
      }
    }),
    hideSubmit: true,
    isDisabled: false,
    popupStyles: isMobile ? {} : {
      width: "29%",
      marginTop: "auto"
    }
  }, /*#__PURE__*/React$1.createElement(Card, null, /*#__PURE__*/React$1.createElement("div", {
    style: {
      marginBottom: "30px"
    }
  }, /*#__PURE__*/React$1.createElement("h1", null, t("PT_YOU_HAVE"), " \u20B9", action === null || action === void 0 ? void 0 : action.AmountDueForPay, " ", t("PT_DUE_WARNING_MSG2"))), /*#__PURE__*/React$1.createElement(Row, {
    rowContainerStyle: {
      display: "flex"
    },
    labelStyle: {
      fontSize: "24px",
      fontWeight: "700",
      marginRight: "10%"
    },
    textStyle: {
      fontSize: "24px",
      fontWeight: "700",
      marginBottom: "20px"
    },
    label: `${t("PT_AMOUNT_DUE")}`,
    text: `₹${t(action === null || action === void 0 ? void 0 : action.AmountDueForPay)}`
  }), /*#__PURE__*/React$1.createElement("div", {
    style: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/React$1.createElement(ButtonSelector, {
    theme: "border",
    label: t('ES_PT_COMMON_CANCEL'),
    onSubmit: closeWarningPopup,
    style: {
      marginLeft: "10px"
    }
  }), /*#__PURE__*/React$1.createElement(ButtonSelector, {
    label: t('PT_COLLECT'),
    onSubmit: () => {
      var _action$redirectionUr;
      return window.location.assign(`${window.location.origin}${action === null || action === void 0 ? void 0 : (_action$redirectionUr = action.redirectionUrl) === null || _action$redirectionUr === void 0 ? void 0 : _action$redirectionUr.pathname}`);
    },
    style: {
      marginLeft: "10px"
    }
  })))), ")");
}

var bind = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

var toString = Object.prototype.toString;
function isArray(val) {
  return toString.call(val) === '[object Array]';
}
function isUndefined(val) {
  return typeof val === 'undefined';
}
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}
function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}
function isString(val) {
  return typeof val === 'string';
}
function isNumber(val) {
  return typeof val === 'number';
}
function isObject(val) {
  return val !== null && typeof val === 'object';
}
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }
  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
function isDate$1(val) {
  return toString.call(val) === '[object Date]';
}
function isFile(val) {
  return toString.call(val) === '[object File]';
}
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
    return false;
  }
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}
function forEach(obj, fn) {
  if (obj === null || typeof obj === 'undefined') {
    return;
  }
  if (typeof obj !== 'object') {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge() {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }
  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}
var utils = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate$1,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
var buildURL = function buildURL(url, params, paramsSerializer) {
  if (!params) {
    return url;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }
      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }
      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });
    serializedParams = parts.join('&');
  }
  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }
  return url;
};

function InterceptorManager() {
  this.handlers = [];
}
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};
var InterceptorManager_1 = InterceptorManager;

var transformData = function transformData(data, headers, fns) {
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });
  return data;
};

var isCancel = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

var enhanceError = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  error.isAxiosError = true;
  error.toJSON = function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code
    };
  };
  return error;
};

var createError = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

var settle = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

var cookies = utils.isStandardBrowserEnv() ? function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));
      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }
      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }
      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }
      if (secure === true) {
        cookie.push('secure');
      }
      document.cookie = cookie.join('; ');
    },
    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() : function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

var isAbsoluteURL = function isAbsoluteURL(url) {
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

var combineURLs = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

var buildFullPath = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
var parseHeaders = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;
  if (!headers) {
    return parsed;
  }
  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));
    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });
  return parsed;
};

var isURLSameOrigin = utils.isStandardBrowserEnv() ? function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;
  function resolveURL(url) {
    var href = url;
    if (msie) {
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute('href', href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type'];
    }
    var request = new XMLHttpRequest();
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }
    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
    request.timeout = config.timeout;
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };
      settle(resolve, reject, response);
      request = null;
    };
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }
      reject(createError('Request aborted', config, 'ECONNABORTED', request));
      request = null;
    };
    request.onerror = function handleError() {
      reject(createError('Network Error', config, null, request));
      request = null;
    };
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED', request));
      request = null;
    };
    if (utils.isStandardBrowserEnv()) {
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          delete requestHeaders[key];
        } else {
          request.setRequestHeader(key, val);
        }
      });
    }
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }
    if (config.cancelToken) {
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }
        request.abort();
        reject(cancel);
        request = null;
      });
    }
    if (!requestData) {
      requestData = null;
    }
    request.send(requestData);
  });
};

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};
function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}
function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    adapter = xhr;
  }
  return adapter;
}
var defaults = {
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],
  transformResponse: [function transformResponse(data) {
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {}
    }
    return data;
  }],
  timeout: 0,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};
defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};
utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});
utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults;

function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}
var dispatchRequest = function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = config.headers || {};
  config.data = transformData(config.data, config.headers, config.transformRequest);
  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults_1.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData(response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);
      if (reason && reason.response) {
        reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
      }
    }
    return Promise.reject(reason);
  });
};

var mergeConfig = function mergeConfig(config1, config2) {
  config2 = config2 || {};
  var config = {};
  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = ['baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer', 'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName', 'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress', 'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent', 'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'];
  var directMergeKeys = ['validateStatus'];
  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }
  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });
  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });
  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });
  var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
  var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
    return axiosKeys.indexOf(key) === -1;
  });
  utils.forEach(otherKeys, mergeDeepProperties);
  return config;
};

function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager_1(),
    response: new InterceptorManager_1()
  };
}
Axios.prototype.request = function request(config) {
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }
  config = mergeConfig(this.defaults, config);
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });
  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }
  return promise;
};
Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  Axios.prototype[method] = function (url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});
utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  Axios.prototype[method] = function (url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});
var Axios_1 = Axios;

function Cancel(message) {
  this.message = message;
}
Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};
Cancel.prototype.__CANCEL__ = true;
var Cancel_1 = Cancel;

function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }
  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      return;
    }
    token.reason = new Cancel_1(message);
    resolvePromise(token.reason);
  });
}
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};
var CancelToken_1 = CancelToken;

var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

var isAxiosError = function isAxiosError(payload) {
  return typeof payload === 'object' && payload.isAxiosError === true;
};

function createInstance(defaultConfig) {
  var context = new Axios_1(defaultConfig);
  var instance = bind(Axios_1.prototype.request, context);
  utils.extend(instance, Axios_1.prototype, context);
  utils.extend(instance, context);
  return instance;
}
var axios = createInstance(defaults_1);
axios.Axios = Axios_1;
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};
axios.Cancel = Cancel_1;
axios.CancelToken = CancelToken_1;
axios.isCancel = isCancel;
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = spread;
axios.isAxiosError = isAxiosError;
var axios_1 = axios;
var _default = axios;
axios_1.default = _default;

var axios$1 = axios_1;

axios$1.defaults.headers.common['X-XSS-Protection'] = '1; mode=block';
axios$1.defaults.headers.common['X-Frame-Options'] = 'DENY';
axios$1.defaults.headers.common['Content-Security-Policy'] = "frame-ancestors 'none';";
axios$1.defaults.headers.common['X-Content-Type-Options'] = 'nosniff';
axios$1.defaults.headers.common['Strict-Transport-Security'] = 'max-age=31536000; includeSubDomains; preload';
axios$1.defaults.headers.common['Cache-Control'] = 'no-cache, no-store, must-revalidate';
axios$1.interceptors.response.use(res => res, err => {
  const isEmployee = window.location.pathname.split("/").includes("employee");
  if (err && err.response && err.response.data && err.response.data.Errors) {
    for (const error of err.response.data.Errors) {
      if (error.message.includes("InvalidAccessTokenException")) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/digit-ui/citizen" + `?from=${encodeURIComponent(window.location.pathname + window.location.search)}`;
      }
    }
  }
  throw err;
});
const requestInfo = () => ({
  authToken: Digit.UserService.getUser().access_token || null
});
const authHeaders = () => ({
  "auth-token": Digit.UserService.getUser().access_token || null
});
const userServiceData = () => ({
  userInfo: Digit.UserService.getUser().info
});
window.Digit = window.Digit || {};
window.Digit = {
  ...window.Digit,
  RequestCache: window.Digit.RequestCache || {}
};
const Request = async ({
  method: _method = "POST",
  url,
  data: _data = {},
  headers: _headers = {},
  useCache: _useCache = false,
  params: _params = {},
  auth,
  urlParams: _urlParams = {},
  userService,
  locale: _locale = true,
  authHeader: _authHeader = false,
  setTimeParam: _setTimeParam = true,
  userDownload: _userDownload = false,
  noResponseData: _noResponseData = false,
  noRequestInfo: _noRequestInfo = false,
  multipartFormData: _multipartFormData = false,
  multipartData: _multipartData = {}
}) => {
  if (_method.toUpperCase() === "POST") {
    const ts = new Date().getTime();
    _data.RequestInfo = {
      apiId: "Rainmaker"
    };
    if (auth) {
      _data.RequestInfo = {
        ..._data.RequestInfo,
        ...requestInfo()
      };
    }
    if (userService) {
      _data.RequestInfo = {
        ..._data.RequestInfo,
        ...userServiceData()
      };
    }
    if (_locale) {
      _data.RequestInfo = {
        ..._data.RequestInfo,
        msgId: `${ts}|${Digit.StoreData.getCurrentLanguage()}`
      };
    }
    if (_noRequestInfo) {
      delete _data.RequestInfo;
    }
  }
  const headers1 = {
    "Content-Type": "application/json",
    Accept: window.globalConfigs.getConfig("ENABLE_SINGLEINSTANCE") ? "application/pdf,application/json" : "*/*",
    "X-XSS-Protection": "1; mode=block",
    "X-Frame-Options": "DENY",
    "Content-Security-Policy": "frame-ancestors 'none';",
    "X-Content-Type-Options": "nosniff",
    "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload",
    "Cache-Control": "no-cache, no-store, must-revalidate"
  };
  if (_authHeader) _headers = {
    ..._headers,
    ...authHeaders()
  };
  if (_userDownload) _headers = {
    ..._headers,
    ...headers1
  };
  let key = "";
  if (_useCache) {
    key = `${_method.toUpperCase()}.${url}.${btoa(escape(JSON.stringify(_params, null, 0)))}.${btoa(escape(JSON.stringify(_data, null, 0)))}`;
    const value = window.Digit.RequestCache[key];
    if (value) {
      return value;
    }
  } else if (_setTimeParam) {
    _params._ = Date.now();
  }
  let _url = url.split("/").map(path => {
    let key = path.split(":")[1];
    return _urlParams[key] ? _urlParams[key] : path;
  }).join("/");
  if (_multipartFormData) {
    const multipartFormDataRes = await axios$1({
      method: _method,
      url: _url,
      data: _multipartData.data,
      params: _params,
      headers: {
        "Content-Type": "multipart/form-data",
        "auth-token": Digit.UserService.getUser().access_token || null
      }
    });
    return multipartFormDataRes;
  }
  const tenantInfo = Digit.SessionStorage.get("userType") === "citizen" ? Digit.ULBService.getStateId() : Digit.ULBService.getCurrentTenantId() || Digit.ULBService.getStateId();
  if (!_params["tenantId"] && window.globalConfigs.getConfig("ENABLE_SINGLEINSTANCE")) {
    _params["tenantId"] = tenantInfo;
  }
  const res = _userDownload ? await axios$1({
    method: _method,
    url: _url,
    data: _data,
    params: _params,
    headers: _headers,
    responseType: "arraybuffer"
  }) : await axios$1({
    method: _method,
    url: _url,
    data: _data,
    params: _params,
    headers: _headers
  });
  if (_userDownload) return res;
  if (_noResponseData) return res;
  const returnData = res.data || res.response.data || {};
  if (_useCache && res.data && Object.keys(returnData).length !== 0) {
    window.Digit.RequestCache[key] = returnData;
  }
  return returnData;
};
const ServiceRequest = async ({
  serviceName,
  method: _method2 = "POST",
  url,
  data: _data2 = {},
  headers: _headers2 = {},
  useCache: _useCache2 = false,
  params: _params2 = {},
  auth,
  userService
}) => {
  const preHookName = `${serviceName}Pre`;
  const postHookName = `${serviceName}Post`;
  let reqParams = _params2;
  let reqData = _data2;
  if (window[preHookName] && typeof window[preHookName] === "function") {
    let preHookRes = await window[preHookName]({
      params: _params2,
      data: _data2
    });
    reqParams = preHookRes.params;
    reqData = preHookRes.data;
  }
  const resData = await Request({
    method: _method2,
    url,
    data: reqData,
    headers: _headers2,
    useCache: _useCache2,
    params: reqParams,
    auth,
    userService
  });
  if (window[postHookName] && typeof window[postHookName] === "function") {
    return await window[postHookName](resData);
  }
  return resData;
};

const Urls = {
  MDMS: `/egov-mdms-service/v1/_search`,
  MdmsSearchV2: `/mdms-v2/v1/_search`,
  MdmsCreateV2: `/mdms-v2/v1/_create`,
  MdmsUpdateV2: `/mdms-v2/v1/_update`,
  opensearchAPI: `/bpa-services/v1/bpa/_plainsearch`,
  WorkFlow: `/egov-workflow-v2/egov-wf/businessservice/_search`,
  WorkFlowProcessSearch: `/egov-workflow-v2/egov-wf/process/_search`,
  WorkFlowProcessCount: `/egov-workflow-v2/egov-wf/process/_count`,
  localization: `/localization/messages/v1/_search`,
  qrCodeURL: {
    bpaQRCode: `/bpa-services/v1/bpa/_qrcodeurl`,
    tlQRCode: `/tl-services/v1/ltp/_qrcodeurl`,
    SelfMap: `/bpa-services/v1/bpa/_qrcodeurl/_SelfMap`
  },
  logoUrl: {
    bpaLogoUrl: `/bpa-services/v1/bpa/_logourl?`
  },
  bpaService: {
    remarksDetail: `/bpa-services/v1/bpa/_remarksDetail/_create`,
    remarksPaymentDetails: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=PaymentDetails`,
    khasraDetails: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=khasraDetails`,
    nocRemarks: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=nocRemarks`,
    remarksDocument: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=DocumentDetails`,
    remarksSiteInspection: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=InspectionDetail`,
    remarksDrawing: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=DrawingsDetails`,
    remarkspFARDetail: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=remarksDetails`,
    remarksNoc: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=nocDetails`,
    remarksNoting: `/bpa-services/v1/bpa/_remarksDetail/_search1?`,
    getNotice: `/bpa-services/v1/bpa/_getNotice?vaadId=`
  },
  location: {
    localities: `/egov-location/location/v11/boundarys/_search?hierarchyTypeCode=ADMIN&boundaryType=Locality`,
    revenue_localities: `/egov-location/location/v11/boundarys/_search?hierarchyTypeCode=REVENUE&boundaryType=Locality`,
    business_services: `/bpa-services/v1/bpa/business-services`
  },
  pgr_search: `/pgr-services/v2/request/_search`,
  pgr_update: `/pgr-services/v2/request/_update`,
  filter_data: `https://run.mocky.io/v3/597a50a0-90e5-4a45-b82e-8a2186b760bd`,
  FileStore: "/filestore/v1/files",
  FileFetch: "/filestore/v1/files/url",
  PGR_Create: `/pgr-services/v2/request/_create`,
  pgr_count: `/pgr-services/v2/request/_count`,
  OTP_Send: "/user-otp/v1/_send",
  Otp_Validate: "/otp/v1/_validate",
  OTP_Send_verify: "/otp/_verify",
  trackAppliactionStatus: "/bpa-services/v1/bpa/_trackapplicationstatus",
  Authenticate: "/user/oauth/token",
  RegisterUser: "/user/citizen/_create",
  ChangePassword: "/user/password/nologin/_update",
  ChangePassword1: "/user/password/_update",
  UserProfileUpdate: "/user/profile/_update",
  UserCaptchaGenerate: "/user/captcha/generate",
  UserCaptchaValidate: "/user/captcha/validate",
  EmployeeSearch: "/egov-hrms/employees/_search",
  UserManualDelete: "/bpa-services/v1/adminApi/_usermanual/_delete",
  InboxSearch: "/inbox/v1/_search",
  InboxSearchApplication: "/bpa-services/v1/bpa/_dashboard/_count",
  SearchApplication: "/bpa-services/v1/bpa/_dashboard/_applicationDetail",
  tlSearchApplication: "/tl-services/v1/_dashboard/_applicationDetail",
  InboxSearchApplicationProfessional: "/tl-services/v1/_dashboard/_count",
  UserSearch: "/user/_search",
  UserManualCreate: `/bpa-services/v1/adminApi/_usermanual/_create`,
  UserManualSearch: `/bpa-services/v1/adminApi/_usermanual/_search`,
  UserLogout: "/user/_logout",
  Shortener: "/egov-url-shortening/shortener",
  fsm: {
    search: "/fsm/v1/_search",
    create: "/fsm/v1/_create",
    update: "/fsm/v1/_update",
    vendorSearch: "/vendor/v1/_search",
    vehicleSearch: "/vehicle/v1/_search",
    audit: "/fsm/v1/_audit",
    vehicleTripSearch: "/vehicle/trip/v1/_search",
    billingSlabSearch: "/fsm-calculator/v1/billingSlab/_search",
    vehilceUpdate: "/vehicle/trip/v1/_update",
    vehicleTripCreate: "/vehicle/trip/v1/_create"
  },
  form11: {
    create: "/bpa-services/v1/bpa/_createForm",
    auth: "/user/oauth/token"
  },
  form12: {
    create: "/bpa-services/v1/bpa/_createForm",
    auth: "/user/oauth/token"
  },
  payment: {
    fetch_bill: "/billing-service/bill/v2/_fetchbill",
    demandSearch: "/billing-service/demand/_search",
    create_reciept: "/collection-services/payments/_create",
    print_reciept: "/collection-services/payments",
    generate_pdf: "/pdf-service/v1/_create",
    create_citizen_reciept: "/pg-service/transaction/v1/_create",
    update_citizen_reciept: "/pg-service/transaction/v1/_update",
    search_bill: "/billing-service/bill/v2/_search",
    reciept_search: "/collection-services/payments/:buisnessService/_search",
    obps_Reciept_Search: "/collection-services/payments/_search"
  },
  dsc: {
    signParams: "/dsc-service/v1/signature/getSignParams"
  },
  pt: {
    fectch_property: "/property-services/property/_search",
    fetch_payment_details: "/billing-service/bill/v2/_fetchbill",
    create: "/property-services/property/_create",
    search: "/property-services/property/_search",
    update: "/property-services/property/_update",
    pt_calculation_estimate: "/pt-calculator-v2/propertytax/v2/_estimate",
    assessment_create: "/property-services/assessment/_create",
    assessment_search: "/property-services/assessment/_search",
    payment_search: "/collection-services/payments/PT/_search",
    pt_calculate_mutation: "/pt-calculator-v2/propertytax/mutation/_calculate"
  },
  dss: {
    dashboardConfig: "/dashboard-analytics/dashboard/getDashboardConfig",
    getCharts: "/dashboard-analytics/dashboard/getChartV2"
  },
  mcollect: {
    search: "/echallan-services/eChallan/v1/_search",
    create: "/echallan-services/eChallan/v1/_create?",
    fetch_bill: "/billing-service/bill/v2/_fetchbill?",
    search_bill: "/egov-searcher/bill-genie/mcollectbills/_get",
    search_bill_pt: "/egov-searcher/bill-genie/billswithaddranduser/_get",
    update: "/echallan-services/eChallan/v1/_update",
    download_pdf: "/egov-pdf/download/UC/mcollect-challan",
    receipt_download: "/egov-pdf/download/PAYMENT/consolidatedreceipt",
    bill_download: "/egov-pdf/download/bills/consolidatedbill",
    count: "/echallan-services/eChallan/v1/_count"
  },
  hrms: {
    search: "/egov-hrms/employees/_search",
    count: "/egov-hrms/employees/_count",
    create: "/egov-hrms/employees/_create",
    update: "/egov-hrms/employees/_update",
    employeeSearch: "/user/users/_jobdelegation/_employeeSearch",
    employeeFileTransfer: "/user/users/_employeeFileTransfer",
    deactivateUser: "/user/users/_deactivate"
  },
  tl: {
    create: "/tl-services/v1/_create",
    search: "/tl-services/v1/_search",
    fetch_payment_details: "/billing-service/bill/v2/_fetchbill",
    download_pdf: "/egov-pdf/download/TL/",
    update: "/tl-services/v1/_update",
    billingslab: "/tl-calculator/billingslab/_search",
    designOfApproval: "/tl-services/_DesignOfApprovalLetter",
    workflowEsclate: "/egov-workflow-v2/egov-wf/auto/BPAREG/_escalate",
    coaValidate: "/tl-services/v1/validate/_architectureNo",
    misReportRegistration: "/tl-services/v1/_misReportRegistration"
  },
  receipts: {
    receipt_download: "/egov-pdf/download/PAYMENT/consolidatedreceipt",
    payments: "/collection-services/payments",
    count: "/egov-hrms/employees/_count"
  },
  obps: {
    compliance_create: "/bpa-services/_compliance/_create",
    compliance_search: "/bpa-services/_compliance/_search",
    compliance_update: "/bpa-services/_compliance/_update",
    scrutinyDetails: "/edcr/rest/dcr/scrutinydetails",
    comparisionReport: "/edcr/rest/dcr/occomparison",
    create: "/bpa-services/v1/bpa/_create",
    createForm11: "/bpa-services/v1/subdivision/_create",
    createLandUseUP: "/bpa-services/v1/_landUse/_create",
    createOwner: "/bpa-services/v1/_owner/_create",
    updateOwner: "/bpa-services/v1/_owner/_update",
    createPurchasableFAR: "/bpa-services/v1/_purchasableFAR/_create",
    updatePurchasableFAR: "/bpa-services/v1/_purchasableFAR/_update",
    createFormCLU: "/bpa-services/v1/subdivision/_create",
    createForm34: "/bpa-services/v1/subdivision/_create",
    createForm26: "/bpa-services/v1/offences/_create",
    nocSearch: "/noc-services/v1/noc/_search",
    updateNOC: "/noc-services/v1/noc/_update",
    update: "/bpa-services/v1/bpa/_update",
    updateForm11: "/bpa-services/v1/subdivision/_update",
    updateFormCLU: "/bpa-services/v1/subdivision/_update",
    updateForm34: "/bpa-services/v1/subdivision/_update",
    updateFormLandUse: "/bpa-services/v1/_landUse/_update",
    bpaSearch: "/bpa-services/v1/bpa/_search",
    ltpGrading: "/bpa-services/v1/bpa/_dashboard/_fastpasHome",
    bpaSearchChallan: "/bpa-services/v1/bpa/_searchChallan",
    bpaCommonSearch: "/bpa-services/v1/bpa/_commonsearch",
    searchLandUseUP: "/bpa-services/v1/_landUse/_search",
    searchfrom11: "/bpa-services/v1/subdivision/_search",
    searchfrom26: "/bpa-services/v1/subdivision/_search",
    searchFromCLU: "/bpa-services/v1/subdivision/_search",
    searchFrom34: "/bpa-services/v1/subdivision/_search",
    ownerSearch: "/bpa-services/v1/_owner/_search",
    searchPurchasableFar: "/bpa-services/v1/_purchasableFAR/_search",
    bpaRegSearch: "/tl-services/v1/BPAREG/_search",
    bpaRegCreate: "/tl-services/v1/BPAREG/_create",
    bpaRegGetBill: "/tl-calculator/v1/BPAREG/_getbill",
    bpaRegUpdate: "/tl-services/v1/BPAREG/_update",
    receipt_download: "/egov-pdf/download/PAYMENT/consolidatedreceipt",
    edcrreportdownload: "/bpa-services/v1/bpa/_permitorderedcr",
    designOfApproval: "/bpa-services/_DesignOfApprovalLetter",
    designOfStuctural: "/bpa-services/_Structralcertificate",
    farIntimationLetter: "/bpa-services/_FarInimitionLetter",
    scheduleInspection: "/bpa-services/v1/bpa/_dashboard/_inspection",
    applicationDetailData: "/bpa-services/v1/bpa//_dashboard/_applicationDetailData",
    applicationDetailDataView: "/bpa-services/v1/bpa/_dashboard/_applicationDetailData",
    fetchProfessional: "/tl-services/v1/_dashboard/_applicationDetailData",
    fetchAppendex: "/bpa-services/v1/bpa/_dashboard/_applicationDetailData",
    paymentList: "/collection-services/payments/_plainsearch",
    paymentReport: "/bpa-services/v1/_paymentReport",
    echargesReport: "/bpa-services/v1/_echargesReport",
    applicationReport: "/bpa-services/v1/_applicationReport",
    applicationMisReport: "/bpa-services/v1/bpa/_extarctMisData",
    paymentMisReport: "/bpa-services/v1/bpa/_extractAllMisData",
    paymentMisReportNew: "/bpa-services/v1/bpa/_extractAllMisData",
    dashboardReport: "/bpa-services/v1/bpa/_bidashboard",
    scrutinyFailedReport: "/edcr/rest/dcr/not-accepted-files",
    inwardApplicationReport: "/bpa-services/v1/_inwardApplicationReport",
    selfApprovalReport: "/bpa-services/v1/_selfCertification",
    installments: "/bpa-calculator/api/installments/_calculate",
    fastpassSearch: "/bpa-services/v1/bpa/_plainsearch",
    bpaCommonSearch: "/bpa-services/v1/bpa/_commonsearch",
    bpacalculate: "/bpa-calculator/_calculate",
    bpacalculatechallan: "/bpa-calculator/_calculateChallan",
    deleteChallan: "/bpa-calculator/bpa/delete-challan",
    migratedSearch: "/bpa-services/v1/bpamigration/_search",
    migratedSearchappNo: "/bpa-services/v1/bpamigration/_searchByAppNo",
    employeeSearchList: "/user/users/_jobdelegation/_employeeSearch",
    totalAmountOfCharges: "/bpa-services/v1/bpa/_totalAmountOfCharges",
    taxHeadEstimateSearch: "/bpa-services/v1/bpa/_taxHeadEstimateSearch",
    employeeWorkflowCount: "/bpa-services/v1/adminApi/_employee-workflow-count",
    installmentCalculate: "/bpa-calculator/_insatllmentCalculate",
    checkPaymentStatus: "/bpa-ui/application-payment-status/live-status",
    challanUpdaterDirect: "/bpa-ui/challan-updater-direct",
    getSelfApprovalData: "/bpa-services/v1/bpa/_dashboard/_selfcount"
  },
  edcr: {
    create: "/edcr/rest/dcr/scrutinize"
  },
  land: {
    chatBoard_data_search: "/land-services/egscrutiny/_search1?applicationNumber",
    chatBoard_data_search3: "/land-services/egscrutiny/_search3?applicationNumber",
    modal_data_search: "/land-services/egscrutiny/_search?applicationNumber"
  },
  events: {
    search: "/egov-user-event/v1/events/_search",
    update: "/egov-user-event/v1/events/lat/_update",
    updateEvent: "/egov-user-event/v1/events/_update",
    updateEventCDG: "/egov-user-event/v1/events/lat/_update",
    count: "/egov-user-event/v1/events/notifications/_count",
    create: "/egov-user-event/v1/events/_create"
  },
  ws: {
    water_search: "/ws-services/wc/_search",
    sewarage_search: "/sw-services/swc/_search"
  },
  engagement: {
    document: {
      search: "/egov-document-uploader/egov-du/document/_search",
      create: "/egov-document-uploader/egov-du/document/_create",
      delete: "/egov-document-uploader/egov-du/document/_delete",
      update: "/egov-document-uploader/egov-du/document/_update"
    },
    surveys: {
      create: "/egov-survey-services/egov-ss/survey/_create",
      update: "/egov-survey-services/egov-ss/survey/_update",
      search: "/egov-survey-services/egov-ss/survey/_search",
      delete: "/egov-survey-services/egov-ss/survey/_delete",
      submitResponse: "/egov-survey-services/egov-ss/survey/response/_submit",
      showResults: "/egov-survey-services/egov-ss/survey/response/_results"
    }
  },
  noc: {
    nocSearch: "/noc-services/v1/noc/_search",
    nocExcelSearch: "/noc-services/v1/noc/excel/search",
    nocExcelCreate: "/noc-services/v1/noc/excel/create",
    nocExcelUpdate: "/noc-services/v1/noc/excel/update",
    nocCountSearch: "/noc-services/v1/noc/_dashboard/noc/_count",
    nocCountApplicationData: "/noc-services/v1/noc/_dashboard/noc/_applicationDetailData"
  }
};

const stringReplaceAll = (str = "", searcher = "", replaceWith = "") => {
  if (searcher == "") return str;
  while (str.includes(searcher)) {
    str = str.replace(searcher, replaceWith);
  }
  return str;
};

const localStoreSupport = () => {
  try {
    return "sessionStorage" in window && window["sessionStorage"] !== null;
  } catch (e) {
    return false;
  }
};
const k = key => `Digit.${key}`;
const getStorage = storageClass => ({
  get: key => {
    if (localStoreSupport() && key) {
      let valueInStorage = storageClass.getItem(k(key));
      if (!valueInStorage || valueInStorage === "undefined") {
        return null;
      }
      const item = JSON.parse(valueInStorage);
      if (Date.now() > item.expiry) {
        storageClass.removeItem(k(key));
        return null;
      }
      return item.value;
    } else if (typeof window !== "undefined") {
      var _window, _window$eGov;
      return ((_window = window) === null || _window === void 0 ? void 0 : (_window$eGov = _window.eGov) === null || _window$eGov === void 0 ? void 0 : _window$eGov.Storage) && window.eGov.Storage[k(key)].value;
    } else {
      return null;
    }
  },
  set: (key, value, ttl = 86400) => {
    const item = {
      value,
      ttl,
      expiry: Date.now() + ttl * 1000
    };
    if (localStoreSupport()) {
      storageClass.setItem(k(key), JSON.stringify(item));
    } else if (typeof window !== "undefined") {
      window.eGov = window.eGov || {};
      window.eGov.Storage = window.eGov.Storage || {};
      window.eGov.Storage[k(key)] = item;
    }
  },
  del: key => {
    if (localStoreSupport()) {
      storageClass.removeItem(k(key));
    } else if (typeof window !== "undefined") {
      window.eGov = window.eGov || {};
      window.eGov.Storage = window.eGov.Storage || {};
      delete window.eGov.Storage[k(key)];
    }
  }
});
const PersistantStorage = getStorage(window.localStorage);

const SortByName = (na, nb) => {
  if (na < nb) {
    return -1;
  }
  if (na > nb) {
    return 1;
  }
  return 0;
};
const GetCitiesWithi18nKeys = (MdmsRes, moduleCode) => {
  const cityList = MdmsRes.tenant.citymodule && MdmsRes.tenant.citymodule.find(module => module.code === moduleCode).tenants || [];
  const citiesMap = cityList.map(city => city.code);
  const cities = MdmsRes.tenant.tenants.filter(city => citiesMap.includes(city.code)).map(({
    code,
    name,
    logoId,
    emailId,
    address,
    contactNumber
  }) => ({
    code,
    name,
    logoId,
    emailId,
    address,
    contactNumber,
    i18nKey: "TENANT_TENANTS_" + code.replace(".", "_").toUpperCase()
  })).sort((cityA, cityB) => {
    const na = cityA.name.toLowerCase(),
      nb = cityB.name.toLowerCase();
    return SortByName(na, nb);
  });
  return cities;
};
const initRequestBody = tenantId => ({
  MdmsCriteria: {
    tenantId,
    moduleDetails: [{
      moduleName: "common-masters",
      masterDetails: [{
        name: "Department"
      }, {
        name: "Designation"
      }, {
        name: "StateInfo"
      }, {
        name: "wfSlaConfig"
      }]
    }, {
      moduleName: "tenant",
      masterDetails: [{
        name: "tenants"
      }, {
        name: "citymodule"
      }]
    }, {
      moduleName: "DIGIT-UI",
      masterDetails: [{
        name: "ApiCachingSettings"
      }]
    }, {
      moduleName: "BPA",
      masterDetails: [{
        name: "SchemesRate"
      }]
    }]
  }
});
const getCriteria = (tenantId, moduleDetails) => {
  return {
    MdmsCriteria: {
      tenantId,
      ...moduleDetails
    }
  };
};
const getGeneralCriteria = (tenantId, moduleCode, type) => ({
  details: {
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: type
      }]
    }]
  }
});
const getMultipleTypes = (tenantId, moduleCode, types) => ({
  details: {
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: types.map(type => {
        if (typeof type === "object") {
          return {
            name: type.name,
            filter: type.filter
          };
        }
        return {
          name: type
        };
      })
    }]
  }
});
const getReceiptKey = (tenantId, moduleCode) => ({
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "uiCommonPay"
      }]
    }]
  }
});
const getModuleServiceDefsCriteria = (tenantId, moduleCode) => ({
  type: "serviceDefs",
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: `RAINMAKER-${moduleCode}`,
      masterDetails: [{
        name: "ServiceDefs"
      }]
    }]
  }
});
const getSanitationTypeCriteria = (tenantId, moduleCode) => ({
  type: "SanitationType",
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "SanitationType",
        filter: null
      }]
    }]
  }
});
const getPitTypeCriteria = (tenantId, moduleCode) => ({
  type: "PitType",
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PitType",
        filter: null
      }]
    }]
  }
});
const getApplicationChannelCriteria = (tenantId, moduleCode) => ({
  type: "ApplicationChannel",
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "ApplicationChannel",
        filter: null
      }]
    }]
  }
});
const getPropertyTypeCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PropertyType",
        filter: null
      }]
    }]
  }
});
const getPropertyUsageCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PropertyType",
        filter: null
      }]
    }]
  }
});
const getCommonFieldsCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "CommonFieldsConfig",
        filter: null
      }]
    }]
  }
});
const getPreFieldsCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PreFieldsConfig",
        filter: null
      }]
    }]
  }
});
const getPostFieldsCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PostFieldsConfig",
        filter: null
      }]
    }]
  }
});
const getConfig = (tenantId, moduleCode) => ({
  type: "Config",
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "Config"
      }]
    }]
  }
});
const getVehicleTypeCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "VehicleMakeModel",
        filter: null
      }]
    }]
  }
});
const getChecklistCriteria = (tenantId, moduleCode) => ({
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "CheckList",
        filter: null
      }]
    }]
  }
});
const getSlumLocalityCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "Slum"
      }]
    }]
  }
});
const getPropertyOwnerTypeCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "OwnerType"
      }]
    }]
  }
});
const getSubPropertyOwnerShipCategoryCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "SubOwnerShipCategory"
      }]
    }]
  }
});
const getPropertyOwnerShipCategoryCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "OwnerShipCategory"
      }]
    }]
  }
});
const getTradeOwnerShipCategoryCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "OwnerShipCategory"
      }]
    }]
  }
});
const getDocumentRequiredScreenCategory = (tenantId, moduleCode) => ({
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "Documents"
      }]
    }]
  }
});
const getDefaultMapConfig = (tenantId, moduleCode) => ({
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "MapConfig"
      }]
    }]
  }
});
const getUsageCategoryList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "UsageCategory"
      }]
    }]
  }
});
const getPTPropertyTypeList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PropertyType"
      }]
    }]
  }
});
const getTLStructureTypeList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "StructureType"
      }]
    }]
  }
});
const getTLAccessoriesTypeList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "AccessoriesCategory"
      }]
    }]
  }
});
const getTLFinancialYearList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "FinancialYear",
        filter: `[?(@.module == "TL")]`
      }]
    }]
  }
});
const getPTFloorList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "Floor"
      }]
    }]
  }
});
const getReasonCriteria = (tenantId, moduleCode, type, payload) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: payload.map(mdmsLoad => ({
        name: mdmsLoad
      }))
    }]
  }
});
const getBillingServiceForBusinessServiceCriteria = filter => ({
  moduleDetails: [{
    moduleName: "BillingService",
    masterDetails: [{
      name: "BusinessService",
      filter
    }, {
      name: "TaxHeadMaster"
    }, {
      name: "TaxPeriod"
    }]
  }]
});
const getRoleStatusCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "RoleStatusMapping",
        filter: null
      }]
    }]
  }
});
const getRentalDetailsCategoryCriteria = (tenantId, moduleCode) => ({
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "RentalDetails"
      }]
    }]
  }
});
const getChargeSlabsCategoryCriteria = (tenantId, moduleCode) => ({
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "ChargeSlabs"
      }]
    }]
  }
});
const getGenderTypeList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "GenderType"
      }]
    }]
  }
});
const getDssDashboardCriteria = (tenantId, moduleCode) => ({
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "dashboard-config"
      }]
    }]
  }
});
const getMCollectBillingServiceCriteria = (tenantId, moduleCode, type, filter) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "BusinessService",
        filter: filter
      }]
    }]
  }
});
const getTradeUnitsDataList = (tenantId, moduleCode, type, filter) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "TradeType",
        filter: filter
      }]
    }]
  }
});
const getMCollectApplicationStatusCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "applicationStatus"
      }]
    }]
  }
});
const getHrmsEmployeeRolesandDesignations = () => ({
  moduleDetails: [{
    moduleName: "common-masters",
    masterDetails: [{
      name: "Department",
      filter: "[?(@.active == true)]"
    }, {
      name: "Designation",
      filter: "[?(@.active == true)]"
    }]
  }, {
    moduleName: "tenant",
    masterDetails: [{
      name: "tenants"
    }]
  }, {
    moduleName: "ACCESSCONTROL-ROLES",
    masterDetails: [{
      name: "roles",
      filter: "$.[?(@.code!='CITIZEN')]"
    }]
  }, {
    moduleName: "egov-location",
    masterDetails: [{
      name: "TenantBoundary"
    }]
  }]
});
const getFSTPPlantCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "FSTPPlantInfo"
      }]
    }]
  }
});
const getCancelReceiptReason = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "CancelReceiptReason"
      }]
    }]
  }
});
const getReceiptStatus = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "ReceiptStatus"
      }]
    }]
  }
});
const getCancelReceiptReasonAndStatus = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "ReceiptStatus"
      }, {
        name: "uiCommonPay"
      }]
    }]
  }
});
const getDocumentTypesCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "DocTypeMapping"
      }]
    }]
  }
});
const getTradeTypeRoleCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "TradeTypetoRoleMapping"
      }]
    }]
  }
});
const getMSDropDownCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "DropdownsConfig"
      }]
    }]
  }
});
const getLandUseCategories = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "BasicFarPurchasable"
      }]
    }]
  }
});
const getFSTPORejectionReasonCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "FSTPORejectionReason",
        filter: null
      }]
    }]
  }
});
const getFSMPaymentTypeCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PaymentType",
        filter: null
      }]
    }]
  }
});
const getFSMTripNumberCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "TripNumber",
        filter: null
      }]
    }]
  }
});
const getFSMReceivedPaymentTypeCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "ReceivedPaymentType",
        filter: null
      }]
    }]
  }
});
const GetEgovLocations = MdmsRes => {
  return MdmsRes["egov-location"].TenantBoundary[0].boundary.children.map(obj => ({
    name: obj.localname,
    i18nKey: obj.localname
  }));
};
const GetServiceDefs = (MdmsRes, moduleCode) => MdmsRes[`RAINMAKER-${moduleCode}`].ServiceDefs.filter(def => def.active);
const GetSanitationType = MdmsRes => MdmsRes["FSM"].SanitationType.filter(type => type.active);
const GetPitType = MdmsRes => MdmsRes["FSM"].PitType.filter(item => item.active).map(type => ({
  ...type,
  i18nKey: `PITTYPE_MASTERS_${type.code}`
}));
const GetApplicationChannel = MdmsRes => MdmsRes["FSM"].ApplicationChannel.filter(type => type.active).map(channel => ({
  ...channel,
  i18nKey: `ES_APPLICATION_DETAILS_APPLICATION_CHANNEL_${channel.code}`
}));
const GetPropertyType = MdmsRes => MdmsRes["FSM"].PropertyType.filter(property => property.active && !property.propertyType).map(item => ({
  ...item,
  i18nKey: `PROPERTYTYPE_MASTERS_${item.code}`,
  code: item.code
}));
const GetPropertySubtype = MdmsRes => MdmsRes["FSM"].PropertyType.filter(property => property.active && property.propertyType).map(item => ({
  ...item,
  i18nKey: `PROPERTYTYPE_MASTERS_${item.code}`,
  code: item.code
}));
const GetVehicleType = MdmsRes => MdmsRes["Vehicle"].VehicleMakeModel.filter(vehicle => vehicle.active).filter(vehicle => vehicle.make).map(vehicleDetails => {
  return {
    ...vehicleDetails,
    i18nKey: `COMMON_MASTER_VEHICLE_${vehicleDetails.code}`
  };
});
const GetSlumLocalityMapping = (MdmsRes, tenantId) => MdmsRes["FSM"].Slum.filter(type => type.active).reduce((prev, curr) => {
  return prev[curr.locality] ? {
    ...prev,
    [curr.locality]: [...prev[curr.locality], {
      ...curr,
      i18nKey: `${tenantId.toUpperCase().replace(".", "_")}_${curr.locality}_${curr.code}`
    }]
  } : {
    ...prev,
    [curr.locality]: [{
      ...curr,
      i18nKey: `${tenantId.toUpperCase().replace(".", "_")}_${curr.locality}_${curr.code}`
    }]
  };
}, {});
const GetPropertyOwnerShipCategory = MdmsRes => MdmsRes["PropertyTax"].OwnerShipCategory.filter(ownerShip => ownerShip.active).map(ownerShipDetails => {
  return {
    ...ownerShipDetails,
    i18nKey: `COMMON_MASTER_OWNER_TYPE_${ownerShipDetails.code}`
  };
});
const GetTradeOwnerShipCategory = MdmsRes => MdmsRes["common-masters"].OwnerShipCategory.filter(ownerShip => ownerShip.active).map(ownerShipDetails => {
  return {
    ...ownerShipDetails,
    i18nKey: `COMMON_MASTER_OWNER_TYPE_${ownerShipDetails.code}`
  };
});
const GetPropertyOwnerType = MdmsRes => MdmsRes["PropertyTax"].OwnerType.filter(owner => owner.active).map(ownerDetails => {
  return {
    ...ownerDetails,
    i18nKey: `PROPERTYTAX_OWNERTYPE_${ownerDetails.code}`
  };
});
const getSubPropertyOwnerShipCategory = MdmsRes => {
  MdmsRes["PropertyTax"].SubOwnerShipCategory.filter(category => category.active).map(subOwnerShipDetails => {
    return {
      ...subOwnerShipDetails,
      i18nKey: `PROPERTYTAX_BILLING_SLAB_${subOwnerShipDetails.code}`
    };
  });
  sessionStorage.setItem("getSubPropertyOwnerShipCategory", JSON.stringify(MdmsRes));
};
const getDocumentRequiredScreen = MdmsRes => {
  MdmsRes["PropertyTax"].Documents.filter(Documents => Documents.active).map(dropdownData => {
    return {
      ...Documents,
      i18nKey: `${dropdownData.code}`
    };
  });
};
const getTLDocumentRequiredScreen = MdmsRes => {
  MdmsRes["TradeLicense"].Documents.filter(Documents => Documents.active).map(dropdownData => {
    return {
      ...Documents,
      i18nKey: `${dropdownData.code}`
    };
  });
};
const getMapConfig = MdmsRes => {
  MdmsRes["PropertyTax"].MapConfig.filter(MapConfig => MapConfig).map(MapData => {
    return {
      ...MapConfig,
      defaultconfig: MapData.defaultConfig
    };
  });
};
const getUsageCategory = MdmsRes => MdmsRes["PropertyTax"].UsageCategory.filter(UsageCategory => UsageCategory.active).map(UsageCategorylist => {
  return {
    ...UsageCategorylist,
    i18nKey: `PROPERTYTAX_BILLING_SLAB_${UsageCategorylist.code}`
  };
});
const getPTPropertyType = MdmsRes => MdmsRes["PropertyTax"].UsageCategory.filter(PropertyType => PropertyType.active).map(PTPropertyTypelist => {
  return {
    ...UsageCategorylist,
    i18nKey: `COMMON_PROPTYPE_${stringReplaceAll(PTPropertyTypelist.code, ".", "_")}`
  };
});
const getTLStructureType = MdmsRes => MdmsRes["common-masters"].StructureType.filter(StructureType => StructureType.active).map(TLStructureTypeList => {
  return {
    ...TLStructureTypeList,
    i18nKey: `COMMON_MASTERS_STRUCTURETYPE_${stringReplaceAll(TLStructureTypeList.code, ".", "_")}`
  };
});
const getTLAccessoriesType = MdmsRes => MdmsRes["TradeLicense"].AccessoriesCategory.filter(AccessoriesCategory => AccessoriesCategory.active).map(TLAccessoryTypeList => {
  return {
    ...TLAccessoryTypeList,
    i18nKey: `TRADELICENSE_ACCESSORIESCATEGORY_${stringReplaceAll(TLAccessoryTypeList.code, ".", "_")}`
  };
});
const getTLFinancialYear = MdmsRes => MdmsRes["egf-master"].FinancialYear.filter(FinancialYear => FinancialYear.active && FinancialYear.module === "TL").map(FinancialYearList => {
  return {
    ...FinancialYearList
  };
});
const getFloorList = MdmsRes => MdmsRes["PropertyTax"].Floor.filter(PTFloor => PTFloor.active).map(PTFloorlist => {
  return {
    ...PTFloorlist,
    i18nKey: `PROPERTYTAX_FLOOR_${PTFloorlist.code}`
  };
});
const GetReasonType = (MdmsRes, type, moduleCode) => Object.assign({}, ...Object.keys(MdmsRes[moduleCode]).map(collection => ({
  [collection]: MdmsRes[moduleCode][collection].filter(reason => reason.active).map(reason => ({
    ...reason,
    i18nKey: `ES_ACTION_REASON_${reason.code}`
  }))
})));
const getRentalDetailsCategory = MdmsRes => {
  MdmsRes["PropertyTax"].RentalDetails.filter(category => category.active).map(RentalDetailsInfo => {
    return {
      ...RentalDetailsInfo,
      i18nKey: `PROPERTYTAX_BILLING_SLAB_${RentalDetailsInfo.code}`
    };
  });
};
const getChargeSlabsCategory = MdmsRes => {
  MdmsRes["PropertyTax"].ChargeSlabs.filter(category => category.active).map(ChargeSlabsInfo => {
    return {
      ...ChargeSlabsInfo
    };
  });
};
const getGenderType = MdmsRes => {
  return MdmsRes["common-masters"].GenderType.filter(GenderType => GenderType.active).map(genderDetails => {
    return {
      ...genderDetails,
      i18nKey: `PT_COMMON_GENDER_${genderDetails.code}`
    };
  });
};
const TLGenderType = MdmsRes => {
  MdmsRes["common-masters"].GenderType.filter(GenderType => GenderType.active).map(genders => {
    return {
      ...genders,
      i18nKey: `TL_GENDER_${genders.code}`
    };
  });
};
const PTGenderType = MdmsRes => {
  MdmsRes["common-masters"].GenderType.filter(GenderType => GenderType.active).map(formGender => {
    return {
      ...formGender,
      i18nKey: `PT_FORM3_${formGender.code}`
    };
  });
};
const HRGenderType = MdmsRes => {
  MdmsRes["common-masters"].GenderType.filter(GenderType => GenderType.active).map(comGender => {
    return {
      ...comGender,
      i18nKey: `COMMON_GENDER_${comGender.code}`
    };
  });
};
const GetMCollectBusinessService = MdmsRes => MdmsRes["BillingService"].BusinessService.map(businesServiceDetails => {
  return {
    ...businesServiceDetails,
    i18nKey: `BILLINGSERVICE_BUSINESSSERVICE_${businesServiceDetails.code}`
  };
});
const GetMCollectApplicationStatus = MdmsRes => MdmsRes["mCollect"].applcationStatus.map(appStatusDetails => {
  return {
    ...appStatusDetails,
    i18nKey: `BILLINGSERVICE_BUSINESSSERVICE_${appStatusDetails.code}`
  };
});
const getFSMGenderType = MdmsRes => {
  return MdmsRes["common-masters"].GenderType.map(genderDetails => {
    return {
      ...genderDetails,
      i18nKey: `COMMON_GENDER_${genderDetails.code}`
    };
  });
};
const GetFSTPORejectionReason = MdmsRes => {
  return MdmsRes["Vehicle"].FSTPORejectionReason.filter(reason => reason.active).map(reasonDetails => {
    return {
      ...reasonDetails,
      i18nKey: `ES_ACTION_REASON_${reasonDetails.code}`
    };
  });
};
const GetPaymentType = MdmsRes => {
  return MdmsRes["FSM"].PaymentType.filter(option => option.active).map(reasonDetails => {
    return {
      ...reasonDetails,
      i18nKey: `ES_ACTION_${reasonDetails.code}`
    };
  });
};
const GetTripNumber = MdmsRes => {
  return MdmsRes["FSM"].TripNumber.filter(option => option.active).map(reasonDetails => {
    return {
      ...reasonDetails,
      i18nKey: `ES_ACTION_TRIP_${reasonDetails.code}`
    };
  });
};
const GetReceivedPaymentType = MdmsRes => {
  return MdmsRes["FSM"].ReceivedPaymentType.filter(option => option.active).map(reasonDetails => {
    return {
      ...reasonDetails,
      i18nKey: `ES_ACTION_${reasonDetails.code}`
    };
  });
};
const getDssDashboard = MdmsRes => MdmsRes["dss-dashboard"]["dashboard-config"];
const GetRoleStatusMapping = MdmsRes => MdmsRes["DIGIT-UI"].RoleStatusMapping;
const GetCommonFields = (MdmsRes, moduleCode) => moduleCode.toUpperCase() === "PROPERTYTAX" ? MdmsRes["PropertyTax"].CommonFieldsConfig : MdmsRes["FSM"].CommonFieldsConfig;
const GetPreFields = MdmsRes => MdmsRes["FSM"].PreFieldsConfig;
const GetPostFields = MdmsRes => MdmsRes["FSM"].PostFieldsConfig;
const GetFSTPPlantInfo = MdmsRes => MdmsRes["FSM"].FSTPPlantInfo;
const GetDocumentsTypes = MdmsRes => MdmsRes["BPA"].DocTypeMapping;
const GetChecklist = MdmsRes => MdmsRes["BPA"].CheckList;
const transformResponse = (type, MdmsRes, moduleCode, tenantId) => {
  switch (type) {
    case "citymodule":
      return GetCitiesWithi18nKeys(MdmsRes, moduleCode);
    case "egovLocation":
      return GetEgovLocations(MdmsRes);
    case "serviceDefs":
      return GetServiceDefs(MdmsRes, moduleCode);
    case "ApplicationChannel":
      return GetApplicationChannel(MdmsRes);
    case "SanitationType":
      return GetSanitationType(MdmsRes);
    case "PropertyType":
      return GetPropertyType(MdmsRes);
    case "PropertySubtype":
      return GetPropertySubtype(MdmsRes);
    case "PitType":
      return GetPitType(MdmsRes);
    case "VehicleType":
      return GetVehicleType(MdmsRes);
    case "Slum":
      return GetSlumLocalityMapping(MdmsRes, tenantId);
    case "OwnerShipCategory":
      return GetPropertyOwnerShipCategory(MdmsRes);
    case "TLOwnerShipCategory":
      return GetTradeOwnerShipCategory(MdmsRes);
    case "OwnerType":
      return GetPropertyOwnerType(MdmsRes);
    case "SubOwnerShipCategory":
      return getSubPropertyOwnerShipCategory(MdmsRes);
    case "Documents":
      return getDocumentRequiredScreen(MdmsRes);
    case "TLDocuments":
      return getTLDocumentRequiredScreen(MdmsRes);
    case "MapConfig":
      return getMapConfig(MdmsRes);
    case "UsageCategory":
      return getUsageCategory(MdmsRes);
    case "PTPropertyType":
      return getPTPropertyType(MdmsRes);
    case "StructureType":
      return getTLStructureType(MdmsRes);
    case "AccessoryCategory":
      return getTLAccessoriesType(MdmsRes);
    case "FinancialYear":
      return getTLFinancialYear(MdmsRes);
    case "Floor":
      return getFloorList(MdmsRes);
    case "Reason":
      return GetReasonType(MdmsRes, type, moduleCode);
    case "RoleStatusMapping":
      return GetRoleStatusMapping(MdmsRes);
    case "CommonFieldsConfig":
      return GetCommonFields(MdmsRes, moduleCode);
    case "PreFieldsConfig":
      return GetPreFields(MdmsRes);
    case "PostFieldsConfig":
      return GetPostFields(MdmsRes);
    case "RentalDeatils":
      return getRentalDetailsCategory(MdmsRes);
    case "ChargeSlabs":
      return getChargeSlabsCategory(MdmsRes);
    case "DssDashboard":
      return getDssDashboard(MdmsRes);
    case "BusinessService":
      return GetMCollectBusinessService(MdmsRes);
    case "applcatonStatus":
      return GetMCollectApplicationStatus(MdmsRes);
    case "FSTPPlantInfo":
      return GetFSTPPlantInfo(MdmsRes);
    case "GenderType":
      return getGenderType(MdmsRes);
    case "TLGendertype":
      return TLGenderType(MdmsRes);
    case "PTGenderType":
      return PTGenderType(MdmsRes);
    case "HRGenderType":
      return HRGenderType(MdmsRes);
    case "DocumentTypes":
      return GetDocumentsTypes(MdmsRes);
    case "CheckList":
      return GetChecklist(MdmsRes);
    case "FSMGenderType":
      return getFSMGenderType(MdmsRes);
    case "FSTPORejectionReason":
      return GetFSTPORejectionReason(MdmsRes);
    case "PaymentType":
      return GetPaymentType(MdmsRes);
    case "TripNumber":
      return GetTripNumber(MdmsRes);
    case "ReceivedPaymentType":
      return GetReceivedPaymentType(MdmsRes);
    default:
      return MdmsRes;
  }
};
const mergedData = {};
const mergedPromises = {};
const callAllPromises = (success, promises = [], resData) => {
  promises.forEach(promise => {
    if (success) {
      promise.resolve(resData);
    } else {
      promise.reject(resData);
    }
  });
};
const mergeMDMSData = (data, tenantId, url) => {
  const key = `${tenantId}:${url}`;
  if (!mergedData[key] || Object.keys(mergedData[key]).length === 0) {
    mergedData[key] = data;
  } else {
    data.MdmsCriteria.moduleDetails.forEach(dataModuleDetails => {
      const moduleName = dataModuleDetails.moduleName;
      const masterDetails = dataModuleDetails.masterDetails;
      let found = false;
      mergedData[key].MdmsCriteria.moduleDetails.forEach(moduleDetail => {
        if (moduleDetail.moduleName === moduleName) {
          found = true;
          moduleDetail.masterDetails = [...moduleDetail.masterDetails, ...masterDetails];
        }
      });
      if (!found) {
        mergedData[key].MdmsCriteria.moduleDetails.push(dataModuleDetails);
      }
    });
  }
};
const debouncedCall = ({
  serviceName,
  url,
  data,
  useCache,
  params
}, resolve, reject) => {
  const key = `${params.tenantId}:${url}`;
  if (!mergedPromises[key] || mergedPromises[key].length === 0) {
    setTimeout(() => {
      let callData = JSON.parse(JSON.stringify(mergedData[key]));
      mergedData[key] = {};
      let callPromises = [...mergedPromises[key]];
      mergedPromises[key] = [];
      ServiceRequest({
        serviceName,
        url,
        data: callData,
        useCache,
        params
      }).then(data => {
        callAllPromises(true, callPromises, data);
      }).catch(err => {
        callAllPromises(false, callPromises, err);
      });
    }, 500);
  }
  mergeMDMSData(data, params.tenantId, url);
  if (!mergedPromises[key]) {
    mergedPromises[key] = [];
  }
  mergedPromises[key].push({
    resolve,
    reject
  });
};
const MdmsService = {
  init: stateCode => ServiceRequest({
    serviceName: "mdmsInit",
    url: Urls.MDMS,
    data: initRequestBody(stateCode),
    useCache: true,
    params: {
      tenantId: stateCode
    }
  }),
  call: (tenantId, details) => {
    return new Promise((resolve, reject) => debouncedCall({
      serviceName: "mdmsCall",
      url: Urls.MDMS,
      data: getCriteria(tenantId, details),
      useCache: true,
      params: {
        tenantId
      }
    }, resolve, reject));
  },
  search: (tenantId, details) => {
    return new Promise((resolve, reject) => debouncedCall({
      serviceName: "mdmsSearchV2",
      url: Urls.MdmsSearchV2,
      data: getCriteria(tenantId, details),
      useCache: true,
      params: {
        tenantId
      }
    }, resolve, reject));
  },
  getDataByCriteria: async (tenantId, mdmsDetails, moduleCode) => {
    const key = `MDMS.${tenantId}.${moduleCode}.${mdmsDetails.type}.${JSON.stringify(mdmsDetails.details)}`;
    const inStoreValue = PersistantStorage.get(key);
    if (inStoreValue) {
      return inStoreValue;
    }
    const {
      MdmsRes
    } = await MdmsService.call(tenantId, mdmsDetails.details);
    const responseValue = transformResponse(mdmsDetails.type, MdmsRes, moduleCode.toUpperCase(), tenantId);
    PersistantStorage.set(key, responseValue, 3600);
    return responseValue;
  },
  searchDataV2: async (tenantId, mdmsDetails, moduleCode) => {
    const key = `MDMSV2.${tenantId}.${moduleCode}.${mdmsDetails.type}.${JSON.stringify(mdmsDetails.details)}`;
    const inStoreValue = PersistantStorage.get(key);
    if (inStoreValue) {
      return inStoreValue;
    }
    const {
      MdmsRes
    } = await MdmsService.search(tenantId, mdmsDetails.details);
    const responseValue = transformResponse(mdmsDetails.type, MdmsRes, moduleCode.toUpperCase(), tenantId);
    PersistantStorage.set(key, responseValue, 3600);
    return responseValue;
  },
  getServiceDefs: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getModuleServiceDefsCriteria(tenantId, moduleCode), moduleCode);
  },
  getSanitationType: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getSanitationTypeCriteria(tenantId, moduleCode), moduleCode);
  },
  getApplicationChannel: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getApplicationChannelCriteria(tenantId, moduleCode), moduleCode);
  },
  getPropertyType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPropertyTypeCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getPropertyUsage: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPropertyUsageCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getPropertySubtype: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPropertyTypeCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getPitType: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getPitTypeCriteria(tenantId, moduleCode), moduleCode);
  },
  getVehicleType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getVehicleTypeCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getChecklist: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getChecklistCriteria(tenantId, moduleCode), moduleCode);
  },
  getPaymentRules: (tenantId, filter) => {
    return MdmsService.call(tenantId, getBillingServiceForBusinessServiceCriteria(filter));
  },
  getCustomizationConfig: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getConfig(tenantId, moduleCode), moduleCode);
  },
  getSlumLocalityMapping: (tenantId, moduleCode, type) => MdmsService.getDataByCriteria(tenantId, getSlumLocalityCriteria(tenantId, moduleCode, type), moduleCode),
  getReason: (tenantId, moduleCode, type, payload) => MdmsService.getDataByCriteria(tenantId, getReasonCriteria(tenantId, moduleCode, type, payload), moduleCode),
  getRoleStatus: (tenantId, moduleCode, type) => MdmsService.getDataByCriteria(tenantId, getRoleStatusCriteria(tenantId, moduleCode, type), moduleCode),
  getCommonFieldsConfig: (tenantId, moduleCode, type, payload) => MdmsService.getDataByCriteria(tenantId, getCommonFieldsCriteria(tenantId, moduleCode, type), moduleCode),
  getPreFieldsConfig: (tenantId, moduleCode, type, payload) => MdmsService.getDataByCriteria(tenantId, getPreFieldsCriteria(tenantId, moduleCode, type), moduleCode),
  getPostFieldsConfig: (tenantId, moduleCode, type, payload) => MdmsService.getDataByCriteria(tenantId, getPostFieldsCriteria(tenantId, moduleCode, type), moduleCode),
  getPropertyOwnerShipCategory: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPropertyOwnerShipCategoryCriteria(tenantId, moduleCode, type), moduleCode);
  },
  GetTradeOwnerShipCategory: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getTradeOwnerShipCategoryCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getPropertyOwnerType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPropertyOwnerTypeCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getPropertySubOwnerShipCategory: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getSubPropertyOwnerShipCategoryCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getDocumentRequiredScreen: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getDocumentRequiredScreenCategory(tenantId, moduleCode), moduleCode);
  },
  getTLDocumentRequiredScreen: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getDocumentRequiredScreenCategory(tenantId, moduleCode), moduleCode);
  },
  getTradeUnitsData: (tenantId, moduleCode, type, filter) => {
    return MdmsService.getDataByCriteria(tenantId, getTradeUnitsDataList(tenantId, moduleCode, type, filter), moduleCode);
  },
  getMapConfig: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getDefaultMapConfig(tenantId, moduleCode), moduleCode);
  },
  getUsageCategory: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getUsageCategoryList(tenantId, moduleCode), moduleCode);
  },
  getPTPropertyType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPTPropertyTypeList(tenantId, moduleCode), moduleCode);
  },
  getTLStructureType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getTLStructureTypeList(tenantId, moduleCode), moduleCode);
  },
  getTLAccessoriesType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getTLAccessoriesTypeList(tenantId, moduleCode), moduleCode);
  },
  getTLFinancialYear: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getTLFinancialYearList(tenantId, moduleCode), moduleCode);
  },
  getFloorList: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPTFloorList(tenantId, moduleCode, type), moduleCode);
  },
  getRentalDetails: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getRentalDetailsCategoryCriteria(tenantId, moduleCode), moduleCode);
  },
  getChargeSlabs: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getChargeSlabsCategoryCriteria(tenantId, moduleCode), moduleCode);
  },
  getDssDashboard: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getDssDashboardCriteria(tenantId, moduleCode), moduleCode);
  },
  getPaymentGateway: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGeneralCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getReceiptKey: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getReceiptKey(tenantId, moduleCode), moduleCode);
  },
  getHelpText: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGeneralCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getMCollectBillingService: (tenantId, moduleCode, type, filter) => {
    return MdmsService.getDataByCriteria(tenantId, getMCollectBillingServiceCriteria(tenantId, moduleCode, type, filter), moduleCode);
  },
  getMCollectApplcationStatus: (tenantId, moduleCode, type, filter) => {
    return MdmsService.getDataByCriteria(tenantId, getMCollectApplicationStatusCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getHrmsEmployeeRolesandDesignation: tenantId => {
    return MdmsService.call(tenantId, getHrmsEmployeeRolesandDesignations());
  },
  getHrmsEmployeeTypes: (tenantId, moduleCode, type, filter) => {
    return MdmsService.getDataByCriteria(tenantId, getGeneralCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getHrmsEmployeeReason: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGeneralCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getMultipleTypes: (tenantId, moduleCode, types) => {
    return MdmsService.getDataByCriteria(tenantId, getMultipleTypes(tenantId, moduleCode, types), moduleCode);
  },
  getMultipleTypesV2: (tenantId, moduleCode, types) => {
    return MdmsService.searchDataV2(tenantId, getMultipleTypes(tenantId, moduleCode, types), moduleCode);
  },
  getFSTPPlantInfo: (tenantId, moduleCode, types) => {
    return MdmsService.getDataByCriteria(tenantId, getFSTPPlantCriteria(tenantId, moduleCode, types), moduleCode);
  },
  getCancelReceiptReason: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getCancelReceiptReason(tenantId, moduleCode), moduleCode);
  },
  getReceiptStatus: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getReceiptStatus(tenantId, moduleCode), moduleCode);
  },
  getCancelReceiptReasonAndStatus: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getCancelReceiptReasonAndStatus(tenantId, moduleCode), moduleCode);
  },
  getGenderType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGenderTypeList(tenantId, moduleCode, type), moduleCode);
  },
  TLGenderType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGenderTypeList(tenantId, moduleCode, type), moduleCode);
  },
  PTGenderType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGenderTypeList(tenantId, moduleCode, type), moduleCode);
  },
  HRGenderType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGenderTypeList(tenantId, moduleCode, type), moduleCode);
  },
  getDocumentTypes: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getDocumentTypesCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getTradeTypeRoleTypes: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getTradeTypeRoleCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getMSDropDownTypes: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getMSDropDownCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getLandUseCategories: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getLandUseCategories(tenantId, moduleCode, type), moduleCode);
  },
  getFSMGenderType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGenderTypeList(tenantId, moduleCode, type), moduleCode);
  },
  getFSTPORejectionReason: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getFSTPORejectionReasonCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getFSMPaymentType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getFSMPaymentTypeCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getFSMTripNumber: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getFSMTripNumberCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getFSMReceivedPaymentType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getFSMReceivedPaymentTypeCriteria(tenantId, moduleCode, type), moduleCode);
  }
};

const UploadServices = {
  Filestorage: async (module, filedata, tenantId) => {
    var _window, _window$globalConfigs, _Digit$UserService$ge;
    const formData = new FormData();
    formData.append("file", filedata, filedata.name);
    formData.append("tenantId", tenantId);
    formData.append("module", module);
    let tenantInfo = (_window = window) !== null && _window !== void 0 && (_window$globalConfigs = _window.globalConfigs) !== null && _window$globalConfigs !== void 0 && _window$globalConfigs.getConfig("ENABLE_SINGLEINSTANCE") ? `?tenantId=${tenantId}` : "";
    var config = {
      method: "post",
      url: `${Urls.FileStore}${tenantInfo}`,
      data: formData,
      headers: {
        "auth-token": Digit.UserService.getUser() ? (_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.access_token : null
      }
    };
    return axios$1(config);
  },
  MultipleFilesStorage: async (module, filesData, tenantId) => {
    var _window2, _window2$globalConfig;
    const formData = new FormData();
    const filesArray = Array.from(filesData);
    filesArray === null || filesArray === void 0 ? void 0 : filesArray.forEach((fileData, index) => fileData ? formData.append("file", fileData, fileData.name) : null);
    formData.append("tenantId", tenantId);
    formData.append("module", module);
    let tenantInfo = (_window2 = window) !== null && _window2 !== void 0 && (_window2$globalConfig = _window2.globalConfigs) !== null && _window2$globalConfig !== void 0 && _window2$globalConfig.getConfig("ENABLE_SINGLEINSTANCE") ? `?tenantId=${tenantId}` : "";
    var config = {
      method: "post",
      url: `${Urls.FileStore}${tenantInfo}`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        "auth-token": Digit.UserService.getUser().access_token
      }
    };
    return axios$1(config);
  },
  Filefetch: async (filesArray, tenantId) => {
    var _window3, _window3$globalConfig;
    let tenantInfo = (_window3 = window) !== null && _window3 !== void 0 && (_window3$globalConfig = _window3.globalConfigs) !== null && _window3$globalConfig !== void 0 && _window3$globalConfig.getConfig("ENABLE_SINGLEINSTANCE") ? `?tenantId=${tenantId}` : "";
    var config = {
      method: "get",
      url: `${Urls.FileFetch}${tenantInfo}`,
      params: {
        tenantId: tenantId,
        fileStoreIds: filesArray === null || filesArray === void 0 ? void 0 : filesArray.join(",")
      }
    };
    const res = await axios$1(config);
    return res;
  }
};

const OBPSService = {
  scrutinyDetails: (tenantId, params) => Request({
    url: Urls.obps.scrutinyDetails,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  comparisionReport: (tenantId, params) => Request({
    url: Urls.obps.comparisionReport,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  create: (details, tenantId) => Request({
    url: Urls.obps.create,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createForm11: details => Request({
    url: Urls.obps.createForm11,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createLandUseUP: details => Request({
    url: Urls.obps.createLandUseUP,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createOwner: details => Request({
    url: Urls.obps.createOwner,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateOwner: details => Request({
    url: Urls.obps.updateOwner,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createPurchasableFAR: details => Request({
    url: Urls.obps.createPurchasableFAR,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updatePurchasableFAR: details => Request({
    url: Urls.obps.updatePurchasableFAR,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  calculateInstallments: details => Request({
    url: Urls.obps.installments,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createFormCLU: details => Request({
    url: Urls.obps.createFormCLU,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createForm34: details => Request({
    url: Urls.obps.createForm34,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createForm26: (details, tenantId) => Request({
    url: Urls.obps.createForm26,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  NOCSearch: (tenantId, sourceRefId) => Request({
    url: Urls.obps.nocSearch,
    params: {
      tenantId,
      ...sourceRefId
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  NOCExcelCreate: (tenantId, details) => Request({
    url: Urls.noc.nocExcelCreate,
    params: {},
    data: details,
    auth: true,
    userService: true,
    method: "POST"
  }),
  NOCExcelUpdate: (tenantId, details) => Request({
    url: Urls.noc.nocExcelUpdate,
    params: {},
    data: details,
    auth: true,
    userService: true,
    method: "POST"
  }),
  update: (details, tenantId) => Request({
    url: Urls.obps.update,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  update11: (details, tenantId) => Request({
    url: Urls.obps.updateForm11,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateForm11: details => Request({
    url: Urls.obps.updateForm11,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateFormCLU: details => Request({
    url: Urls.obps.updateFormCLU,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateForm34: details => Request({
    url: Urls.obps.updateForm34,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateFormLandUse: details => Request({
    url: Urls.obps.updateFormLandUse,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateNOC: (details, tenantId) => Request({
    url: Urls.obps.updateNOC,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  BPASearch: (tenantId, params) => Request({
    url: Urls.obps.bpaSearch,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchNoAuth: (tenantId, params) => Request({
    url: Urls.obps.bpaSearchChallan,
    params: {
      tenantId,
      ...params
    },
    method: "POST"
  }),
  BPAmigratedSearch: params => Request({
    url: Urls.obps.migratedSearch,
    params: {
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPAREGCommonSearch: (tenantId, params) => Request({
    url: Urls.obps.bpaCommonSearch,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPAmigratedSearchappNo: params => Request({
    url: Urls.obps.migratedSearchappNo,
    params: {
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchForm11: (tenantId, params) => Request({
    url: Urls.obps.searchfrom11,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPAOwnerRegistration: (tenantId, params) => Request({
    url: Urls.obps.ownerSearch,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchPurchasableFAR: (tenantId, params) => Request({
    url: Urls.obps.searchPurchasableFar,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchFormLandUse: (tenantId, params) => Request({
    url: Urls.obps.searchLandUseUP,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchForm26: (tenantId, params) => Request({
    url: Urls.obps.searchfrom26,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchFormCLU: (tenantId, params) => Request({
    url: Urls.obps.searchFromCLU,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPAFastPASSearch: params => Request({
    url: Urls.obps.fastpassSearch,
    params: {
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchForm34: (tenantId, params) => Request({
    url: Urls.obps.searchFrom34,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchMyApplicationForm11: (tenantId, applicationType, limit, departement, details, params) => Request({
    url: Urls.obps.searchfrom11,
    params: {
      tenantId,
      applicationType,
      limit,
      departement,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  BPASearchMyApplicationForm12: (tenantId, applType, limit, departement, details, params) => Request({
    url: Urls.obps.bpaSearch,
    params: {
      tenantId,
      applType,
      limit,
      departement,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  BPAMyApplicationCommonsearch: (tenantId, applType, limit, departement, details, params) => Request({
    url: Urls.obps.bpaCommonSearch,
    params: {
      tenantId,
      applType,
      limit,
      departement,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  BPASearchMyApplicationFormLandUse: (tenantId, applicationType, limit, details, params) => Request({
    url: Urls.obps.searchLandUseUP,
    params: {
      tenantId,
      applicationType,
      limit,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  designOfApprovalLetterPdf: (tenantId, applicationNumber, params) => Request({
    url: Urls.obps.designOfApproval,
    params: {
      tenantId,
      applicationNumber,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    userDownload: true
  }),
  designOfRegApprovalLetterPdf: (tenantId, applicationNumber, details) => Request({
    url: Urls.tl.designOfApproval,
    params: {
      tenantId,
      applicationNumber
    },
    auth: true,
    userService: true,
    method: "POST",
    userDownload: true,
    data: details
  }),
  designOfStructuralLetter: (tenantId, applicationNumber, params) => Request({
    url: Urls.obps.designOfStuctural,
    params: {
      tenantId,
      applicationNumber,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    userDownload: true
  }),
  farIntimationLetter: (tenantId, applicationNumber) => Request({
    url: Urls.obps.farIntimationLetter,
    params: {
      tenantId,
      applicationNumber
    },
    auth: true,
    userService: true,
    method: "POST",
    data: {}
  }),
  scheduleInspection: details => Request({
    url: Urls.obps.scheduleInspection,
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  applicationDetailData: (tenantId, params) => Request({
    url: Urls.obps.applicationDetailData,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  logUrlData: params => Request({
    url: Urls.logoUrl.bpaLogoUrl,
    params: {
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  applicationDetailDataView: (tenantId, params) => Request({
    url: Urls.obps.applicationDetailDataView,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  NOCCountApplicationData: (tenantId, params) => Request({
    url: Urls.noc.nocCountApplicationData,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  fetchAppendex: (tenantId, params) => Request({
    url: Urls.obps.fetchAppendex,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  fetchProfessional: (tenantId, params) => Request({
    url: Urls.obps.fetchProfessional,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  NOCCountSearch: (tenantId, params) => Request({
    url: Urls.noc.nocCountSearch,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  InboxSearchApplication: (tenantId, params) => Request({
    url: Urls.InboxSearchApplication,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  InboxSearchApplicationProfessional: (tenantId, params) => Request({
    url: Urls.InboxSearchApplicationProfessional,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  paymentDetailData: tenantId => Request({
    url: Urls.obps.paymentList,
    params: {
      tenantId
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  paymentReportData: () => Request({
    url: Urls.obps.paymentReport,
    method: "POST"
  }),
  eChargesReportData: tenantId => Request({
    url: Urls.obps.echargesReport,
    params: {
      tenantId
    },
    method: "POST"
  }),
  applicationReportData: (tenantId, params) => Request({
    url: Urls.obps.applicationReport,
    params: {
      tenantId,
      ...params
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  applicationReportMISData: (tenantId, params) => Request({
    url: Urls.obps.applicationMisReport,
    params: {
      tenantId,
      ...params
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  searchReportData: params => Request({
    url: Urls.obps.employeeSearchList,
    params: params,
    userService: true,
    auth: true,
    method: "POST"
  }),
  paymentReportMISData: (tenantId, params) => Request({
    url: Urls.obps.paymentMisReport,
    params: {
      tenantId,
      ...params
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  paymentReportMISDataNew: async (tenantId, params) => {
    try {
      return await Request({
        url: Urls.obps.paymentMisReportNew || "/bpa-services/v1/bpa/_extractAllMisData",
        params: {
          tenantId,
          _: Date.now(),
          ...params
        },
        userService: true,
        auth: true,
        method: "POST"
      });
    } catch (err) {
      var _err$response;
      if ((err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status) === 405) {
        return await Request({
          url: Urls.obps.paymentMisReportNew ,
          params: {
            tenantId,
            _: Date.now(),
            ...params
          },
          userService: true,
          auth: true,
          method: "GET"
        });
      }
      throw err;
    }
  },
  dashboardReportData: (tenantId, params) => Request({
    url: Urls.obps.dashboardReport,
    params: {
      tenantId,
      ...params
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  selfApprovalReportData: (tenantId, params) => Request({
    url: Urls.obps.selfApprovalReport,
    params: {
      tenantId,
      ...params
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  scrutinyReportFailedData: selectedDate => Request({
    url: Urls.obps.scrutinyFailedReport,
    params: {
      selectedDate
    },
    userService: true,
    auth: true,
    method: "GET"
  }),
  inwardReportData: tenantId => Request({
    url: Urls.obps.inwardApplicationReport,
    params: {
      tenantId
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  bpacalculate: details => Request({
    url: Urls.obps.bpacalculate,
    userService: true,
    auth: true,
    method: "POST",
    data: details
  }),
  bpacalculatechallan: details => Request({
    url: Urls.obps.bpacalculatechallan,
    userService: true,
    auth: true,
    method: "POST",
    data: details
  }),
  deleteChallan: (details, params) => Request({
    url: Urls.obps.deleteChallan,
    params: {
      ...params
    },
    userService: true,
    auth: true,
    method: "POST",
    data: details
  }),
  calculateInstallment: (details, params) => Request({
    url: Urls.obps.installmentCalculate,
    params: {
      ...params
    },
    userService: true,
    auth: true,
    method: "POST",
    data: details
  }),
  BPAREGSearch: (tenantId, details, params) => Request({
    url: Urls.obps.bpaRegSearch,
    params: {
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  BPAREGCreate: (details, tenantId) => Request({
    url: Urls.obps.bpaRegCreate,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: window.location.href.includes("openlink") ? false : true,
    method: "POST",
    params: {},
    auth: window.location.href.includes("openlink") ? false : true
  }),
  BPAREGGetBill: (tenantId, filters = {}) => Request({
    url: Urls.obps.bpaRegGetBill,
    useCache: false,
    method: "POST",
    auth: true,
    userService: false,
    params: {
      tenantId,
      ...filters
    }
  }).then(d => {
    return d;
  }).catch(err => {
    var _err$response2, _err$response2$data, _err$response2$data$E, _err$response2$data$E2;
    if ((err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$E = _err$response2$data.Errors) === null || _err$response2$data$E === void 0 ? void 0 : (_err$response2$data$E2 = _err$response2$data$E[0]) === null || _err$response2$data$E2 === void 0 ? void 0 : _err$response2$data$E2.code) === "EG_BS_BILL_NO_DEMANDS_FOUND") return {
      Bill: []
    };else throw err;
  }),
  BPAREGupdate: (details, tenantId) => Request({
    url: Urls.obps.bpaRegUpdate,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: window.location.href.includes("openlink") ? false : true,
    method: "POST",
    params: {},
    auth: window.location.href.includes("openlink") ? false : true
  }),
  receipt_download: (bussinessService, consumerCode, tenantId, filters = {}) => Request({
    url: Urls.obps.receipt_download,
    data: {},
    useCache: true,
    method: "POST",
    params: {
      bussinessService,
      consumerCode,
      tenantId,
      ...filters
    },
    auth: true,
    locale: true,
    userService: true,
    userDownload: true
  }),
  edcr_report_download: (details, tenantId) => Request({
    url: Urls.obps.edcrreportdownload,
    data: details,
    useCache: true,
    method: "POST",
    auth: true,
    locale: true,
    userService: false,
    userDownload: true
  }),
  ltpGrading: (details, tenantId) => Request({
    url: Urls.obps.ltpGrading,
    useCache: false,
    method: "POST",
    auth: false,
    userService: false
  }),
  LicenseDetails: async (tenantId, params) => {
    var _response$Licenses, _License$tradeLicense, _License$tradeLicense2, _mdmsRes$StakeholderR, _mdmsRes$StakeholderR2, _License$tradeLicense8, _License$tradeLicense9, _License$tradeLicense10, _License$tradeLicense11, _License$tradeLicense12, _License$tradeLicense13, _License$tradeLicense14, _License$tradeLicense15, _License$tradeLicense16, _License$tradeLicense17, _License$tradeLicense18, _License$tradeLicense19, _License$tradeLicense20, _License$tradeLicense21, _License$tradeLicense22, _License$tradeLicense23, _License$tradeLicense24, _License$tradeLicense25, _License$tradeLicense26, _License$tradeLicense27, _License$tradeLicense28, _License$tradeLicense29, _License$tradeLicense30, _License$tradeLicense31, _License$tradeLicense32, _License$tradeLicense33, _License$tradeLicense34, _License$tradeLicense35, _License$tradeLicense36, _License$tradeLicense37, _License$tradeLicense38, _License$tradeLicense39, _License$tradeLicense40, _License$tradeLicense41, _License$tradeLicense42, _License$tradeLicense43, _License$tradeLicense44, _License$tradeLicense45, _License$tradeLicense46, _License$tradeLicense47, _License$tradeLicense48, _License$tradeLicense49, _License$tradeLicense50, _License$tradeLicense51, _License$tradeLicense52, _License$tradeLicense53, _License$tradeLicense54, _License$tradeLicense55, _License$tradeLicense56, _License$tradeLicense57, _License$tradeLicense58, _License$tradeLicense59, _License$tradeLicense60, _License$tradeLicense61, _License$tradeLicense62, _License$tradeLicense63, _License$tradeLicense64, _License$tradeLicense65, _License$tradeLicense66, _License$tradeLicense67, _License$tradeLicense68, _License$tradeLicense69, _License$tradeLicense70, _License$tradeLicense71, _License$tradeLicense72, _License$tradeLicense73, _License$tradeLicense74, _License$tradeLicense75, _License$tradeLicense76, _License$tradeLicense77, _License$tradeLicense78, _License$tradeLicense79, _License$tradeLicense80, _License$tradeLicense81, _License$tradeLicense82, _License$tradeLicense83, _License$tradeLicense84, _License$tradeLicense85, _License$tradeLicense86, _License$tradeLicense87, _License$tradeLicense88, _License$tradeLicense89, _License$tradeLicense90, _License$tradeLicense91, _License$tradeLicense92, _License$tradeLicense93, _License$tradeLicense94, _License$tradeLicense95, _License$tradeLicense96, _License$tradeLicense97, _License$tradeLicense98, _License$tradeLicense99, _License$tradeLicense100, _License$tradeLicense101, _License$tradeLicense102, _License$tradeLicense103, _License$tradeLicense104, _License$tradeLicense105, _License$tradeLicense106, _License$tradeLicense107, _License$tradeLicense108, _License$tradeLicense109, _License$tradeLicense110, _License$tradeLicense111, _License$tradeLicense112, _License$tradeLicense113, _License$tradeLicense114, _License$tradeLicense115, _License$tradeLicense116, _License$tradeLicense117, _License$tradeLicense118, _License$tradeLicense119, _License$tradeLicense120, _License$tradeLicense121, _License$tradeLicense122, _License$tradeLicense123, _License$tradeLicense124, _License$tradeLicense125, _License$tradeLicense126, _License$tradeLicense127, _License$tradeLicense128, _License$tradeLicense129, _License$tradeLicense130, _License$tradeLicense131, _License$tradeLicense132, _License$tradeLicense133, _License$tradeLicense134, _License$tradeLicense135, _License$tradeLicense136, _License$tradeLicense137, _paymentRes$Payments, _paymentRes$Payments2, _paymentRes$Payments3, _paymentRes$Payments4, _paymentRes$Payments5;
    const response = await OBPSService.BPAREGSearch(tenantId, {}, params);
    if (!(response !== null && response !== void 0 && (_response$Licenses = response.Licenses) !== null && _response$Licenses !== void 0 && _response$Licenses.length)) {
      return;
    }
    const [License] = response === null || response === void 0 ? void 0 : response.Licenses;
    const paymentRes = await Digit.PaymentService.recieptSearch(tenantId, "BPAREG", {
      consumerCodes: License === null || License === void 0 ? void 0 : License.applicationNumber,
      isEmployee: true
    });
    const mdmsRes = await MdmsService.getMultipleTypes(License === null || License === void 0 ? void 0 : License.tenantId, "StakeholderRegistraition", ["TradeTypetoRoleMapping"]);
    if (License !== null && License !== void 0 && (_License$tradeLicense = License.tradeLicenseDetail) !== null && _License$tradeLicense !== void 0 && (_License$tradeLicense2 = _License$tradeLicense.applicationDocuments) !== null && _License$tradeLicense2 !== void 0 && _License$tradeLicense2.length && (mdmsRes === null || mdmsRes === void 0 ? void 0 : (_mdmsRes$StakeholderR = mdmsRes.StakeholderRegistraition) === null || _mdmsRes$StakeholderR === void 0 ? void 0 : (_mdmsRes$StakeholderR2 = _mdmsRes$StakeholderR.TradeTypetoRoleMapping) === null || _mdmsRes$StakeholderR2 === void 0 ? void 0 : _mdmsRes$StakeholderR2.length) > 0) {
      var _mdmsRes$StakeholderR3, _mdmsRes$StakeholderR4;
      mdmsRes === null || mdmsRes === void 0 ? void 0 : (_mdmsRes$StakeholderR3 = mdmsRes.StakeholderRegistraition) === null || _mdmsRes$StakeholderR3 === void 0 ? void 0 : (_mdmsRes$StakeholderR4 = _mdmsRes$StakeholderR3.TradeTypetoRoleMapping) === null || _mdmsRes$StakeholderR4 === void 0 ? void 0 : _mdmsRes$StakeholderR4.map(doc => {
        var _doc$docTypes, _License$tradeLicense3, _License$tradeLicense4, _License$tradeLicense5;
        if ((doc === null || doc === void 0 ? void 0 : (_doc$docTypes = doc.docTypes) === null || _doc$docTypes === void 0 ? void 0 : _doc$docTypes.length) > 0 && (doc === null || doc === void 0 ? void 0 : doc.tradeType) == (License === null || License === void 0 ? void 0 : (_License$tradeLicense3 = License.tradeLicenseDetail) === null || _License$tradeLicense3 === void 0 ? void 0 : (_License$tradeLicense4 = _License$tradeLicense3.tradeUnits) === null || _License$tradeLicense4 === void 0 ? void 0 : (_License$tradeLicense5 = _License$tradeLicense4[0]) === null || _License$tradeLicense5 === void 0 ? void 0 : _License$tradeLicense5.tradeType)) {
          var _doc$docTypes2;
          doc === null || doc === void 0 ? void 0 : (_doc$docTypes2 = doc.docTypes) === null || _doc$docTypes2 === void 0 ? void 0 : _doc$docTypes2.map(docType => {
            var _License$tradeLicense6, _License$tradeLicense7;
            License === null || License === void 0 ? void 0 : (_License$tradeLicense6 = License.tradeLicenseDetail) === null || _License$tradeLicense6 === void 0 ? void 0 : (_License$tradeLicense7 = _License$tradeLicense6.applicationDocuments) === null || _License$tradeLicense7 === void 0 ? void 0 : _License$tradeLicense7.forEach(document => {
              if ((docType === null || docType === void 0 ? void 0 : docType.code) == (document === null || document === void 0 ? void 0 : document.documentType) && docType !== null && docType !== void 0 && docType.info) document.info = docType === null || docType === void 0 ? void 0 : docType.info;
            });
          });
        }
      });
    }
    const appDocumentFileStoreIds = License === null || License === void 0 ? void 0 : (_License$tradeLicense8 = License.tradeLicenseDetail) === null || _License$tradeLicense8 === void 0 ? void 0 : (_License$tradeLicense9 = _License$tradeLicense8.applicationDocuments) === null || _License$tradeLicense9 === void 0 ? void 0 : _License$tradeLicense9.map(appDoc => appDoc === null || appDoc === void 0 ? void 0 : appDoc.fileStoreId);
    let fileDetails = {};
    if ((appDocumentFileStoreIds === null || appDocumentFileStoreIds === void 0 ? void 0 : appDocumentFileStoreIds.length) > 0) {
      fileDetails = await UploadServices.Filefetch(appDocumentFileStoreIds, Digit.ULBService.getStateId());
    }
    const details = [{
      title: " ",
      values: [{
        title: "BPA_APPLICATION_NUMBER_LABEL",
        value: (License === null || License === void 0 ? void 0 : License.applicationNumber) || "NA"
      }]
    }, License !== null && License !== void 0 && (_License$tradeLicense10 = License.tradeLicenseDetail) !== null && _License$tradeLicense10 !== void 0 && (_License$tradeLicense11 = _License$tradeLicense10.tradeUnits) !== null && _License$tradeLicense11 !== void 0 && (_License$tradeLicense12 = _License$tradeLicense11[0]) !== null && _License$tradeLicense12 !== void 0 && _License$tradeLicense12.tradeType.includes("ARCHITECT") ? {
      title: "BPA_LICENSE_DETAILS_LABEL",
      asSectionHeader: true,
      values: [{
        title: "BPA_LICENSE_TYPE",
        value: `TRADELICENSE_TRADETYPE_${License === null || License === void 0 ? void 0 : (_License$tradeLicense13 = License.tradeLicenseDetail) === null || _License$tradeLicense13 === void 0 ? void 0 : (_License$tradeLicense14 = _License$tradeLicense13.tradeUnits) === null || _License$tradeLicense14 === void 0 ? void 0 : (_License$tradeLicense15 = _License$tradeLicense14[0]) === null || _License$tradeLicense15 === void 0 ? void 0 : (_License$tradeLicense16 = _License$tradeLicense15.tradeType) === null || _License$tradeLicense16 === void 0 ? void 0 : _License$tradeLicense16.split(".")[0]}` || "NA"
      }, {
        title: "BPA_COUNCIL_OF_ARCH_NO_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense17 = License.tradeLicenseDetail) === null || _License$tradeLicense17 === void 0 ? void 0 : (_License$tradeLicense18 = _License$tradeLicense17.additionalDetail) === null || _License$tradeLicense18 === void 0 ? void 0 : _License$tradeLicense18.counsilForArchNo) || "NA"
      }]
    } : {
      title: "BPA_LICENSE_DETAILS_LABEL",
      asSectionHeader: true,
      values: [{
        title: "BPA_LICENSE_TYPE",
        value: `TRADELICENSE_TRADETYPE_${License === null || License === void 0 ? void 0 : (_License$tradeLicense19 = License.tradeLicenseDetail) === null || _License$tradeLicense19 === void 0 ? void 0 : (_License$tradeLicense20 = _License$tradeLicense19.tradeUnits) === null || _License$tradeLicense20 === void 0 ? void 0 : (_License$tradeLicense21 = _License$tradeLicense20[0]) === null || _License$tradeLicense21 === void 0 ? void 0 : (_License$tradeLicense22 = _License$tradeLicense21.tradeType) === null || _License$tradeLicense22 === void 0 ? void 0 : _License$tradeLicense22.split(".")[0]}` || "NA"
      }]
    }, {
      title: "BPA_LICENSEE_DETAILS_HEADER_OWNER_INFO",
      asSectionHeader: true,
      values: [{
        title: "BPA_APPLICANT_NAME_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense23 = License.tradeLicenseDetail) === null || _License$tradeLicense23 === void 0 ? void 0 : (_License$tradeLicense24 = _License$tradeLicense23.owners) === null || _License$tradeLicense24 === void 0 ? void 0 : (_License$tradeLicense25 = _License$tradeLicense24[0]) === null || _License$tradeLicense25 === void 0 ? void 0 : _License$tradeLicense25.name) || "NA"
      }, {
        title: "BPA_APPLICANT_GENDER_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense26 = License.tradeLicenseDetail) === null || _License$tradeLicense26 === void 0 ? void 0 : (_License$tradeLicense27 = _License$tradeLicense26.owners) === null || _License$tradeLicense27 === void 0 ? void 0 : (_License$tradeLicense28 = _License$tradeLicense27[0]) === null || _License$tradeLicense28 === void 0 ? void 0 : _License$tradeLicense28.gender) || "NA"
      }, {
        title: "BPA_OWNER_MOBILE_NO_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense29 = License.tradeLicenseDetail) === null || _License$tradeLicense29 === void 0 ? void 0 : (_License$tradeLicense30 = _License$tradeLicense29.owners) === null || _License$tradeLicense30 === void 0 ? void 0 : (_License$tradeLicense31 = _License$tradeLicense30[0]) === null || _License$tradeLicense31 === void 0 ? void 0 : _License$tradeLicense31.mobileNumber) || "NA"
      }, {
        title: "BPA_APPLICANT_EMAIL_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense32 = License.tradeLicenseDetail) === null || _License$tradeLicense32 === void 0 ? void 0 : (_License$tradeLicense33 = _License$tradeLicense32.owners) === null || _License$tradeLicense33 === void 0 ? void 0 : (_License$tradeLicense34 = _License$tradeLicense33[0]) === null || _License$tradeLicense34 === void 0 ? void 0 : _License$tradeLicense34.emailId) || "NA"
      }, {
        title: "BPA_APPLICANT_PAN_NO",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense35 = License.tradeLicenseDetail) === null || _License$tradeLicense35 === void 0 ? void 0 : (_License$tradeLicense36 = _License$tradeLicense35.owners) === null || _License$tradeLicense36 === void 0 ? void 0 : (_License$tradeLicense37 = _License$tradeLicense36[0]) === null || _License$tradeLicense37 === void 0 ? void 0 : _License$tradeLicense37.pan) || "NA"
      }]
    }, {
      title: "BPA_PERMANANT_ADDRESS_LABEL",
      asSectionHeader: true,
      values: [{
        title: "BPA_PERMANANT_ADDRESS_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense38 = License.tradeLicenseDetail) === null || _License$tradeLicense38 === void 0 ? void 0 : (_License$tradeLicense39 = _License$tradeLicense38.additionalDetail) === null || _License$tradeLicense39 === void 0 ? void 0 : (_License$tradeLicense40 = _License$tradeLicense39[0]) === null || _License$tradeLicense40 === void 0 ? void 0 : (_License$tradeLicense41 = _License$tradeLicense40.tradeLicenseDetail) === null || _License$tradeLicense41 === void 0 ? void 0 : (_License$tradeLicense42 = _License$tradeLicense41.owners) === null || _License$tradeLicense42 === void 0 ? void 0 : (_License$tradeLicense43 = _License$tradeLicense42[0]) === null || _License$tradeLicense43 === void 0 ? void 0 : (_License$tradeLicense44 = _License$tradeLicense43.permanentAddress) === null || _License$tradeLicense44 === void 0 ? void 0 : _License$tradeLicense44.address) || "NA"
      }, {
        title: "CORE_COMMON_STATE",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense45 = License.tradeLicenseDetail) === null || _License$tradeLicense45 === void 0 ? void 0 : (_License$tradeLicense46 = _License$tradeLicense45.additionalDetail) === null || _License$tradeLicense46 === void 0 ? void 0 : (_License$tradeLicense47 = _License$tradeLicense46[0]) === null || _License$tradeLicense47 === void 0 ? void 0 : (_License$tradeLicense48 = _License$tradeLicense47.tradeLicenseDetail) === null || _License$tradeLicense48 === void 0 ? void 0 : (_License$tradeLicense49 = _License$tradeLicense48.owners) === null || _License$tradeLicense49 === void 0 ? void 0 : (_License$tradeLicense50 = _License$tradeLicense49[0]) === null || _License$tradeLicense50 === void 0 ? void 0 : (_License$tradeLicense51 = _License$tradeLicense50.permanentAddress) === null || _License$tradeLicense51 === void 0 ? void 0 : _License$tradeLicense51.state) || "NA"
      }, {
        title: "CORE_COMMON_DISTRICT",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense52 = License.tradeLicenseDetail) === null || _License$tradeLicense52 === void 0 ? void 0 : (_License$tradeLicense53 = _License$tradeLicense52.additionalDetail) === null || _License$tradeLicense53 === void 0 ? void 0 : (_License$tradeLicense54 = _License$tradeLicense53[0]) === null || _License$tradeLicense54 === void 0 ? void 0 : (_License$tradeLicense55 = _License$tradeLicense54.tradeLicenseDetail) === null || _License$tradeLicense55 === void 0 ? void 0 : (_License$tradeLicense56 = _License$tradeLicense55.owners) === null || _License$tradeLicense56 === void 0 ? void 0 : (_License$tradeLicense57 = _License$tradeLicense56[0]) === null || _License$tradeLicense57 === void 0 ? void 0 : (_License$tradeLicense58 = _License$tradeLicense57.permanentAddress) === null || _License$tradeLicense58 === void 0 ? void 0 : _License$tradeLicense58.district) || "NA"
      }, {
        title: "CORE_COMMON_TEHSIL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense59 = License.tradeLicenseDetail) === null || _License$tradeLicense59 === void 0 ? void 0 : (_License$tradeLicense60 = _License$tradeLicense59.additionalDetail) === null || _License$tradeLicense60 === void 0 ? void 0 : (_License$tradeLicense61 = _License$tradeLicense60[0]) === null || _License$tradeLicense61 === void 0 ? void 0 : (_License$tradeLicense62 = _License$tradeLicense61.tradeLicenseDetail) === null || _License$tradeLicense62 === void 0 ? void 0 : (_License$tradeLicense63 = _License$tradeLicense62.owners) === null || _License$tradeLicense63 === void 0 ? void 0 : (_License$tradeLicense64 = _License$tradeLicense63[0]) === null || _License$tradeLicense64 === void 0 ? void 0 : (_License$tradeLicense65 = _License$tradeLicense64.permanentAddress) === null || _License$tradeLicense65 === void 0 ? void 0 : _License$tradeLicense65.tehsil) || "NA"
      }, {
        title: "CORE_COMMON_TOWN",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense66 = License.tradeLicenseDetail) === null || _License$tradeLicense66 === void 0 ? void 0 : (_License$tradeLicense67 = _License$tradeLicense66.additionalDetail) === null || _License$tradeLicense67 === void 0 ? void 0 : (_License$tradeLicense68 = _License$tradeLicense67[0]) === null || _License$tradeLicense68 === void 0 ? void 0 : (_License$tradeLicense69 = _License$tradeLicense68.tradeLicenseDetail) === null || _License$tradeLicense69 === void 0 ? void 0 : (_License$tradeLicense70 = _License$tradeLicense69.owners) === null || _License$tradeLicense70 === void 0 ? void 0 : (_License$tradeLicense71 = _License$tradeLicense70[0]) === null || _License$tradeLicense71 === void 0 ? void 0 : (_License$tradeLicense72 = _License$tradeLicense71.permanentAddress) === null || _License$tradeLicense72 === void 0 ? void 0 : _License$tradeLicense72.town) || "NA"
      }, {
        title: "CORE_COMMON_PINNO",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense73 = License.tradeLicenseDetail) === null || _License$tradeLicense73 === void 0 ? void 0 : (_License$tradeLicense74 = _License$tradeLicense73.additionalDetail) === null || _License$tradeLicense74 === void 0 ? void 0 : (_License$tradeLicense75 = _License$tradeLicense74[0]) === null || _License$tradeLicense75 === void 0 ? void 0 : (_License$tradeLicense76 = _License$tradeLicense75.tradeLicenseDetail) === null || _License$tradeLicense76 === void 0 ? void 0 : (_License$tradeLicense77 = _License$tradeLicense76.owners) === null || _License$tradeLicense77 === void 0 ? void 0 : (_License$tradeLicense78 = _License$tradeLicense77[0]) === null || _License$tradeLicense78 === void 0 ? void 0 : (_License$tradeLicense79 = _License$tradeLicense78.permanentAddress) === null || _License$tradeLicense79 === void 0 ? void 0 : _License$tradeLicense79.pinNo) || "NA"
      }, {
        title: "CORE_COMMON_UNIVERSITY_NAME",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense80 = License.tradeLicenseDetail) === null || _License$tradeLicense80 === void 0 ? void 0 : (_License$tradeLicense81 = _License$tradeLicense80.additionalDetail) === null || _License$tradeLicense81 === void 0 ? void 0 : (_License$tradeLicense82 = _License$tradeLicense81[0]) === null || _License$tradeLicense82 === void 0 ? void 0 : (_License$tradeLicense83 = _License$tradeLicense82.tradeLicenseDetail) === null || _License$tradeLicense83 === void 0 ? void 0 : (_License$tradeLicense84 = _License$tradeLicense83.owners) === null || _License$tradeLicense84 === void 0 ? void 0 : (_License$tradeLicense85 = _License$tradeLicense84[0]) === null || _License$tradeLicense85 === void 0 ? void 0 : (_License$tradeLicense86 = _License$tradeLicense85.permanentAddress) === null || _License$tradeLicense86 === void 0 ? void 0 : _License$tradeLicense86.university) || "NA"
      }]
    }, {
      title: "BPA_APPLICANT_CORRESPONDENCE_ADDRESS_LABEL",
      asSectionHeader: true,
      values: [{
        title: "BPA_APPLICANT_CORRESPONDENCE_ADDRESS_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense87 = License.tradeLicenseDetail) === null || _License$tradeLicense87 === void 0 ? void 0 : (_License$tradeLicense88 = _License$tradeLicense87.additionalDetail) === null || _License$tradeLicense88 === void 0 ? void 0 : (_License$tradeLicense89 = _License$tradeLicense88[0]) === null || _License$tradeLicense89 === void 0 ? void 0 : (_License$tradeLicense90 = _License$tradeLicense89.tradeLicenseDetail) === null || _License$tradeLicense90 === void 0 ? void 0 : (_License$tradeLicense91 = _License$tradeLicense90.owners) === null || _License$tradeLicense91 === void 0 ? void 0 : (_License$tradeLicense92 = _License$tradeLicense91[0]) === null || _License$tradeLicense92 === void 0 ? void 0 : (_License$tradeLicense93 = _License$tradeLicense92.correspondenceAddress) === null || _License$tradeLicense93 === void 0 ? void 0 : _License$tradeLicense93.address) || "NA"
      }, {
        title: "CORE_COMMON_STATE",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense94 = License.tradeLicenseDetail) === null || _License$tradeLicense94 === void 0 ? void 0 : (_License$tradeLicense95 = _License$tradeLicense94.additionalDetail) === null || _License$tradeLicense95 === void 0 ? void 0 : (_License$tradeLicense96 = _License$tradeLicense95[0]) === null || _License$tradeLicense96 === void 0 ? void 0 : (_License$tradeLicense97 = _License$tradeLicense96.tradeLicenseDetail) === null || _License$tradeLicense97 === void 0 ? void 0 : (_License$tradeLicense98 = _License$tradeLicense97.owners) === null || _License$tradeLicense98 === void 0 ? void 0 : (_License$tradeLicense99 = _License$tradeLicense98[0]) === null || _License$tradeLicense99 === void 0 ? void 0 : (_License$tradeLicense100 = _License$tradeLicense99.correspondenceAddress) === null || _License$tradeLicense100 === void 0 ? void 0 : _License$tradeLicense100.state) || "NA"
      }, {
        title: "CORE_COMMON_DISTRICT",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense101 = License.tradeLicenseDetail) === null || _License$tradeLicense101 === void 0 ? void 0 : (_License$tradeLicense102 = _License$tradeLicense101.additionalDetail) === null || _License$tradeLicense102 === void 0 ? void 0 : (_License$tradeLicense103 = _License$tradeLicense102[0]) === null || _License$tradeLicense103 === void 0 ? void 0 : (_License$tradeLicense104 = _License$tradeLicense103.tradeLicenseDetail) === null || _License$tradeLicense104 === void 0 ? void 0 : (_License$tradeLicense105 = _License$tradeLicense104.owners) === null || _License$tradeLicense105 === void 0 ? void 0 : (_License$tradeLicense106 = _License$tradeLicense105[0]) === null || _License$tradeLicense106 === void 0 ? void 0 : (_License$tradeLicense107 = _License$tradeLicense106.correspondenceAddress) === null || _License$tradeLicense107 === void 0 ? void 0 : _License$tradeLicense107.district) || "NA"
      }, {
        title: "CORE_COMMON_TEHSIL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense108 = License.tradeLicenseDetail) === null || _License$tradeLicense108 === void 0 ? void 0 : (_License$tradeLicense109 = _License$tradeLicense108.additionalDetail) === null || _License$tradeLicense109 === void 0 ? void 0 : (_License$tradeLicense110 = _License$tradeLicense109[0]) === null || _License$tradeLicense110 === void 0 ? void 0 : (_License$tradeLicense111 = _License$tradeLicense110.tradeLicenseDetail) === null || _License$tradeLicense111 === void 0 ? void 0 : (_License$tradeLicense112 = _License$tradeLicense111.owners) === null || _License$tradeLicense112 === void 0 ? void 0 : (_License$tradeLicense113 = _License$tradeLicense112[0]) === null || _License$tradeLicense113 === void 0 ? void 0 : (_License$tradeLicense114 = _License$tradeLicense113.correspondenceAddress) === null || _License$tradeLicense114 === void 0 ? void 0 : _License$tradeLicense114.tehsil) || "NA"
      }, {
        title: "CORE_COMMON_TOWN",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense115 = License.tradeLicenseDetail) === null || _License$tradeLicense115 === void 0 ? void 0 : (_License$tradeLicense116 = _License$tradeLicense115.additionalDetail) === null || _License$tradeLicense116 === void 0 ? void 0 : (_License$tradeLicense117 = _License$tradeLicense116[0]) === null || _License$tradeLicense117 === void 0 ? void 0 : (_License$tradeLicense118 = _License$tradeLicense117.tradeLicenseDetail) === null || _License$tradeLicense118 === void 0 ? void 0 : (_License$tradeLicense119 = _License$tradeLicense118.owners) === null || _License$tradeLicense119 === void 0 ? void 0 : (_License$tradeLicense120 = _License$tradeLicense119[0]) === null || _License$tradeLicense120 === void 0 ? void 0 : (_License$tradeLicense121 = _License$tradeLicense120.correspondenceAddress) === null || _License$tradeLicense121 === void 0 ? void 0 : _License$tradeLicense121.town) || "NA"
      }, {
        title: "CORE_COMMON_PINNO",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense122 = License.tradeLicenseDetail) === null || _License$tradeLicense122 === void 0 ? void 0 : (_License$tradeLicense123 = _License$tradeLicense122.additionalDetail) === null || _License$tradeLicense123 === void 0 ? void 0 : (_License$tradeLicense124 = _License$tradeLicense123[0]) === null || _License$tradeLicense124 === void 0 ? void 0 : (_License$tradeLicense125 = _License$tradeLicense124.tradeLicenseDetail) === null || _License$tradeLicense125 === void 0 ? void 0 : (_License$tradeLicense126 = _License$tradeLicense125.owners) === null || _License$tradeLicense126 === void 0 ? void 0 : (_License$tradeLicense127 = _License$tradeLicense126[0]) === null || _License$tradeLicense127 === void 0 ? void 0 : (_License$tradeLicense128 = _License$tradeLicense127.correspondenceAddress) === null || _License$tradeLicense128 === void 0 ? void 0 : _License$tradeLicense128.pinNo) || "NA"
      }, {
        title: "CORE_COMMON_UNIVERSITY_NAME",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense129 = License.tradeLicenseDetail) === null || _License$tradeLicense129 === void 0 ? void 0 : (_License$tradeLicense130 = _License$tradeLicense129.additionalDetail) === null || _License$tradeLicense130 === void 0 ? void 0 : (_License$tradeLicense131 = _License$tradeLicense130[0]) === null || _License$tradeLicense131 === void 0 ? void 0 : (_License$tradeLicense132 = _License$tradeLicense131.tradeLicenseDetail) === null || _License$tradeLicense132 === void 0 ? void 0 : (_License$tradeLicense133 = _License$tradeLicense132.owners) === null || _License$tradeLicense133 === void 0 ? void 0 : (_License$tradeLicense134 = _License$tradeLicense133[0]) === null || _License$tradeLicense134 === void 0 ? void 0 : (_License$tradeLicense135 = _License$tradeLicense134.correspondenceAddress) === null || _License$tradeLicense135 === void 0 ? void 0 : _License$tradeLicense135.university) || "NA"
      }]
    }, {
      title: "BPA_DOCUMENT_DETAILS_LABEL",
      asSectionHeader: true,
      additionalDetails: {
        documentsWithUrl: [{
          title: "",
          values: License === null || License === void 0 ? void 0 : (_License$tradeLicense136 = License.tradeLicenseDetail) === null || _License$tradeLicense136 === void 0 ? void 0 : (_License$tradeLicense137 = _License$tradeLicense136.applicationDocuments) === null || _License$tradeLicense137 === void 0 ? void 0 : _License$tradeLicense137.map(doc => {
            var _doc$documentType, _fileDetails, _fileDetails2, _fileDetails2$data$do;
            return {
              title: `BPAREG_HEADER_${doc === null || doc === void 0 ? void 0 : (_doc$documentType = doc.documentType) === null || _doc$documentType === void 0 ? void 0 : _doc$documentType.replaceAll(".", "_")}`,
              documentType: doc === null || doc === void 0 ? void 0 : doc.documentType,
              documentUid: doc === null || doc === void 0 ? void 0 : doc.documentUid,
              fileStoreId: doc === null || doc === void 0 ? void 0 : doc.fileStoreId,
              id: doc === null || doc === void 0 ? void 0 : doc.id,
              docInfo: doc === null || doc === void 0 ? void 0 : doc.info,
              url: (_fileDetails = fileDetails) !== null && _fileDetails !== void 0 && _fileDetails.data[doc === null || doc === void 0 ? void 0 : doc.fileStoreId] ? (_fileDetails2 = fileDetails) === null || _fileDetails2 === void 0 ? void 0 : (_fileDetails2$data$do = _fileDetails2.data[doc === null || doc === void 0 ? void 0 : doc.fileStoreId]) === null || _fileDetails2$data$do === void 0 ? void 0 : _fileDetails2$data$do.split(",")[0] : ""
            };
          })
        }]
      }
    }, (paymentRes === null || paymentRes === void 0 ? void 0 : (_paymentRes$Payments = paymentRes.Payments) === null || _paymentRes$Payments === void 0 ? void 0 : _paymentRes$Payments.length) > 0 && {
      title: "BPA_FEE_DETAILS_LABEL",
      additionalDetails: {
        inspectionReport: [],
        values: [{
          title: "BPAREG_FEES",
          value: /*#__PURE__*/React$1.createElement("span", null, "\u20B9", paymentRes === null || paymentRes === void 0 ? void 0 : (_paymentRes$Payments2 = paymentRes.Payments) === null || _paymentRes$Payments2 === void 0 ? void 0 : (_paymentRes$Payments3 = _paymentRes$Payments2[0]) === null || _paymentRes$Payments3 === void 0 ? void 0 : _paymentRes$Payments3.totalAmountPaid)
        }, {
          title: "BPA_STATUS_LABEL",
          isTransLate: true,
          isStatus: true,
          value: paymentRes !== null && paymentRes !== void 0 && (_paymentRes$Payments4 = paymentRes.Payments) !== null && _paymentRes$Payments4 !== void 0 && (_paymentRes$Payments5 = _paymentRes$Payments4[0]) !== null && _paymentRes$Payments5 !== void 0 && _paymentRes$Payments5.totalAmountPaid ? "WF_BPA_PAID" : "NA",
          isTransLate: true
        }]
      }
    }];
    return {
      applicationData: License,
      applicationDetails: details,
      tenantId: License === null || License === void 0 ? void 0 : License.tenantId,
      payments: (paymentRes === null || paymentRes === void 0 ? void 0 : paymentRes.Payments) || []
    };
  },
  BPADetailsPage: async (tenantId, filters) => {
    var _response$BPA, _response$BPA$, _response$BPA$$docume, _response$BPA2, _response$BPA3, _response$BPA3$, _response$BPA3$$addit, _response$BPA4, _response$BPA4$, _response$BPA4$$addit, _response$BPA5, _edcrResponse, _BPA$additionalDetail, _BPA$additionalDetail2, _BPA$additionalDetail3, _BPA$additionalDetail4, _BPA$additionalDetail5, _BPA$additionalDetail6, _BPA$additionalDetail7, _BPA$additionalDetail8, _BPA$additionalDetail9, _BPA$auditDetails, _BPA$auditDetails2, _edcr$, _edcr$2, _edcr$3, _edcr$3$planDetail, _edcr$3$planDetail$pl, _edcr$4, _edcr$4$planDetail, _edcr$4$planDetail$pl, _edcr$5, _edcr$5$planDetail, _edcr$5$planDetail$pl, _edcr$6, _edcr$6$planDetail, _edcr$6$planDetail$pl, _edcr$7, _edcr$7$planDetail, _edcr$7$planDetail$pl, _BPA$additionalDetail13, _BPA$additionalDetail14, _edcr$8, _edcr$9, _edcr$10, _edcr$11, _edcr$11$planDetail, _edcr$11$planDetail$b, _edcr$11$planDetail$b2, _edcr$11$planDetail$b3, _edcr$12, _edcr$12$planDetail, _edcr$12$planDetail$b, _edcr$12$planDetail$b2, _edcr$12$planDetail$b3, _edcr$13, _edcr$13$planDetail, _edcr$13$planDetail$b, _edcr$13$planDetail$b2, _edcr$13$planDetail$b3, _edcr$14, _edcr$14$planDetail, _edcr$14$planDetail$p, _BPA$landInfo, _BPA$landInfo$address, _BPA$additionalDetail15, _BPA$additionalDetail16, _BPA$additionalDetail17, _BPA$additionalDetail18, _BPA$additionalDetail19, _BPA$additionalDetail20, _BPA$landInfo2, _BPA$landInfo2$owners, _BPA$landInfo3, _BPA$landInfo3$owners, _BPA$additionalDetail21, _BPA$additionalDetail22, _BPA$additionalDetail23, _BPA$documents, _BPA$additionalDetail24, _BPA$additionalDetail25, _BPA$additionalDetail26, _BPA$additionalDetail27, _BPA$additionalDetail28, _BPA$additionalDetail29, _BPA$additionalDetail30, _billDetails$addition, _billDetails$addition2, _details;
    const response = await OBPSService.BPASearch(tenantId, filters);
    console.log("Latest5111111111111111111", response);
    const currentTenant = Digit.ULBService.getCurrentTenantId();
    let appDocumentFileStoreIds = response === null || response === void 0 ? void 0 : (_response$BPA = response.BPA) === null || _response$BPA === void 0 ? void 0 : (_response$BPA$ = _response$BPA[0]) === null || _response$BPA$ === void 0 ? void 0 : (_response$BPA$$docume = _response$BPA$.documents) === null || _response$BPA$$docume === void 0 ? void 0 : _response$BPA$$docume.map(docId => docId.fileStoreId);
    if (!appDocumentFileStoreIds) appDocumentFileStoreIds = [];
    if (!(response !== null && response !== void 0 && (_response$BPA2 = response.BPA) !== null && _response$BPA2 !== void 0 && _response$BPA2.length)) {
      return;
    }
    sessionStorage.setItem("BPA_ARCHITECT_NAME", JSON.stringify(response !== null && response !== void 0 && (_response$BPA3 = response.BPA) !== null && _response$BPA3 !== void 0 && (_response$BPA3$ = _response$BPA3[0]) !== null && _response$BPA3$ !== void 0 && (_response$BPA3$$addit = _response$BPA3$.additionalDetails) !== null && _response$BPA3$$addit !== void 0 && _response$BPA3$$addit.typeOfArchitect ? response === null || response === void 0 ? void 0 : (_response$BPA4 = response.BPA) === null || _response$BPA4 === void 0 ? void 0 : (_response$BPA4$ = _response$BPA4[0]) === null || _response$BPA4$ === void 0 ? void 0 : (_response$BPA4$$addit = _response$BPA4$.additionalDetails) === null || _response$BPA4$$addit === void 0 ? void 0 : _response$BPA4$$addit.typeOfArchitect : "ARCHITECT"));
    const BPA = response === null || response === void 0 ? void 0 : (_response$BPA5 = response.BPA) === null || _response$BPA5 === void 0 ? void 0 : _response$BPA5[0];
    let edcrResponse = {};
    if (BPA !== null && BPA !== void 0 && BPA.edcrNumber) {
      edcrResponse = await OBPSService.scrutinyDetails(currentTenant, {
        edcrNumber: BPA === null || BPA === void 0 ? void 0 : BPA.edcrNumber
      });
    }
    const edcr = ((_edcrResponse = edcrResponse) === null || _edcrResponse === void 0 ? void 0 : _edcrResponse.edcrDetail) || [];
    const nocResponse = await OBPSService.NOCSearch(currentTenant, {
      sourceRefId: BPA === null || BPA === void 0 ? void 0 : BPA.applicationNo
    });
    const noc = nocResponse === null || nocResponse === void 0 ? void 0 : nocResponse.Noc;
    noc === null || noc === void 0 ? void 0 : noc.map(nocDetails => {
      var _nocDetails$documents;
      nocDetails === null || nocDetails === void 0 ? void 0 : (_nocDetails$documents = nocDetails.documents) === null || _nocDetails$documents === void 0 ? void 0 : _nocDetails$documents.map(nocDoc => {
        if (nocDoc !== null && nocDoc !== void 0 && nocDoc.fileStoreId) appDocumentFileStoreIds.push(nocDoc === null || nocDoc === void 0 ? void 0 : nocDoc.fileStoreId);
      });
    });
    let fileDetails = {};
    let appBusinessService = [],
      collectionBillDetails = [],
      collectionBillArray = [],
      totalAmount = 0,
      collectionBillRes = [];
    const bussinessService = BPA === null || BPA === void 0 ? void 0 : BPA.businessService;
    const isUD = bussinessService === null || bussinessService === void 0 ? void 0 : bussinessService.includes("UD");
    if (bussinessService === "BPA_LOW") appBusinessService = ["BPA.LOW_RISK_PERMIT_FEE"];else if (bussinessService === "BPA") appBusinessService = ["BPA.FORM_12_FEE_UD", "BPA.FORM_12_FEE_UD"];else if (bussinessService === "BPA_OC") appBusinessService = ["BPA.NC_OC_APP_FEE", "BPA.NC_OC_SAN_FEE"];
    if (bussinessService !== null && bussinessService !== void 0 && bussinessService.includes("UD") || bussinessService !== null && bussinessService !== void 0 && bussinessService.includes("TCP")) appBusinessService = ["BPA.FORM_12_FEE", "BPA.FORM_12_FEE_UD"];
    const splittedFeeData = BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail = BPA.additionalDetails) === null || _BPA$additionalDetail === void 0 ? void 0 : (_BPA$additionalDetail2 = _BPA$additionalDetail.taxHeadEstimates) === null || _BPA$additionalDetail2 === void 0 ? void 0 : _BPA$additionalDetail2.map(item => {
      return Object.fromEntries(Object.entries(item).filter(([key, value]) => typeof value === "number"));
    });
    for (let _i = 0; _i < ((_appBusinessService = appBusinessService) === null || _appBusinessService === void 0 ? void 0 : _appBusinessService.length); _i++) {
      var _appBusinessService, _collectionres$Paymen, _collectionres$Paymen3;
      let collectionres = await Digit.PaymentService.recieptSearch(BPA === null || BPA === void 0 ? void 0 : BPA.tenantId, appBusinessService[_i], {
        consumerCodes: BPA === null || BPA === void 0 ? void 0 : BPA.applicationNo,
        isEmployee: true
      });
      if ((collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen = collectionres.Payments) === null || _collectionres$Paymen === void 0 ? void 0 : _collectionres$Paymen.length) > 0) {
        var _collectionres$Paymen2;
        collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen2 = collectionres.Payments) === null || _collectionres$Paymen2 === void 0 ? void 0 : _collectionres$Paymen2.map(res => {
          var _res$paymentDetails;
          res === null || res === void 0 ? void 0 : (_res$paymentDetails = res.paymentDetails) === null || _res$paymentDetails === void 0 ? void 0 : _res$paymentDetails.map(resData => {
            if ((resData === null || resData === void 0 ? void 0 : resData.businessService) == appBusinessService[_i]) {
              collectionBillRes.push(res);
            }
          });
        });
      }
      if ((collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen3 = collectionres.Payments) === null || _collectionres$Paymen3 === void 0 ? void 0 : _collectionres$Paymen3.length) > 0) collectionBillDetails.push(...(collectionres === null || collectionres === void 0 ? void 0 : collectionres.Payments));
    }
    if ((collectionBillRes === null || collectionBillRes === void 0 ? void 0 : collectionBillRes.length) > 0) {
      collectionBillRes === null || collectionBillRes === void 0 ? void 0 : collectionBillRes.map(ob => {
        var _ob$paymentDetails, _ob$paymentDetails$, _ob$paymentDetails$$b, _ob$paymentDetails$$b2, _ob$paymentDetails$$b3;
        ob === null || ob === void 0 ? void 0 : (_ob$paymentDetails = ob.paymentDetails) === null || _ob$paymentDetails === void 0 ? void 0 : (_ob$paymentDetails$ = _ob$paymentDetails[0]) === null || _ob$paymentDetails$ === void 0 ? void 0 : (_ob$paymentDetails$$b = _ob$paymentDetails$.bill) === null || _ob$paymentDetails$$b === void 0 ? void 0 : (_ob$paymentDetails$$b2 = _ob$paymentDetails$$b.billDetails) === null || _ob$paymentDetails$$b2 === void 0 ? void 0 : (_ob$paymentDetails$$b3 = _ob$paymentDetails$$b2[0]) === null || _ob$paymentDetails$$b3 === void 0 ? void 0 : _ob$paymentDetails$$b3.billAccountDetails.map((bill, index) => {
          collectionBillArray.push({
            title: `${bill === null || bill === void 0 ? void 0 : bill.taxHeadCode}_DETAILS`,
            value: "",
            isSubTitle: true
          }, {
            title: bill === null || bill === void 0 ? void 0 : bill.taxHeadCode,
            value: `₹${bill === null || bill === void 0 ? void 0 : bill.amount}`
          }, {
            title: "BPA_STATUS_LABEL",
            value: "Paid"
          });
          totalAmount = totalAmount + parseInt(bill === null || bill === void 0 ? void 0 : bill.amount);
        });
      });
    } else {
      var _splittedFeeData$;
      for (const key in splittedFeeData === null || splittedFeeData === void 0 ? void 0 : splittedFeeData[0]) {
        if (key === "estimateAmount") continue;
        collectionBillArray.push({
          title: `BPA_COMMON_${key.toUpperCase()}_FEE`,
          value: `₹${splittedFeeData[0][key]}`
        });
      }
      collectionBillArray.push({
        title: "BPA_COMMON_TOTAL_FEE",
        value: `₹${splittedFeeData === null || splittedFeeData === void 0 ? void 0 : (_splittedFeeData$ = splittedFeeData[0]) === null || _splittedFeeData$ === void 0 ? void 0 : _splittedFeeData$.estimateAmount}`
      });
      collectionBillArray.push({
        title: "BPA_STATUS_LABEL",
        value: "Unpaid"
      });
    }
    totalAmount > 0 && collectionBillArray.push({
      title: "BPA_TOT_AMT_PAID",
      value: `₹${totalAmount}`
    });
    const billDetails = {
      title: "BPA_FEE_DETAILS_LABEL",
      isFeeDetails: true,
      additionalDetails: {
        inspectionReport: [],
        values: [...collectionBillArray]
      }
    };
    BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail3 = BPA.additionalDetails) === null || _BPA$additionalDetail3 === void 0 ? void 0 : (_BPA$additionalDetail4 = _BPA$additionalDetail3.fieldinspection_pending) === null || _BPA$additionalDetail4 === void 0 ? void 0 : _BPA$additionalDetail4.forEach(fiData => {
      var _fiData$docs;
      fiData === null || fiData === void 0 ? void 0 : (_fiData$docs = fiData.docs) === null || _fiData$docs === void 0 ? void 0 : _fiData$docs.forEach(fiDoc => {
        var _fileDetails$data$fiD;
        if (fileDetails !== null && fileDetails !== void 0 && fileDetails.data[fiDoc === null || fiDoc === void 0 ? void 0 : fiDoc.fileStoreId]) fiDoc.url = fileDetails === null || fileDetails === void 0 ? void 0 : (_fileDetails$data$fiD = fileDetails.data[fiDoc === null || fiDoc === void 0 ? void 0 : fiDoc.fileStoreId]) === null || _fileDetails$data$fiD === void 0 ? void 0 : _fileDetails$data$fiD.split(",")[0];
      });
    });
    function ConvertEpochToValidityDate(dateEpoch) {
      if (dateEpoch == null || dateEpoch == undefined || dateEpoch == "") {
        return "NA";
      }
      const dateFromApi = new Date(dateEpoch);
      let month = dateFromApi.getMonth() + 1;
      let day = dateFromApi.getDate();
      let year = dateFromApi.getFullYear() - 3;
      month = (month > 9 ? "" : "0") + month;
      day = (day > 9 ? "" : "0") + day;
      return `${day}/${month}/${year}`;
    }
    const nocDetails = noc === null || noc === void 0 ? void 0 : noc.map((nocDetails, index) => {
      var _nocDetails$additiona, _nocDetails$additiona2, _nocDetails$additiona3, _nocDetails$auditDeta, _nocDetails$documents2;
      return {
        title: index === 0 ? "BPA_NOC_DETAILS_SUMMARY" : "",
        values: [{
          title: `BPA_${nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.nocType}_LABEL`,
          value: nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationNo,
          isNotTranslated: true
        }, {
          title: `BPA_NOC_STATUS`,
          value: nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationStatus,
          field: "STATUS"
        }, (nocDetails === null || nocDetails === void 0 ? void 0 : (_nocDetails$additiona = nocDetails.additionalDetails) === null || _nocDetails$additiona === void 0 ? void 0 : _nocDetails$additiona.SubmittedOn) && {
          title: "BPA_SUDMITTED_ON_LABEL",
          value: nocDetails !== null && nocDetails !== void 0 && (_nocDetails$additiona2 = nocDetails.additionalDetails) !== null && _nocDetails$additiona2 !== void 0 && _nocDetails$additiona2.SubmittedOn ? format(new Date(Number(nocDetails === null || nocDetails === void 0 ? void 0 : (_nocDetails$additiona3 = nocDetails.additionalDetails) === null || _nocDetails$additiona3 === void 0 ? void 0 : _nocDetails$additiona3.SubmittedOn)), "dd/MM/yyyy") : "NA",
          isNotTranslated: true
        }, (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.nocNo) && {
          title: "BPA_APPROVAL_NUMBER_LABEL",
          value: (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.nocNo) || "NA",
          isNotTranslated: true
        }, (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.nocNo) && {
          title: "BPA_APPROVED_REJECTED_ON_LABEL",
          value: (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationStatus) === "APPROVED" || (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationStatus) === "REJECTED" || (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationStatus) === "AUTO_APPROVED" || (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationStatus) === "AUTO_REJECTED" ? format(new Date(Number(nocDetails === null || nocDetails === void 0 ? void 0 : (_nocDetails$auditDeta = nocDetails.auditDetails) === null || _nocDetails$auditDeta === void 0 ? void 0 : _nocDetails$auditDeta.lastModifiedTime)), "dd/MM/yyyy") : "NA",
          isNotTranslated: true
        }],
        additionalDetails: {
          data: nocDetails,
          noc: [{
            title: "BPA_DOCUMENT_DETAILS_LABEL",
            values: nocDetails === null || nocDetails === void 0 ? void 0 : (_nocDetails$documents2 = nocDetails.documents) === null || _nocDetails$documents2 === void 0 ? void 0 : _nocDetails$documents2.map(doc => {
              var _doc$documentType2, _fileDetails$data, _fileDetails$data2, _fileDetails$data2$do;
              return {
                title: doc === null || doc === void 0 ? void 0 : (_doc$documentType2 = doc.documentType) === null || _doc$documentType2 === void 0 ? void 0 : _doc$documentType2.replaceAll(".", "_"),
                documentType: doc === null || doc === void 0 ? void 0 : doc.documentType,
                documentUid: doc === null || doc === void 0 ? void 0 : doc.documentUid,
                fileStoreId: doc === null || doc === void 0 ? void 0 : doc.fileStoreId,
                id: doc === null || doc === void 0 ? void 0 : doc.id,
                url: fileDetails !== null && fileDetails !== void 0 && (_fileDetails$data = fileDetails.data) !== null && _fileDetails$data !== void 0 && _fileDetails$data[doc === null || doc === void 0 ? void 0 : doc.fileStoreId] ? fileDetails === null || fileDetails === void 0 ? void 0 : (_fileDetails$data2 = fileDetails.data) === null || _fileDetails$data2 === void 0 ? void 0 : (_fileDetails$data2$do = _fileDetails$data2[doc === null || doc === void 0 ? void 0 : doc.fileStoreId]) === null || _fileDetails$data2$do === void 0 ? void 0 : _fileDetails$data2$do.split(",")[0] : ""
              };
            })
          }]
        }
      };
    });
    let inspectionReport = [];
    let checklist = [];
    BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail5 = BPA.additionalDetails) === null || _BPA$additionalDetail5 === void 0 ? void 0 : (_BPA$additionalDetail6 = _BPA$additionalDetail5.fieldinspection_pending) === null || _BPA$additionalDetail6 === void 0 ? void 0 : _BPA$additionalDetail6.filter(ob => ob.docs && ob.docs.length > 0).map((ob, ind) => {
      var _ob$date, _ob$date2, _ob$date3, _ob$questions, _ob$docs;
      checklist = [];
      inspectionReport.push({
        title: "BPA_FI_REPORT",
        asSectionHeader: true,
        values: [{
          title: "BPA_FI_DATE_LABEL",
          value: ob.date.includes("-") ? `${(_ob$date = ob.date) === null || _ob$date === void 0 ? void 0 : _ob$date.split("-")[2]}/${(_ob$date2 = ob.date) === null || _ob$date2 === void 0 ? void 0 : _ob$date2.split("-")[1]}/${(_ob$date3 = ob.date) === null || _ob$date3 === void 0 ? void 0 : _ob$date3.split("-")[0]}` : ob.date
        }, {
          title: "BPA_FI_TIME_LABEL",
          value: ob.time
        }]
      });
      ob === null || ob === void 0 ? void 0 : (_ob$questions = ob.questions) === null || _ob$questions === void 0 ? void 0 : _ob$questions.map((q, index) => {
        checklist.push({
          title: q.question,
          value: q.value
        });
        checklist.push({
          title: "BPA_ENTER_REMARKS",
          value: q.remarks
        });
      });
      inspectionReport.push({
        title: "BPA_CHECK_LIST_DETAILS",
        asSectionHeader: true,
        values: checklist
      });
      inspectionReport.push({
        title: "BPA_DOCUMENT_DETAILS_LABEL",
        asSectionHeader: true,
        additionalDetails: {
          obpsDocuments: [{
            title: "",
            values: ob === null || ob === void 0 ? void 0 : (_ob$docs = ob.docs) === null || _ob$docs === void 0 ? void 0 : _ob$docs.map(doc => {
              var _doc$documentType3, _fileDetails$data3, _fileDetails$data4, _fileDetails$data4$do;
              return {
                title: doc === null || doc === void 0 ? void 0 : (_doc$documentType3 = doc.documentType) === null || _doc$documentType3 === void 0 ? void 0 : _doc$documentType3.replaceAll(".", "_"),
                documentType: doc === null || doc === void 0 ? void 0 : doc.documentType,
                documentUid: doc === null || doc === void 0 ? void 0 : doc.fileStore,
                fileStoreId: doc === null || doc === void 0 ? void 0 : doc.fileStoreId,
                id: doc === null || doc === void 0 ? void 0 : doc.id,
                url: fileDetails !== null && fileDetails !== void 0 && (_fileDetails$data3 = fileDetails.data) !== null && _fileDetails$data3 !== void 0 && _fileDetails$data3[doc === null || doc === void 0 ? void 0 : doc.fileStoreId] ? fileDetails === null || fileDetails === void 0 ? void 0 : (_fileDetails$data4 = fileDetails.data) === null || _fileDetails$data4 === void 0 ? void 0 : (_fileDetails$data4$do = _fileDetails$data4[doc === null || doc === void 0 ? void 0 : doc.fileStoreId]) === null || _fileDetails$data4$do === void 0 ? void 0 : _fileDetails$data4$do.split(",")[0] : ""
              };
            })
          }]
        }
      });
    });
    let details = [];
    let applicationDetailsInfo = {
      title: " ",
      isCommon: true,
      values: [{
        title: "BPA_APPLICATION_NUMBER_LABEL",
        value: (BPA === null || BPA === void 0 ? void 0 : BPA.applicationNo) || "NA"
      }]
    };
    let envCitizenName = window.location.href.includes("/employee") ? "employee" : "citizen";
    if (BPA !== null && BPA !== void 0 && BPA.businessService.includes("BPA_OC")) {
      var _response$BPA6, _response$BPA6$, _response$BPA7, _response$BPA7$, _response$BPA8, _response$BPA8$, _response$BPA8$$addit, _response$BPA9, _response$BPA9$, _response$BPA9$$addit, _response$BPA10, _response$BPA10$, _response$BPA10$$addi;
      applicationDetailsInfo["values"] = [...(applicationDetailsInfo === null || applicationDetailsInfo === void 0 ? void 0 : applicationDetailsInfo.values), {
        title: "BPA_PERMIT_APP_NUMBER",
        to: `/digit-ui/${envCitizenName}/obps/bpa/${response === null || response === void 0 ? void 0 : (_response$BPA6 = response.BPA) === null || _response$BPA6 === void 0 ? void 0 : (_response$BPA6$ = _response$BPA6[0]) === null || _response$BPA6$ === void 0 ? void 0 : _response$BPA6$.applicationNo}`,
        value: response === null || response === void 0 ? void 0 : (_response$BPA7 = response.BPA) === null || _response$BPA7 === void 0 ? void 0 : (_response$BPA7$ = _response$BPA7[0]) === null || _response$BPA7$ === void 0 ? void 0 : _response$BPA7$.approvalNo,
        isLink: true
      }];
      applicationDetailsInfo["values"] = [...(applicationDetailsInfo === null || applicationDetailsInfo === void 0 ? void 0 : applicationDetailsInfo.values), {
        title: "BPA_PERMIT_VALIDITY",
        value: response !== null && response !== void 0 && (_response$BPA8 = response.BPA) !== null && _response$BPA8 !== void 0 && (_response$BPA8$ = _response$BPA8[0]) !== null && _response$BPA8$ !== void 0 && (_response$BPA8$$addit = _response$BPA8$.additionalDetails) !== null && _response$BPA8$$addit !== void 0 && _response$BPA8$$addit.validityDate ? `${ConvertEpochToValidityDate(response === null || response === void 0 ? void 0 : (_response$BPA9 = response.BPA) === null || _response$BPA9 === void 0 ? void 0 : (_response$BPA9$ = _response$BPA9[0]) === null || _response$BPA9$ === void 0 ? void 0 : (_response$BPA9$$addit = _response$BPA9$.additionalDetails) === null || _response$BPA9$$addit === void 0 ? void 0 : _response$BPA9$$addit.validityDate)} - ${format(new Date(response === null || response === void 0 ? void 0 : (_response$BPA10 = response.BPA) === null || _response$BPA10 === void 0 ? void 0 : (_response$BPA10$ = _response$BPA10[0]) === null || _response$BPA10$ === void 0 ? void 0 : (_response$BPA10$$addi = _response$BPA10$.additionalDetails) === null || _response$BPA10$$addi === void 0 ? void 0 : _response$BPA10$$addi.validityDate), "dd/MM/yyyy")}` : "NA"
      }];
    }
    let permitcondn = [];
    (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail7 = BPA.additionalDetails) === null || _BPA$additionalDetail7 === void 0 ? void 0 : _BPA$additionalDetail7.pendingapproval) && (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail8 = BPA.additionalDetails) === null || _BPA$additionalDetail8 === void 0 ? void 0 : _BPA$additionalDetail8.pendingapproval.length) > 0 && (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail9 = BPA.additionalDetails) === null || _BPA$additionalDetail9 === void 0 ? void 0 : _BPA$additionalDetail9.pendingapproval.map((ob, index) => {
      permitcondn.push({
        title: `${index + 1}. ${ob}`,
        value: ""
      });
    }));
    let PermitConditions = {
      title: "BPA_PERMIT_CONDITIONS",
      isTitleVisible: (permitcondn === null || permitcondn === void 0 ? void 0 : permitcondn.length) > 0 ? false : true,
      isNotAllowed: (permitcondn === null || permitcondn === void 0 ? void 0 : permitcondn.length) > 0 ? false : true,
      additionalDetails: {
        inspectionReport: [],
        permit: [...permitcondn]
      }
    };
    if (permitcondn.length == 0) PermitConditions = {};
    if (BPA !== null && BPA !== void 0 && BPA.approvalNo) {
      var _applicationDetailsIn, _applicationDetailsIn2, _BPA$additionalDetail10, _BPA$additionalDetail11, _BPA$additionalDetail12;
      applicationDetailsInfo === null || applicationDetailsInfo === void 0 ? void 0 : (_applicationDetailsIn = applicationDetailsInfo.values) === null || _applicationDetailsIn === void 0 ? void 0 : _applicationDetailsIn.push({
        title: (BPA === null || BPA === void 0 ? void 0 : BPA.businessService) !== "BPA_OC" ? "BPA_PERMIT_NUMBER_LABEL" : "BPA_OC_PERMIT_NUMBER_LABEL",
        value: (BPA === null || BPA === void 0 ? void 0 : BPA.approvalNo) || "NA"
      });
      applicationDetailsInfo === null || applicationDetailsInfo === void 0 ? void 0 : (_applicationDetailsIn2 = applicationDetailsInfo.values) === null || _applicationDetailsIn2 === void 0 ? void 0 : _applicationDetailsIn2.push({
        title: (BPA === null || BPA === void 0 ? void 0 : BPA.businessService) !== "BPA_OC" ? "BPA_PERMIT_VALIDITY" : "BPA_OC_PERMIT_VALIDITY",
        value: BPA !== null && BPA !== void 0 && (_BPA$additionalDetail10 = BPA.additionalDetails) !== null && _BPA$additionalDetail10 !== void 0 && _BPA$additionalDetail10.validityDate ? `${ConvertEpochToValidityDate(BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail11 = BPA.additionalDetails) === null || _BPA$additionalDetail11 === void 0 ? void 0 : _BPA$additionalDetail11.validityDate)} - ${format(new Date(BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail12 = BPA.additionalDetails) === null || _BPA$additionalDetail12 === void 0 ? void 0 : _BPA$additionalDetail12.validityDate), "dd/MM/yyyy")}` : "NA"
      });
    }
    const basicDetails = {
      title: "BPA_BASIC_DETAILS_TITLE",
      asSectionHeader: true,
      isInsert: true,
      isCommon: true,
      values: [{
        title: "BPA_BASIC_DETAILS_APP_DATE_LABEL",
        value: BPA !== null && BPA !== void 0 && (_BPA$auditDetails = BPA.auditDetails) !== null && _BPA$auditDetails !== void 0 && _BPA$auditDetails.createdTime ? format(new Date(BPA === null || BPA === void 0 ? void 0 : (_BPA$auditDetails2 = BPA.auditDetails) === null || _BPA$auditDetails2 === void 0 ? void 0 : _BPA$auditDetails2.createdTime), "dd/MM/yyyy") : ""
      }, {
        title: "BPA_BASIC_DETAILS_APPLICATION_TYPE_LABEL",
        value: `WF_BPA_${edcr === null || edcr === void 0 ? void 0 : (_edcr$ = edcr[0]) === null || _edcr$ === void 0 ? void 0 : _edcr$.appliactionType}`
      }, {
        title: "BPA_BASIC_DETAILS_SERVICE_TYPE_LABEL",
        value: edcr === null || edcr === void 0 ? void 0 : (_edcr$2 = edcr[0]) === null || _edcr$2 === void 0 ? void 0 : _edcr$2.applicationSubType
      }, {
        title: "BPA_BASIC_DETAILS_OCCUPANCY_LABEL",
        value: edcr === null || edcr === void 0 ? void 0 : (_edcr$3 = edcr[0]) === null || _edcr$3 === void 0 ? void 0 : (_edcr$3$planDetail = _edcr$3.planDetail) === null || _edcr$3$planDetail === void 0 ? void 0 : (_edcr$3$planDetail$pl = _edcr$3$planDetail.planInformation) === null || _edcr$3$planDetail$pl === void 0 ? void 0 : _edcr$3$planDetail$pl.occupancy
      }, {
        title: "BPA_BASIC_DETAILS_APPLICATION_NAME_LABEL",
        value: edcr === null || edcr === void 0 ? void 0 : (_edcr$4 = edcr[0]) === null || _edcr$4 === void 0 ? void 0 : (_edcr$4$planDetail = _edcr$4.planDetail) === null || _edcr$4$planDetail === void 0 ? void 0 : (_edcr$4$planDetail$pl = _edcr$4$planDetail.planInformation) === null || _edcr$4$planDetail$pl === void 0 ? void 0 : _edcr$4$planDetail$pl.applicantName
      }]
    };
    const plotDetails = {
      title: "BPA_PLOT_DETAILS_TITLE",
      asSectionHeader: true,
      isCommon: true,
      values: [{
        title: "BPA_BOUNDARY_PLOT_AREA_LABEL",
        value: `${edcr === null || edcr === void 0 ? void 0 : (_edcr$5 = edcr[0]) === null || _edcr$5 === void 0 ? void 0 : (_edcr$5$planDetail = _edcr$5.planDetail) === null || _edcr$5$planDetail === void 0 ? void 0 : (_edcr$5$planDetail$pl = _edcr$5$planDetail.planInformation) === null || _edcr$5$planDetail$pl === void 0 ? void 0 : _edcr$5$planDetail$pl.plotArea}`,
        isNotTranslated: true,
        isUnit: "BPA_SQ_MT_LABEL"
      }, {
        title: "BPA_PLOT_NUMBER_LABEL",
        value: (edcr === null || edcr === void 0 ? void 0 : (_edcr$6 = edcr[0]) === null || _edcr$6 === void 0 ? void 0 : (_edcr$6$planDetail = _edcr$6.planDetail) === null || _edcr$6$planDetail === void 0 ? void 0 : (_edcr$6$planDetail$pl = _edcr$6$planDetail.planInformation) === null || _edcr$6$planDetail$pl === void 0 ? void 0 : _edcr$6$planDetail$pl.plotNo) || "NA",
        isNotTranslated: true
      }, {
        title: "BPA_KHATHA_NUMBER_LABEL",
        value: (edcr === null || edcr === void 0 ? void 0 : (_edcr$7 = edcr[0]) === null || _edcr$7 === void 0 ? void 0 : (_edcr$7$planDetail = _edcr$7.planDetail) === null || _edcr$7$planDetail === void 0 ? void 0 : (_edcr$7$planDetail$pl = _edcr$7$planDetail.planInformation) === null || _edcr$7$planDetail$pl === void 0 ? void 0 : _edcr$7$planDetail$pl.khataNo) || "NA",
        isNotTranslated: true
      }, {
        title: "BPA_HOLDING_NUMBER_LABEL",
        value: (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail13 = BPA.additionalDetails) === null || _BPA$additionalDetail13 === void 0 ? void 0 : _BPA$additionalDetail13.holdingNo) || "NA",
        isNotTranslated: true
      }, {
        title: "BPA_BOUNDARY_LAND_REG_DETAIL_LABEL",
        value: (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail14 = BPA.additionalDetails) === null || _BPA$additionalDetail14 === void 0 ? void 0 : _BPA$additionalDetail14.registrationDetails) || "NA",
        isNotTranslated: true
      }]
    };
    const scrutinyDetails = {
      title: "BPA_STEPPER_SCRUTINY_DETAILS_HEADER",
      isScrutinyDetails: true,
      isBackGroundColor: true,
      additionalDetails: {
        values: [{
          title: "BPA_EDCR_DETAILS",
          value: " ",
          isHeader: true
        }, {
          title: (BPA === null || BPA === void 0 ? void 0 : BPA.businessService) !== "BPA_OC" ? "BPA_EDCR_NO_LABEL" : "BPA_OC_EDCR_NO_LABEL",
          value: (BPA === null || BPA === void 0 ? void 0 : BPA.edcrNumber) || "NA"
        }],
        scruntinyDetails: [{
          title: "BPA_UPLOADED_PLAN_DIAGRAM",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$8 = edcr[0]) === null || _edcr$8 === void 0 ? void 0 : _edcr$8.updatedDxfFile,
          text: "BPA_UPLOADED_PLAN_DXF"
        }, {
          title: "BPA_SCRUNTINY_REPORT_OUTPUT",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$9 = edcr[0]) === null || _edcr$9 === void 0 ? void 0 : _edcr$9.planReport,
          text: "BPA_SCRUTINY_REPORT_PDF"
        }, {
          title: "BPA_UPLOADED_PLAN_DXF",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$10 = edcr[0]) === null || _edcr$10 === void 0 ? void 0 : _edcr$10.dxfFile,
          text: "BPA_UPLOADED_PLAN_DXF"
        }]
      }
    };
    const buildingExtractionDetails = {
      title: "",
      isScrutinyDetails: true,
      isBackGroundColor: true,
      additionalDetails: {
        values: [{
          title: (BPA === null || BPA === void 0 ? void 0 : BPA.businessService) !== "BPA_OC" ? "BPA_BUILDING_EXTRACT_HEADER" : "BPA_ACTUAL_BUILDING_EXTRACT_HEADER",
          value: " ",
          isHeader: true
        }, {
          title: "BPA_TOTAL_BUILT_UP_AREA_HEADER",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$11 = edcr[0]) === null || _edcr$11 === void 0 ? void 0 : (_edcr$11$planDetail = _edcr$11.planDetail) === null || _edcr$11$planDetail === void 0 ? void 0 : (_edcr$11$planDetail$b = _edcr$11$planDetail.blocks) === null || _edcr$11$planDetail$b === void 0 ? void 0 : (_edcr$11$planDetail$b2 = _edcr$11$planDetail$b[0]) === null || _edcr$11$planDetail$b2 === void 0 ? void 0 : (_edcr$11$planDetail$b3 = _edcr$11$planDetail$b2.building) === null || _edcr$11$planDetail$b3 === void 0 ? void 0 : _edcr$11$planDetail$b3.totalBuitUpArea,
          isUnit: "BPA_SQ_MTRS_LABEL"
        }, {
          title: "BPA_SCRUTINY_DETAILS_NUMBER_OF_FLOORS_LABEL",
          value: (edcr === null || edcr === void 0 ? void 0 : (_edcr$12 = edcr[0]) === null || _edcr$12 === void 0 ? void 0 : (_edcr$12$planDetail = _edcr$12.planDetail) === null || _edcr$12$planDetail === void 0 ? void 0 : (_edcr$12$planDetail$b = _edcr$12$planDetail.blocks) === null || _edcr$12$planDetail$b === void 0 ? void 0 : (_edcr$12$planDetail$b2 = _edcr$12$planDetail$b[0]) === null || _edcr$12$planDetail$b2 === void 0 ? void 0 : (_edcr$12$planDetail$b3 = _edcr$12$planDetail$b2.building) === null || _edcr$12$planDetail$b3 === void 0 ? void 0 : _edcr$12$planDetail$b3.totalFloors) || "NA"
        }, {
          title: "BPA_HEIGHT_FROM_GROUND_LEVEL",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$13 = edcr[0]) === null || _edcr$13 === void 0 ? void 0 : (_edcr$13$planDetail = _edcr$13.planDetail) === null || _edcr$13$planDetail === void 0 ? void 0 : (_edcr$13$planDetail$b = _edcr$13$planDetail.blocks) === null || _edcr$13$planDetail$b === void 0 ? void 0 : (_edcr$13$planDetail$b2 = _edcr$13$planDetail$b[0]) === null || _edcr$13$planDetail$b2 === void 0 ? void 0 : (_edcr$13$planDetail$b3 = _edcr$13$planDetail$b2.building) === null || _edcr$13$planDetail$b3 === void 0 ? void 0 : _edcr$13$planDetail$b3.declaredBuildingHeigh,
          isUnit: "BPA_MTRS_LABEL"
        }],
        scruntinyDetails: []
      }
    };
    const demolitionAreaDetails = {
      title: "",
      isScrutinyDetails: true,
      isBackGroundColor: true,
      additionalDetails: {
        values: [{
          title: "BPA_APP_DETAILS_DEMOLITION_DETAILS_LABEL",
          value: " ",
          isHeader: true
        }, {
          title: "BPA_APPLICATION_DEMOLITION_AREA_LABEL",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$14 = edcr[0]) === null || _edcr$14 === void 0 ? void 0 : (_edcr$14$planDetail = _edcr$14.planDetail) === null || _edcr$14$planDetail === void 0 ? void 0 : (_edcr$14$planDetail$p = _edcr$14$planDetail.planInformation) === null || _edcr$14$planDetail$p === void 0 ? void 0 : _edcr$14$planDetail$p.demolitionArea,
          isUnit: "BPA_SQ_MTRS_LABEL"
        }],
        scruntinyDetails: []
      }
    };
    const subOccupancyTableDetails = {
      title: "",
      isSubOccupancyTable: true,
      isTitleRepeat: true,
      additionalDetails: {
        values: [{
          title: "BPA_OCC_SUBOCC_HEADER",
          value: " ",
          isHeader: true
        }],
        subOccupancyTableDetails: [{
          title: "BPA_APPLICATION_DEMOLITION_AREA_LABEL",
          value: edcr
        }, {
          title: "NO_REPEAT",
          value: ""
        }]
      }
    };
    const addressDetails = {
      title: "BPA_NEW_TRADE_DETAILS_HEADER_DETAILS",
      asSectionHeader: true,
      isCommon: true,
      values: [{
        title: "BPA_CITY_LABEL",
        value: BPA === null || BPA === void 0 ? void 0 : (_BPA$landInfo = BPA.landInfo) === null || _BPA$landInfo === void 0 ? void 0 : (_BPA$landInfo$address = _BPA$landInfo.address) === null || _BPA$landInfo$address === void 0 ? void 0 : _BPA$landInfo$address.city
      }, {
        title: !isUD ? "BPA_LOC_NOTIFIED-AREA_LABEL" : "BPA_ULB-AREA_LABEL",
        value: BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail15 = BPA.additionalDetails) === null || _BPA$additionalDetail15 === void 0 ? void 0 : (_BPA$additionalDetail16 = _BPA$additionalDetail15.landInfo) === null || _BPA$additionalDetail16 === void 0 ? void 0 : (_BPA$additionalDetail17 = _BPA$additionalDetail16.address) === null || _BPA$additionalDetail17 === void 0 ? void 0 : _BPA$additionalDetail17.doorNo
      }, {
        title: !isUD ? "BPA_LOC_VILLAGE-AREA_LABEL" : "BPA_LOC_WARD-AREA_LABEL",
        value: BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail18 = BPA.additionalDetails) === null || _BPA$additionalDetail18 === void 0 ? void 0 : (_BPA$additionalDetail19 = _BPA$additionalDetail18.landInfo) === null || _BPA$additionalDetail19 === void 0 ? void 0 : (_BPA$additionalDetail20 = _BPA$additionalDetail19.address) === null || _BPA$additionalDetail20 === void 0 ? void 0 : _BPA$additionalDetail20.village
      }]
    };
    const checkOwnerLength = (BPA === null || BPA === void 0 ? void 0 : (_BPA$landInfo2 = BPA.landInfo) === null || _BPA$landInfo2 === void 0 ? void 0 : (_BPA$landInfo2$owners = _BPA$landInfo2.owners) === null || _BPA$landInfo2$owners === void 0 ? void 0 : _BPA$landInfo2$owners.length) || 1;
    if ((BPA === null || BPA === void 0 ? void 0 : (_BPA$landInfo3 = BPA.landInfo) === null || _BPA$landInfo3 === void 0 ? void 0 : (_BPA$landInfo3$owners = _BPA$landInfo3.owners) === null || _BPA$landInfo3$owners === void 0 ? void 0 : _BPA$landInfo3$owners.length) > 0) {
      var _BPA$landInfo4, _BPA$landInfo4$owners;
      BPA === null || BPA === void 0 ? void 0 : (_BPA$landInfo4 = BPA.landInfo) === null || _BPA$landInfo4 === void 0 ? void 0 : (_BPA$landInfo4$owners = _BPA$landInfo4.owners) === null || _BPA$landInfo4$owners === void 0 ? void 0 : _BPA$landInfo4$owners.forEach(ownerD => {
        if (!ownerD.isPrimaryOwner) ownerD.isPrimaryOwner = "false";
      });
    }
    const ownerDetails = {
      title: "BPA_APPLICANT_DETAILS_HEADER",
      isOwnerDetails: true,
      additionalDetails: {
        owners: BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail21 = BPA.additionalDetails) === null || _BPA$additionalDetail21 === void 0 ? void 0 : (_BPA$additionalDetail22 = _BPA$additionalDetail21.landInfo) === null || _BPA$additionalDetail22 === void 0 ? void 0 : (_BPA$additionalDetail23 = _BPA$additionalDetail22.owners) === null || _BPA$additionalDetail23 === void 0 ? void 0 : _BPA$additionalDetail23.map((owner, index) => {
          var _owner$permanentAddre, _owner$permanentAddre2, _owner$permanentAddre3, _owner$permanentAddre4, _owner$permanentAddre5, _owner$permanentAddre6, _owner$correspondence, _owner$correspondence2, _owner$correspondence3, _owner$correspondence4, _owner$correspondence5, _owner$correspondence6;
          return {
            title: Number(checkOwnerLength) > 1 ? "COMMON_OWNER" : "",
            values: [{
              title: "CORE_COMMON_NAME",
              value: owner === null || owner === void 0 ? void 0 : owner.name
            }, {
              title: "BPA_APPLICANT_GENDER_LABEL",
              value: owner === null || owner === void 0 ? void 0 : owner.gender
            }, {
              title: "CORE_COMMON_MOBILE_NUMBER",
              value: owner === null || owner === void 0 ? void 0 : owner.mobileNumber
            }, {
              title: "BPA_APPLICANT_EMAIL_LABEL",
              value: owner === null || owner === void 0 ? void 0 : owner.emailId
            }, {
              title: "CORE_COMMON_GUARDIAN_NAME",
              value: owner === null || owner === void 0 ? void 0 : owner.fatherOrHusbandName
            }, {
              title: "BPA_IS_PRIMARY_OWNER_LABEL",
              value: owner === null || owner === void 0 ? void 0 : owner.isPrimaryOwner,
              isNotTranslated: false
            }, {
              title: "BPA_OWNER_PERMANENT_ADDRESS_DETAILS",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre = owner.permanentAddress) === null || _owner$permanentAddre === void 0 ? void 0 : _owner$permanentAddre.address
            }, {
              title: "CORE_COMMON_STATE",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre2 = owner.permanentAddress) === null || _owner$permanentAddre2 === void 0 ? void 0 : _owner$permanentAddre2.state
            }, {
              title: "CORE_COMMON_DISTRICT",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre3 = owner.permanentAddress) === null || _owner$permanentAddre3 === void 0 ? void 0 : _owner$permanentAddre3.district
            }, {
              title: "CORE_COMMON_TEHSIL",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre4 = owner.permanentAddress) === null || _owner$permanentAddre4 === void 0 ? void 0 : _owner$permanentAddre4.tehsil
            }, {
              title: "CORE_COMMON_TOWN",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre5 = owner.permanentAddress) === null || _owner$permanentAddre5 === void 0 ? void 0 : _owner$permanentAddre5.town
            }, {
              title: "CORE_COMMON_PINNO",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre6 = owner.permanentAddress) === null || _owner$permanentAddre6 === void 0 ? void 0 : _owner$permanentAddre6.pinno
            }, {
              title: "BPA_OWNER_CORRESPONDANCE_ADDRESS_DETAILS",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence = owner.correspondenceAddress) === null || _owner$correspondence === void 0 ? void 0 : _owner$correspondence.address
            }, {
              title: "CORE_COMMON_STATE",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence2 = owner.correspondenceAddress) === null || _owner$correspondence2 === void 0 ? void 0 : _owner$correspondence2.state
            }, {
              title: "CORE_COMMON_DISTRICT",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence3 = owner.correspondenceAddress) === null || _owner$correspondence3 === void 0 ? void 0 : _owner$correspondence3.district
            }, {
              title: "CORE_COMMON_TEHSIL",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence4 = owner.correspondenceAddress) === null || _owner$correspondence4 === void 0 ? void 0 : _owner$correspondence4.tehsil
            }, {
              title: "CORE_COMMON_TOWN",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence5 = owner.correspondenceAddress) === null || _owner$correspondence5 === void 0 ? void 0 : _owner$correspondence5.town
            }, {
              title: "CORE_COMMON_PINNO",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence6 = owner.correspondenceAddress) === null || _owner$correspondence6 === void 0 ? void 0 : _owner$correspondence6.pinno
            }]
          };
        })
      }
    };
    const professionalDetails = {
      title: "BPA_PROFESSIONAL_DETAILS_HEADER",
      asSectionHeader: true,
      isprofessionalDetail: true,
      values: [BPA === null || BPA === void 0 ? void 0 : BPA.professionaldetails]
    };
    const documentDetails = {
      title: "BPA_DOCUMENT_DETAILS_LABEL",
      asSectionHeader: true,
      isDocumentDetails: true,
      additionalDetails: {
        obpsDocuments: [{
          title: "",
          values: BPA === null || BPA === void 0 ? void 0 : (_BPA$documents = BPA.documents) === null || _BPA$documents === void 0 ? void 0 : _BPA$documents.map(doc => {
            var _doc$documentType4, _fileDetails$data5, _fileDetails$data6, _fileDetails$data6$do;
            return {
              title: doc === null || doc === void 0 ? void 0 : (_doc$documentType4 = doc.documentType) === null || _doc$documentType4 === void 0 ? void 0 : _doc$documentType4.replaceAll(".", "_"),
              documentType: doc === null || doc === void 0 ? void 0 : doc.documentType,
              documentUid: doc === null || doc === void 0 ? void 0 : doc.documentUid,
              fileStoreId: doc === null || doc === void 0 ? void 0 : doc.fileStoreId,
              id: doc === null || doc === void 0 ? void 0 : doc.id,
              url: fileDetails !== null && fileDetails !== void 0 && (_fileDetails$data5 = fileDetails.data) !== null && _fileDetails$data5 !== void 0 && _fileDetails$data5[doc === null || doc === void 0 ? void 0 : doc.fileStoreId] ? fileDetails === null || fileDetails === void 0 ? void 0 : (_fileDetails$data6 = fileDetails.data) === null || _fileDetails$data6 === void 0 ? void 0 : (_fileDetails$data6$do = _fileDetails$data6[doc === null || doc === void 0 ? void 0 : doc.fileStoreId]) === null || _fileDetails$data6$do === void 0 ? void 0 : _fileDetails$data6$do.split(",")[0] : ""
            };
          })
        }]
      }
    };
    let approvalChecks = [];
    let approvalChecksDetails = {};
    if ((BPA === null || BPA === void 0 ? void 0 : BPA.status) === "APPROVAL_INPROGRESS") {
      approvalChecksDetails = {
        title: "",
        isTitleVisible: (approvalChecks === null || approvalChecks === void 0 ? void 0 : approvalChecks.length) > 0 ? false : true,
        asSectionHeader: true,
        isPermissions: true,
        additionalDetails: {
          permissions: approvalChecks
        }
      };
    }
    let val;
    var i;
    inspectionReport && (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail24 = BPA.additionalDetails) === null || _BPA$additionalDetail24 === void 0 ? void 0 : (_BPA$additionalDetail25 = _BPA$additionalDetail24.fieldinspection_pending) === null || _BPA$additionalDetail25 === void 0 ? void 0 : (_BPA$additionalDetail26 = _BPA$additionalDetail25[0]) === null || _BPA$additionalDetail26 === void 0 ? void 0 : _BPA$additionalDetail26.questions.length) > 0 && inspectionReport.map((ob, index) => {
      if (ob.title.includes("FI_REPORT")) ;else if (ob.title.includes("CHECK_LIST")) ;else {
        var _ob$additionalDetails, _ob$additionalDetails2;
        let improvedDoc = [...((_ob$additionalDetails = ob.additionalDetails.obpsDocuments) === null || _ob$additionalDetails === void 0 ? void 0 : (_ob$additionalDetails2 = _ob$additionalDetails[0]) === null || _ob$additionalDetails2 === void 0 ? void 0 : _ob$additionalDetails2.values)];
        improvedDoc.map(ob => {
          ob["isNotDuplicate"] = true;
        });
        improvedDoc.map((ob, index) => {
          val = ob.documentType;
          if (ob.isNotDuplicate == true) for (i = index + 1; i < improvedDoc.length; i++) {
            if (val === improvedDoc[i].documentType) improvedDoc[i].isNotDuplicate = false;
          }
        });
      }
    });
    const fiReports = {
      title: "",
      isFieldInspection: true,
      isNotAllowed: (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail27 = BPA.additionalDetails) === null || _BPA$additionalDetail27 === void 0 ? void 0 : (_BPA$additionalDetail28 = _BPA$additionalDetail27.fieldinspection_pending) === null || _BPA$additionalDetail28 === void 0 ? void 0 : _BPA$additionalDetail28.length) > 0 ? false : true,
      additionalDetails: {
        values: [],
        fiReport: (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail29 = BPA.additionalDetails) === null || _BPA$additionalDetail29 === void 0 ? void 0 : (_BPA$additionalDetail30 = _BPA$additionalDetail29.fieldinspection_pending) === null || _BPA$additionalDetail30 === void 0 ? void 0 : _BPA$additionalDetail30.length) > 0 ? true : false
      }
    };
    if ((BPA === null || BPA === void 0 ? void 0 : BPA.businessService) !== "BPA_OC") {
      details = [...details, applicationDetailsInfo, basicDetails, plotDetails, scrutinyDetails, buildingExtractionDetails, subOccupancyTableDetails, demolitionAreaDetails, addressDetails, ownerDetails, professionalDetails, documentDetails, fiReports, ...nocDetails, approvalChecksDetails, PermitConditions];
    } else {
      details = [...details, applicationDetailsInfo, basicDetails, plotDetails, scrutinyDetails, buildingExtractionDetails, subOccupancyTableDetails, demolitionAreaDetails, documentDetails, fiReports, ...nocDetails, PermitConditions];
    }
    if (billDetails !== null && billDetails !== void 0 && (_billDetails$addition = billDetails.additionalDetails) !== null && _billDetails$addition !== void 0 && (_billDetails$addition2 = _billDetails$addition.values) !== null && _billDetails$addition2 !== void 0 && _billDetails$addition2.length) {
      details.push(billDetails);
    }
    let bpaFilterDetails = (_details = details) === null || _details === void 0 ? void 0 : _details.filter(data => data);
    return {
      applicationData: BPA,
      applicationDetails: bpaFilterDetails,
      tenantId: BPA === null || BPA === void 0 ? void 0 : BPA.tenantId,
      edcrDetails: edcr || [],
      nocData: noc,
      businessService: BPA === null || BPA === void 0 ? void 0 : BPA.businessService,
      applicationNo: BPA === null || BPA === void 0 ? void 0 : BPA.applicationNo,
      applicationStatus: BPA === null || BPA === void 0 ? void 0 : BPA.status,
      collectionBillDetails: collectionBillDetails
    };
  },
  BPADetailsPageForm11: async (tenantId, filters) => {
    var _response$PermissionO5;
    const response = await OBPSService.BPASearchForm11(tenantId, filters);
    if (filters !== null && filters !== void 0 && filters.isEmployee) {
      var _response$PermissionO, _response$PermissionO2, _filters$formType, _businessService$join, _response$PermissionO4;
      const businessServiceValue = response === null || response === void 0 ? void 0 : (_response$PermissionO = response.PermissionOfSubdivision) === null || _response$PermissionO === void 0 ? void 0 : (_response$PermissionO2 = _response$PermissionO[0]) === null || _response$PermissionO2 === void 0 ? void 0 : _response$PermissionO2.businessService;
      const businessService = Array.isArray(businessServiceValue) ? businessServiceValue : [businessServiceValue];
      const collectionBillRes = [],
        collectionBillDetails = [];
      const formNo = filters === null || filters === void 0 ? void 0 : (_filters$formType = filters.formType) === null || _filters$formType === void 0 ? void 0 : _filters$formType.replace("form", "");
      const appBusinessService = (_businessService$join = businessService.join("")) !== null && _businessService$join !== void 0 && _businessService$join.includes("UD") ? [`BPA.FORM_${formNo}_FEE_UD`] : [`BPA.FORM_${formNo}_FEE`];
      console.log("555556262", appBusinessService);
      for (let i = 0; i < (appBusinessService === null || appBusinessService === void 0 ? void 0 : appBusinessService.length); i++) {
        var _response$PermissionO3;
        if (appBusinessService[0] !== "BPA.FORM_NOC_FEE") {
          var _collectionres$Paymen4;
          let collectionres = await Digit.PaymentService.recieptSearch(tenantId, appBusinessService[i], {
            consumerCodes: filters === null || filters === void 0 ? void 0 : filters.applicationNo,
            isEmployee: filters === null || filters === void 0 ? void 0 : filters.isEmployee
          });
          if ((collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen4 = collectionres.Payments) === null || _collectionres$Paymen4 === void 0 ? void 0 : _collectionres$Paymen4.length) > 0) {
            var _collectionres$Paymen5;
            collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen5 = collectionres.Payments) === null || _collectionres$Paymen5 === void 0 ? void 0 : _collectionres$Paymen5.map(res => {
              var _res$paymentDetails2;
              res === null || res === void 0 ? void 0 : (_res$paymentDetails2 = res.paymentDetails) === null || _res$paymentDetails2 === void 0 ? void 0 : _res$paymentDetails2.map(resData => {
                if ((resData === null || resData === void 0 ? void 0 : resData.businessService) == appBusinessService[i]) {
                  collectionBillRes.push(res);
                }
              });
            });
            collectionBillDetails.push(...(collectionres === null || collectionres === void 0 ? void 0 : collectionres.Payments));
          }
        }
        return {
          appData: response === null || response === void 0 ? void 0 : (_response$PermissionO3 = response.PermissionOfSubdivision) === null || _response$PermissionO3 === void 0 ? void 0 : _response$PermissionO3[0],
          collectionBillRes,
          collectionBillDetails
        };
      }
      return {
        appData: response === null || response === void 0 ? void 0 : (_response$PermissionO4 = response.PermissionOfSubdivision) === null || _response$PermissionO4 === void 0 ? void 0 : _response$PermissionO4[0]
      };
    }
    return response === null || response === void 0 ? void 0 : (_response$PermissionO5 = response.PermissionOfSubdivision) === null || _response$PermissionO5 === void 0 ? void 0 : _response$PermissionO5[0];
  },
  BPADetailsPageFormLandUse: async (tenantId, filters) => {
    var _response$LandUse4;
    const response = await OBPSService.BPASearchFormLandUse(tenantId, filters);
    if (filters !== null && filters !== void 0 && filters.isEmployee) {
      var _response$LandUse, _response$LandUse$, _filters$formType2, _businessService$join2, _response$LandUse3;
      const businessServiceValue = response === null || response === void 0 ? void 0 : (_response$LandUse = response.LandUse) === null || _response$LandUse === void 0 ? void 0 : (_response$LandUse$ = _response$LandUse[0]) === null || _response$LandUse$ === void 0 ? void 0 : _response$LandUse$.businessService;
      const businessService = Array.isArray(businessServiceValue) ? businessServiceValue : [businessServiceValue];
      const collectionBillRes = [],
        collectionBillDetails = [];
      const formNo = filters === null || filters === void 0 ? void 0 : (_filters$formType2 = filters.formType) === null || _filters$formType2 === void 0 ? void 0 : _filters$formType2.replace("form", "");
      const appBusinessService = (_businessService$join2 = businessService.join("")) !== null && _businessService$join2 !== void 0 && _businessService$join2.includes("UD") ? [`BPA.FORM_${formNo}_FEE_UD`] : [`BPA.FORM_${formNo}_FEE`];
      console.log("555556262", appBusinessService);
      for (let i = 0; i < (appBusinessService === null || appBusinessService === void 0 ? void 0 : appBusinessService.length); i++) {
        var _response$LandUse2;
        if (appBusinessService[0] !== "BPA.FORM_NOC_FEE") {
          var _collectionres$Paymen6;
          let collectionres = await Digit.PaymentService.recieptSearch(tenantId, appBusinessService[i], {
            consumerCodes: filters === null || filters === void 0 ? void 0 : filters.applicationNo,
            isEmployee: filters === null || filters === void 0 ? void 0 : filters.isEmployee
          });
          if ((collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen6 = collectionres.Payments) === null || _collectionres$Paymen6 === void 0 ? void 0 : _collectionres$Paymen6.length) > 0) {
            var _collectionres$Paymen7;
            collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen7 = collectionres.Payments) === null || _collectionres$Paymen7 === void 0 ? void 0 : _collectionres$Paymen7.map(res => {
              var _res$paymentDetails3;
              res === null || res === void 0 ? void 0 : (_res$paymentDetails3 = res.paymentDetails) === null || _res$paymentDetails3 === void 0 ? void 0 : _res$paymentDetails3.map(resData => {
                if ((resData === null || resData === void 0 ? void 0 : resData.businessService) == appBusinessService[i]) {
                  collectionBillRes.push(res);
                }
              });
            });
            collectionBillDetails.push(...(collectionres === null || collectionres === void 0 ? void 0 : collectionres.Payments));
          }
        }
        return {
          appData: response === null || response === void 0 ? void 0 : (_response$LandUse2 = response.LandUse) === null || _response$LandUse2 === void 0 ? void 0 : _response$LandUse2[0],
          collectionBillRes,
          collectionBillDetails
        };
      }
      return {
        appData: response === null || response === void 0 ? void 0 : (_response$LandUse3 = response.LandUse) === null || _response$LandUse3 === void 0 ? void 0 : _response$LandUse3[0]
      };
    }
    return response === null || response === void 0 ? void 0 : (_response$LandUse4 = response.LandUse) === null || _response$LandUse4 === void 0 ? void 0 : _response$LandUse4[0];
  },
  Form12DetailsPage: async (tenantId, filter) => {
    var _response$BPA11;
    const response = await OBPSService.BPASearch(tenantId, filter);
    const BPA = response === null || response === void 0 ? void 0 : (_response$BPA11 = response.BPA) === null || _response$BPA11 === void 0 ? void 0 : _response$BPA11[0];
    return {
      applicationData: BPA
    };
  }
};

const ApplicationDetails = props => {
  var _workflowDetails$data;
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const state = Digit.ULBService.getStateId();
  const {
    t
  } = useTranslation();
  const history = useHistory();
  let {
    id: applicationNumber
  } = useParams();
  const [displayMenu, setDisplayMenu] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isEnableLoader, setIsEnableLoader] = useState(false);
  const [isWarningPop, setWarningPopUp] = useState(false);
  const {
    applicationDetails,
    showToast,
    setShowToast,
    isLoading,
    isDataLoading,
    applicationData,
    mutate,
    nocMutation,
    workflowDetails,
    businessService,
    closeToast,
    moduleCode,
    timelineStatusPrefix,
    forcedActionPrefix,
    statusAttribute,
    ActionBarStyle,
    MenuStyle,
    paymentsList,
    showTimeLine = true
  } = props;
  useEffect(() => {
    if (showToast) {
      workflowDetails.revalidate();
    }
  }, [showToast]);
  async function onActionSelect(action) {
    if (action) {
      if (action !== null && action !== void 0 && action.isWarningPopUp) {
        setWarningPopUp(true);
      } else if (action !== null && action !== void 0 && action.redirectionUrll) {
        var _action$redirectionUr;
        window.location.assign(`${window.location.origin}/digit-ui/employee/payment/collect/${action === null || action === void 0 ? void 0 : (_action$redirectionUr = action.redirectionUrll) === null || _action$redirectionUr === void 0 ? void 0 : _action$redirectionUr.pathname}`);
      } else if ((action === null || action === void 0 ? void 0 : action.action) === 'APPROVAL_LETTER_GENERATE') {
        setShowModal(false);
        let payload = {};
        payload.BPA = applicationData;
        payload.BPA.workflow = {
          "action": "APPROVAL_LETTER_GENERATE",
          "assignes": null,
          "comments": null,
          "varificationDocuments": null
        }, payload.RequestInfo = applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.RequestInfo;
        try {
          const res = await OBPSService.designOfApprovalLetterPdf(state, applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationNo);
          const pdfBlob = new Blob([res === null || res === void 0 ? void 0 : res.data], {
            type: "application/pdf"
          });
          const pdfUrl = URL.createObjectURL(pdfBlob);
          window.open(pdfUrl);
          if (res) {
            await OBPSService.update(payload, tenantId);
            history.push({
              pathname: "/digit-ui/employee/obps/form12inbox"
            });
          } else {
            setShowToast({
              key: "error",
              error: {
                message: "Error in APPROVAL_LETTER_GENERATE"
              }
            });
          }
        } catch (error) {
          console.error("Error in APPROVAL_LETTER_GENERATE action:", error);
        }
      } else if (!(action !== null && action !== void 0 && action.redirectionUrl)) {
        setShowModal(true);
      } else {
        var _action$redirectionUr2, _action$redirectionUr3;
        history.push({
          pathname: (_action$redirectionUr2 = action.redirectionUrl) === null || _action$redirectionUr2 === void 0 ? void 0 : _action$redirectionUr2.pathname,
          state: {
            ...((_action$redirectionUr3 = action.redirectionUrl) === null || _action$redirectionUr3 === void 0 ? void 0 : _action$redirectionUr3.state)
          }
        });
      }
    }
    setSelectedAction(action);
    setDisplayMenu(false);
  }
  const queryClient = useQueryClient();
  const closeModal = () => {
    setSelectedAction(null);
    setShowModal(false);
  };
  const closeWarningPopup = () => {
    setWarningPopUp(false);
  };
  const submitAction = async (data, nocData = false, isOBPS = {}) => {
    setIsEnableLoader(true);
    if (typeof (data === null || data === void 0 ? void 0 : data.customFunctionToExecute) === "function") {
      data === null || data === void 0 ? void 0 : data.customFunctionToExecute({
        ...data
      });
    }
    if (nocData !== false && nocMutation) {
      const nocPrmomises = nocData === null || nocData === void 0 ? void 0 : nocData.map(noc => {
        return nocMutation === null || nocMutation === void 0 ? void 0 : nocMutation.mutateAsync(noc);
      });
      try {
        setIsEnableLoader(true);
        const values = await Promise.all(nocPrmomises);
        values && values.map(ob => {
          var _ob$Noc, _ob$Noc$;
          Digit.SessionStorage.del(ob === null || ob === void 0 ? void 0 : (_ob$Noc = ob.Noc) === null || _ob$Noc === void 0 ? void 0 : (_ob$Noc$ = _ob$Noc[0]) === null || _ob$Noc$ === void 0 ? void 0 : _ob$Noc$.nocType);
        });
      } catch (err) {
        var _err$response, _err$response$data, _err$response$data$Er, _err$response$data$Er2, _err$response2, _err$response2$data, _err$response2$data$E, _err$response2$data$E2, _err$response3, _err$response3$data, _err$response3$data$E, _err$response3$data$E2;
        setIsEnableLoader(false);
        let errorValue = err !== null && err !== void 0 && (_err$response = err.response) !== null && _err$response !== void 0 && (_err$response$data = _err$response.data) !== null && _err$response$data !== void 0 && (_err$response$data$Er = _err$response$data.Errors) !== null && _err$response$data$Er !== void 0 && (_err$response$data$Er2 = _err$response$data$Er[0]) !== null && _err$response$data$Er2 !== void 0 && _err$response$data$Er2.code ? t(err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$E = _err$response2$data.Errors) === null || _err$response2$data$E === void 0 ? void 0 : (_err$response2$data$E2 = _err$response2$data$E[0]) === null || _err$response2$data$E2 === void 0 ? void 0 : _err$response2$data$E2.code) : (err === null || err === void 0 ? void 0 : (_err$response3 = err.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$data = _err$response3.data) === null || _err$response3$data === void 0 ? void 0 : (_err$response3$data$E = _err$response3$data.Errors) === null || _err$response3$data$E === void 0 ? void 0 : (_err$response3$data$E2 = _err$response3$data$E[0]) === null || _err$response3$data$E2 === void 0 ? void 0 : _err$response3$data$E2.message) || err;
        closeModal();
        setShowToast({
          key: "error",
          error: {
            message: errorValue
          }
        });
        setTimeout(closeToast, 5000);
        return;
      }
    }
    if (mutate) {
      setIsEnableLoader(true);
      mutate(data, {
        onError: (error, variables) => {
          setIsEnableLoader(false);
          setShowToast({
            key: "error",
            error
          });
          setTimeout(closeToast, 5000);
        },
        onSuccess: (data, variables) => {
          setIsEnableLoader(false);
          if (isOBPS !== null && isOBPS !== void 0 && isOBPS.bpa) {
            data.selectedAction = selectedAction;
            history.replace(`/digit-ui/employee/obps/response`, {
              data: data
            });
          }
          if (isOBPS !== null && isOBPS !== void 0 && isOBPS.isStakeholder) {
            data.selectedAction = selectedAction;
            history.push(`/digit-ui/employee/obps/stakeholder-response`, {
              data: data
            });
          }
          if (isOBPS !== null && isOBPS !== void 0 && isOBPS.isNoc) {
            history.push(`/digit-ui/employee/noc/response`, {
              data: data
            });
          }
          setShowToast({
            key: "success",
            action: selectedAction
          });
          setTimeout(closeToast, 5000);
          queryClient.clear();
          queryClient.refetchQueries("APPLICATION_SEARCH");
        }
      });
    }
    closeModal();
  };
  if (isLoading || isEnableLoader) {
    return /*#__PURE__*/React$1.createElement(Loader, null);
  }
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, !isLoading ? /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(ApplicationDetailsContent, {
    applicationDetails: applicationDetails,
    workflowDetails: workflowDetails,
    isDataLoading: isDataLoading,
    applicationData: applicationData,
    businessService: businessService,
    timelineStatusPrefix: timelineStatusPrefix,
    statusAttribute: statusAttribute,
    paymentsList: paymentsList,
    showTimeLine: showTimeLine
  }), showModal ? /*#__PURE__*/React$1.createElement(ActionModal$6, {
    t: t,
    action: selectedAction,
    tenantId: tenantId,
    state: state,
    id: applicationNumber,
    applicationDetails: applicationDetails,
    applicationData: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData,
    closeModal: closeModal,
    submitAction: submitAction,
    actionData: workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : _workflowDetails$data.timeline,
    businessService: businessService,
    workflowDetails: workflowDetails,
    moduleCode: moduleCode
  }) : null, isWarningPop ? /*#__PURE__*/React$1.createElement(ApplicationDetailsWarningPopup, {
    action: selectedAction,
    workflowDetails: workflowDetails,
    businessService: businessService,
    isWarningPop: isWarningPop,
    closeWarningPopup: closeWarningPopup
  }) : null, /*#__PURE__*/React$1.createElement(ApplicationDetailsToast, {
    t: t,
    showToast: showToast,
    closeToast: closeToast,
    businessService: businessService
  }), /*#__PURE__*/React$1.createElement(ApplicationDetailsActionBar, {
    workflowDetails: workflowDetails,
    displayMenu: displayMenu,
    onActionSelect: onActionSelect,
    setDisplayMenu: setDisplayMenu,
    businessService: businessService,
    forcedActionPrefix: forcedActionPrefix,
    ActionBarStyle: ActionBarStyle,
    MenuStyle: MenuStyle,
    applicationDetails: applicationDetails
  })) : /*#__PURE__*/React$1.createElement(Loader, null));
};

const Heading$6 = ({
  t,
  heading
}) => {
  return /*#__PURE__*/React$1.createElement("h1", {
    className: "heading-m"
  }, `${t(heading)}`);
};
const Close$7 = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React$1.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$7 = props => {
  return /*#__PURE__*/React$1.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React$1.createElement(Close$7, null));
};
const ConfirmationQuestion = ({
  t,
  title
}) => /*#__PURE__*/React$1.createElement("div", {
  className: "confirmation_box"
}, /*#__PURE__*/React$1.createElement("span", null, " ", `${t('CONFIRM_DELETE_MSG')} `, " ", /*#__PURE__*/React$1.createElement("b", null, ` ${title}`), " "));
const Confirmation = ({
  t,
  heading,
  docName,
  closeModal,
  actionCancelLabel,
  actionCancelOnSubmit,
  actionSaveLabel,
  actionSaveOnSubmit
}) => {
  return /*#__PURE__*/React$1.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React$1.createElement(Heading$6, {
      t: t,
      heading: heading
    }),
    headerBarEnd: /*#__PURE__*/React$1.createElement(CloseBtn$7, {
      onClick: closeModal
    }),
    actionCancelLabel: t(actionCancelLabel),
    actionCancelOnSubmit: actionCancelOnSubmit,
    actionSaveLabel: t(actionSaveLabel),
    actionSaveOnSubmit: actionSaveOnSubmit,
    formId: "modal-action"
  }, /*#__PURE__*/React$1.createElement(ConfirmationQuestion, {
    t: t,
    title: docName
  }));
};

const renderMultipleDocuments = documents => {
  let isMobile = window.Digit.Utils.browser.isMobile();
  if (!documents && !documents.length) return null;
  return /*#__PURE__*/React$1.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      gap: isMobile ? '40px' : '100px'
    }
  }, documents.map(({
    fileStoreId,
    fileName
  }) => /*#__PURE__*/React$1.createElement("div", {
    className: "documentDetails_pdf"
  }, /*#__PURE__*/React$1.createElement("div", {
    style: {
      width: '100px'
    },
    onClick: () => openUploadedDocument(fileStoreId, fileName)
  }, /*#__PURE__*/React$1.createElement(GenericFileIcon, null), /*#__PURE__*/React$1.createElement("span", {
    className: "cell-text"
  }, fileName === null || fileName === void 0 ? void 0 : fileName.split(10))))));
};
const Actions = ['EDIT', 'DELETE'];
const getUlbName = tenantId => {
  var _ulbName, _ulbName$, _ulbName2;
  let ulbName = tenantId === null || tenantId === void 0 ? void 0 : tenantId.split('.')[1];
  ulbName = `${(_ulbName = ulbName) === null || _ulbName === void 0 ? void 0 : (_ulbName$ = _ulbName[0]) === null || _ulbName$ === void 0 ? void 0 : _ulbName$.toUpperCase()}${(_ulbName2 = ulbName) === null || _ulbName2 === void 0 ? void 0 : _ulbName2.slice(1)} `;
  return ulbName;
};
const DocumentDetails = () => {
  var _data$applicationData, _data$applicationData2, _data$applicationData3, _data$applicationData4, _data$applicationData5, _data$applicationData6, _data$applicationData7, _data$applicationData8, _data$applicationData9, _data$applicationData10, _data$applicationData11, _data$applicationData12, _data$applicationData13, _data$applicationData14, _data$applicationData15, _data$applicationData16, _data$applicationData17, _data$applicationData18;
  let isMobile = window.Digit.Utils.browser.isMobile();
  const {
    id
  } = useParams();
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [displayMenu, setDisplayMenu] = useState(false);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const {
    isLoading,
    data
  } = Digit.Hooks.events.useEventDetails(tenantId, {
    ids: id
  }, {});
  const [mutationHappened, setMutationHappened, clear] = Digit.Hooks.useSessionStorage("EMPLOYEE_MSG_MUTATION_HAPPENED", false);
  const [errorInfo, setErrorInfo, clearError] = Digit.Hooks.useSessionStorage("EMPLOYEE_MSG_ERROR_DATA", false);
  const [successData, setsuccessData, clearSuccessData] = Digit.Hooks.useSessionStorage("EMPLOYEE_MSG_MUTATION_SUCCESS_DATA", false);
  useEffect(() => {
    setMutationHappened(false);
    clearSuccessData();
    clearError();
  }, []);
  function onActionSelect(action) {
    if (action === "EDIT") {
      history.push(`/digit-ui/employee/engagement/messages/inbox/edit/${id}`);
    }
    if (action === "DELETE") {
      setShowModal(true);
    }
    setDisplayMenu(false);
  }
  const handleDelete = () => {
    const finalData = (({
      uploadedFilesData,
      ...ogData
    }) => ogData)(data === null || data === void 0 ? void 0 : data.applicationData);
    const details = {
      events: [{
        ...finalData,
        status: "CANCELLED"
      }]
    };
    history.push("/digit-ui/employee/engagement/messages/response?delete=true", details);
  };
  function onModalCancel() {
    setShowModal(false);
  }
  if (isLoading) {
    return /*#__PURE__*/React$1.createElement(Loader, null);
  }
  return /*#__PURE__*/React$1.createElement("div", null, showModal ? /*#__PURE__*/React$1.createElement(Confirmation, {
    t: t,
    heading: 'CONFIRM_DELETE_PUB_BRCST',
    docName: data === null || data === void 0 ? void 0 : (_data$applicationData = data.applicationData) === null || _data$applicationData === void 0 ? void 0 : _data$applicationData.name,
    closeModal: () => setShowModal(!showModal),
    actionCancelLabel: 'CS_COMMON_CANCEL',
    actionCancelOnSubmit: onModalCancel,
    actionSaveLabel: 'ES_COMMON_Y_DEL',
    actionSaveOnSubmit: handleDelete
  }) : null, /*#__PURE__*/React$1.createElement(Header, null, t(`CS_HEADER_PUBLIC_BRDCST`)), /*#__PURE__*/React$1.createElement("div", {
    className: "notice_and_circular_main gap-ten"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "documentDetails_wrapper"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "documentDetails_row_items"
  }, /*#__PURE__*/React$1.createElement("p", {
    className: "documentDetails_title"
  }, `${t("EVENTS_ULB_LABEL")}:`), " ", /*#__PURE__*/React$1.createElement("p", null, getUlbName(data === null || data === void 0 ? void 0 : data.tenantId)), " "), /*#__PURE__*/React$1.createElement("div", {
    className: "documentDetails_row_items"
  }, /*#__PURE__*/React$1.createElement("p", {
    className: "documentDetails_title"
  }, `${t("PUBLIC_BRDCST_TITLE_LABEL")}:`), " ", /*#__PURE__*/React$1.createElement("p", null, data === null || data === void 0 ? void 0 : (_data$applicationData2 = data.applicationData) === null || _data$applicationData2 === void 0 ? void 0 : _data$applicationData2.name), " "), /*#__PURE__*/React$1.createElement("div", {
    className: "documentDetails_row_items"
  }, /*#__PURE__*/React$1.createElement("p", {
    className: "documentDetails_title"
  }, `${t("EVENTS_COMMENTS_LABEL")}:`), " ", /*#__PURE__*/React$1.createElement("p", {
    className: "documentDetails__description"
  }, data !== null && data !== void 0 && (_data$applicationData3 = data.applicationData) !== null && _data$applicationData3 !== void 0 && (_data$applicationData4 = _data$applicationData3.description) !== null && _data$applicationData4 !== void 0 && _data$applicationData4.length ? data === null || data === void 0 ? void 0 : (_data$applicationData5 = data.applicationData) === null || _data$applicationData5 === void 0 ? void 0 : _data$applicationData5.description : 'NA'), " "), /*#__PURE__*/React$1.createElement("div", {
    className: "documentDetails_row_items"
  }, /*#__PURE__*/React$1.createElement("p", {
    className: "documentDetails_title"
  }, `${t("EVENTS_FROM_DATE_LABEL")}:`), " ", /*#__PURE__*/React$1.createElement("p", null, data !== null && data !== void 0 && (_data$applicationData6 = data.applicationData) !== null && _data$applicationData6 !== void 0 && (_data$applicationData7 = _data$applicationData6.eventDetails) !== null && _data$applicationData7 !== void 0 && _data$applicationData7.fromDate ? format(new Date(data === null || data === void 0 ? void 0 : (_data$applicationData8 = data.applicationData) === null || _data$applicationData8 === void 0 ? void 0 : (_data$applicationData9 = _data$applicationData8.eventDetails) === null || _data$applicationData9 === void 0 ? void 0 : _data$applicationData9.fromDate), 'dd/MM/yyyy') : null), " "), /*#__PURE__*/React$1.createElement("div", {
    className: "documentDetails_row_items"
  }, /*#__PURE__*/React$1.createElement("p", {
    className: "documentDetails_title"
  }, `${t("EVENTS_TO_DATE_LABEL")}:`), " ", /*#__PURE__*/React$1.createElement("p", null, data !== null && data !== void 0 && (_data$applicationData10 = data.applicationData) !== null && _data$applicationData10 !== void 0 && (_data$applicationData11 = _data$applicationData10.eventDetails) !== null && _data$applicationData11 !== void 0 && _data$applicationData11.toDate ? format(new Date(data === null || data === void 0 ? void 0 : (_data$applicationData12 = data.applicationData) === null || _data$applicationData12 === void 0 ? void 0 : (_data$applicationData13 = _data$applicationData12.eventDetails) === null || _data$applicationData13 === void 0 ? void 0 : _data$applicationData13.toDate), 'dd/MM/yyyy') : null), " "), /*#__PURE__*/React$1.createElement("span", {
    className: "documentDetails_subheader"
  }, `${t('CS_COMMON_DOCUMENTS')}`), data !== null && data !== void 0 && (_data$applicationData14 = data.applicationData) !== null && _data$applicationData14 !== void 0 && (_data$applicationData15 = _data$applicationData14.eventDetails) !== null && _data$applicationData15 !== void 0 && (_data$applicationData16 = _data$applicationData15.documents) !== null && _data$applicationData16 !== void 0 && _data$applicationData16.length ? renderMultipleDocuments(data === null || data === void 0 ? void 0 : (_data$applicationData17 = data.applicationData) === null || _data$applicationData17 === void 0 ? void 0 : (_data$applicationData18 = _data$applicationData17.eventDetails) === null || _data$applicationData18 === void 0 ? void 0 : _data$applicationData18.documents) : "NA")), /*#__PURE__*/React$1.createElement(ActionBar, null, displayMenu ? /*#__PURE__*/React$1.createElement(Menu, {
    style: {
      width: isMobile ? 'full' : '240px'
    },
    localeKeyPrefix: "ES_CE",
    options: Actions,
    t: t,
    onSelect: onActionSelect
  }) : null, /*#__PURE__*/React$1.createElement(SubmitBar, {
    label: t("ES_COMMON_TAKE_ACTION"),
    onSubmit: () => setDisplayMenu(!displayMenu)
  })));
};

const Messages = ({
  match: {
    path
  } = {},
  tenants,
  parentRoute
}) => {
  return /*#__PURE__*/React$1.createElement(Switch, null, /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/create`,
    component: props => /*#__PURE__*/React$1.createElement(NewEvents$1, props)
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/inbox/create`,
    component: props => /*#__PURE__*/React$1.createElement(NewEvents$1, props)
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/inbox/details/:id`,
    component: props => /*#__PURE__*/React$1.createElement(DocumentDetails, props)
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/inbox/edit/:id`,
    component: props => /*#__PURE__*/React$1.createElement(EditMessage, props)
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/inbox`,
    component: props => /*#__PURE__*/React$1.createElement(Inbox$1, Object.assign({}, props, {
      tenants: tenants,
      parentRoute: parentRoute
    }))
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/response`,
    component: props => /*#__PURE__*/React$1.createElement(Response$1, props)
  }));
};

const EventForm = ({
  onSelect,
  config,
  formData,
  register,
  control,
  errors
}) => {
  var _errors$name, _errors$name2, _data$mseva, _data$mseva$EventCate;
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const state = tenantId === null || tenantId === void 0 ? void 0 : tenantId.split('.')[0];
  const ulbs = Digit.SessionStorage.get("ENGAGEMENT_TENANTS");
  const userInfo = Digit.UserService.getUser().info;
  const userUlbs = ulbs.filter(ulb => {
    var _userInfo$roles;
    return userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$roles = userInfo.roles) === null || _userInfo$roles === void 0 ? void 0 : _userInfo$roles.some(role => (role === null || role === void 0 ? void 0 : role.tenantId) === (ulb === null || ulb === void 0 ? void 0 : ulb.code));
  }).sort(alphabeticalSortFunctionForTenantsBasedOnName);
  const getDefaultUlb = () => {
    if (formData !== null && formData !== void 0 && formData.defaultTenantId) {
      return ulbs === null || ulbs === void 0 ? void 0 : ulbs.find(ulb => (ulb === null || ulb === void 0 ? void 0 : ulb.code) === (formData === null || formData === void 0 ? void 0 : formData.defaultTenantId));
    }
    if (tenantId) {
      return ulbs === null || ulbs === void 0 ? void 0 : ulbs.find(ulb => (ulb === null || ulb === void 0 ? void 0 : ulb.code) === tenantId);
    }
    return (userUlbs === null || userUlbs === void 0 ? void 0 : userUlbs.length) === 1 ? userUlbs === null || userUlbs === void 0 ? void 0 : userUlbs[0] : null;
  };
  const {
    isLoading,
    data
  } = Digit.Hooks.useCommonMDMS(state, "mseva", ["EventCategories"]);
  const location = useLocation();
  const isInEditFormMode = useMemo(() => {
    if (location.pathname.includes('/engagement/event/edit-event')) return true;
    return false;
  }, [location.pathname]);
  if (isLoading) {
    return /*#__PURE__*/React$1.createElement(Loader, null);
  }
  return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(LabelFieldPair, null, /*#__PURE__*/React$1.createElement(CardLabel, {
    className: "card-label-smaller"
  }, `${t(`EVENTS_ULB_LABEL`)} *`), /*#__PURE__*/React$1.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React$1.createElement(Controller, {
    control: control,
    defaultValue: getDefaultUlb(),
    name: "tenantId",
    rules: {
      required: true
    },
    render: ({
      onChange,
      value
    }) => /*#__PURE__*/React$1.createElement(Dropdown, {
      option: userUlbs,
      selected: value,
      disable: isInEditFormMode ? true : (userUlbs === null || userUlbs === void 0 ? void 0 : userUlbs.length) === 1,
      optionKey: "code",
      t: t,
      select: onChange
    })
  }), errors && errors['tenantId'] && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TENANT_ERROR_REQUIRED`)))), /*#__PURE__*/React$1.createElement(LabelFieldPair, null, /*#__PURE__*/React$1.createElement(CardLabel, {
    className: "card-label-smaller"
  }, `${t(`EVENTS_NAME_LABEL`)} *`), /*#__PURE__*/React$1.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React$1.createElement(Controller, {
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.name,
    render: ({
      onChange,
      ref,
      value
    }) => /*#__PURE__*/React$1.createElement(TextInput, {
      value: value,
      type: "text",
      name: "name",
      onChange: onChange,
      inputRef: ref
    }),
    name: "name",
    rules: {
      required: true,
      maxLength: 66
    },
    control: control
  }), errors && (errors === null || errors === void 0 ? void 0 : errors.name) && (errors === null || errors === void 0 ? void 0 : (_errors$name = errors.name) === null || _errors$name === void 0 ? void 0 : _errors$name.type) === "required" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_COMMENTS_ERROR_REQUIRED`)), errors && (errors === null || errors === void 0 ? void 0 : errors.name) && (errors === null || errors === void 0 ? void 0 : (_errors$name2 = errors.name) === null || _errors$name2 === void 0 ? void 0 : _errors$name2.type) === "maxLength" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_MAXLENGTH_66_CHARS_REACHED`)))), /*#__PURE__*/React$1.createElement(LabelFieldPair, null, /*#__PURE__*/React$1.createElement(CardLabel, {
    className: "card-label-smaller"
  }, `${t(`EVENTS_CATEGORY_LABEL`)} *`), /*#__PURE__*/React$1.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React$1.createElement(Controller, {
    name: "eventCategory",
    control: control,
    defaultValue: formData !== null && formData !== void 0 && formData.category ? data === null || data === void 0 ? void 0 : (_data$mseva = data.mseva) === null || _data$mseva === void 0 ? void 0 : (_data$mseva$EventCate = _data$mseva.EventCategories.filter(category => category.code === (formData === null || formData === void 0 ? void 0 : formData.category))) === null || _data$mseva$EventCate === void 0 ? void 0 : _data$mseva$EventCate[0] : null,
    rules: {
      required: true
    },
    render: ({
      onChange,
      ref,
      value
    }) => {
      var _data$mseva2;
      return /*#__PURE__*/React$1.createElement(Dropdown, {
        inputRef: ref,
        option: data === null || data === void 0 ? void 0 : (_data$mseva2 = data.mseva) === null || _data$mseva2 === void 0 ? void 0 : _data$mseva2.EventCategories,
        optionKey: "code",
        t: t,
        select: onChange,
        selected: value
      });
    }
  }), errors && errors['eventCategory'] && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_CATEGORY_ERROR_REQUIRED`)))));
};

const allowedFileTypes = /(.*?)(jpg|jpeg|png|image|pdf|msword|openxmlformats-officedocument)$/i;
const MessageForm = ({
  onSelect,
  config,
  formData,
  register,
  control,
  errors,
  setError
}) => {
  var _errors$name, _errors$name2, _data$mseva, _data$mseva$EventCate, _errors$description, _errors$description2, _errors$fromDate, _errors$fromDate2, _errors$toDate, _errors$toDate2;
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const state = tenantId === null || tenantId === void 0 ? void 0 : tenantId.split('.')[0];
  const ulbs = Digit.SessionStorage.get("ENGAGEMENT_TENANTS");
  const {
    isLoading,
    data
  } = Digit.Hooks.useCommonMDMS(state, "mseva", ["EventCategories"]);
  const stateId = Digit.ULBService.getStateId();
  const userUlbs = ulbs.filter(ulb => (ulb === null || ulb === void 0 ? void 0 : ulb.code) === tenantId);
  const isValidFromDate = date => {
    const fromDate = convertDateToMaximumPossibleValue(new Date(`${formData === null || formData === void 0 ? void 0 : formData.fromDate}`));
    const todaysDate = new Date();
    if (!isValid(fromDate)) return false;
    if (fromDate.getTime() < todaysDate.getTime()) {
      setError('fromDate', {
        type: 'isValidFromDate'
      }, {
        shouldFocus: true
      });
      return false;
    }
    return true;
  };
  const isValidToDate = date => {
    const fromDate = convertDateToMaximumPossibleValue(new Date(`${formData === null || formData === void 0 ? void 0 : formData.fromDate}`));
    const toDate = convertDateToMaximumPossibleValue(new Date(`${formData === null || formData === void 0 ? void 0 : formData.toDate}`));
    const todaysDate = new Date();
    if (!isValid(toDate)) return false;
    if (toDate.getTime() < todaysDate.getTime() || toDate.getTime() < fromDate.getTime()) {
      setError('toDate', {
        type: 'isValidToDate'
      }, {
        shouldFocus: true
      });
      return false;
    }
    return true;
  };
  if (isLoading) {
    return /*#__PURE__*/React$1.createElement(Loader, null);
  }
  return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(LabelFieldPair, null, /*#__PURE__*/React$1.createElement(CardLabel, {
    className: "card-label-smaller"
  }, `${t(`EVENTS_ULB_LABEL`)} *`), /*#__PURE__*/React$1.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React$1.createElement(Controller, {
    control: control,
    defaultValue: (userUlbs === null || userUlbs === void 0 ? void 0 : userUlbs.length) === 1 ? userUlbs === null || userUlbs === void 0 ? void 0 : userUlbs[0] : null,
    name: "tenantId",
    rules: {
      required: true
    },
    render: ({
      onChange,
      value
    }) => /*#__PURE__*/React$1.createElement(Dropdown, {
      option: userUlbs,
      selected: value,
      disable: (userUlbs === null || userUlbs === void 0 ? void 0 : userUlbs.length) === 1,
      optionKey: "code",
      t: t,
      select: onChange
    })
  }), errors && errors['tenantId'] && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TENANT_ERROR_REQUIRED`)))), /*#__PURE__*/React$1.createElement(LabelFieldPair, null, /*#__PURE__*/React$1.createElement(CardLabel, {
    className: "card-label-smaller"
  }, `${t(`PUBLIC_BRDCST_TITLE_LABEL`)} *`), /*#__PURE__*/React$1.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React$1.createElement(Controller, {
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.name,
    render: ({
      onChange,
      ref,
      value
    }) => /*#__PURE__*/React$1.createElement(TextInput, {
      value: value,
      type: "text",
      name: "name",
      onChange: onChange,
      inputRef: ref
    }),
    name: "name",
    rules: {
      required: true,
      maxLength: 66
    },
    control: control
  }), errors && (errors === null || errors === void 0 ? void 0 : errors.name) && (errors === null || errors === void 0 ? void 0 : (_errors$name = errors.name) === null || _errors$name === void 0 ? void 0 : _errors$name.type) === "required" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_COMMENTS_ERROR_REQUIRED`)), errors && (errors === null || errors === void 0 ? void 0 : errors.name) && (errors === null || errors === void 0 ? void 0 : (_errors$name2 = errors.name) === null || _errors$name2 === void 0 ? void 0 : _errors$name2.type) === "maxLength" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_MAXLENGTH_66_CHARS_REACHED`)))), /*#__PURE__*/React$1.createElement(LabelFieldPair, {
    style: {
      marginBottom: "24px"
    }
  }, /*#__PURE__*/React$1.createElement(CardLabel, {
    className: "card-label-smaller"
  }, `${t(`EVENTS_COMMENTS_LABEL`)} *`), /*#__PURE__*/React$1.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React$1.createElement(Controller, {
    name: "description",
    control: control,
    defaultValue: formData !== null && formData !== void 0 && formData.category ? data === null || data === void 0 ? void 0 : (_data$mseva = data.mseva) === null || _data$mseva === void 0 ? void 0 : (_data$mseva$EventCate = _data$mseva.EventCategories.filter(category => category.code === (formData === null || formData === void 0 ? void 0 : formData.category))) === null || _data$mseva$EventCate === void 0 ? void 0 : _data$mseva$EventCate[0] : null,
    rules: {
      required: true,
      maxLength: 500
    },
    render: ({
      onChange,
      ref,
      value
    }) => /*#__PURE__*/React$1.createElement(TextArea, {
      inputRef: ref,
      value: value,
      name: "description",
      onChange: onChange,
      hintText: t('PUBLIC_BRDCST_MSG_LENGTH')
    })
  }), errors && (errors === null || errors === void 0 ? void 0 : errors.description) && (errors === null || errors === void 0 ? void 0 : (_errors$description = errors.description) === null || _errors$description === void 0 ? void 0 : _errors$description.type) === "required" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_COMMENTS_ERROR_REQUIRED`)), errors && (errors === null || errors === void 0 ? void 0 : errors.description) && (errors === null || errors === void 0 ? void 0 : (_errors$description2 = errors.description) === null || _errors$description2 === void 0 ? void 0 : _errors$description2.type) === "maxLength" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_MAXLENGTH_REACHED`)))), /*#__PURE__*/React$1.createElement(LabelFieldPair, {
    style: {
      marginBottom: "24px"
    }
  }, /*#__PURE__*/React$1.createElement(CardLabel, {
    className: "card-label-smaller"
  }, `${t(`EVENTS_ATTACHMENT_LABEL`)}`), /*#__PURE__*/React$1.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React$1.createElement(Controller, {
    name: "documents",
    control: control,
    rules: {
      required: false
    },
    render: ({
      onChange,
      ref,
      value: _value = []
    }) => {
      function getFileStoreData(filesData) {
        const numberOfFiles = filesData.length;
        let finalDocumentData = [];
        if (numberOfFiles > 0) {
          filesData.forEach(value => {
            var _value$, _value$$fileStoreId, _value$2, _value$2$file;
            finalDocumentData.push({
              fileName: value === null || value === void 0 ? void 0 : value[0],
              fileStoreId: value === null || value === void 0 ? void 0 : (_value$ = value[1]) === null || _value$ === void 0 ? void 0 : (_value$$fileStoreId = _value$.fileStoreId) === null || _value$$fileStoreId === void 0 ? void 0 : _value$$fileStoreId.fileStoreId,
              documentType: value === null || value === void 0 ? void 0 : (_value$2 = value[1]) === null || _value$2 === void 0 ? void 0 : (_value$2$file = _value$2.file) === null || _value$2$file === void 0 ? void 0 : _value$2$file.type
            });
          });
        }
        onChange(finalDocumentData);
      }
      return /*#__PURE__*/React$1.createElement(MultiUploadWrapper, {
        t: t,
        module: "engagement",
        tenantId: stateId,
        getFormState: getFileStoreData,
        showHintBelow: true,
        setuploadedstate: _value,
        allowedFileTypesRegex: allowedFileTypes,
        allowedMaxSizeInMB: 5,
        hintText: t("DOCUMENTS_ATTACH_RESTRICTIONS_SIZE")
      });
    }
  }))), /*#__PURE__*/React$1.createElement(LabelFieldPair, null, /*#__PURE__*/React$1.createElement(CardLabel, {
    className: "card-label-smaller"
  }, `${t(`PUBLIC_BRDCST_FROM_DATE_LABEL`)} *`), /*#__PURE__*/React$1.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React$1.createElement(Controller, {
    control: control,
    name: "fromDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.fromDate,
    rules: {
      required: true,
      validate: {
        isValidFromDate
      }
    },
    render: ({
      onChange,
      value
    }) => /*#__PURE__*/React$1.createElement(TextInput, {
      type: "date",
      isRequired: true,
      onChange: onChange,
      defaultValue: value
    })
  }), errors && (errors === null || errors === void 0 ? void 0 : errors.fromDate) && (errors === null || errors === void 0 ? void 0 : (_errors$fromDate = errors.fromDate) === null || _errors$fromDate === void 0 ? void 0 : _errors$fromDate.type) === "required" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_FROM_DATE_ERROR_REQUIRED`)), errors && (errors === null || errors === void 0 ? void 0 : errors.fromDate) && (errors === null || errors === void 0 ? void 0 : (_errors$fromDate2 = errors.fromDate) === null || _errors$fromDate2 === void 0 ? void 0 : _errors$fromDate2.type) === "isValidFromDate" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_FROM_DATE_ERROR_INVALID`)))), /*#__PURE__*/React$1.createElement(LabelFieldPair, null, /*#__PURE__*/React$1.createElement(CardLabel, {
    className: "card-label-smaller"
  }, `${t(`PUBLIC_BRDCST_TO_DATE_LABEL`)} *`), /*#__PURE__*/React$1.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React$1.createElement(Controller, {
    control: control,
    name: "toDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.toDate,
    rules: {
      required: true,
      validate: {
        isValidToDate
      }
    },
    render: ({
      onChange,
      value
    }) => /*#__PURE__*/React$1.createElement(TextInput, {
      type: "date",
      isRequired: true,
      onChange: onChange,
      defaultValue: value
    })
  }), errors && (errors === null || errors === void 0 ? void 0 : errors.toDate) && (errors === null || errors === void 0 ? void 0 : (_errors$toDate = errors.toDate) === null || _errors$toDate === void 0 ? void 0 : _errors$toDate.type) === "required" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_REQUIRED`)), errors && (errors === null || errors === void 0 ? void 0 : errors.toDate) && (errors === null || errors === void 0 ? void 0 : (_errors$toDate2 = errors.toDate) === null || _errors$toDate2 === void 0 ? void 0 : _errors$toDate2.type) === "isValidToDate" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_INVALID`)))));
};

const SelectGeolocation = ({
  onSelect,
  config,
  formData
}) => {
  var _formData$geoLocation, _formData$geoLocation2;
  const {
    t
  } = useTranslation();
  const onChange = (pincode, position) => {
    onSelect(config === null || config === void 0 ? void 0 : config.key, position);
  };
  return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(LabelFieldPair, null, /*#__PURE__*/React$1.createElement(CardLabel, {
    className: "card-label-smaller"
  }, `${t(`EVENTS_GEOLOCATION_LABEL`)}`), /*#__PURE__*/React$1.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React$1.createElement(LocationSearch, {
    position: {
      latitude: formData === null || formData === void 0 ? void 0 : (_formData$geoLocation = formData.geoLocation) === null || _formData$geoLocation === void 0 ? void 0 : _formData$geoLocation.latitude,
      longitude: formData === null || formData === void 0 ? void 0 : (_formData$geoLocation2 = formData.geoLocation) === null || _formData$geoLocation2 === void 0 ? void 0 : _formData$geoLocation2.longitude
    },
    onChange: onChange
  }))));
};

const SelectToDate = ({
  onSelect,
  config,
  formData,
  register,
  control,
  errors,
  setError
}) => {
  var _errors$toDate, _errors$toDate2;
  const {
    t
  } = useTranslation();
  const isValidDate = date => {
    if (!isValid(new Date(formData === null || formData === void 0 ? void 0 : formData.fromDate)) || !isValid(new Date(date))) return false;
    if (new Date(`${formData === null || formData === void 0 ? void 0 : formData.fromDate} ${formData === null || formData === void 0 ? void 0 : formData.fromTime}`) < new Date()) {
      setError('fromDate', {
        type: 'isValidFromDate'
      }, {
        shouldFocus: true
      });
      return false;
    }
    if (new Date(`${date} ${formData === null || formData === void 0 ? void 0 : formData.toTime}`) < new Date()) return false;
    return new Date(`${formData === null || formData === void 0 ? void 0 : formData.fromDate} ${formData === null || formData === void 0 ? void 0 : formData.fromTime}`) <= new Date(`${date} ${formData === null || formData === void 0 ? void 0 : formData.toTime}`);
  };
  return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(LabelFieldPair, null, /*#__PURE__*/React$1.createElement(CardLabel, {
    className: "card-label-smaller"
  }, `${t(`EVENTS_TO_DATE_LABEL`)} *`), /*#__PURE__*/React$1.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React$1.createElement(Controller, {
    control: control,
    name: "toDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.toDate,
    rules: {
      required: true,
      validate: {
        isValidDate: isValidDate
      }
    },
    render: ({
      onChange,
      value
    }) => /*#__PURE__*/React$1.createElement(TextInput, {
      type: "date",
      isRequired: true,
      onChange: onChange,
      defaultValue: value
    })
  }), errors && (errors === null || errors === void 0 ? void 0 : errors.toDate) && (errors === null || errors === void 0 ? void 0 : (_errors$toDate = errors.toDate) === null || _errors$toDate === void 0 ? void 0 : _errors$toDate.type) === "required" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_REQUIRED`)), errors && (errors === null || errors === void 0 ? void 0 : errors.toDate) && (errors === null || errors === void 0 ? void 0 : (_errors$toDate2 = errors.toDate) === null || _errors$toDate2 === void 0 ? void 0 : _errors$toDate2.type) === "isValidDate" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_INVALID`)))));
};

const renderSingleViewAndDownloadButton = (t, documents) => {
  if (!(documents !== null && documents !== void 0 && documents.length)) return null;
  const {
    fileStoreId,
    fileName
  } = documents === null || documents === void 0 ? void 0 : documents[0];
  return /*#__PURE__*/React$1.createElement("div", {
    className: "display-flex-gap-2"
  }, fileStoreId && fileStoreId.length ? /*#__PURE__*/React$1.createElement("span", {
    className: "link",
    onClick: () => openUploadedDocument(fileStoreId, fileName)
  }, " ", t("CE_DOCUMENT_VIEW_LINK"), " ") : null, fileStoreId && fileStoreId.length ? /*#__PURE__*/React$1.createElement("span", {
    className: "link",
    onClick: () => downloadDocument(fileStoreId)
  }, " ", t("CE_DOCUMENT_DOWNLOAD_LINK"), " ") : null);
};
const renderMultipleViewAndDownloadButtons = (t, documents) => {
  if (!documents.length) return null;
  return /*#__PURE__*/React$1.createElement("div", {
    className: "broadcastnotifications_actionswrapper-multi"
  }, documents.map(({
    fileName,
    fileStoreId
  }, index) => {
    return /*#__PURE__*/React$1.createElement("div", {
      className: "display-flex-gap-2"
    }, fileName.length ? /*#__PURE__*/React$1.createElement("p", null, fileName, " : ") : null, fileStoreId.length ? /*#__PURE__*/React$1.createElement("span", {
      className: "link",
      onClick: () => openUploadedDocument(fileStoreId, fileName)
    }, " ", t("CE_DOCUMENT_VIEW_LINK"), " ") : null, fileStoreId.length ? /*#__PURE__*/React$1.createElement("span", {
      className: "link",
      onClick: () => downloadDocument(fileStoreId)
    }, " ", t("CE_DOCUMENT_DOWNLOAD_LINK"), " ") : null);
  }));
};
const BroadcastWhatsNewCard = ({
  header,
  actions,
  eventNotificationText,
  timePastAfterEventCreation,
  timeApproxiamationInUnits,
  ...props
}) => {
  const {
    t
  } = useTranslation();
  const uploadedDocuments = props.eventDetails.documents;
  const getTransformedLocale = label => {
    if (typeof label === "number") return label;
    return label && label.toUpperCase().replace(/[.:-\s\/]/g, "_");
  };
  return /*#__PURE__*/React$1.createElement("div", {
    className: "WhatsNewCard"
  }, /*#__PURE__*/React$1.createElement("h2", null, t(header)), /*#__PURE__*/React$1.createElement("p", null, eventNotificationText), actions === null || actions === void 0 ? void 0 : actions.map(i => /*#__PURE__*/React$1.createElement("a", {
    href: i === null || i === void 0 ? void 0 : i.actionUrl
  }, `${t(`CS_COMMON_${getTransformedLocale(i === null || i === void 0 ? void 0 : i.code)}`)}`)), (uploadedDocuments === null || uploadedDocuments === void 0 ? void 0 : uploadedDocuments.length) > 1 ? renderMultipleViewAndDownloadButtons(t, uploadedDocuments) : renderSingleViewAndDownloadButton(t, uploadedDocuments), /*#__PURE__*/React$1.createElement("p", null, timePastAfterEventCreation + ` ${t(timeApproxiamationInUnits)}`));
};

const NotificationsAndWhatsNew = ({
  variant,
  parentRoute
}) => {
  var _Digit$UserService, _Digit$UserService$ge;
  const {
    t
  } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const tenantId = Digit.ULBService.getCitizenCurrentTenant();
  const {
    data: {
      unreadCount: preVisitUnseenNotificationCount
    } = {},
    isSuccess: preVisitUnseenNotificationCountLoaded,
    refetch
  } = Digit.Hooks.useNotificationCount({
    tenantId,
    config: {
      enabled: !!((_Digit$UserService = Digit.UserService) !== null && _Digit$UserService !== void 0 && (_Digit$UserService$ge = _Digit$UserService.getUser()) !== null && _Digit$UserService$ge !== void 0 && _Digit$UserService$ge.access_token)
    }
  });
  const {
    mutate,
    isSuccess
  } = Digit.Hooks.useClearNotifications();
  useEffect(() => {
    isSuccess ? refetch() : false;
  }, [isSuccess]);
  useEffect(() => preVisitUnseenNotificationCount && tenantId ? mutate({
    tenantId
  }) : null, [tenantId, preVisitUnseenNotificationCount]);
  const {
    data: EventsData,
    isLoading: EventsDataLoading
  } = Digit.Hooks.useEvents({
    tenantId,
    variant
  });
  if (EventsDataLoading) return /*#__PURE__*/React$1.createElement(Loader, null);
  if ((EventsData === null || EventsData === void 0 ? void 0 : EventsData.length) === 0) {
    return /*#__PURE__*/React$1.createElement("div", {
      className: "CitizenEngagementNotificationWrapper"
    }, /*#__PURE__*/React$1.createElement(Header, null, `${t("CS_HEADER_NOTIFICATIONS")}`), /*#__PURE__*/React$1.createElement("h1", null, "Nothing to show"));
  }
  const VariantWiseRender = () => {
    switch (variant) {
      case "notifications":
        return /*#__PURE__*/React$1.createElement(Header, null, `${t("CS_HEADER_NOTIFICATIONS")} ${preVisitUnseenNotificationCount ? `(${preVisitUnseenNotificationCount})` : ""}`);
      case "whats-new":
        return /*#__PURE__*/React$1.createElement(Header, null, t("CS_HEADER_WHATSNEW"));
      default:
        return /*#__PURE__*/React$1.createElement(Redirect$1, {
          to: {
            pathname: `/digit-ui/citizen`,
            state: {
              from: location.pathname + location.search
            }
          }
        });
    }
  };
  function onEventCardClick(id) {
    history.push(parentRoute + "/events/details/" + id);
  }
  return /*#__PURE__*/React$1.createElement("div", {
    className: "CitizenEngagementNotificationWrapper"
  }, /*#__PURE__*/React$1.createElement(VariantWiseRender, null), EventsData !== null && EventsData !== void 0 && EventsData.length ? EventsData.map(DataParamsInEvent => (DataParamsInEvent === null || DataParamsInEvent === void 0 ? void 0 : DataParamsInEvent.eventType) === "EVENTSONGROUND" ? /*#__PURE__*/React$1.createElement(OnGroundEventCard, Object.assign({
    onClick: onEventCardClick
  }, DataParamsInEvent)) : (DataParamsInEvent === null || DataParamsInEvent === void 0 ? void 0 : DataParamsInEvent.eventType) === "BROADCAST" ? /*#__PURE__*/React$1.createElement(BroadcastWhatsNewCard, DataParamsInEvent) : /*#__PURE__*/React$1.createElement(WhatsNewCard, DataParamsInEvent)) : /*#__PURE__*/React$1.createElement(Card, null, /*#__PURE__*/React$1.createElement(CardCaption, null, t("COMMON_INBOX_NO_DATA"))));
};

const EventsListOnGround = ({
  variant,
  parentRoute
}) => {
  var _Digit$UserService, _Digit$UserService$ge, _Digit$UserService2, _Digit$UserService2$g;
  const {
    t
  } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const tenantId = Digit.ULBService.getCitizenCurrentTenant();
  const {
    data: {
      unreadCount: preVisitUnseenEventsCount
    } = {},
    isSuccess: preVisitUnseenEventsCountLoaded
  } = Digit.Hooks.useNotificationCount({
    tenantId,
    config: {
      enabled: !!((_Digit$UserService = Digit.UserService) !== null && _Digit$UserService !== void 0 && (_Digit$UserService$ge = _Digit$UserService.getUser()) !== null && _Digit$UserService$ge !== void 0 && _Digit$UserService$ge.access_token)
    }
  });
  const {
    data: EventsData,
    isLoading: EventsDataLoading
  } = Digit.Hooks.useEvents({
    tenantId,
    variant
  });
  if (!((_Digit$UserService2 = Digit.UserService) !== null && _Digit$UserService2 !== void 0 && (_Digit$UserService2$g = _Digit$UserService2.getUser()) !== null && _Digit$UserService2$g !== void 0 && _Digit$UserService2$g.access_token)) {
    localStorage.clear();
    sessionStorage.clear();
    return /*#__PURE__*/React$1.createElement(Redirect$1, {
      to: {
        pathname: `/digit-ui/citizen/login`,
        state: {
          from: location.pathname + location.search
        }
      }
    });
  }
  if (EventsDataLoading || !preVisitUnseenEventsCountLoaded) return /*#__PURE__*/React$1.createElement(Loader, null);
  function onEventCardClick(id) {
    history.push(parentRoute + "/events/details/" + id);
  }
  return /*#__PURE__*/React$1.createElement("div", {
    className: "CitizenEngagementNotificationWrapper"
  }, /*#__PURE__*/React$1.createElement(Header, null, `${t("EVENTS_EVENTS_HEADER")}(${EventsData === null || EventsData === void 0 ? void 0 : EventsData.length})`), EventsData.length ? EventsData.map(DataParamsInEvent => /*#__PURE__*/React$1.createElement(OnGroundEventCard, Object.assign({
    onClick: onEventCardClick
  }, DataParamsInEvent))) : /*#__PURE__*/React$1.createElement(Card, null, /*#__PURE__*/React$1.createElement(CardCaption, null, t("COMMON_INBOX_NO_DATA"))));
};

const Heading$7 = props => {
  return /*#__PURE__*/React$1.createElement("h1", {
    className: "heading-m"
  }, props.label);
};
const Close$8 = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React$1.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$8 = props => {
  return /*#__PURE__*/React$1.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React$1.createElement(Close$8, null));
};
const EventDetails = () => {
  const {
    id
  } = useParams();
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [displayMenu, setDisplayMenu] = useState(false);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const {
    isLoading,
    data
  } = Digit.Hooks.events.useEventDetails(tenantId, {
    ids: id
  });
  const [mutationHappened, setMutationHappened, clear] = Digit.Hooks.useSessionStorage("EMPLOYEE_EVENT_MUTATION_HAPPENED", false);
  const [errorInfo, setErrorInfo, clearError] = Digit.Hooks.useSessionStorage("EMPLOYEE_EVENT_ERROR_DATA", false);
  const [successData, setsuccessData, clearSuccessData] = Digit.Hooks.useSessionStorage("EMPLOYEE_EVENT_MUTATION_SUCCESS_DATA", false);
  useEffect(() => {
    setMutationHappened(false);
    clearSuccessData();
    clearError();
  }, []);
  function onActionSelect(action) {
    if (action === "EDIT") {
      history.push(`/digit-ui/employee/engagement/event/edit-event/${id}`);
    }
    if (action === "DELETE") {
      setShowModal(true);
    }
    setDisplayMenu(false);
  }
  const handleDelete = () => {
    const details = {
      events: [{
        ...(data === null || data === void 0 ? void 0 : data.applicationData),
        status: "CANCELLED"
      }]
    };
    history.push("/digit-ui/employee/engagement/event/response?delete=true", details);
  };
  return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(Header, null, t("ES_TITLE_APPLICATION_DETAILS")), /*#__PURE__*/React$1.createElement(ApplicationDetails, {
    applicationData: data === null || data === void 0 ? void 0 : data.applicationData,
    applicationDetails: data,
    isLoading: isLoading,
    isDataLoading: isLoading
  }), /*#__PURE__*/React$1.createElement(ActionBar, null, displayMenu ? /*#__PURE__*/React$1.createElement(Menu, {
    localeKeyPrefix: "ES_EVENT",
    options: ['EDIT', 'DELETE'],
    t: t,
    onSelect: onActionSelect
  }) : null, /*#__PURE__*/React$1.createElement(SubmitBar, {
    label: t("ES_COMMON_TAKE_ACTION"),
    onSubmit: () => setDisplayMenu(!displayMenu)
  })), showModal && /*#__PURE__*/React$1.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React$1.createElement(Heading$7, {
      label: t('ES_EVENT_DELETE_POPUP_HEADER')
    }),
    headerBarEnd: /*#__PURE__*/React$1.createElement(CloseBtn$8, {
      onClick: () => setShowModal(false)
    }),
    actionCancelLabel: t("CS_COMMON_CANCEL"),
    actionCancelOnSubmit: () => setShowModal(false),
    actionSaveLabel: t('ES_EVENT_DELETE'),
    actionSaveOnSubmit: handleDelete
  }, /*#__PURE__*/React$1.createElement(Card, {
    style: {
      boxShadow: "none"
    }
  }, /*#__PURE__*/React$1.createElement(CardText, null, t(`ES_EVENT_DELETE_TEXT`)))));
};

const Searchbar = ({
  searchValue,
  onChange,
  handleKeyPress,
  handleSearch,
  t
}) => {
  return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(TextInput, {
    className: "searchInput",
    placeholder: t("CE_SERACH_DOCUMENTS"),
    value: searchValue,
    onChange: ev => onChange(ev.target.value),
    signature: true,
    signatureImg: /*#__PURE__*/React$1.createElement(SearchIconSvg, {
      className: "signature-img",
      onClick: () => handleSearch()
    }),
    onKeyPress: handleKeyPress
  }));
};

const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
};

const DocumentCard = ({
  documentTitle,
  documentSize: _documentSize = 2.3,
  lastModifiedData,
  description,
  filestoreId,
  documentLink,
  t
}) => {
  let isMobile = window.Digit.Utils.browser.isMobile();
  return /*#__PURE__*/React$1.createElement("div", {
    className: "notice_and_circular_main"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "notice_and_circular_image"
  }, /*#__PURE__*/React$1.createElement(GenericFileIcon, {
    height: `${isMobile ? 66 : 100}`,
    width: `${isMobile ? 53 : 100}`
  })), /*#__PURE__*/React$1.createElement("div", {
    className: "notice_and_circular_content"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "notice_and_circular_heading_mb"
  }, /*#__PURE__*/React$1.createElement(CardHeader, null, documentTitle), _documentSize ? /*#__PURE__*/React$1.createElement(CardCaption, null, getFileSize(_documentSize)) : null), /*#__PURE__*/React$1.createElement("div", {
    className: "notice_and_circular_caption"
  }, /*#__PURE__*/React$1.createElement(CardCaption, null, `${t(`CE_DCOUMENT_UPLOADED_ON`)} ${lastModifiedData ? format(new Date(lastModifiedData), "do MMMM yyyy") : "-"}`)), /*#__PURE__*/React$1.createElement("div", {
    className: "notice_and_circular_text"
  }, /*#__PURE__*/React$1.createElement(CardText, null, description !== null && description !== void 0 && description.length ? description : "NA")), /*#__PURE__*/React$1.createElement("div", {
    className: "view_download_main"
  }, filestoreId && filestoreId.length ? /*#__PURE__*/React$1.createElement(LinkButton, {
    label: /*#__PURE__*/React$1.createElement("div", {
      className: "views",
      onClick: () => openUploadedDocument(filestoreId ? filestoreId : null, documentTitle)
    }, /*#__PURE__*/React$1.createElement(ViewsIcon, null), /*#__PURE__*/React$1.createElement("p", null, t(`CE_DOCUMENT_VIEW_LINK`)))
  }) : null, documentLink && documentLink.length ? /*#__PURE__*/React$1.createElement(LinkButton, {
    label: /*#__PURE__*/React$1.createElement("div", {
      className: "views",
      onClick: () => openDocumentLink(documentLink, documentTitle)
    }, /*#__PURE__*/React$1.createElement(ExternalLinkIcon, null), /*#__PURE__*/React$1.createElement("p", null, t(`CE_DOCUMENT_OPEN_LINK`)))
  }) : null, filestoreId && filestoreId.length ? /*#__PURE__*/React$1.createElement(LinkButton, {
    label: /*#__PURE__*/React$1.createElement("div", {
      className: "views download_views_padding"
    }, /*#__PURE__*/React$1.createElement(DownloadImgIcon, null), /*#__PURE__*/React$1.createElement("p", null, t(`CE_DOCUMENT_DOWNLOAD_LINK`))),
    onClick: () => downloadDocument(filestoreId ? filestoreId : null)
  }) : null)));
};

const DocumentList = ({
  match
}) => {
  const {
    t
  } = useTranslation();
  const {
    category,
    count
  } = match.params;
  const tenantIds = Digit.ULBService.getCitizenCurrentTenant();
  const [pageSize, setPageSize] = useState(20);
  const [pageOffset, setPageOffset] = useState(0);
  const [searchValue, setSearchValue] = useState();
  const debouncedSearchQuery = useDebounce(searchValue, 700);
  const {
    data: filteredDocs,
    isLoading: isLoadingDocs
  } = Digit.Hooks.engagement.useDocSearch({
    name: debouncedSearchQuery,
    category,
    tenantIds,
    limit: pageSize
  }, {
    select: data => {
      var _data$Documents;
      return data === null || data === void 0 ? void 0 : (_data$Documents = data.Documents) === null || _data$Documents === void 0 ? void 0 : _data$Documents.map(({
        uuid,
        name,
        category,
        documentLink,
        description,
        auditDetails,
        fileSize,
        filestoreId
      }) => ({
        docId: uuid,
        name,
        category,
        description,
        documentLink,
        createdTime: auditDetails === null || auditDetails === void 0 ? void 0 : auditDetails.createdTime,
        fileSize,
        filestoreId
      }));
    }
  });
  const handleKeyPress = async event => {
    if (event.key === "Enter") {
      if (searchValue.length) {
        setSearchValue("");
      }
    }
  };
  const handleSearch = async event => {
    if (searchValue.length) {
      setSearchValue("");
    }
  };
  return /*#__PURE__*/React$1.createElement(AppContainer, null, /*#__PURE__*/React$1.createElement(Header, null, `${t(`${category}`)} (${count ? count : "-"})`), /*#__PURE__*/React$1.createElement("div", {
    className: "documentContainerPadding"
  }, /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(Searchbar, {
    searchValue: searchValue,
    handleKeyPress: handleKeyPress,
    handleSearch: handleSearch,
    onChange: setSearchValue,
    t: t
  })), isLoadingDocs ? /*#__PURE__*/React$1.createElement(Loader, null) : filteredDocs && filteredDocs.length ? renderDocsList(filteredDocs, t) : /*#__PURE__*/React$1.createElement(Card, null, /*#__PURE__*/React$1.createElement(CardCaption, null, t("COMMON_INBOX_NO_DATA")))));
};
const renderDocsList = (documents, t) => documents.map(({
  name,
  createdTime,
  description,
  documentLink,
  fileSize,
  filestoreId
}, index) => /*#__PURE__*/React$1.createElement(DocumentCard, {
  key: index,
  documentTitle: name,
  documentSize: fileSize,
  lastModifiedData: createdTime,
  description: description,
  documentLink: documentLink,
  filestoreId: filestoreId,
  t: t
}));

const Accordion = ({
  t,
  title,
  count,
  onClick,
  children
}) => {
  const [isOpen, setOpen] = React$1.useState(false);
  return /*#__PURE__*/React$1.createElement("div", {
    className: "accordion-wrapper",
    onClick: () => onClick(title, count)
  }, /*#__PURE__*/React$1.createElement("div", {
    className: `accordion-title ${isOpen ? "open" : ""}`,
    onClick: () => setOpen(!isOpen)
  }, `${t(title)} (${count})`, /*#__PURE__*/React$1.createElement(PrevIcon, null)), /*#__PURE__*/React$1.createElement("div", {
    className: `accordion-item ${!isOpen ? "collapsed" : ""}`
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "accordion-content"
  }, children)));
};
const DocumentCategories = ({
  t,
  parentRoute
}) => {
  var _Digit$UserService, _Digit$UserService$ge, _data$documentList, _data$statusCount, _data$statusCount2;
  const history = useHistory();
  const [searchValue, setSearchValue] = useState("");
  const tenantIds = Digit.ULBService.getCitizenCurrentTenant();
  const debouncedSearchQuery = useDebounce(searchValue, 700);
  const {
    data,
    isLoading
  } = Digit.Hooks.engagement.useDocSearch({
    name: debouncedSearchQuery,
    tenantIds
  }, {
    select: data => {
      var _data$Documents;
      const mappedDocuments = data === null || data === void 0 ? void 0 : (_data$Documents = data.Documents) === null || _data$Documents === void 0 ? void 0 : _data$Documents.map(({
        uuid,
        name,
        category,
        documentLink,
        description,
        auditDetails,
        fileSize,
        filestoreId
      }) => ({
        docId: uuid,
        name,
        category,
        description,
        documentLink,
        createdTime: auditDetails === null || auditDetails === void 0 ? void 0 : auditDetails.createdTime,
        fileSize,
        filestoreId
      }));
      return {
        documentList: mappedDocuments,
        statusCount: data === null || data === void 0 ? void 0 : data.statusCount
      };
    }
  });
  if (!((_Digit$UserService = Digit.UserService) !== null && _Digit$UserService !== void 0 && (_Digit$UserService$ge = _Digit$UserService.getUser()) !== null && _Digit$UserService$ge !== void 0 && _Digit$UserService$ge.access_token)) {
    return /*#__PURE__*/React$1.createElement(Redirect, {
      to: {
        pathname: `/digit-ui/citizen/login`,
        state: {
          from: location.pathname + location.search
        }
      }
    });
  }
  const showDocuments = (category, count) => {
    history.push(`documents/list/${category}/${count}`);
  };
  const handleKeyPress = event => {
    if (event.key === "Enter") {
      setSearchValue("");
    }
  };
  const handleSearch = event => {
    setSearchValue("");
  };
  return /*#__PURE__*/React$1.createElement(AppContainer, null, /*#__PURE__*/React$1.createElement(Header, null, t("DOCUMENTS_DOCUMENT_HEADER")), /*#__PURE__*/React$1.createElement("div", {
    className: "Docs_CardWrapper"
  }, /*#__PURE__*/React$1.createElement(Searchbar, {
    searchValue: searchValue,
    handleKeyPress: handleKeyPress,
    handleSearch: handleSearch,
    onChange: setSearchValue,
    t: t
  }), /*#__PURE__*/React$1.createElement("hr", {
    style: {
      color: "#ccc"
    }
  }), isLoading ? /*#__PURE__*/React$1.createElement(Loader, null) : /*#__PURE__*/React$1.createElement("div", {
    className: "wrapper"
  }, searchValue.length && data !== null && data !== void 0 && (_data$documentList = data.documentList) !== null && _data$documentList !== void 0 && _data$documentList.length ? renderDocsList(data.documentList, t) : data !== null && data !== void 0 && data.statusCount && data !== null && data !== void 0 && (_data$statusCount = data.statusCount) !== null && _data$statusCount !== void 0 && _data$statusCount.length ? data === null || data === void 0 ? void 0 : (_data$statusCount2 = data.statusCount) === null || _data$statusCount2 === void 0 ? void 0 : _data$statusCount2.map(({
    category,
    count
  }, index) => {
    return /*#__PURE__*/React$1.createElement(Accordion, {
      t: t,
      title: category,
      count: count,
      key: index,
      onClick: showDocuments
    });
  }) : /*#__PURE__*/React$1.createElement(Card, null, /*#__PURE__*/React$1.createElement(CardCaption, null, t("COMMON_INBOX_NO_DATA"))))));
};

const ViewDocument = ({
  match
}) => {
  const {
    t
  } = useTranslation();
  const {
    applicationNumber: uuid,
    tenantId
  } = Digit.Hooks.useQueryParams();
  const {
    data,
    isLoading
  } = Digit.Hooks.engagement.useDocSearch({
    uuid,
    tenantId
  }, {
    select: data => {
      var _data$Documents;
      const mappedDocuments = data === null || data === void 0 ? void 0 : (_data$Documents = data.Documents) === null || _data$Documents === void 0 ? void 0 : _data$Documents.map(({
        uuid,
        name,
        category,
        documentLink,
        description,
        auditDetails,
        fileSize,
        filestoreId
      }) => ({
        docId: uuid,
        name,
        category,
        description,
        documentLink,
        createdTime: auditDetails === null || auditDetails === void 0 ? void 0 : auditDetails.createdTime,
        fileSize,
        filestoreId
      }));
      return {
        documentList: mappedDocuments,
        statusCount: data === null || data === void 0 ? void 0 : data.statusCount
      };
    }
  });
  const {
    documentList = []
  } = data || {};
  const {
    name = false,
    createdTime,
    description,
    documentLink,
    fileSize,
    filestoreId
  } = (documentList === null || documentList === void 0 ? void 0 : documentList[0]) || {};
  return /*#__PURE__*/React$1.createElement(AppContainer, null, /*#__PURE__*/React$1.createElement(Header, null, `${t(`COMMON_VIEW_DOC`)}`), isLoading && /*#__PURE__*/React$1.createElement(Loader, null), name && /*#__PURE__*/React$1.createElement(DocumentCard, {
    key: 1,
    documentTitle: name,
    documentSize: fileSize,
    lastModifiedData: createdTime,
    description: description,
    documentLink: documentLink,
    filestoreId: filestoreId,
    t: t
  }), !name && !isLoading && /*#__PURE__*/React$1.createElement(Card, null, /*#__PURE__*/React$1.createElement(CardCaption, null, t("COMMON_DOC_DATA_NOT_FOUND"))));
};

const getMessage = mutation => {
  var _mutation$data, _mutation$data$Survey, _mutation$data$Survey2;
  if (mutation.isSuccess) return (_mutation$data = mutation.data) === null || _mutation$data === void 0 ? void 0 : (_mutation$data$Survey = _mutation$data.Surveys) === null || _mutation$data$Survey === void 0 ? void 0 : (_mutation$data$Survey2 = _mutation$data$Survey[0]) === null || _mutation$data$Survey2 === void 0 ? void 0 : _mutation$data$Survey2.uuid;
  return "";
};
const BannerPicker$2 = props => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement(Banner, {
    message: props.mutation.isSuccess ? t(`SURVEY_RESPONSE_SUBMITED`) : t("SURVEY_RESPONSE_FAILED"),
    applicationNumber: getMessage(props.mutation),
    info: props.mutation.isSuccess ? props.surveyTitle : "",
    successful: props.mutation.isSuccess,
    whichSvg: "tick"
  });
};
const Acknowledgement = props => {
  var _state$AnswerEntity;
  const queryClient = useQueryClient();
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const mutation = Digit.Hooks.survey.useSubmitResponse();
  const {
    state
  } = props.location;
  const surveyTitlev1 = state === null || state === void 0 ? void 0 : (_state$AnswerEntity = state.AnswerEntity) === null || _state$AnswerEntity === void 0 ? void 0 : _state$AnswerEntity.surveyTitle;
  useEffect(() => {
    const onSuccess = () => {
      queryClient.clear();
    };
    mutation.mutate(state, {
      onSuccess
    });
  }, []);
  if (mutation.isLoading && !mutation.isIdle) {
    return /*#__PURE__*/React$1.createElement(Loader, null);
  }
  return /*#__PURE__*/React$1.createElement(Card, null, /*#__PURE__*/React$1.createElement(BannerPicker$2, {
    t: t,
    mutation: mutation,
    surveyTitle: surveyTitlev1
  }), /*#__PURE__*/React$1.createElement(CardText, null, mutation.isSuccess ? t("SURVEY_FORM_RESPONSE_MESSAGE") : null), /*#__PURE__*/React$1.createElement(ActionBar, null, /*#__PURE__*/React$1.createElement(Link, {
    to: "/digit-ui/citizen/engagement/surveys/list"
  }, /*#__PURE__*/React$1.createElement(SubmitBar, {
    label: t("CORE_COMMON_GO_TO_HOME")
  }))));
};

const CitizenApp = ({
  path,
  url,
  userType,
  tenants
}) => {
  const location = useLocation();
  const {
    t
  } = useTranslation();
  const NotificationsOrWhatsNew = Digit.ComponentRegistryService.getComponent("NotificationsAndWhatsNew");
  const Events = Digit.ComponentRegistryService.getComponent("EventsListOnGround");
  const EventDetails = Digit.ComponentRegistryService.getComponent("EventDetails");
  const Documents = Digit.ComponentRegistryService.getComponent("DocumentList");
  const SurveyList = Digit.ComponentRegistryService.getComponent("SurveyList");
  const FillSurvey = Digit.ComponentRegistryService.getComponent('FillSurvey');
  const ShowSurvey = Digit.ComponentRegistryService.getComponent('ShowSurvey');
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(BackButton, null, t("CS_COMMON_BACK")), /*#__PURE__*/React$1.createElement(Switch, null, /*#__PURE__*/React$1.createElement(Route, {
    path: `${path}/notifications`,
    component: () => /*#__PURE__*/React$1.createElement(NotificationsOrWhatsNew, {
      variant: "notifications",
      parentRoute: path
    })
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/whats-new`,
    component: () => /*#__PURE__*/React$1.createElement(NotificationsOrWhatsNew, {
      variant: "whats-new",
      parentRoute: path
    })
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    exact: true,
    path: `${path}/events`,
    component: () => /*#__PURE__*/React$1.createElement(Events, {
      variant: "events",
      parentRoute: path
    })
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/events/details/:id`,
    component: () => /*#__PURE__*/React$1.createElement(EventDetails, {
      parentRoute: path
    })
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/docs`,
    component: () => /*#__PURE__*/React$1.createElement(DocumentCategories, Object.assign({
      t: t
    }, {
      path
    }))
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/documents/viewDocument`,
    component: () => /*#__PURE__*/React$1.createElement(ViewDocument, Object.assign({
      t: t
    }, {
      path
    }))
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/documents/list/:category/:count`,
    component: props => /*#__PURE__*/React$1.createElement(Documents, props)
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/surveys/list`,
    component: props => /*#__PURE__*/React$1.createElement(SurveyList, props)
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/surveys/fill-survey`,
    component: props => /*#__PURE__*/React$1.createElement(FillSurvey, props)
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/surveys/submit-response`,
    component: props => /*#__PURE__*/React$1.createElement(Acknowledgement, props)
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/surveys/show-survey`,
    component: props => /*#__PURE__*/React$1.createElement(ShowSurvey, props)
  })));
};

const EventDetails$1 = () => {
  var _Digit$UserService, _Digit$UserService$ge, _FilteredEventForThis, _FilteredEventForThis2, _FilteredEventForThis3, _FilteredEventForThis4, _FilteredEventForThis5;
  const {
    t
  } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const {
    id: EventId
  } = useParams();
  const tenantId = Digit.ULBService.getCitizenCurrentTenant();
  const {
    data: EventsData,
    isLoading: EventsDataLoading
  } = Digit.Hooks.useEvents({
    tenantId,
    variant: "events"
  });
  if (!((_Digit$UserService = Digit.UserService) !== null && _Digit$UserService !== void 0 && (_Digit$UserService$ge = _Digit$UserService.getUser()) !== null && _Digit$UserService$ge !== void 0 && _Digit$UserService$ge.access_token)) {
    localStorage.clear();
    sessionStorage.clear();
    return /*#__PURE__*/React$1.createElement(Redirect$1, {
      to: {
        pathname: `/digit-ui/citizen/login`,
        state: {
          from: location.pathname + location.search
        }
      }
    });
  }
  function onGroundEventCardPropsForEventDetails(DataParamsInEvent) {
    const {
      eventCategory,
      name,
      onGroundEventDate,
      onGroundEventMonth,
      onGroundEventTimeRange
    } = DataParamsInEvent;
    return {
      eventCategory: t(eventCategory),
      showEventCatergory: true,
      name,
      onGroundEventDate,
      onGroundEventMonth,
      onGroundEventTimeRange
    };
  }
  const FilteredEventForThisPage = useMemo(() => !EventsDataLoading ? EventsData === null || EventsData === void 0 ? void 0 : EventsData.filter(i => i.id === EventId)[0] : null, [EventsDataLoading, EventsData]);
  if (EventsDataLoading) return /*#__PURE__*/React$1.createElement(Loader, null);
  return /*#__PURE__*/React$1.createElement("div", {
    className: "CitizenEngagementNotificationWrapper"
  }, /*#__PURE__*/React$1.createElement(Header, null, t("ES_TITLE_APPLICATION_DETAILS")), /*#__PURE__*/React$1.createElement(OnGroundEventCard, onGroundEventCardPropsForEventDetails(FilteredEventForThisPage)), /*#__PURE__*/React$1.createElement("div", {
    className: "OnGroundEventDetailsCard"
  }, /*#__PURE__*/React$1.createElement("p", {
    className: "cardCaptionBodyS"
  }, FilteredEventForThisPage === null || FilteredEventForThisPage === void 0 ? void 0 : FilteredEventForThisPage.description), /*#__PURE__*/React$1.createElement("div", {
    className: "eventAddressAndDirection"
  }, /*#__PURE__*/React$1.createElement("span", null, /*#__PURE__*/React$1.createElement(MapMarker, null), /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement("p", null, FilteredEventForThisPage === null || FilteredEventForThisPage === void 0 ? void 0 : (_FilteredEventForThis = FilteredEventForThisPage.eventDetails) === null || _FilteredEventForThis === void 0 ? void 0 : _FilteredEventForThis.address), FilteredEventForThisPage !== null && FilteredEventForThisPage !== void 0 && (_FilteredEventForThis2 = FilteredEventForThisPage.eventDetails) !== null && _FilteredEventForThis2 !== void 0 && _FilteredEventForThis2.latitude && FilteredEventForThisPage !== null && FilteredEventForThisPage !== void 0 && (_FilteredEventForThis3 = FilteredEventForThisPage.eventDetails) !== null && _FilteredEventForThis3 !== void 0 && _FilteredEventForThis3.longitude ? /*#__PURE__*/React$1.createElement("a", {
    className: "direction",
    target: "_blank",
    href: `https://www.google.com/maps/search/?api=1&query=${FilteredEventForThisPage === null || FilteredEventForThisPage === void 0 ? void 0 : (_FilteredEventForThis4 = FilteredEventForThisPage.eventDetails) === null || _FilteredEventForThis4 === void 0 ? void 0 : _FilteredEventForThis4.latitude}%2C${FilteredEventForThisPage === null || FilteredEventForThisPage === void 0 ? void 0 : (_FilteredEventForThis5 = FilteredEventForThisPage.eventDetails) === null || _FilteredEventForThis5 === void 0 ? void 0 : _FilteredEventForThis5.longitude}`
  }, t("CS_COMMON_GET_DIRECTIONS")) : null))), /*#__PURE__*/React$1.createElement("div", {
    className: "eventTimeRange"
  }, /*#__PURE__*/React$1.createElement(Clock, null), /*#__PURE__*/React$1.createElement("p", null, FilteredEventForThisPage === null || FilteredEventForThisPage === void 0 ? void 0 : FilteredEventForThisPage.onGroundEventTimeRange))));
};

const documentsFormConfig = [{
  body: [{
    type: "form",
    key: "ULB",
    component: "EngagementDocSelectULB",
    withoutLabel: true
  }, {
    type: "form",
    key: "documentName",
    component: "EnagementDocName",
    withoutLabel: true
  }, {
    type: "form",
    key: "docCategory",
    component: "EngagementDocCategory",
    withoutLabel: true
  }, {
    type: "form",
    key: "description",
    component: "EngagementDocDescription",
    withoutLabel: true
  }, {
    type: "form",
    key: "document",
    component: "EngagementDocUploadDocument",
    withoutLabel: true,
    inputs: [{
      name: ""
    }]
  }]
}];

const Documents$1 = () => {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [canSubmit, setSubmitValve] = useState(false);
  const onFormValueChange = (setValue, formData, formState) => {
    var _formData$ULB;
    if (formData !== null && formData !== void 0 && formData.documentName && formData !== null && formData !== void 0 && formData.docCategory && (formData !== null && formData !== void 0 && formData.document.filestoreId || formData !== null && formData !== void 0 && formData.document.documentLink) && formData !== null && formData !== void 0 && (_formData$ULB = formData.ULB) !== null && _formData$ULB !== void 0 && _formData$ULB.length) {
      setSubmitValve(true);
    } else {
      setSubmitValve(false);
    }
  };
  const onSubmit = data => {
    var _data$docCategory, _data$document, _data$document2, _data$document2$files, _data$document3, _data$document3$files, _data$document4, _data$document4$files;
    const DocumentEntity = {
      name: data.documentName,
      description: data !== null && data !== void 0 && data.description.length ? data.description : "",
      category: (_data$docCategory = data.docCategory) === null || _data$docCategory === void 0 ? void 0 : _data$docCategory.name,
      documentLink: (_data$document = data.document) === null || _data$document === void 0 ? void 0 : _data$document.documentLink,
      filestoreId: (_data$document2 = data.document) === null || _data$document2 === void 0 ? void 0 : (_data$document2$files = _data$document2.filestoreId) === null || _data$document2$files === void 0 ? void 0 : _data$document2$files.fileStoreId,
      fileSize: (_data$document3 = data.document) === null || _data$document3 === void 0 ? void 0 : (_data$document3$files = _data$document3.filestoreId) === null || _data$document3$files === void 0 ? void 0 : _data$document3$files.fileSize,
      fileType: (_data$document4 = data.document) === null || _data$document4 === void 0 ? void 0 : (_data$document4$files = _data$document4.filestoreId) === null || _data$document4$files === void 0 ? void 0 : _data$document4$files.fileType,
      tenantIds: data.ULB.map(e => e.code)
    };
    history.push("/digit-ui/employee/engagement/documents/response", {
      DocumentEntity
    });
  };
  return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(Header, null, t("ES_ENGAGEMENT_DOCUMENTS")), /*#__PURE__*/React$1.createElement(FormComposer, {
    label: t("ES_COMMON_APPLICATION_SUBMIT"),
    config: documentsFormConfig,
    onSubmit: onSubmit,
    fieldStyle: {},
    onFormValueChange: onFormValueChange,
    isDisabled: !canSubmit
  }));
};

const documentsFormConfig$1 = [{
  body: [{
    type: "form",
    key: "ULB",
    component: "EngagementULBDropdown",
    withoutLabel: true
  }, {
    type: "form",
    key: "documentName",
    component: "EnagementDocName",
    withoutLabel: true
  }, {
    type: "form",
    key: "docCategory",
    component: "EngagementDocCategory",
    withoutLabel: true
  }, {
    type: "form",
    key: "description",
    component: "EngagementDocDescription",
    withoutLabel: true
  }, {
    type: "form",
    key: "document",
    component: "EngagementDocUploadDocument",
    withoutLabel: true,
    inputs: [{
      name: ""
    }]
  }]
}];

const Documents$2 = props => {
  var _props$location$state6;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [canSubmit, setSubmitValve] = useState(false);
  const onFormValueChange = useCallback((setValue, updatedFormData, formState) => {
    if (updatedFormData !== null && updatedFormData !== void 0 && updatedFormData.documentName && updatedFormData !== null && updatedFormData !== void 0 && updatedFormData.docCategory && (updatedFormData !== null && updatedFormData !== void 0 && updatedFormData.document.filestoreId || updatedFormData !== null && updatedFormData !== void 0 && updatedFormData.document.documentLink) && updatedFormData !== null && updatedFormData !== void 0 && updatedFormData.ULB && Object.keys(updatedFormData === null || updatedFormData === void 0 ? void 0 : updatedFormData.ULB).length) {
      setSubmitValve(true);
    } else {
      setSubmitValve(false);
    }
  }, []);
  const update = data => {
    var _data$document, _data$document$filest, _data$document2, _data$document2$files, _props$location$state, _props$location$state2, _data$document3, _data$document3$files, _data$document4, _data$document4$files, _props$location$state3, _props$location$state4, _props$location, _props$location$state5, _data$docCategory, _data$document5, _data$document5$files, _data$document6, _data$ULB;
    const fileSize = (_data$document = data.document) !== null && _data$document !== void 0 && (_data$document$filest = _data$document.filestoreId) !== null && _data$document$filest !== void 0 && _data$document$filest.fileSize ? (_data$document2 = data.document) === null || _data$document2 === void 0 ? void 0 : (_data$document2$files = _data$document2.filestoreId) === null || _data$document2$files === void 0 ? void 0 : _data$document2$files.fileSize : (_props$location$state = props.location.state) === null || _props$location$state === void 0 ? void 0 : (_props$location$state2 = _props$location$state.DocumentEntity) === null || _props$location$state2 === void 0 ? void 0 : _props$location$state2.fileSize;
    const fileType = (_data$document3 = data.document) !== null && _data$document3 !== void 0 && (_data$document3$files = _data$document3.filestoreId) !== null && _data$document3$files !== void 0 && _data$document3$files.fileType ? (_data$document4 = data.document) === null || _data$document4 === void 0 ? void 0 : (_data$document4$files = _data$document4.filestoreId) === null || _data$document4$files === void 0 ? void 0 : _data$document4$files.fileType : (_props$location$state3 = props.location.state) === null || _props$location$state3 === void 0 ? void 0 : (_props$location$state4 = _props$location$state3.DocumentEntity) === null || _props$location$state4 === void 0 ? void 0 : _props$location$state4.fileType;
    const DocumentEntity = {
      ...((_props$location = props.location) === null || _props$location === void 0 ? void 0 : (_props$location$state5 = _props$location.state) === null || _props$location$state5 === void 0 ? void 0 : _props$location$state5.DocumentEntity),
      name: data.documentName,
      description: data !== null && data !== void 0 && data.description.length ? data.description : "",
      category: (_data$docCategory = data.docCategory) === null || _data$docCategory === void 0 ? void 0 : _data$docCategory.name,
      filestoreId: (_data$document5 = data.document) === null || _data$document5 === void 0 ? void 0 : (_data$document5$files = _data$document5.filestoreId) === null || _data$document5$files === void 0 ? void 0 : _data$document5$files.fileStoreId,
      fileSize,
      fileType,
      documentLink: (_data$document6 = data.document) === null || _data$document6 === void 0 ? void 0 : _data$document6.documentLink,
      tenantId: data === null || data === void 0 ? void 0 : (_data$ULB = data.ULB) === null || _data$ULB === void 0 ? void 0 : _data$ULB.code
    };
    delete DocumentEntity.ULB;
    delete DocumentEntity.docCategory;
    delete DocumentEntity.documentName;
    history.push("/digit-ui/employee/engagement/documents/update-response", {
      DocumentEntity
    });
  };
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(Header, null, t("ES_ENGAGEMENT_EDIT_DOC")), /*#__PURE__*/React$1.createElement(FormComposer, {
    label: t("ES_COMMON_UPDATE"),
    config: documentsFormConfig$1,
    onSubmit: data => {
      update(data);
    },
    fieldStyle: {},
    onFormValueChange: onFormValueChange,
    defaultValues: (_props$location$state6 = props.location.state) === null || _props$location$state6 === void 0 ? void 0 : _props$location$state6.DocumentEntity,
    isDisabled: !canSubmit
  }));
};

const getMessage$1 = mutation => {
  var _mutation$data, _mutation$data$Docume, _mutation$data$Docume2;
  if (mutation.isSuccess) return (_mutation$data = mutation.data) === null || _mutation$data === void 0 ? void 0 : (_mutation$data$Docume = _mutation$data.Documents) === null || _mutation$data$Docume === void 0 ? void 0 : (_mutation$data$Docume2 = _mutation$data$Docume[0]) === null || _mutation$data$Docume2 === void 0 ? void 0 : _mutation$data$Docume2.uuid;
  return "";
};
const BannerPicker$3 = props => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement(Banner, {
    message: props.isSuccess ? t(`ENGAGEMENT_DOC_CREATED`) : t("ENGAGEMENT_DOC_FAILURE"),
    applicationNumber: getMessage$1(props.mutation),
    info: props.isSuccess ? t("ENGAGEMENT_DOCUMENT_ID") : "",
    successful: props.isSuccess
  });
};
const Response$2 = props => {
  const queryClient = useQueryClient();
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const mutation = Digit.Hooks.engagement.useDocCreate();
  const {
    state
  } = props.location;
  useEffect(() => {
    const onSuccess = () => {
      queryClient.clear();
    };
    mutation.mutate(state, {
      onSuccess
    });
  }, []);
  if (mutation.isLoading || mutation.isIdle) {
    return /*#__PURE__*/React$1.createElement(Loader, null);
  }
  return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(Card, null, /*#__PURE__*/React$1.createElement(BannerPicker$3, {
    t: t,
    data: mutation.data,
    mutation: mutation,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isIdle || mutation.isLoading
  })), /*#__PURE__*/React$1.createElement(ActionBar, null, /*#__PURE__*/React$1.createElement(Link, {
    to: "/digit-ui/employee"
  }, /*#__PURE__*/React$1.createElement(SubmitBar, {
    label: t("CORE_COMMON_GO_TO_HOME")
  }))));
};

const getMessage$2 = mutation => {
  var _mutation$data, _mutation$data$Docume, _mutation$data$Docume2;
  if (mutation.isSuccess) return (_mutation$data = mutation.data) === null || _mutation$data === void 0 ? void 0 : (_mutation$data$Docume = _mutation$data.Documents) === null || _mutation$data$Docume === void 0 ? void 0 : (_mutation$data$Docume2 = _mutation$data$Docume[0]) === null || _mutation$data$Docume2 === void 0 ? void 0 : _mutation$data$Docume2.uuid;
  return "";
};
const BannerPicker$4 = props => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement(Banner, {
    message: props.isSuccess ? t(`ENGAGEMENT_DOC_UPDATED`) : t("ENGAGEMENT_DOC_UPDATE_FAILURE"),
    applicationNumber: getMessage$2(props.mutation),
    info: props.isSuccess ? t("ENGAGEMENT_DOCUMENT_ID") : "",
    successful: props.isSuccess
  });
};
const Response$3 = props => {
  const queryClient = useQueryClient();
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const mutation = Digit.Hooks.engagement.useDocUpdate();
  const {
    state
  } = props.location;
  useEffect(() => {
    const onSuccess = () => {
      queryClient.clear();
    };
    mutation.mutate(state, {
      onSuccess
    });
  }, []);
  if (mutation.isLoading || mutation.isIdle) {
    return /*#__PURE__*/React$1.createElement(Loader, null);
  }
  return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(Card, null, /*#__PURE__*/React$1.createElement(BannerPicker$4, {
    t: t,
    data: mutation.data,
    mutation: mutation,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isIdle || mutation.isLoading
  })), /*#__PURE__*/React$1.createElement(ActionBar, null, /*#__PURE__*/React$1.createElement(Link, {
    to: "/digit-ui/employee"
  }, /*#__PURE__*/React$1.createElement(SubmitBar, {
    label: t("CORE_COMMON_GO_TO_HOME")
  }))));
};

const BannerPicker$5 = props => {
  var _props$mutation;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement(Banner, {
    message: props.isSuccess ? t(`ENGAGEMENT_DOC_DELETED`) : t("ENGAGEMENT_DOC_DELETE_FAILURE"),
    applicationNumber: (_props$mutation = props.mutation) !== null && _props$mutation !== void 0 && _props$mutation.isSuccess ? props.uuid : '',
    info: props.isSuccess ? t("ENGAGEMENT_DOCUMENT_ID") : "",
    successful: props.isSuccess
  });
};
const Response$4 = props => {
  var _state$DocumentEntity;
  const queryClient = useQueryClient();
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const mutation = Digit.Hooks.engagement.useDocDelete();
  const {
    state
  } = props.location;
  useEffect(() => {
    const onSuccess = () => {
      queryClient.clear();
    };
    mutation.mutate(state, {
      onSuccess
    });
  }, []);
  if (mutation.isLoading || mutation.isIdle) {
    return /*#__PURE__*/React$1.createElement(Loader, null);
  }
  return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(Card, null, /*#__PURE__*/React$1.createElement(BannerPicker$5, {
    t: t,
    data: mutation.data,
    mutation: mutation,
    uuid: state === null || state === void 0 ? void 0 : (_state$DocumentEntity = state.DocumentEntity) === null || _state$DocumentEntity === void 0 ? void 0 : _state$DocumentEntity.uuid,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isIdle || mutation.isLoading
  })), /*#__PURE__*/React$1.createElement(ActionBar, null, /*#__PURE__*/React$1.createElement(Link, {
    to: "/digit-ui/employee"
  }, /*#__PURE__*/React$1.createElement(SubmitBar, {
    label: t("CORE_COMMON_GO_TO_HOME")
  }))));
};

const DocumentNotificationTable = ({
  t,
  data,
  columns,
  globalSearch,
  onSearch,
  getCellProps,
  pageSizeLimit,
  totalRecords,
  currentPage,
  onNextPage,
  onPrevPage,
  onPageSizeChange,
  onSort,
  sortParams
}) => {
  return /*#__PURE__*/React$1.createElement(Table, {
    t: t,
    data: data,
    columns: columns,
    onSearch: onSearch,
    globalSearch: globalSearch,
    manualGlobalFilter: true,
    manualPagination: true,
    currentPage: currentPage,
    onNextPage: onNextPage,
    onPrevPage: onPrevPage,
    pageSizeLimit: pageSizeLimit,
    onPageSizeChange: onPageSizeChange,
    getCellProps: getCellProps,
    totalRecords: totalRecords,
    onSort: onSort,
    sortParams: sortParams
  });
};

const Search$2 = ({
  onSearch,
  searchParams,
  searchFields,
  type,
  onClose,
  isInboxPage,
  t
}) => {
  const {
    register,
    handleSubmit,
    formState,
    reset,
    watch,
    control
  } = useForm({
    defaultValues: searchParams
  });
  const mobileView = innerWidth <= 640;
  const ulbs = Digit.SessionStorage.get("ENGAGEMENT_TENANTS");
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const userInfo = Digit.UserService.getUser().info;
  const userUlbs = ulbs.filter(ulb => {
    var _userInfo$roles;
    return userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$roles = userInfo.roles) === null || _userInfo$roles === void 0 ? void 0 : _userInfo$roles.some(role => (role === null || role === void 0 ? void 0 : role.tenantId) === (ulb === null || ulb === void 0 ? void 0 : ulb.code));
  }).sort(alphabeticalSortFunctionForTenantsBasedOnName);
  const selectedTenat = useMemo(() => {
    const filtered = ulbs.filter(item => item.code === tenantId);
    return filtered;
  }, [tenantId, ulbs]);
  const getFields = input => {
    switch (input.type) {
      case "ulb":
        return /*#__PURE__*/React$1.createElement(Controller, {
          rules: {
            required: true
          },
          defaultValue: selectedTenat === null || selectedTenat === void 0 ? void 0 : selectedTenat[0],
          render: props => /*#__PURE__*/React$1.createElement(Dropdown, {
            option: userUlbs,
            optionKey: "i18nKey",
            selected: props.value,
            select: props.onChange,
            t: t
          }),
          name: input.name,
          control: control
        });
      default:
        return /*#__PURE__*/React$1.createElement(Controller, {
          render: props => /*#__PURE__*/React$1.createElement(TextInput, {
            onChange: props.onChange,
            value: props.value
          }),
          name: input.name,
          control: control,
          defaultValue: null
        });
    }
  };
  const onSubmitInput = data => {
    onSearch(data);
    if (type === "mobile") {
      onClose();
    }
  };
  const clearSearch = () => {
    reset({
      name: '',
      ulbs: {
        code: tenantId.code
      },
      postedBy: ""
    });
    onSearch({
      name: '',
      ulbs: {
        code: tenantId.code
      },
      postedBy: ""
    });
  };
  const clearAll = mobileView => {
    const mobileViewStyles = mobileView ? {
      margin: 0
    } : {};
    return /*#__PURE__*/React$1.createElement(LinkLabel, {
      style: {
        display: "inline",
        ...mobileViewStyles
      },
      onClick: clearSearch
    }, t("ES_COMMON_CLEAR_SEARCH"));
  };
  return /*#__PURE__*/React$1.createElement("form", {
    onSubmit: handleSubmit(onSubmitInput)
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "search-container",
    style: {
      width: "auto",
      marginLeft: isInboxPage ? "24px" : "revert"
    }
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "search-complaint-container"
  }, (type === "mobile" || mobileView) && /*#__PURE__*/React$1.createElement("div", {
    className: "complaint-header"
  }, /*#__PURE__*/React$1.createElement("h2", null, t("ES_COMMON_SEARCH_BY")), /*#__PURE__*/React$1.createElement("span", {
    onClick: onClose
  }, /*#__PURE__*/React$1.createElement(CloseSvg, null))), /*#__PURE__*/React$1.createElement("div", {
    className: "complaint-input-container for-pt " + (!isInboxPage ? "for-search" : ""),
    style: {
      width: "100%"
    }
  }, searchFields === null || searchFields === void 0 ? void 0 : searchFields.map((input, index) => {
    var _formState$dirtyField, _formState$errors, _formState$errors$inp;
    return /*#__PURE__*/React$1.createElement("div", {
      key: input.name,
      className: "input-fields"
    }, /*#__PURE__*/React$1.createElement("span", {
      className: "mobile-input"
    }, /*#__PURE__*/React$1.createElement(Label, null, t(input.label) + ` ${input.isMendatory ? "*" : ""}`), getFields(input)), formState !== null && formState !== void 0 && (_formState$dirtyField = formState.dirtyFields) !== null && _formState$dirtyField !== void 0 && _formState$dirtyField[input.name] ? /*#__PURE__*/React$1.createElement("span", {
      style: {
        fontWeight: "700",
        color: "rgba(212, 53, 28)",
        paddingLeft: "8px",
        marginTop: "-20px",
        fontSize: "12px"
      },
      className: "inbox-search-form-error"
    }, formState === null || formState === void 0 ? void 0 : (_formState$errors = formState.errors) === null || _formState$errors === void 0 ? void 0 : (_formState$errors$inp = _formState$errors[input.name]) === null || _formState$errors$inp === void 0 ? void 0 : _formState$errors$inp.message) : null);
  }), type === "desktop" && !mobileView && /*#__PURE__*/React$1.createElement("div", {
    style: {
      maxWidth: "unset",
      marginLeft: "unset"
    },
    className: "search-submit-wrapper"
  }, /*#__PURE__*/React$1.createElement(SubmitBar, {
    className: "submit-bar-search",
    label: t("ES_COMMON_SEARCH"),
    submit: true
  })), type === "desktop" && !mobileView && /*#__PURE__*/React$1.createElement("div", {
    className: "document-clear-all"
  }, clearAll())))), (type === "mobile" || mobileView) && /*#__PURE__*/React$1.createElement(ActionBar, {
    className: "clear-search-container"
  }, /*#__PURE__*/React$1.createElement("button", {
    className: "clear-search",
    style: {
      flex: 1
    }
  }, clearAll(mobileView)), /*#__PURE__*/React$1.createElement(SubmitBar, {
    disabled: !!Object.keys(formState.errors).length,
    label: t("ES_COMMON_SEARCH"),
    style: {
      flex: 1
    },
    submit: true
  })));
};

const Filter$2 = ({
  type: _type = "desktop",
  onClose,
  onSearch,
  onFilterChange,
  searchParams
}) => {
  const {
    t
  } = useTranslation();
  const [localSearchParams, setLocalSearchParams] = useState(() => ({
    ...searchParams
  }));
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = tenantId === null || tenantId === void 0 ? void 0 : tenantId.split('.')[0];
  const currrentUlb = Digit.ULBService.getCurrentUlb();
  const {
    data: categoryData,
    isLoading
  } = Digit.Hooks.engagement.useMDMS(stateId, "DocumentUploader", ["UlbLevelCategories"], {
    select: d => {
      var _d$DocumentUploader, _d$DocumentUploader$U, _d$DocumentUploader$U2;
      const data = d === null || d === void 0 ? void 0 : (_d$DocumentUploader = d.DocumentUploader) === null || _d$DocumentUploader === void 0 ? void 0 : (_d$DocumentUploader$U = _d$DocumentUploader.UlbLevelCategories) === null || _d$DocumentUploader$U === void 0 ? void 0 : (_d$DocumentUploader$U2 = _d$DocumentUploader$U.filter) === null || _d$DocumentUploader$U2 === void 0 ? void 0 : _d$DocumentUploader$U2.call(_d$DocumentUploader$U, e => e.ulb === currrentUlb.code);
      return data[0].categoryList.map(category => ({
        category
      }));
    }
  });
  const clearAll = () => {
    setLocalSearchParams({
      category: null,
      name: null,
      postedBy: null
    });
    onFilterChange({
      category: null,
      name: null,
      postedBy: null
    });
    onClose === null || onClose === void 0 ? void 0 : onClose();
  };
  const applyLocalFilters = () => {
    onFilterChange(localSearchParams);
    onClose === null || onClose === void 0 ? void 0 : onClose();
  };
  const handleChange = data => {
    setLocalSearchParams({
      ...localSearchParams,
      ...data
    });
  };
  if (isLoading) {
    return /*#__PURE__*/React$1.createElement(Loader, null);
  }
  return /*#__PURE__*/React$1.createElement("div", {
    className: "filter"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "filter-card"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "heading"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "filter-label"
  }, t("ES_COMMON_FILTER_BY"), ":"), /*#__PURE__*/React$1.createElement("div", {
    className: "clearAll",
    onClick: clearAll
  }, t("ES_COMMON_CLEAR_ALL")), _type === "desktop" && /*#__PURE__*/React$1.createElement("span", {
    className: "clear-search",
    onClick: clearAll
  }, /*#__PURE__*/React$1.createElement(RefreshIcon, null)), _type === "mobile" && /*#__PURE__*/React$1.createElement("span", {
    onClick: onClose
  }, /*#__PURE__*/React$1.createElement(CloseSvg, null))), /*#__PURE__*/React$1.createElement("div", {
    className: "filter-label"
  }, `${t('DOCUMENTS_CATEGORY_CARD_LABEL')}`), /*#__PURE__*/React$1.createElement(Dropdown, {
    option: categoryData,
    optionKey: "category",
    selected: localSearchParams,
    select: value => {
      handleChange(value);
    },
    t: t
  }), /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(SubmitBar, {
    style: {
      width: '100%'
    },
    onSubmit: () => applyLocalFilters(),
    label: t("ES_COMMON_APPLY")
  }))));
};

const getDocumentDetailsPath = document => {
  return {
    pathname: `inbox/details/${document.name}`,
    state: {
      details: document
    }
  };
};
const GetCell$2 = value => /*#__PURE__*/React$1.createElement("span", {
  className: "cell-text styled-cell"
}, value);
const getDocumentDetails = (value = "", link, t) => /*#__PURE__*/React$1.createElement("span", {
  className: "document-table-docs-columns"
}, /*#__PURE__*/React$1.createElement(Link, {
  className: "link",
  to: link
}, value.length ? value : t('CE_DOCUMENT_TITLE')));
const getDocumentCell = (name = "mSeva", link, docLink, t) => /*#__PURE__*/React$1.createElement("span", {
  className: "document-table-docs-columns"
}, link !== null && link !== void 0 && link.length ? /*#__PURE__*/React$1.createElement("span", {
  className: "link",
  onClick: () => openUploadedDocument(link, name)
}, " ", t('CE_DOCUMENT_VIEW_LINK'), " ") : null, docLink.length ? /*#__PURE__*/React$1.createElement("span", {
  className: "link",
  onClick: () => openDocumentLink(docLink, name)
}, " ", t('CE_DOCUMENT_OPEN_LINK'), " ") : null);
const DocumentDesktopInbox = ({
  isLoading,
  data,
  t,
  onSearch,
  title,
  iconName,
  links,
  onSort,
  sortParams,
  globalSearch,
  searchFields,
  searchParams,
  onFilterChange,
  pageSizeLimit,
  totalRecords,
  currentPage,
  onNextPage,
  onPrevPage,
  onPageSizeChange
}) => {
  const columns = React$1.useMemo(() => [{
    Header: t('CE_TABLE_DOCUMENT_NAME'),
    accessor: row => getDocumentDetails(row === null || row === void 0 ? void 0 : row.name, getDocumentDetailsPath(row), t)
  }, {
    Header: t('DOCUMENTS_CATEGORY_CARD_LABEL'),
    accessor: row => GetCell$2(row !== null && row !== void 0 && row.category ? t(`${row === null || row === void 0 ? void 0 : row.category}`) : "")
  }, {
    Header: t('CE_TABLE_DOCUMENT_LINK'),
    accessor: row => getDocumentCell(row === null || row === void 0 ? void 0 : row.name, row.filestoreId, row.documentLink || "", t)
  }, {
    Header: t('CE_TABLE_DOCUMENT_POSTED_BY'),
    accessor: row => GetCell$2(row.postedBy)
  }], []);
  let result;
  if (isLoading) {
    result = /*#__PURE__*/React$1.createElement(Loader, null);
  } else if (!data || (data === null || data === void 0 ? void 0 : data.length) === 0) {
    result = /*#__PURE__*/React$1.createElement(Card, {
      style: {
        marginTop: 20,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }, t("CE_DOCUMENTS_NOT_FOUND"), /*#__PURE__*/React$1.createElement("br", null), /*#__PURE__*/React$1.createElement(Link, {
      className: "link",
      to: `/digit-ui/employee/engagement/documents/inbox/new-doc`
    }, t('NEW_DOCUMENT_TEXT')));
  } else if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
    result = /*#__PURE__*/React$1.createElement(DocumentNotificationTable, {
      t: t,
      data: data,
      columns: columns,
      onSort: onSort,
      sortParams: sortParams,
      globalSearch: globalSearch,
      onSearch: searchParams,
      pageSizeLimit: pageSizeLimit,
      totalRecords: totalRecords,
      currentPage: currentPage,
      onNextPage: onNextPage,
      onPrevPage: onPrevPage,
      onPageSizeChange: onPageSizeChange,
      getCellProps: cellInfo => {
        return {
          style: {
            minWidth: cellInfo.column.Header === t("CE_TABLE_DOCUMENT_NAME") ? "240px" : "",
            padding: "20px 18px",
            fontSize: "16px"
          }
        };
      }
    });
  }
  return /*#__PURE__*/React$1.createElement("div", {
    className: "inbox-container"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "filters-container"
  }, /*#__PURE__*/React$1.createElement(EventLink, {
    title: title,
    icon: iconName,
    links: links
  }), /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(Filter$2, {
    onFilterChange: onFilterChange,
    searchParams: searchParams
  }))), /*#__PURE__*/React$1.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React$1.createElement(Search$2, {
    t: t,
    onSearch: onSearch,
    type: "desktop",
    searchFields: searchFields,
    isInboxPage: true,
    searchParams: searchParams
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "result",
    style: {
      marginLeft: "24px",
      flex: 1
    }
  }, result)));
};

const ApplicationCard$2 = ({
  searchFields,
  searchParams,
  onFilterChange,
  onSearch,
  t,
  data,
  responseData
}) => {
  const [type, setType] = useState("");
  const [popup, setPopup] = useState(false);
  const [params, setParams] = useState(searchParams);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const history = useHistory();
  useEffect(() => {
    if (type) setPopup(true);
  }, [type]);
  const handlePopupClose = () => {
    setPopup(false);
    setParams(searchParams);
  };
  const redirectToDetailsPage = data => {
    const details = responseData === null || responseData === void 0 ? void 0 : responseData.find(item => areEqual(item.postedBy, data["Posted By"]) && areEqual(item.name, data["Document Name"]));
    if (details) {
      history.push(`/digit-ui/employee/engagement/documents/inbox/details/${details === null || details === void 0 ? void 0 : details.name}`, {
        details
      });
    }
  };
  let result;
  if ((data === null || data === void 0 ? void 0 : data.length) === 0) {
    result = /*#__PURE__*/React$1.createElement(Card, {
      style: {
        marginTop: 20,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }, t("CE_DOCUMENTS_NOT_FOUND"), /*#__PURE__*/React$1.createElement("br", null), /*#__PURE__*/React$1.createElement(Link, {
      className: "link",
      to: `/digit-ui/employee/engagement/documents/inbox/new-doc`
    }, t('NEW_DOCUMENT_TEXT')));
  } else if (data && (data === null || data === void 0 ? void 0 : data.length) > 0) {
    result = /*#__PURE__*/React$1.createElement(DetailsCard, {
      data: data,
      handleSelect: () => {},
      handleDetailCardClick: redirectToDetailsPage
    });
  }
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement("div", {
    className: "searchBox"
  }, onSearch && /*#__PURE__*/React$1.createElement(SearchAction, {
    text: "SEARCH",
    handleActionClick: () => {
      setType("SEARCH");
      setPopup(true);
    }
  }), /*#__PURE__*/React$1.createElement(FilterAction, {
    text: "FILTER",
    handleActionClick: () => {
      setType("FILTER");
      setPopup(true);
    }
  })), result, popup && /*#__PURE__*/React$1.createElement(PopUp, null, type === "FILTER" && /*#__PURE__*/React$1.createElement("div", {
    className: "popup-module"
  }, /*#__PURE__*/React$1.createElement(Filter$2, {
    onFilterChange: onFilterChange,
    onClose: handlePopupClose,
    onSearch: onSearch,
    type: "mobile",
    searchParams: params
  })), type === "SEARCH" && /*#__PURE__*/React$1.createElement("div", {
    className: "popup-module"
  }, /*#__PURE__*/React$1.createElement(Search$2, {
    t: t,
    type: "mobile",
    onClose: handlePopupClose,
    onSearch: onSearch,
    searchParams: searchParams,
    searchFields: searchFields
  }))));
};

const MobileInbox$2 = ({
  data,
  t,
  title,
  iconName,
  links,
  searchFields,
  searchParams,
  onFilterChange,
  onSearch,
  isLoading
}) => {
  const getData = () => {
    return data === null || data === void 0 ? void 0 : data.filter(document => {
      var _searchParams$tenantI, _searchParams$tenantI2, _document$name, _searchParams$name, _document$postedBy, _document$postedBy$tr, _searchParams$postedB, _searchParams$postedB2;
      return ((searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$tenantI = searchParams.tenantIds) === null || _searchParams$tenantI === void 0 ? void 0 : _searchParams$tenantI.length) > 0 ? searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$tenantI2 = searchParams.tenantIds) === null || _searchParams$tenantI2 === void 0 ? void 0 : _searchParams$tenantI2.includes(document.tenantId) : true) && (searchParams !== null && searchParams !== void 0 && searchParams.name ? (_document$name = document.name) === null || _document$name === void 0 ? void 0 : _document$name.toUpperCase().startsWith(searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$name = searchParams.name) === null || _searchParams$name === void 0 ? void 0 : _searchParams$name.toUpperCase()) : true) && (searchParams !== null && searchParams !== void 0 && searchParams.postedBy ? ((_document$postedBy = document.postedBy) === null || _document$postedBy === void 0 ? void 0 : (_document$postedBy$tr = _document$postedBy.trim()) === null || _document$postedBy$tr === void 0 ? void 0 : _document$postedBy$tr.toLowerCase()) === (searchParams === null || searchParams === void 0 ? void 0 : (_searchParams$postedB = searchParams.postedBy) === null || _searchParams$postedB === void 0 ? void 0 : (_searchParams$postedB2 = _searchParams$postedB.trim()) === null || _searchParams$postedB2 === void 0 ? void 0 : _searchParams$postedB2.toLowerCase()) : true) && (searchParams !== null && searchParams !== void 0 && searchParams.category ? document.category === (searchParams === null || searchParams === void 0 ? void 0 : searchParams.category) : true);
    }).map(document => {
      return {
        [t("CE_TABLE_DOCUMENT_NAME")]: document === null || document === void 0 ? void 0 : document.name,
        [t("DOCUMENTS_CATEGORY_CARD_LABEL")]: t(`${document === null || document === void 0 ? void 0 : document.category}`),
        [t("CE_TABLE_DOCUMENT_LINK")]: /*#__PURE__*/React$1.createElement("div", {
          className: "mobileInbox_attachments"
        }, document !== null && document !== void 0 && document.filestoreId ? /*#__PURE__*/React$1.createElement("div", {
          className: "link",
          onClick: ev => {
            openUploadedDocument(document.filestoreId, document.name);
          }
        }, t('CE_DOCUMENT_VIEW_LINK')) : null, document !== null && document !== void 0 && document.documentLink ? /*#__PURE__*/React$1.createElement("div", {
          className: "link",
          onClick: ev => {
            openDocumentLink(document.documentLink, document.name);
          }
        }, t('CE_DOCUMENT_OPEN_LINK')) : null),
        [t("CE_TABLE_DOCUMENT_POSTED_BY")]: document === null || document === void 0 ? void 0 : document.postedBy
      };
    });
  };
  return /*#__PURE__*/React$1.createElement("div", {
    style: {
      padding: 0
    }
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "inbox-container"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "filters-container"
  }, /*#__PURE__*/React$1.createElement(EventLink, {
    title: title,
    icon: iconName,
    links: links
  }), /*#__PURE__*/React$1.createElement(ApplicationCard$2, {
    t: t,
    data: getData(),
    onFilterChange: onFilterChange,
    isLoading: isLoading,
    onSearch: onSearch,
    searchParams: searchParams,
    searchFields: searchFields,
    responseData: data
  }))));
};

const Inbox$2 = ({
  tenants
}) => {
  const {
    t
  } = useTranslation();
  Digit.SessionStorage.set("ENGAGEMENT_TENANTS", tenants);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [searchParams, setSearchParams] = useState({
    tenantIds: tenantId,
    offset: 0,
    limit: 10
  });
  let isMobile = window.Digit.Utils.browser.isMobile();
  const {
    data: response,
    isLoading
  } = Digit.Hooks.engagement.useDocSearch(searchParams, {
    select: ({
      Documents,
      totalCount
    }) => ({
      documentsList: Documents,
      totalCount
    })
  });
  const onSearch = params => {
    var _params$ulbs, _params$ulbs$code, _params$ulbs2;
    const tenantIds = params !== null && params !== void 0 && (_params$ulbs = params.ulbs) !== null && _params$ulbs !== void 0 && (_params$ulbs$code = _params$ulbs.code) !== null && _params$ulbs$code !== void 0 && _params$ulbs$code.length ? params === null || params === void 0 ? void 0 : (_params$ulbs2 = params.ulbs) === null || _params$ulbs2 === void 0 ? void 0 : _params$ulbs2.code : tenantId;
    const {
      name,
      postedBy
    } = params;
    setSearchParams(prevSearchParams => ({
      ...prevSearchParams,
      name,
      postedBy,
      tenantIds
    }));
  };
  const handleFilterChange = data => {
    setSearchParams(prevSearchParams => ({
      ...prevSearchParams,
      ...data
    }));
  };
  const fetchNextPage = useCallback(() => {
    setSearchParams(prevSearchParams => ({
      ...prevSearchParams,
      offset: parseInt(prevSearchParams === null || prevSearchParams === void 0 ? void 0 : prevSearchParams.offset) + parseInt(prevSearchParams === null || prevSearchParams === void 0 ? void 0 : prevSearchParams.limit)
    }));
  }, []);
  const fetchPrevPage = () => {
    setSearchParams(prevSearchParams => ({
      ...prevSearchParams,
      offset: parseInt(prevSearchParams === null || prevSearchParams === void 0 ? void 0 : prevSearchParams.offset) - parseInt(prevSearchParams === null || prevSearchParams === void 0 ? void 0 : prevSearchParams.limit)
    }));
  };
  const handlePageSizeChange = e => {
    setSearchParams(prevSearchParams => ({
      ...prevSearchParams,
      limit: e.target.value
    }));
  };
  useEffect(() => {
    setSearchParams(prevSearchParams => ({
      ...prevSearchParams,
      tenantIds: tenantId
    }));
  }, [tenantId]);
  const getSearchFields = () => {
    return [{
      label: t('LABEL_FOR_ULB'),
      name: "ulbs",
      type: "ulb"
    }, {
      label: t('DOCUMENTS_DOCUMENT_HEADER'),
      name: "name"
    }, {
      label: t('CE_TABLE_DOCUMENT_POSTED_BY'),
      name: "postedBy"
    }];
  };
  const links = [{
    text: t('NEW_DOCUMENT_TEXT'),
    link: "/digit-ui/employee/engagement/documents/inbox/new-doc"
  }];
  if (isMobile) {
    return /*#__PURE__*/React$1.createElement(MobileInbox$2, {
      data: response === null || response === void 0 ? void 0 : response.documentsList,
      searchParams: searchParams,
      searchFields: getSearchFields(),
      t: t,
      onFilterChange: handleFilterChange,
      onSearch: onSearch,
      isLoading: isLoading,
      title: "DOCUMENTS_DOCUMENT_HEADER",
      iconName: "document",
      links: links
    });
  }
  return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(Header, null, t("DOCUMENTS_DOCUMENT_HEADER"), Number(response === null || response === void 0 ? void 0 : response.totalCount) ? /*#__PURE__*/React$1.createElement("p", {
    className: "inbox-count"
  }, Number(response === null || response === void 0 ? void 0 : response.totalCount)) : null), /*#__PURE__*/React$1.createElement(DocumentDesktopInbox, {
    t: t,
    isLoading: isLoading,
    data: response === null || response === void 0 ? void 0 : response.documentsList,
    links: links,
    searchParams: searchParams,
    onSearch: onSearch,
    searchFields: getSearchFields(),
    onFilterChange: handleFilterChange,
    pageSizeLimit: searchParams === null || searchParams === void 0 ? void 0 : searchParams.limit,
    totalRecords: response === null || response === void 0 ? void 0 : response.totalCount,
    title: "DOCUMENTS_DOCUMENT_HEADER",
    iconName: "document",
    links: links,
    currentPage: parseInt(searchParams.offset / searchParams.limit),
    onNextPage: fetchNextPage,
    onPrevPage: fetchPrevPage,
    onPageSizeChange: handlePageSizeChange
  }));
};

const SurveyListCard = ({
  header,
  about,
  activeTime,
  postedAt,
  responseStatus,
  hasResponded,
  onCardClick
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement("div", {
    className: "WhatsNewCard",
    onClick: onCardClick
  }, /*#__PURE__*/React$1.createElement("h2", null, header), /*#__PURE__*/React$1.createElement("p", null, about), /*#__PURE__*/React$1.createElement("div", {
    className: "surveyListclockDiv"
  }, /*#__PURE__*/React$1.createElement(Clock, null), " ", /*#__PURE__*/React$1.createElement("span", null, `Active till ${format(new Date(activeTime), "do MMM HH:mm")}`)), /*#__PURE__*/React$1.createElement("div", {
    className: "surveyListstatus"
  }, /*#__PURE__*/React$1.createElement("p", null, formatDistanceToNow(new Date(postedAt), {
    addSuffix: true
  })), /*#__PURE__*/React$1.createElement("span", {
    className: hasResponded ? 'surveyLisResponded' : 'surveyLisNotResponded'
  }, t(responseStatus))));
};

const isActive = (startDate, endDate) => {
  const currentDate = new Date().getTime();
  if (startDate < currentDate && currentDate <= endDate) {
    return true;
  }
  return false;
};
const SurveyList = () => {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const tenantIds = Digit.ULBService.getCitizenCurrentTenant();
  const {
    data,
    isLoading: isLoadingSurveys
  } = Digit.Hooks.survey.useSearch({
    tenantIds
  }, {
    select: ({
      Surveys
    }) => {
      const allSurveys = Surveys.map(survey => {
        const isSurveyActive = isActive(survey.startDate, survey.endDate);
        let resStatus = "";
        if (isSurveyActive && survey.hasResponded) resStatus = "CS_SURVEY_RESPONDED";else if (isSurveyActive) resStatus = "CS_SURVEY_YT_TO_RESPOND";else resStatus = "CANNOT_RESPOND_MSG";
        return {
          hasResponded: false,
          responseStatus: resStatus,
          ...survey
        };
      });
      const activeSurveysList = [];
      const inactiveSurveysList = [];
      for (let survey of allSurveys) {
        if (survey.status === "ACTIVE" && isActive(survey.startDate, survey.endDate)) {
          activeSurveysList.push(survey);
        } else {
          inactiveSurveysList.push(survey);
        }
      }
      return {
        activeSurveysList,
        inactiveSurveysList
      };
    }
  });
  const handleCardClick = details => {
    if (!details.hasResponded) {
      history.push("/digit-ui/citizen/engagement/surveys/fill-survey", details);
    } else {
      history.push("/digit-ui/citizen/engagement/surveys/show-survey", details);
    }
  };
  if (isLoadingSurveys) {
    return /*#__PURE__*/React$1.createElement(Loader, null);
  }
  return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(Header, null, `${t("CS_COMMON_SURVEYS")} (${data === null || data === void 0 ? void 0 : data.activeSurveysList.length})`), data !== null && data !== void 0 && data.activeSurveysList && data.activeSurveysList.length ? data.activeSurveysList.map((data, index) => {
    return /*#__PURE__*/React$1.createElement("div", {
      className: "surveyListCardMargin"
    }, /*#__PURE__*/React$1.createElement(SurveyListCard, {
      header: data.title,
      about: data.description,
      activeTime: data.endDate,
      postedAt: data.auditDetails.createdTime,
      responseStatus: data.responseStatus,
      hasResponsed: data.status,
      key: index,
      onCardClick: () => handleCardClick(data)
    }));
  }) : /*#__PURE__*/React$1.createElement("div", {
    className: "centered-message"
  }, /*#__PURE__*/React$1.createElement("p", null, t("CS_NO_ACTIVE_SURVEYS"))), /*#__PURE__*/React$1.createElement(Header, null, `${t("CS_COMMON_INACTIVE_SURVEYS")} (${data.inactiveSurveysList.length})`), data !== null && data !== void 0 && data.inactiveSurveysList && data.inactiveSurveysList.length ? data.inactiveSurveysList.map((data, index) => {
    return /*#__PURE__*/React$1.createElement("div", {
      className: "surveyListCardMargin"
    }, /*#__PURE__*/React$1.createElement(SurveyListCard, {
      header: data.title,
      about: data.description,
      activeTime: data.endDate,
      postedAt: data.auditDetails.createdTime,
      responseStatus: data.responseStatus,
      hasResponsed: data.status,
      key: index
    }));
  }) : /*#__PURE__*/React$1.createElement("div", {
    className: "centered-message"
  }, /*#__PURE__*/React$1.createElement("p", null, t(`CS_NO_INACTIVE_SURVEYS`))));
};

const Actions$1 = ["EDIT_DOCUMENT", "DELETE"];
const getUlbName$1 = tenantId => {
  var _ulbName$, _ulbName;
  let ulbName = tenantId === null || tenantId === void 0 ? void 0 : tenantId.split(".")[1];
  ulbName = `${(_ulbName$ = ulbName[0]) === null || _ulbName$ === void 0 ? void 0 : _ulbName$.toUpperCase()}${(_ulbName = ulbName) === null || _ulbName === void 0 ? void 0 : _ulbName.slice(1)} `;
  return ulbName;
};
const DocumentDetails$1 = ({
  location,
  match,
  history
}) => {
  var _details$description;
  let isMobile = window.Digit.Utils.browser.isMobile();
  const {
    t
  } = useTranslation();
  const {
    details
  } = location === null || location === void 0 ? void 0 : location.state;
  const [displayMenu, setDisplayMenu] = React$1.useState(false);
  const [showModal, setShowModal] = useState(false);
  const {
    data: ulbArray,
    isLoading: loading
  } = Digit.Hooks.useTenants();
  const currrentUlb = Digit.ULBService.getCurrentUlb();
  const stateId = Digit.ULBService.getStateId();
  const {
    data: categoryOptions,
    isLoading
  } = Digit.Hooks.engagement.useMDMS(stateId, "DocumentUploader", ["UlbLevelCategories"], {
    select: d => {
      var _d$DocumentUploader, _d$DocumentUploader$U, _d$DocumentUploader$U2;
      const data = d === null || d === void 0 ? void 0 : (_d$DocumentUploader = d.DocumentUploader) === null || _d$DocumentUploader === void 0 ? void 0 : (_d$DocumentUploader$U = _d$DocumentUploader.UlbLevelCategories) === null || _d$DocumentUploader$U === void 0 ? void 0 : (_d$DocumentUploader$U2 = _d$DocumentUploader$U.filter) === null || _d$DocumentUploader$U2 === void 0 ? void 0 : _d$DocumentUploader$U2.call(_d$DocumentUploader$U, e => e.ulb === currrentUlb.code);
      return data[0].categoryList.map(name => ({
        name
      }));
    }
  });
  function onActionSelect(action) {
    setDisplayMenu(false);
    if (action !== null && action !== void 0 && action.includes("EDIT")) {
      var _categoryOptions$filt;
      const DocumentEntity = {
        tenantIds: details === null || details === void 0 ? void 0 : details.tenantId,
        documentName: details === null || details === void 0 ? void 0 : details.name,
        docCategory: categoryOptions === null || categoryOptions === void 0 ? void 0 : (_categoryOptions$filt = categoryOptions.filter(item => item.name === (details === null || details === void 0 ? void 0 : details.category))) === null || _categoryOptions$filt === void 0 ? void 0 : _categoryOptions$filt[0],
        document: {
          filestoreId: {
            fileStoreId: details === null || details === void 0 ? void 0 : details.filestoreId
          },
          documentLink: details === null || details === void 0 ? void 0 : details.documentLink
        },
        ULB: {
          code: details === null || details === void 0 ? void 0 : details.tenantId
        },
        ...details
      };
      history.push({
        pathname: `/digit-ui/employee/engagement/documents/inbox/update`,
        state: {
          DocumentEntity
        }
      });
    }
    if (action !== null && action !== void 0 && action.includes("DELETE")) {
      setShowModal(true);
    }
  }
  function onModalSubmit() {
    setShowModal(false);
    const DocumentEntity = {
      ...details
    };
    history.push({
      pathname: `/digit-ui/employee/engagement/documents/delete-response`,
      state: {
        DocumentEntity
      }
    });
  }
  function onModalCancel() {
    setShowModal(false);
  }
  return /*#__PURE__*/React$1.createElement("div", null, showModal ? /*#__PURE__*/React$1.createElement(Confirmation, {
    t: t,
    heading: "CONFIRM_DELETE_DOC",
    docName: details === null || details === void 0 ? void 0 : details.name,
    closeModal: () => setShowModal(!showModal),
    actionCancelLabel: "CS_COMMON_CANCEL",
    actionCancelOnSubmit: onModalCancel,
    actionSaveLabel: "ES_COMMON_Y_DEL",
    actionSaveOnSubmit: onModalSubmit
  }) : null, /*#__PURE__*/React$1.createElement(Header, null, t(`CE_DOCUMENT_DETAILS`)), /*#__PURE__*/React$1.createElement("div", {
    className: "notice_and_circular_main gap-ten"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "documentDetails_wrapper"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "documentDetails_row_items"
  }, /*#__PURE__*/React$1.createElement("p", {
    className: "documentDetails_title"
  }, `${t("ULB")}:`), " ", /*#__PURE__*/React$1.createElement("p", null, getUlbName$1(details === null || details === void 0 ? void 0 : details.tenantId)), " "), /*#__PURE__*/React$1.createElement("div", {
    className: "documentDetails_row_items"
  }, /*#__PURE__*/React$1.createElement("p", {
    className: "documentDetails_title"
  }, `${t("DOCUMENT_NAME")}:`), " ", /*#__PURE__*/React$1.createElement("p", null, details === null || details === void 0 ? void 0 : details.name), " "), /*#__PURE__*/React$1.createElement("div", {
    className: "documentDetails_row_items"
  }, /*#__PURE__*/React$1.createElement("p", {
    className: "documentDetails_title"
  }, `${t("DOCUMENT_CATEGORY")}:`), " ", /*#__PURE__*/React$1.createElement("p", null, t(details === null || details === void 0 ? void 0 : details.category)), " "), /*#__PURE__*/React$1.createElement("div", {
    className: "documentDetails_row_items"
  }, /*#__PURE__*/React$1.createElement("p", {
    className: "documentDetails_title"
  }, `${t("DCOUMENT_DESCRIPTION")}:`), " ", /*#__PURE__*/React$1.createElement("p", {
    className: "documentDetails__description"
  }, details !== null && details !== void 0 && (_details$description = details.description) !== null && _details$description !== void 0 && _details$description.length ? details === null || details === void 0 ? void 0 : details.description : "NA"), " "), details !== null && details !== void 0 && details.filestoreId ? /*#__PURE__*/React$1.createElement("div", {
    className: "documentDetails_pdf"
  }, /*#__PURE__*/React$1.createElement("span", {
    className: "documentDetails_subheader"
  }, `${t("Document")}`), /*#__PURE__*/React$1.createElement("div", {
    style: {
      width: "100px"
    },
    onClick: () => openUploadedDocument(details === null || details === void 0 ? void 0 : details.filestoreId, details === null || details === void 0 ? void 0 : details.name)
  }, /*#__PURE__*/React$1.createElement(GenericFileIcon, null))) : null)), /*#__PURE__*/React$1.createElement(ActionBar, null, displayMenu ? /*#__PURE__*/React$1.createElement(Menu, {
    style: {
      width: isMobile ? "full" : "240px"
    },
    localeKeyPrefix: "ES_CE",
    options: Actions$1,
    t: t,
    onSelect: onActionSelect
  }) : null, /*#__PURE__*/React$1.createElement(SubmitBar, {
    label: t("ES_COMMON_TAKE_ACTION"),
    onSubmit: () => setDisplayMenu(!displayMenu)
  })));
};

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

const FilterFormFieldsComponent = ({
  statuses,
  isInboxLoading,
  registerRef,
  controlFilterForm,
  setFilterFormValue,
  filterFormState,
  getFilterFormValue,
  localitiesForEmployeesCurrentTenant,
  loadingLocalitiesForEmployeesCurrentTenant
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(FilterFormField, null, /*#__PURE__*/React$1.createElement(Controller, {
    name: "status",
    control: controlFilterForm,
    render: ({
      ref,
      onChange,
      value
    }) => {
      return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement("div", {
        className: "filter-label"
      }, t("CS_SURVEY_STATUS")), /*#__PURE__*/React$1.createElement(Dropdown, {
        inputRef: ref,
        option: statuses,
        optionKey: "code",
        t: t,
        select: onChange,
        selected: value
      }));
    }
  })));
};

const SearchFormFieldsComponents = ({
  registerRef,
  controlSearchForm,
  searchFormState
}) => {
  var _searchFormState$erro, _searchFormState$erro2, _searchFormState$erro3, _searchFormState$erro4;
  const {
    t
  } = useTranslation();
  const ulbs = Digit.SessionStorage.get("ENGAGEMENT_TENANTS");
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const userInfo = Digit.SessionStorage.get("citizen.userRequestObject");
  const userUlbs = ulbs.filter(ulb => {
    var _userInfo$info, _userInfo$info$roles;
    return userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : (_userInfo$info$roles = _userInfo$info.roles) === null || _userInfo$info$roles === void 0 ? void 0 : _userInfo$info$roles.some(role => (role === null || role === void 0 ? void 0 : role.tenantId) === (ulb === null || ulb === void 0 ? void 0 : ulb.code));
  }).sort(alphabeticalSortFunctionForTenantsBasedOnName);
  const selectedTenat = useMemo(() => {
    const filtered = ulbs.filter(item => item.code === tenantId);
    return filtered;
  }, [ulbs]);
  return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(SearchField, null, /*#__PURE__*/React$1.createElement("label", null, t("LABEL_FOR_ULB")), /*#__PURE__*/React$1.createElement(Controller, {
    rules: {
      required: true
    },
    defaultValue: selectedTenat === null || selectedTenat === void 0 ? void 0 : selectedTenat[0],
    render: props => /*#__PURE__*/React$1.createElement(Dropdown, {
      option: userUlbs,
      optionKey: "i18nKey",
      selected: props.value,
      select: e => props.onChange(e),
      t: t
    }),
    name: "tenantIds",
    control: controlSearchForm
  })), /*#__PURE__*/React$1.createElement(SearchField, null, /*#__PURE__*/React$1.createElement("label", null, t("CS_SURVEY_NAME")), /*#__PURE__*/React$1.createElement(TextInput, {
    name: "title",
    type: "text",
    inputRef: registerRef({
      maxLength: {
        value: 60,
        message: t("EXCEEDS_60_CHAR_LIMIT")
      }
    })
  }), /*#__PURE__*/React$1.createElement(CardLabelError$1, null, searchFormState === null || searchFormState === void 0 ? void 0 : (_searchFormState$erro = searchFormState.errors) === null || _searchFormState$erro === void 0 ? void 0 : (_searchFormState$erro2 = _searchFormState$erro["title"]) === null || _searchFormState$erro2 === void 0 ? void 0 : _searchFormState$erro2.message)), /*#__PURE__*/React$1.createElement(SearchField, null, /*#__PURE__*/React$1.createElement("label", null, t("EVENTS_POSTEDBY_LABEL")), /*#__PURE__*/React$1.createElement(TextInput, {
    name: "postedBy",
    type: "text",
    inputRef: registerRef({
      maxLength: {
        value: 30,
        message: t("EXCEEDS_30_CHAR_LIMIT")
      }
    })
  }), /*#__PURE__*/React$1.createElement(CardLabelError$1, null, searchFormState === null || searchFormState === void 0 ? void 0 : (_searchFormState$erro3 = searchFormState.errors) === null || _searchFormState$erro3 === void 0 ? void 0 : (_searchFormState$erro4 = _searchFormState$erro3["postedBy"]) === null || _searchFormState$erro4 === void 0 ? void 0 : _searchFormState$erro4.message)));
};

const useInboxTableConfig = ({
  parentRoute,
  onPageSizeChange,
  formState,
  totalCount,
  table,
  dispatch
}) => {
  var _formState$tableForm, _formState$tableForm2, _formState$tableForm7, _formState$searchForm;
  const GetCell = value => /*#__PURE__*/React$1.createElement("span", {
    className: "cell-text styled-cell"
  }, value);
  const GetStatusCell = value => (value === null || value === void 0 ? void 0 : value.toLowerCase()) === "active" ? /*#__PURE__*/React$1.createElement("span", {
    className: "sla-cell-success"
  }, value) : /*#__PURE__*/React$1.createElement("span", {
    className: "sla-cell-error"
  }, value);
  const {
    t
  } = useTranslation();
  const tableColumnConfig = useMemo(() => {
    return [{
      Header: t("CS_SURVEY_TITLE"),
      accessor: "uuid",
      Cell: ({
        row
      }) => {
        return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(Link, {
          to: `${parentRoute}/surveys/inbox/details/${row.original["uuid"]}`
        }, /*#__PURE__*/React$1.createElement("span", {
          className: "link"
        }, row.original["title"])));
      }
    }, {
      Header: t("EVENTS_START_DATE_LABEL"),
      accessor: "startDate",
      Cell: ({
        row
      }) => {
        var _row$original, _row$original2;
        return (_row$original = row.original) !== null && _row$original !== void 0 && _row$original.startDate ? GetCell(format(new Date((_row$original2 = row.original) === null || _row$original2 === void 0 ? void 0 : _row$original2.startDate), 'dd/MM/yyyy')) : "";
      }
    }, {
      Header: t("EVENTS_END_DATE_LABEL"),
      accessor: "endDate",
      Cell: ({
        row
      }) => {
        var _row$original3, _row$original4;
        return (_row$original3 = row.original) !== null && _row$original3 !== void 0 && _row$original3.endDate ? GetCell(format(new Date((_row$original4 = row.original) === null || _row$original4 === void 0 ? void 0 : _row$original4.endDate), 'dd/MM/yyyy')) : "";
      }
    }, {
      Header: t("CS_RESPONSE_COUNT"),
      accessor: "answersCount",
      Cell: ({
        row
      }) => {
        var _row$original5, _row$original6;
        return (_row$original5 = row.original) !== null && _row$original5 !== void 0 && _row$original5.answersCount ? GetCell(Number((_row$original6 = row.original) === null || _row$original6 === void 0 ? void 0 : _row$original6.answersCount)) : "-";
      }
    }, {
      Header: t("EVENTS_STATUS_LABEL"),
      accessor: "status",
      Cell: ({
        row
      }) => {
        var _row$original7;
        return GetStatusCell((_row$original7 = row.original) === null || _row$original7 === void 0 ? void 0 : _row$original7.status);
      }
    }, {
      Header: t("EVENTS_POSTEDBY_LABEL"),
      accessor: row => row.postedBy
    }, {
      Header: t("CS_SURVEY_RESULTS"),
      accessor: "results",
      Cell: ({
        row
      }) => {
        return /*#__PURE__*/React$1.createElement("div", {
          style: {
            "display": "flex",
            "justifyContent": "center"
          }
        }, /*#__PURE__*/React$1.createElement(Link, {
          to: `${parentRoute}/surveys/inbox/results/${row.original["uuid"]}`
        }, /*#__PURE__*/React$1.createElement("span", {
          className: "link"
        }, /*#__PURE__*/React$1.createElement("svg", {
          width: "20",
          height: "18",
          viewBox: "0 0 20 18",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/React$1.createElement("path", {
          d: "M5.5 18H0V6H5.5V18ZM12.75 0H7.25V18H12.75V0ZM20 8H14.5V18H20V8Z",
          fill: "#1F4A7C"
        })))));
      }
    }];
  });
  return {
    getCellProps: cellInfo => {
      return {
        style: {
          padding: "20px 18px",
          fontSize: "16px"
        }
      };
    },
    disableSort: false,
    autoSort: false,
    manualPagination: true,
    initSortI: "endDate",
    onPageSizeChange: onPageSizeChange,
    currentPage: ((_formState$tableForm = formState.tableForm) === null || _formState$tableForm === void 0 ? void 0 : _formState$tableForm.offset) / ((_formState$tableForm2 = formState.tableForm) === null || _formState$tableForm2 === void 0 ? void 0 : _formState$tableForm2.limit),
    onNextPage: () => {
      var _formState$tableForm3, _formState$tableForm4;
      return dispatch({
        action: "mutateTableForm",
        data: {
          ...formState.tableForm,
          offset: parseInt((_formState$tableForm3 = formState.tableForm) === null || _formState$tableForm3 === void 0 ? void 0 : _formState$tableForm3.offset) + parseInt((_formState$tableForm4 = formState.tableForm) === null || _formState$tableForm4 === void 0 ? void 0 : _formState$tableForm4.limit)
        }
      });
    },
    onPrevPage: () => {
      var _formState$tableForm5, _formState$tableForm6;
      return dispatch({
        action: "mutateTableForm",
        data: {
          ...formState.tableForm,
          offset: parseInt((_formState$tableForm5 = formState.tableForm) === null || _formState$tableForm5 === void 0 ? void 0 : _formState$tableForm5.offset) - parseInt((_formState$tableForm6 = formState.tableForm) === null || _formState$tableForm6 === void 0 ? void 0 : _formState$tableForm6.limit)
        }
      });
    },
    pageSizeLimit: (_formState$tableForm7 = formState.tableForm) === null || _formState$tableForm7 === void 0 ? void 0 : _formState$tableForm7.limit,
    totalRecords: totalCount,
    onSearch: formState === null || formState === void 0 ? void 0 : (_formState$searchForm = formState.searchForm) === null || _formState$searchForm === void 0 ? void 0 : _formState$searchForm.message,
    data: table,
    columns: tableColumnConfig,
    noResultsMessage: "CS_NO_SURVEYS_FOUND"
  };
};

const useInboxMobileCardsData = ({
  parentRoute,
  table
}) => {
  const {
    t
  } = useTranslation();
  const dataForMobileInboxCards = table === null || table === void 0 ? void 0 : table.map(({
    title,
    startDate,
    endDate,
    answersCount,
    status,
    postedBy
  }) => ({
    [t("CS_SURVEY_TITLE")]: title,
    [t("EVENTS_START_DATE_LABEL")]: format(new Date(startDate), 'dd/MM/yyyy'),
    [t("EVENTS_END_DATE_LABEL")]: format(new Date(endDate), 'dd/MM/yyyy'),
    [t("CS_RESPONSE_COUNT")]: answersCount,
    [t("EVENTS_STATUS_LABEL")]: status,
    [t("EVENTS_POSTEDBY_LABEL")]: postedBy
  }));
  return {
    data: dataForMobileInboxCards,
    linkPrefix: `${parentRoute}/inbox/`,
    serviceRequestIdKey: t("TL_COMMON_TABLE_COL_APP_NO")
  };
};

const Inbox$3 = ({
  parentRoute
}) => {
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const ulbs = Digit.SessionStorage.get("ENGAGEMENT_TENANTS");
  const userInfo = Digit.UserService.getUser().info;
  const userUlbs = ulbs.filter(ulb => {
    var _userInfo$roles;
    return userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$roles = userInfo.roles) === null || _userInfo$roles === void 0 ? void 0 : _userInfo$roles.some(role => (role === null || role === void 0 ? void 0 : role.tenantId) === (ulb === null || ulb === void 0 ? void 0 : ulb.code));
  });
  const statuses = [{
    code: "ALL",
    name: `${t("ES_COMMON_ALL")}`
  }, {
    code: "ACTIVE",
    name: `${t("ES_COMMON_ACTIVE")}`
  }, {
    code: "INACTIVE",
    name: `${t("ES_COMMON_INACTIVE")}`
  }];
  const searchFormDefaultValues = {
    tenantIds: userUlbs[0],
    postedBy: "",
    title: ""
  };
  const filterFormDefaultValues = {
    status: statuses[0]
  };
  const tableOrderFormDefaultValues = {
    sortBy: "",
    limit: 10,
    offset: 0,
    sortOrder: "DESC"
  };
  function formReducer(state, payload) {
    switch (payload.action) {
      case "mutateSearchForm":
        Digit.SessionStorage.set("CITIZENSURVEY.INBOX", {
          ...state,
          searchForm: payload.data
        });
        return {
          ...state,
          searchForm: payload.data
        };
      case "mutateFilterForm":
        Digit.SessionStorage.set("CITIZENSURVEY.INBOX", {
          ...state,
          filterForm: payload.data
        });
        return {
          ...state,
          filterForm: payload.data
        };
      case "mutateTableForm":
        Digit.SessionStorage.set("CITIZENSURVEY.INBOX", {
          ...state,
          tableForm: payload.data
        });
        return {
          ...state,
          tableForm: payload.data
        };
    }
  }
  const InboxObjectInSessionStorage = Digit.SessionStorage.get("CITIZENSURVEY.INBOX");
  const onSearchFormReset = setSearchFormValue => {
    setSearchFormValue("postedBy", "");
    setSearchFormValue("title", "");
    setSearchFormValue("tenantIds", tenantId);
    dispatch({
      action: "mutateSearchForm",
      data: searchFormDefaultValues
    });
  };
  const onFilterFormReset = setFilterFormValue => {
    setFilterFormValue("status", statuses[0]);
    dispatch({
      action: "mutateFilterForm",
      data: filterFormDefaultValues
    });
  };
  const formInitValue = useMemo(() => {
    return InboxObjectInSessionStorage || {
      filterForm: filterFormDefaultValues,
      searchForm: searchFormDefaultValues,
      tableForm: tableOrderFormDefaultValues
    };
  }, [Object.values((InboxObjectInSessionStorage === null || InboxObjectInSessionStorage === void 0 ? void 0 : InboxObjectInSessionStorage.filterForm) || {}), Object.values((InboxObjectInSessionStorage === null || InboxObjectInSessionStorage === void 0 ? void 0 : InboxObjectInSessionStorage.searchForm) || {}), Object.values((InboxObjectInSessionStorage === null || InboxObjectInSessionStorage === void 0 ? void 0 : InboxObjectInSessionStorage.tableForm) || {})]);
  const [formState, dispatch] = useReducer(formReducer, formInitValue);
  const onPageSizeChange = e => {
    dispatch({
      action: "mutateTableForm",
      data: {
        ...formState.tableForm,
        limit: e.target.value
      }
    });
  };
  const {
    data: {
      Surveys,
      TotalCount
    } = {},
    isLoading: isInboxLoading
  } = Digit.Hooks.survey.useSurveyInbox(formState);
  const PropsForInboxLinks = {
    logoIcon: /*#__PURE__*/React$1.createElement(DocumentIcon, null),
    headerText: "CS_COMMON_SURVEYS",
    links: [{
      text: t("CS_COMMON_NEW_SURVEY"),
      link: "/digit-ui/employee/engagement/surveys/inbox/create"
    }]
  };
  const SearchFormFields = useCallback(({
    registerRef,
    searchFormState,
    controlSearchForm
  }) => /*#__PURE__*/React$1.createElement(SearchFormFieldsComponents, {
    registerRef,
    searchFormState,
    controlSearchForm
  }), []);
  const FilterFormFields = useCallback(({
    registerRef,
    controlFilterForm,
    setFilterFormValue,
    getFilterFormValue
  }) => /*#__PURE__*/React$1.createElement(FilterFormFieldsComponent, {
    statuses,
    registerRef,
    controlFilterForm,
    setFilterFormValue,
    filterFormState: formState === null || formState === void 0 ? void 0 : formState.filterForm,
    getFilterFormValue
  }), [statuses]);
  const onSearchFormSubmit = data => {
    data.hasOwnProperty("") ? data === null || data === void 0 ? true : delete data[""] : null;
    dispatch({
      action: "mutateSearchForm",
      data
    });
  };
  const onFilterFormSubmit = data => {
    data.hasOwnProperty("") ? data === null || data === void 0 ? true : delete data[""] : null;
    dispatch({
      action: "mutateFilterForm",
      data
    });
  };
  const propsForSearchForm = {
    SearchFormFields,
    onSearchFormSubmit,
    searchFormDefaultValues: formState === null || formState === void 0 ? void 0 : formState.searchForm,
    resetSearchFormDefaultValues: searchFormDefaultValues,
    onSearchFormReset
  };
  const propsForFilterForm = {
    FilterFormFields,
    onFilterFormSubmit,
    filterFormDefaultValues: formState === null || formState === void 0 ? void 0 : formState.filterForm,
    resetFilterFormDefaultValues: filterFormDefaultValues,
    onFilterFormReset
  };
  const propsForInboxTable = useInboxTableConfig({
    ...{
      parentRoute,
      onPageSizeChange,
      formState,
      totalCount: TotalCount,
      table: Surveys,
      noResultsMessage: "CS_SURVEYS_NOT_FOUND",
      dispatch
    }
  });
  const propsForInboxMobileCards = useInboxMobileCardsData({
    parentRoute,
    table: Surveys
  });
  return /*#__PURE__*/React$1.createElement(InboxComposer, _extends({
    isInboxLoading,
    PropsForInboxLinks
  }, propsForSearchForm, propsForFilterForm, {
    propsForInboxMobileCards,
    propsForInboxTable,
    formState
  }));
};

const SurveyDetailsForms = ({
  t,
  registerRef,
  controlSurveyForm,
  surveyFormState,
  surveyFormData,
  disableInputs,
  enableDescriptionOnly
}) => {
  var _surveyFormState$erro, _surveyFormState$erro2, _surveyFormState$erro3, _surveyFormState$erro4, _surveyFormState$erro5, _surveyFormState$erro6, _surveyFormState$erro7;
  const ulbs = Digit.SessionStorage.get("ENGAGEMENT_TENANTS");
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const userInfo = Digit.UserService.getUser().info;
  const userUlbs = ulbs.filter(ulb => {
    var _userInfo$roles;
    return userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$roles = userInfo.roles) === null || _userInfo$roles === void 0 ? void 0 : _userInfo$roles.some(role => (role === null || role === void 0 ? void 0 : role.tenantId) === (ulb === null || ulb === void 0 ? void 0 : ulb.code));
  }).sort(alphabeticalSortFunctionForTenantsBasedOnName);
  const selectedTenat = useMemo(() => {
    const filtered = ulbs.filter(item => item.code === tenantId);
    return filtered;
  }, [ulbs]);
  return /*#__PURE__*/React$1.createElement("div", {
    className: "surveydetailsform-wrapper"
  }, /*#__PURE__*/React$1.createElement("span", {
    className: "surveyformfield"
  }, /*#__PURE__*/React$1.createElement("label", null, `${t("LABEL_FOR_ULB")} * :`), /*#__PURE__*/React$1.createElement(Controller, {
    name: "tenantIds",
    control: controlSurveyForm,
    defaultValue: selectedTenat,
    rules: {
      required: true
    },
    render: props => {
      const renderRemovableTokens = useMemo(() => {
        var _props$value;
        return props === null || props === void 0 ? void 0 : (_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.map((ulb, index) => {
          return /*#__PURE__*/React$1.createElement(RemoveableTag, {
            key: index,
            text: ulb.name,
            onClick: () => {
              var _props$value2;
              props.onChange(props === null || props === void 0 ? void 0 : (_props$value2 = props.value) === null || _props$value2 === void 0 ? void 0 : _props$value2.filter(loc => loc.code !== ulb.code));
            }
          });
        });
      }, [props === null || props === void 0 ? void 0 : props.value]);
      return /*#__PURE__*/React$1.createElement("div", {
        style: {
          display: "grid",
          gridAutoFlow: "row"
        }
      }, /*#__PURE__*/React$1.createElement(Dropdown, {
        allowMultiselect: true,
        optionKey: "i18nKey",
        option: userUlbs,
        select: e => {
          var _surveyFormData, _surveyFormData$filte;
          props.onChange([...(((_surveyFormData = surveyFormData("tenantIds")) === null || _surveyFormData === void 0 ? void 0 : (_surveyFormData$filte = _surveyFormData.filter) === null || _surveyFormData$filte === void 0 ? void 0 : _surveyFormData$filte.call(_surveyFormData, f => e.code !== (f === null || f === void 0 ? void 0 : f.code))) || []), e]);
        },
        selected: props === null || props === void 0 ? void 0 : props.value,
        keepNull: true,
        disable: disableInputs,
        t: t
      }), /*#__PURE__*/React$1.createElement("div", {
        className: "tag-container"
      }, renderRemovableTokens));
    }
  }), (surveyFormState === null || surveyFormState === void 0 ? void 0 : (_surveyFormState$erro = surveyFormState.errors) === null || _surveyFormState$erro === void 0 ? void 0 : _surveyFormState$erro.tenantIds) && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t("ES_ERROR_REQUIRED"))), /*#__PURE__*/React$1.createElement("span", {
    className: "surveyformfield"
  }, /*#__PURE__*/React$1.createElement("label", null, t("CS_SURVEY_NAME")), /*#__PURE__*/React$1.createElement(TextInput, {
    name: "title",
    type: "text",
    inputRef: registerRef({
      required: t("ES_ERROR_REQUIRED"),
      maxLength: {
        value: 60,
        message: t("EXCEEDS_60_CHAR_LIMIT")
      },
      pattern: {
        value: /^[A-Za-z_-][A-Za-z0-9_\ -]*$/,
        message: t("ES_SURVEY_DONT_START_WITH_NUMBER")
      }
    }),
    disable: disableInputs
  }), (surveyFormState === null || surveyFormState === void 0 ? void 0 : (_surveyFormState$erro2 = surveyFormState.errors) === null || _surveyFormState$erro2 === void 0 ? void 0 : _surveyFormState$erro2.title) && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, surveyFormState === null || surveyFormState === void 0 ? void 0 : (_surveyFormState$erro3 = surveyFormState.errors) === null || _surveyFormState$erro3 === void 0 ? void 0 : (_surveyFormState$erro4 = _surveyFormState$erro3["title"]) === null || _surveyFormState$erro4 === void 0 ? void 0 : _surveyFormState$erro4.message)), /*#__PURE__*/React$1.createElement("span", {
    className: "surveyformfield"
  }, /*#__PURE__*/React$1.createElement("label", null, t("CS_SURVEY_DESCRIPTION")), /*#__PURE__*/React$1.createElement(TextInput, {
    name: "description",
    type: "text",
    inputRef: registerRef({
      required: t("ES_ERROR_REQUIRED"),
      maxLength: {
        value: 250,
        message: t("EXCEEDS_250_CHAR_LIMIT")
      },
      pattern: {
        value: /^[A-Za-z_-][A-Za-z0-9_\ -]*$/,
        message: t("ES_SURVEY_DONT_START_WITH_NUMBER")
      }
    }),
    disable: enableDescriptionOnly ? !enableDescriptionOnly : disableInputs
  }), (surveyFormState === null || surveyFormState === void 0 ? void 0 : (_surveyFormState$erro5 = surveyFormState.errors) === null || _surveyFormState$erro5 === void 0 ? void 0 : _surveyFormState$erro5.description) && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, surveyFormState === null || surveyFormState === void 0 ? void 0 : (_surveyFormState$erro6 = surveyFormState.errors) === null || _surveyFormState$erro6 === void 0 ? void 0 : (_surveyFormState$erro7 = _surveyFormState$erro6["description"]) === null || _surveyFormState$erro7 === void 0 ? void 0 : _surveyFormState$erro7.message)));
};

const Checkboxes = ({
  t,
  options: _options = checkboxlist,
  updateOption,
  addOption,
  removeOption,
  isPartiallyEnabled,
  createNewSurvey,
  formDisabled
}) => {
  return /*#__PURE__*/React$1.createElement("div", {
    className: "options_checkboxes"
  }, _options.map((title, index) => /*#__PURE__*/React$1.createElement(CheckBoxOption, {
    key: index,
    index: index,
    title: title,
    updateOption: updateOption,
    removeOption: removeOption
  })), /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement("button", {
    className: "unstyled-button link",
    type: "button",
    disabled: !createNewSurvey && formDisabled,
    onClick: () => addOption()
  }, t("CS_COMMON_ADD_OPTION"))));
};
const CheckBoxOption = ({
  index,
  title,
  updateOption,
  removeOption
}) => {
  const [optionTitle, setOptionTitle] = useState(title);
  const [isFocused, setIsFocused] = useState(false);
  useEffect(() => {
    updateOption({
      value: optionTitle,
      id: index
    });
  }, [optionTitle]);
  return /*#__PURE__*/React$1.createElement("div", {
    className: "optioncheckboxwrapper"
  }, /*#__PURE__*/React$1.createElement(CheckBox, null), /*#__PURE__*/React$1.createElement("input", {
    type: "text",
    value: optionTitle,
    onChange: ev => setOptionTitle(ev.target.value),
    onBlur: () => setIsFocused(false),
    onFocus: () => setIsFocused(true),
    className: isFocused ? "simple_editable-input" : "simple_readonly-input"
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "pointer",
    onClick: () => removeOption(index)
  }, /*#__PURE__*/React$1.createElement(CloseSvg, null)));
};

const MultipleChoice = ({
  t,
  options: _options = checkboxlist,
  updateOption,
  addOption,
  removeOption,
  createNewSurvey,
  isPartiallyEnabled,
  formDisabled
}) => {
  return /*#__PURE__*/React$1.createElement("div", {
    className: "options_checkboxes"
  }, _options.map((title, index) => /*#__PURE__*/React$1.createElement(RadioButtonOption, {
    key: index,
    index: index,
    title: title,
    updateOption: updateOption,
    removeOption: removeOption
  })), /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement("button", {
    className: "unstyled-button link",
    type: "button",
    disabled: !createNewSurvey && formDisabled,
    onClick: () => addOption()
  }, t("CS_COMMON_ADD_OPTION"))));
};
const RadioButtonOption = ({
  index,
  title,
  updateOption,
  removeOption
}) => {
  const [optionTitle, setOptionTitle] = useState(title);
  const [isFocused, setIsFocused] = useState(false);
  useEffect(() => {
    updateOption({
      value: optionTitle,
      id: index
    });
  }, [optionTitle]);
  return /*#__PURE__*/React$1.createElement("div", {
    className: "optionradiobtnwrapper"
  }, /*#__PURE__*/React$1.createElement("input", {
    type: "radio",
    className: "customradiobutton"
  }), /*#__PURE__*/React$1.createElement("input", {
    type: "text",
    value: optionTitle,
    onChange: ev => setOptionTitle(ev.target.value),
    onBlur: () => setIsFocused(false),
    onFocus: () => setIsFocused(true),
    className: isFocused ? "simple_editable-input" : "simple_readonly-input"
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "pointer",
    onClick: () => removeOption(index)
  }, /*#__PURE__*/React$1.createElement(CloseSvg, null)));
};

const dropdownOptions = [{
  title: "Short Answer",
  value: "SHORT_ANSWER_TYPE"
}, {
  title: "Multiple Choice",
  value: "MULTIPLE_ANSWER_TYPE"
}, {
  title: "Check Boxes",
  value: "CHECKBOX_ANSWER_TYPE"
}, {
  title: "Paragraph",
  value: "LONG_ANSWER_TYPE"
}, {
  title: "Date",
  value: "DATE_ANSWER_TYPE"
}, {
  title: "Time",
  value: "TIME_ANSWER_TYPE"
}];
const NewSurveyForm = ({
  t,
  index,
  questionStatement,
  type,
  required,
  options,
  disableInputs,
  dispatch,
  isPartiallyEnabled,
  addOption,
  formDisabled
}) => {
  var _formState$errors, _formState$errors2, _formState$errors3;
  const [surveyQuestionConfig, setSurveyQuestionConfig] = useState({
    questionStatement,
    type,
    required,
    options: ["option 1"]
  });
  const {
    register,
    formState
  } = useFormContext();
  const handleAddOption = () => setSurveyQuestionConfig(prevState => {
    const updatedState = {
      ...prevState
    };
    updatedState.options.push(`option ${updatedState.options.length + 1}`);
    return updatedState;
  });
  const handleUpdateOption = ({
    value,
    id
  }) => {
    setSurveyQuestionConfig(prevState => {
      const updatedState = {
        ...prevState
      };
      updatedState.options.splice(id, 1, value);
      return updatedState;
    });
  };
  const handleRemoveOption = id => {
    if (surveyQuestionConfig.options.length === 1) return;
    setSurveyQuestionConfig(prevState => {
      const updatedState = {
        ...prevState
      };
      updatedState.options.splice(id, 1);
      return updatedState;
    });
  };
  useEffect(() => {
    dispatch({
      type: "updateForm",
      payload: {
        index: index,
        formConfig: surveyQuestionConfig
      }
    });
  }, [surveyQuestionConfig]);
  const renderAnswerComponent = type => {
    switch (type) {
      case "Paragraph":
        return /*#__PURE__*/React$1.createElement(TextArea, {
          value: "LONG ANSWER"
        });
      case "Date":
        return /*#__PURE__*/React$1.createElement(DatePicker, {
          stylesForInput: {
            width: "calc(100% - 290px)"
          }
        });
      case "Time":
        return /*#__PURE__*/React$1.createElement(TimePicker, null);
      case "Multiple Choice":
        return /*#__PURE__*/React$1.createElement(MultipleChoice, {
          t: t,
          addOption: handleAddOption,
          updateOption: handleUpdateOption,
          removeOption: handleRemoveOption,
          options: surveyQuestionConfig === null || surveyQuestionConfig === void 0 ? void 0 : surveyQuestionConfig.options,
          createNewSurvey: addOption,
          isPartiallyEnabled: isPartiallyEnabled,
          formDisabled: formDisabled
        });
      case "Check Boxes":
        return /*#__PURE__*/React$1.createElement(Checkboxes, {
          t: t,
          addOption: handleAddOption,
          updateOption: handleUpdateOption,
          removeOption: handleRemoveOption,
          options: surveyQuestionConfig === null || surveyQuestionConfig === void 0 ? void 0 : surveyQuestionConfig.options,
          isPartiallyEnabled: isPartiallyEnabled,
          createNewSurvey: addOption,
          formDisabled: formDisabled
        });
      default:
        return /*#__PURE__*/React$1.createElement(TextInput, {
          value: "SHORT ANSWER"
        });
    }
  };
  return /*#__PURE__*/React$1.createElement("div", {
    className: "newSurveyForm_wrapper"
  }, /*#__PURE__*/React$1.createElement("span", {
    className: "newSurveyForm_quesno"
  }, `${t("CS_COMMON_QUESTION")} ${index + 1}`), /*#__PURE__*/React$1.createElement("span", {
    className: "newSurveyForm_mainsection"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "newSurveyForm_questions"
  }, /*#__PURE__*/React$1.createElement("div", {
    style: {
      width: "80%"
    }
  }, /*#__PURE__*/React$1.createElement(TextInput, {
    placeholder: t("CS_COMMON_TYPE_QUESTION"),
    value: surveyQuestionConfig.questionStatement,
    onChange: ev => {
      setSurveyQuestionConfig(prevState => ({
        ...prevState,
        questionStatement: ev.target.value
      }));
    },
    textInputStyle: {
      width: "100%"
    },
    name: `QUESTION_SURVEY_${index}`,
    disable: disableInputs,
    inputRef: register({
      required: t("ES_ERROR_REQUIRED"),
      maxLength: {
        value: 60,
        message: t("EXCEEDS_60_CHAR_LIMIT")
      },
      pattern: {
        value: /^[A-Za-z_-][A-Za-z0-9_\ -]*$/,
        message: t("ES_SURVEY_DONT_START_WITH_NUMBER")
      }
    })
  }), (formState === null || formState === void 0 ? void 0 : (_formState$errors = formState.errors) === null || _formState$errors === void 0 ? void 0 : _formState$errors.title) && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, formState === null || formState === void 0 ? void 0 : (_formState$errors2 = formState.errors) === null || _formState$errors2 === void 0 ? void 0 : (_formState$errors3 = _formState$errors2[`QUESTION_SURVEY_${index}`]) === null || _formState$errors3 === void 0 ? void 0 : _formState$errors3.message)), /*#__PURE__*/React$1.createElement(Dropdown, {
    option: dropdownOptions,
    select: ev => {
      setSurveyQuestionConfig(prevState => ({
        ...prevState,
        type: ev.title
      }));
    },
    selected: surveyQuestionConfig.type || {
      title: "Short Answer",
      value: "SHORT_ANSWER_TYPE"
    },
    optionKey: "title",
    disable: disableInputs
  })), /*#__PURE__*/React$1.createElement("div", {
    className: "newSurveyForm_answer"
  }, renderAnswerComponent(surveyQuestionConfig.type)), /*#__PURE__*/React$1.createElement("div", {
    className: "newSurveyForm_actions"
  }, /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(CheckBox, {
    onChange: e => setSurveyQuestionConfig(prevState => ({
      ...prevState,
      required: !prevState.required
    })),
    checked: surveyQuestionConfig.required,
    label: t("CS_COMMON_REQUIRED"),
    pageType: "employee",
    disable: disableInputs
  })), /*#__PURE__*/React$1.createElement("div", {
    className: "newSurveyForm_seprator"
  }), /*#__PURE__*/React$1.createElement("div", {
    className: `pointer ${disableInputs ? 'disabled-btn' : ''}`,
    onClick: () => dispatch({
      type: "removeForm",
      payload: {
        index
      }
    })
  }, /*#__PURE__*/React$1.createElement(DustbinIcon, null)))));
};

const SurveyFormsMaker = ({
  t,
  formsConfig,
  setSurveyConfig,
  disableInputs,
  isPartiallyEnabled,
  addOption,
  formDisabled
}) => {
  const defaultFormsConfig = {
    question: "",
    answerType: "Short Answer",
    required: false,
    options: []
  };
  const initialSurveyFormState = [defaultFormsConfig];
  const surveyFormReducer = (state, {
    type,
    payload
  }) => {
    switch (type) {
      case "addNewForm":
        const newSurveyQues = [...state, defaultFormsConfig];
        payload.setSurveyConfig("questions", newSurveyQues);
        return newSurveyQues;
      case "updateForm":
        const updatedSurveyQues = [...state];
        updatedSurveyQues.splice(payload.index, 1, payload);
        payload.setSurveyConfig("questions", updatedSurveyQues);
        return updatedSurveyQues;
      case "removeForm":
        if (state.length === 1) return state;
        const copyOfSate = [...state];
        copyOfSate.splice(payload.index, 1);
        payload.setSurveyConfig("questions", copyOfSate);
        return copyOfSate;
    }
  };
  const [surveyState, dispatch] = useReducer(surveyFormReducer, formsConfig ? formsConfig : initialSurveyFormState);
  const passingSurveyConfigInDispatch = ({
    type,
    payload
  }) => {
    dispatch({
      type,
      payload: {
        ...payload,
        setSurveyConfig
      }
    });
  };
  const renderPreviewForms = () => {
    return surveyState.length ? surveyState.map((config, index) => /*#__PURE__*/React$1.createElement(NewSurveyForm, Object.assign({
      key: index
    }, config, {
      addOption: addOption,
      t: t,
      index: index,
      disableInputs: disableInputs,
      dispatch: passingSurveyConfigInDispatch,
      isPartiallyEnabled: isPartiallyEnabled,
      formDisabled: formDisabled
    }))) : null;
  };
  return /*#__PURE__*/React$1.createElement("div", {
    className: "surveyformslist_wrapper"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "heading"
  }, t("CS_SURVEYS_QUESTIONS")), renderPreviewForms(), /*#__PURE__*/React$1.createElement("div", {
    className: "pointer"
  }, /*#__PURE__*/React$1.createElement("button", {
    className: `unstyled-button link ${disableInputs ? "disabled-btn" : ""} ${surveyState.length >= 30 ? "disabled-btn" : ""} `,
    type: "button",
    onClick: () => passingSurveyConfigInDispatch({
      type: "addNewForm"
    })
  }, t("CS_COMMON_ADD_QUESTION"))));
};

const SurveySettingsForms = ({
  t,
  controlSurveyForm,
  surveyFormState,
  disableInputs,
  enableEndDateTimeOnly
}) => {
  var _formErrors$fromDate, _formErrors$fromDate2, _formErrors$fromTime, _formErrors$fromTime2, _formErrors$toDate, _formErrors$toDate2, _formErrors$toTime, _formErrors$toTime2, _formErrors$collectCi;
  const formErrors = surveyFormState === null || surveyFormState === void 0 ? void 0 : surveyFormState.errors;
  const {
    getValues
  } = useFormContext();
  const currentTs = new Date().getTime();
  const isValidFromDate = enteredValue => {
    const enteredTs = new Date(enteredValue).getTime();
    const toDate = getValues("toDate") ? new Date(getValues("toDate")).getTime() : new Date().getTime();
    return toDate > enteredTs ? true : false;
  };
  const isValidToDate = enteredValue => {
    const enteredTs = new Date(enteredValue).getTime();
    const fromDate = getValues("fromDate") ? new Date(getValues("fromDate")).getTime() : new Date().getTime();
    return enteredTs > fromDate && enteredTs > currentTs ? true : false;
  };
  const isValidFromTime = () => true;
  const isValidToTime = () => true;
  return /*#__PURE__*/React$1.createElement("div", {
    className: "surveydetailsform-wrapper"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "heading"
  }, t("CS_COMMON_SETTINGS")), /*#__PURE__*/React$1.createElement("span", {
    className: "surveyformfield"
  }, /*#__PURE__*/React$1.createElement("label", null, t("LABEL_SURVEY_START_DATE")), /*#__PURE__*/React$1.createElement(Controller, {
    control: controlSurveyForm,
    name: "fromDate",
    defaultValue: surveyFormState === null || surveyFormState === void 0 ? void 0 : surveyFormState.fromDate,
    rules: {
      required: true,
      validate: {
        isValidFromDate
      }
    },
    render: ({
      onChange,
      value
    }) => /*#__PURE__*/React$1.createElement(TextInput, {
      type: "date",
      onChange: onChange,
      defaultValue: value,
      disable: disableInputs
    })
  }), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors.fromDate) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$fromDate = formErrors.fromDate) === null || _formErrors$fromDate === void 0 ? void 0 : _formErrors$fromDate.type) === "required" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_REQUIRED`)), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors.fromDate) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$fromDate2 = formErrors.fromDate) === null || _formErrors$fromDate2 === void 0 ? void 0 : _formErrors$fromDate2.type) === "isValidFromDate" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_INVALID`))), /*#__PURE__*/React$1.createElement("span", {
    className: "surveyformfield"
  }, /*#__PURE__*/React$1.createElement("label", null, t("LABEL_SURVEY_START_TIME")), /*#__PURE__*/React$1.createElement(Controller, {
    control: controlSurveyForm,
    name: "fromTime",
    defaultValue: surveyFormState === null || surveyFormState === void 0 ? void 0 : surveyFormState.fromTime,
    rules: {
      required: true,
      validate: {
        isValidFromTime
      }
    },
    render: ({
      onChange,
      value
    }) => /*#__PURE__*/React$1.createElement(TextInput, {
      type: "time",
      onChange: onChange,
      defaultValue: value,
      disable: disableInputs
    })
  }), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors.fromTime) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$fromTime = formErrors.fromTime) === null || _formErrors$fromTime === void 0 ? void 0 : _formErrors$fromTime.type) === "required" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_REQUIRED`)), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors.fromTime) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$fromTime2 = formErrors.fromTime) === null || _formErrors$fromTime2 === void 0 ? void 0 : _formErrors$fromTime2.type) === "isValidFromDate" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_INVALID`))), /*#__PURE__*/React$1.createElement("span", {
    className: "surveyformfield"
  }, /*#__PURE__*/React$1.createElement("label", null, t("LABEL_SURVEY_END_DATE")), /*#__PURE__*/React$1.createElement(Controller, {
    control: controlSurveyForm,
    name: "toDate",
    defaultValue: surveyFormState === null || surveyFormState === void 0 ? void 0 : surveyFormState.toDate,
    rules: {
      required: true,
      validate: {
        isValidToDate
      }
    },
    render: ({
      onChange,
      value
    }) => /*#__PURE__*/React$1.createElement(TextInput, {
      type: "date",
      onChange: onChange,
      defaultValue: value,
      disable: enableEndDateTimeOnly ? !enableEndDateTimeOnly : disableInputs
    })
  }), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors.toDate) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$toDate = formErrors.toDate) === null || _formErrors$toDate === void 0 ? void 0 : _formErrors$toDate.type) === "required" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_REQUIRED`)), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors.toDate) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$toDate2 = formErrors.toDate) === null || _formErrors$toDate2 === void 0 ? void 0 : _formErrors$toDate2.type) === "isValidToDate" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_INVALID`)), " "), /*#__PURE__*/React$1.createElement("span", {
    className: "surveyformfield"
  }, /*#__PURE__*/React$1.createElement("label", null, t("LABEL_SURVEY_END_TIME")), /*#__PURE__*/React$1.createElement(Controller, {
    control: controlSurveyForm,
    name: "toTime",
    defaultValue: surveyFormState === null || surveyFormState === void 0 ? void 0 : surveyFormState.toTime,
    rules: {
      required: true,
      validate: {
        isValidToTime
      }
    },
    render: ({
      onChange,
      value
    }) => /*#__PURE__*/React$1.createElement(TextInput, {
      type: "time",
      onChange: onChange,
      defaultValue: value,
      disable: enableEndDateTimeOnly ? !enableEndDateTimeOnly : disableInputs
    })
  }), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors.toTime) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$toTime = formErrors.toTime) === null || _formErrors$toTime === void 0 ? void 0 : _formErrors$toTime.type) === "required" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_REQUIRED`)), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors.toTime) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$toTime2 = formErrors.toTime) === null || _formErrors$toTime2 === void 0 ? void 0 : _formErrors$toTime2.type) === "isValidToDate" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_INVALID`))), /*#__PURE__*/React$1.createElement("span", {
    className: "surveyformfield"
  }, /*#__PURE__*/React$1.createElement("label", null, t("LABEL_SURVEY_EMAIL_MOBILE")), /*#__PURE__*/React$1.createElement(Controller, {
    control: controlSurveyForm,
    name: "collectCitizenInfo",
    defaultValue: surveyFormState === null || surveyFormState === void 0 ? void 0 : surveyFormState.collectCitizenInfo,
    rules: {
      required: true
    },
    render: ({
      onChange,
      value
    }) => /*#__PURE__*/React$1.createElement(RadioButtons, {
      onSelect: onChange,
      selectedOption: value,
      optionsKey: "name",
      options: [{
        code: true,
        name: t("ES_COMMON_YES")
      }, {
        code: false,
        name: t("ES_COMMON_NO")
      }],
      disabled: disableInputs
    })
  }), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors.collectCitizenInfo) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$collectCi = formErrors.collectCitizenInfo) === null || _formErrors$collectCi === void 0 ? void 0 : _formErrors$collectCi.type) === "required" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_REQUIRED`))));
};

const CreateNewSurvey = ({
  t,
  initialFormValues,
  onSubmit,
  isFormDisabled: _isFormDisabled = false
}) => {
  const {
    register: registerRef,
    control: controlSurveyForm,
    handleSubmit: handleSurveyFormSubmit,
    setValue: setSurveyFormValue,
    getValues: getSurveyFormValues,
    reset: resetSurveyForm,
    formState: surveyFormState,
    clearErrors: clearSurveyFormsErrors,
    ...methods
  } = useForm({
    defaultValues: initialFormValues
  });
  useEffect(() => {
    registerRef("questions");
  }, []);
  return /*#__PURE__*/React$1.createElement("div", {
    style: {
      margin: "8px"
    }
  }, /*#__PURE__*/React$1.createElement(FormProvider, _extends({
    register: registerRef,
    control: controlSurveyForm,
    handleSubmit: handleSurveyFormSubmit,
    setValue: setSurveyFormValue,
    getValues: getSurveyFormValues,
    reset: resetSurveyForm,
    formState: surveyFormState,
    clearErrors: clearSurveyFormsErrors
  }, methods), /*#__PURE__*/React$1.createElement("form", {
    onSubmit: handleSurveyFormSubmit(onSubmit)
  }, /*#__PURE__*/React$1.createElement(Card, null, /*#__PURE__*/React$1.createElement(SurveyDetailsForms, {
    t: t,
    registerRef: registerRef,
    controlSurveyForm: controlSurveyForm,
    surveyFormState: surveyFormState,
    surveyFormData: getSurveyFormValues
  }), /*#__PURE__*/React$1.createElement(SurveyFormsMaker, {
    t: t,
    setSurveyConfig: setSurveyFormValue,
    addOption: true
  }), /*#__PURE__*/React$1.createElement(SurveySettingsForms, {
    t: t,
    controlSurveyForm: controlSurveyForm,
    surveyFormState: surveyFormState
  })), /*#__PURE__*/React$1.createElement(ActionBar, null, /*#__PURE__*/React$1.createElement(SubmitBar, {
    label: t("CS_CREATE_SURVEY"),
    submit: "submit"
  })))));
};

const answerTypeEnum = {
  "Short Answer": "SHORT_ANSWER_TYPE",
  Paragraph: "LONG_ANSWER_TYPE",
  "Multiple Choice": "MULTIPLE_ANSWER_TYPE",
  "Check Boxes": "CHECKBOX_ANSWER_TYPE",
  Date: "DATE_ANSWER_TYPE",
  Time: "TIME_ANSWER_TYPE"
};
const mapQuestions = (questions = []) => {
  if (!questions.length) return;
  return questions.map(({
    formConfig
  }, index) => {
    const {
      options: choices,
      questionStatement,
      required,
      type: stringType
    } = formConfig;
    const finalQuestion = {
      questionStatement,
      required,
      type: answerTypeEnum[stringType]
    };
    if (stringType === "Multiple Choice" || stringType === "Check Boxes") {
      finalQuestion["options"] = choices;
    }
    return finalQuestion;
  });
};
const NewSurveys = () => {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const onSubmit = data => {
    const {
      collectCitizenInfo,
      title,
      description,
      tenantIds,
      fromDate,
      toDate,
      fromTime,
      toTime,
      questions
    } = data;
    const mappedQuestions = mapQuestions(questions);
    const details = {
      SurveyEntity: {
        tenantIds: tenantIds.map(({
          code
        }) => code),
        title,
        description,
        collectCitizenInfo: collectCitizenInfo.code,
        startDate: new Date(`${fromDate} ${fromTime}`).getTime(),
        endDate: new Date(`${toDate} ${toTime}`).getTime(),
        questions: mappedQuestions
      }
    };
    history.push("/digit-ui/employee/engagement/surveys/create-response", details);
  };
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const ulbs = Digit.SessionStorage.get("ENGAGEMENT_TENANTS");
  const userInfo = Digit.UserService.getUser().info;
  const userUlbs = ulbs.filter(ulb => {
    var _userInfo$roles;
    return userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$roles = userInfo.roles) === null || _userInfo$roles === void 0 ? void 0 : _userInfo$roles.some(role => (role === null || role === void 0 ? void 0 : role.tenantId) === (ulb === null || ulb === void 0 ? void 0 : ulb.code));
  });
  const defaultValues = {
    fromDate: "",
    fromTime: "",
    toDate: "",
    toTime: "",
    questions: {},
    collectCitizenInfo: "",
    tenantIds: userUlbs
  };
  const stylesForForm = {
    marginLeft: '-20px'
  };
  return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(Header, null, t("CREATE_NEW_SURVEY")), /*#__PURE__*/React$1.createElement("div", {
    style: stylesForForm
  }, /*#__PURE__*/React$1.createElement(CreateNewSurvey, {
    t: t,
    onSubmit: onSubmit,
    initialFormValues: defaultValues
  })));
};

const getMessage$3 = mutation => {
  var _mutation$data, _mutation$data$Survey, _mutation$data$Survey2;
  if (mutation.isSuccess) return (_mutation$data = mutation.data) === null || _mutation$data === void 0 ? void 0 : (_mutation$data$Survey = _mutation$data.Surveys) === null || _mutation$data$Survey === void 0 ? void 0 : (_mutation$data$Survey2 = _mutation$data$Survey[0]) === null || _mutation$data$Survey2 === void 0 ? void 0 : _mutation$data$Survey2.uuid;
  return "";
};
const BannerPicker$6 = props => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement(Banner, {
    message: props.mutation.isSuccess ? t(`SURVEY_FORM_CREATED`) : t("SURVEY_FORM_FAILURE"),
    applicationNumber: getMessage$3(props.mutation),
    info: props.mutation.isSuccess ? t("SURVEY_FORM_ID") : "",
    successful: props.mutation.isSuccess
  });
};
const Acknowledgement$1 = props => {
  var _mutation$data2, _mutation$data2$Surve;
  const queryClient = useQueryClient();
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const mutation = Digit.Hooks.survey.useCreate();
  const {
    state
  } = props.location;
  const history = useHistory();
  const [isActionClicked, setIsActionClicked] = useState(false);
  useEffect(() => {
    const onSuccess = () => {
      queryClient.clear();
      window.history.replaceState(null, 'CREATE_SURVEY_STATE');
    };
    if (!!state) {
      mutation.mutate(state, {
        onSuccess
      });
    }
  }, []);
  if (mutation.isLoading && !mutation.isIdle) {
    return /*#__PURE__*/React$1.createElement(Loader, null);
  }
  const survey = (_mutation$data2 = mutation.data) === null || _mutation$data2 === void 0 ? void 0 : (_mutation$data2$Surve = _mutation$data2.Surveys) === null || _mutation$data2$Surve === void 0 ? void 0 : _mutation$data2$Surve[0];
  const handleActionClick = () => {
    setIsActionClicked(prevState => {
      return !prevState;
    });
  };
  const actionClickHandler = option => {
    if (option === t("GO_BACK_TO_HOME")) history.push("/digit-ui/employee");else if (option === t("CREATE_ANOTHER_SURVEY")) history.push("/digit-ui/employee/engagement/surveys/create");
  };
  return /*#__PURE__*/React$1.createElement(Card, null, /*#__PURE__*/React$1.createElement(BannerPicker$6, {
    t: t,
    mutation: mutation
  }), /*#__PURE__*/React$1.createElement(CardText, null, mutation.isSuccess ? t(`SURVEY_FORM_CREATION_MESSAGE`, {
    surveyName: survey === null || survey === void 0 ? void 0 : survey.title,
    fromDate: Digit.DateUtils.ConvertTimestampToDate(survey === null || survey === void 0 ? void 0 : survey.startDate),
    toDate: Digit.DateUtils.ConvertTimestampToDate(survey === null || survey === void 0 ? void 0 : survey.endDate)
  }) : null), /*#__PURE__*/React$1.createElement(ActionBar, null, /*#__PURE__*/React$1.createElement("button", {
    onClick: handleActionClick
  }, /*#__PURE__*/React$1.createElement(SubmitBar, {
    label: "Action"
  }), isActionClicked && /*#__PURE__*/React$1.createElement(Menu, {
    options: [t("GO_BACK_TO_HOME"), t("CREATE_ANOTHER_SURVEY")],
    onSelect: actionClickHandler
  }))));
};

const getMessage$4 = mutation => {
  var _mutation$data, _mutation$data$Docume, _mutation$data$Docume2;
  if (mutation.isSuccess) return (_mutation$data = mutation.data) === null || _mutation$data === void 0 ? void 0 : (_mutation$data$Docume = _mutation$data.Documents) === null || _mutation$data$Docume === void 0 ? void 0 : (_mutation$data$Docume2 = _mutation$data$Docume[0]) === null || _mutation$data$Docume2 === void 0 ? void 0 : _mutation$data$Docume2.uuid;
  return "";
};
const BannerPicker$7 = props => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement(Banner, {
    message: props.isSuccess ? t(`ENGAGEMENT_SURVEY_UPDATED`) : t("ENGAGEMENT_SURVEY_UPDATE_FAILURE"),
    applicationNumber: getMessage$4(props.mutation),
    info: props.isSuccess ? t("SURVEY_FORM_ID") : "",
    successful: props.isSuccess
  });
};
const Response$5 = props => {
  const queryClient = useQueryClient();
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const mutation = Digit.Hooks.survey.useUpdate();
  const {
    state
  } = props.location;
  useEffect(() => {
    const onSuccess = () => {
      queryClient.clear();
      window.history.replaceState(null, 'UPDATE_SURVEY_STATE');
    };
    if (!!state) {
      mutation.mutate(state, {
        onSuccess
      });
    }
  }, []);
  if (mutation.isLoading || mutation.isIdle) {
    return /*#__PURE__*/React$1.createElement(Loader, null);
  }
  return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(Card, null, /*#__PURE__*/React$1.createElement(BannerPicker$7, {
    t: t,
    data: mutation.data,
    mutation: mutation,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isIdle || mutation.isLoading
  })), /*#__PURE__*/React$1.createElement(ActionBar, null, /*#__PURE__*/React$1.createElement(Link, {
    to: "/digit-ui/employee"
  }, /*#__PURE__*/React$1.createElement(SubmitBar, {
    label: t("CORE_COMMON_GO_TO_HOME")
  }))));
};

const BannerPicker$8 = props => {
  var _props$mutation;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement(Banner, {
    message: props.isSuccess ? t(`ENGAGEMENT_SURVEY_DELETED`) : t("ENGAGEMENT_SURVEY_DELETE_FAILURE"),
    applicationNumber: (_props$mutation = props.mutation) !== null && _props$mutation !== void 0 && _props$mutation.isSuccess ? props.uuid : '',
    info: props.isSuccess ? t("SURVEY_FORM_ID") : "",
    successful: props.isSuccess
  });
};
const Response$6 = props => {
  var _state$DocumentEntity;
  const queryClient = useQueryClient();
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const mutation = Digit.Hooks.survey.useDelete();
  const {
    state
  } = props.location;
  useEffect(() => {
    const onSuccess = () => {
      queryClient.clear();
      window.history.replaceState(null, 'DELETE_SURVEY_STATE');
    };
    if (!!state) {
      mutation.mutate(state, {
        onSuccess
      });
    }
  }, []);
  if (mutation.isLoading || mutation.isIdle) {
    return /*#__PURE__*/React$1.createElement(Loader, null);
  }
  return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(Card, null, /*#__PURE__*/React$1.createElement(BannerPicker$8, {
    t: t,
    data: mutation.data,
    mutation: mutation,
    uuid: state === null || state === void 0 ? void 0 : (_state$DocumentEntity = state.DocumentEntity) === null || _state$DocumentEntity === void 0 ? void 0 : _state$DocumentEntity.uuid,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isIdle || mutation.isLoading
  })), /*#__PURE__*/React$1.createElement(ActionBar, null, /*#__PURE__*/React$1.createElement(Link, {
    to: "/digit-ui/employee"
  }, /*#__PURE__*/React$1.createElement(SubmitBar, {
    label: t("CORE_COMMON_GO_TO_HOME")
  }))));
};

const EditSurveyForms = ({
  t,
  onEdit,
  menuOptions,
  initialSurveysConfig,
  isFormDisabled,
  isPartiallyEnabled,
  displayMenu,
  setDisplayMenu,
  onActionSelect,
  isSurveyActive
}) => {
  const {
    register: registerRef,
    control: controlSurveyForm,
    handleSubmit: handleSurveyFormSubmit,
    setValue: setSurveyFormValue,
    getValues: getSurveyFormValues,
    reset: resetSurveyForm,
    formState: surveyFormState,
    clearErrors: clearSurveyFormsErrors
  } = useForm({
    defaultValues: initialSurveysConfig
  });
  useEffect(() => {
    registerRef("questions");
  }, []);
  return /*#__PURE__*/React$1.createElement(FormProvider, {
    register: registerRef,
    control: controlSurveyForm,
    handleSubmit: handleSurveyFormSubmit,
    setValue: setSurveyFormValue,
    getValues: getSurveyFormValues,
    reset: resetSurveyForm,
    formState: surveyFormState,
    clearErrors: clearSurveyFormsErrors
  }, /*#__PURE__*/React$1.createElement("form", {
    onSubmit: handleSurveyFormSubmit(onEdit)
  }, /*#__PURE__*/React$1.createElement(Card, null, /*#__PURE__*/React$1.createElement(SurveyDetailsForms, {
    t: t,
    registerRef: registerRef,
    controlSurveyForm: controlSurveyForm,
    surveyFormState: surveyFormState,
    disableInputs: isFormDisabled,
    enableDescriptionOnly: isPartiallyEnabled,
    surveyFormData: getSurveyFormValues
  }), /*#__PURE__*/React$1.createElement(SurveyFormsMaker, {
    t: t,
    setSurveyConfig: setSurveyFormValue,
    disableInputs: isFormDisabled,
    formsConfig: initialSurveysConfig.questions,
    isPartiallyEnabled: isPartiallyEnabled,
    formDisabled: isFormDisabled
  }), /*#__PURE__*/React$1.createElement(SurveySettingsForms, {
    t: t,
    controlSurveyForm: controlSurveyForm,
    surveyFormState: surveyFormState,
    disableInputs: isFormDisabled,
    enableEndDateTimeOnly: isPartiallyEnabled
  }), /*#__PURE__*/React$1.createElement("span", {
    className: "edit-action-btn"
  }, !isSurveyActive && !isFormDisabled && /*#__PURE__*/React$1.createElement(SubmitBar, {
    label: t("CS_EDIT_SURVEY"),
    submit: "submit",
    disabled: isPartiallyEnabled ? !isPartiallyEnabled : isFormDisabled
  }), isPartiallyEnabled && isSurveyActive && /*#__PURE__*/React$1.createElement(SubmitBar, {
    label: t("CS_EDIT_SURVEY"),
    submit: "submit",
    disabled: isPartiallyEnabled ? !isPartiallyEnabled : isFormDisabled
  })))), /*#__PURE__*/React$1.createElement(ActionBar, null, displayMenu ? /*#__PURE__*/React$1.createElement(Menu, {
    localeKeyPrefix: "ES_SURVEY",
    options: menuOptions,
    t: t,
    onSelect: onActionSelect
  }) : null, /*#__PURE__*/React$1.createElement(SubmitBar, {
    label: t("ES_COMMON_TAKE_ACTION"),
    onSubmit: () => setDisplayMenu(!displayMenu)
  })));
};

const Heading$8 = props => {
  return /*#__PURE__*/React$1.createElement("h1", {
    className: "heading-m"
  }, props.t(props.heading));
};
const Close$9 = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React$1.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$9 = props => {
  return /*#__PURE__*/React$1.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React$1.createElement(Close$9, null));
};
const ConfirmationQuestion$1 = ({
  t,
  title
}) => /*#__PURE__*/React$1.createElement("div", {
  className: "confirmation_box"
}, /*#__PURE__*/React$1.createElement("span", null, " ", t("CONFIRM_DELETE_MSG_NEW"), " ", /*#__PURE__*/React$1.createElement("b", null, ` ${title}`), t("COMPLETELY_DELETE"), " ", /*#__PURE__*/React$1.createElement("br", null), /*#__PURE__*/React$1.createElement("br", null), t("COMPLETELY_DELETE_WARN_MSG")));
const DeleteModal = ({
  t,
  heading,
  surveyTitle,
  closeModal,
  actionCancelLabel,
  actionCancelOnSubmit,
  actionSaveLabel,
  actionSaveOnSubmit
}) => {
  return /*#__PURE__*/React$1.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React$1.createElement(Heading$8, {
      t: t,
      heading: heading
    }),
    headerBarEnd: /*#__PURE__*/React$1.createElement(CloseBtn$9, {
      onClick: closeModal
    }),
    actionCancelLabel: t(actionCancelLabel),
    actionCancelOnSubmit: actionCancelOnSubmit,
    actionSaveLabel: t(actionSaveLabel),
    actionSaveOnSubmit: actionSaveOnSubmit,
    formId: "modal-action"
  }, /*#__PURE__*/React$1.createElement(ConfirmationQuestion$1, {
    t: t,
    title: surveyTitle
  }));
};

const Heading$9 = props => {
  return /*#__PURE__*/React$1.createElement("h1", {
    className: "heading-m"
  }, props.t(props.heading));
};
const Close$a = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React$1.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$a = props => {
  return /*#__PURE__*/React$1.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React$1.createElement(Close$a, null));
};
const isValidFromDate = () => true;
const isValidToDate = () => true;
const isValidFromTime = () => true;
const isValidToTime = () => true;
const MarkActiveModal = ({
  t,
  heading,
  surveyTitle,
  initialValues,
  onSubmit,
  closeModal,
  actionCancelLabel,
  actionCancelOnSubmit,
  actionSaveLabel,
  actionSaveOnSubmit
}) => {
  var _formErrors$fromDate, _formErrors$fromDate2, _formErrors$fromTime, _formErrors$fromTime2, _formErrors$toDate, _formErrors$toDate2, _formErrors$toTime, _formErrors$toTime2;
  const {
    fromDate,
    fromTime,
    toDate,
    toTime
  } = initialValues;
  const {
    control: controlSurveyForm,
    handleSubmit: handleSurveySettingSubmit,
    formState: surveyFormState
  } = useForm({
    defaultValues: {
      fromDate,
      fromTime,
      toDate,
      toTime
    }
  });
  const formErrors = surveyFormState === null || surveyFormState === void 0 ? void 0 : surveyFormState.errors;
  return /*#__PURE__*/React$1.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React$1.createElement(Heading$9, {
      t: t,
      heading: heading
    }),
    headerBarEnd: /*#__PURE__*/React$1.createElement(CloseBtn$a, {
      onClick: closeModal
    }),
    actionCancelLabel: t(actionCancelLabel),
    actionCancelOnSubmit: actionCancelOnSubmit,
    actionSaveLabel: t(actionSaveLabel),
    actionSaveOnSubmit: handleSurveySettingSubmit(actionSaveOnSubmit),
    formId: "modal-action",
    headerBarMainStyle: {
      marginLeft: "20px"
    }
  }, /*#__PURE__*/React$1.createElement(Card, {
    style: {
      boxShadow: "none"
    }
  }, /*#__PURE__*/React$1.createElement("p", null, t("CONFIRM_ACTIVE_SURVEY_MSG"), " ", /*#__PURE__*/React$1.createElement("br", null), " ", surveyTitle, " ", t("CONFIRM_ACTIVE_SURVEY_MSG_END")), /*#__PURE__*/React$1.createElement("br", null), /*#__PURE__*/React$1.createElement("form", {
    onSubmit: handleSurveySettingSubmit(onSubmit)
  }, /*#__PURE__*/React$1.createElement("span", {
    className: "surveyformfield"
  }, /*#__PURE__*/React$1.createElement("label", null, t("LABEL_SURVEY_START_DATE")), /*#__PURE__*/React$1.createElement(Controller, {
    control: controlSurveyForm,
    name: "fromDate",
    defaultValue: surveyFormState === null || surveyFormState === void 0 ? void 0 : surveyFormState.fromDate,
    rules: {
      required: true,
      validate: {
        isValidFromDate
      }
    },
    render: ({
      onChange,
      value
    }) => /*#__PURE__*/React$1.createElement(TextInput, {
      type: "date",
      isRequired: true,
      onChange: onChange,
      defaultValue: value
    })
  }), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors.fromDate) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$fromDate = formErrors.fromDate) === null || _formErrors$fromDate === void 0 ? void 0 : _formErrors$fromDate.type) === "required" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_REQUIRED`)), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors.fromDate) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$fromDate2 = formErrors.fromDate) === null || _formErrors$fromDate2 === void 0 ? void 0 : _formErrors$fromDate2.type) === "isValidToDate" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_INVALID`))), /*#__PURE__*/React$1.createElement("span", {
    className: "surveyformfield"
  }, /*#__PURE__*/React$1.createElement("label", null, t("LABEL_SURVEY_START_TIME")), /*#__PURE__*/React$1.createElement(Controller, {
    control: controlSurveyForm,
    name: "fromTime",
    defaultValue: surveyFormState === null || surveyFormState === void 0 ? void 0 : surveyFormState.fromTime,
    rules: {
      required: true,
      validate: {
        isValidFromTime
      }
    },
    render: ({
      onChange,
      value
    }) => /*#__PURE__*/React$1.createElement(TextInput, {
      type: "time",
      isRequired: true,
      onChange: onChange,
      defaultValue: value
    })
  }), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors.fromTime) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$fromTime = formErrors.fromTime) === null || _formErrors$fromTime === void 0 ? void 0 : _formErrors$fromTime.type) === "required" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_REQUIRED`)), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors.fromTime) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$fromTime2 = formErrors.fromTime) === null || _formErrors$fromTime2 === void 0 ? void 0 : _formErrors$fromTime2.type) === "isValidToDate" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_INVALID`))), /*#__PURE__*/React$1.createElement("span", {
    className: "surveyformfield"
  }, /*#__PURE__*/React$1.createElement("label", null, t("LABEL_SURVEY_END_DATE")), /*#__PURE__*/React$1.createElement(Controller, {
    control: controlSurveyForm,
    name: "toDate",
    defaultValue: surveyFormState === null || surveyFormState === void 0 ? void 0 : surveyFormState.toDate,
    rules: {
      required: true,
      validate: {
        isValidToDate
      }
    },
    render: ({
      onChange,
      value
    }) => /*#__PURE__*/React$1.createElement(TextInput, {
      type: "date",
      isRequired: true,
      onChange: onChange,
      defaultValue: value
    })
  }), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors.toDate) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$toDate = formErrors.toDate) === null || _formErrors$toDate === void 0 ? void 0 : _formErrors$toDate.type) === "required" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_REQUIRED`)), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors.toDate) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$toDate2 = formErrors.toDate) === null || _formErrors$toDate2 === void 0 ? void 0 : _formErrors$toDate2.type) === "isValidToDate" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_INVALID`)), " "), /*#__PURE__*/React$1.createElement("span", {
    className: "surveyformfield"
  }, /*#__PURE__*/React$1.createElement("label", null, t("LABEL_SURVEY_END_TIME")), /*#__PURE__*/React$1.createElement(Controller, {
    control: controlSurveyForm,
    name: "toTime",
    defaultValue: surveyFormState === null || surveyFormState === void 0 ? void 0 : surveyFormState.toTime,
    rules: {
      required: true,
      validate: {
        isValidToTime
      }
    },
    render: ({
      onChange,
      value
    }) => /*#__PURE__*/React$1.createElement(TextInput, {
      type: "time",
      isRequired: true,
      onChange: onChange,
      defaultValue: value
    })
  }), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors.toTime) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$toTime = formErrors.toTime) === null || _formErrors$toTime === void 0 ? void 0 : _formErrors$toTime.type) === "required" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_REQUIRED`)), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors.toTime) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$toTime2 = formErrors.toTime) === null || _formErrors$toTime2 === void 0 ? void 0 : _formErrors$toTime2.type) === "isValidToDate" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_INVALID`))))));
};

const Heading$a = props => {
  return /*#__PURE__*/React$1.createElement("h1", {
    className: "heading-m"
  }, props.t(props.heading));
};
const Close$b = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React$1.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$b = props => {
  return /*#__PURE__*/React$1.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React$1.createElement(Close$b, null));
};
const ConfirmationQuestion$2 = ({
  t,
  title
}) => /*#__PURE__*/React$1.createElement("div", {
  className: "confirmation_box"
}, /*#__PURE__*/React$1.createElement("span", null, " ", t("CONFIRM_INACTIVE_SURVEY_MSG_NEW"), " ", /*#__PURE__*/React$1.createElement("b", null, ` ${title}`), t("CONFIRM_INACTIVE_SURVEY_MSG_TO_INACTIVE"), /*#__PURE__*/React$1.createElement("br", null), /*#__PURE__*/React$1.createElement("br", null), t("CONFIRM_INACTIVE_SURVEY_WARN_MSG")));
const MarkInActiveModal = ({
  t,
  heading,
  surveyTitle,
  closeModal,
  actionCancelLabel,
  actionCancelOnSubmit,
  actionSaveLabel,
  actionSaveOnSubmit
}) => {
  return /*#__PURE__*/React$1.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React$1.createElement(Heading$a, {
      t: t,
      heading: heading
    }),
    headerBarEnd: /*#__PURE__*/React$1.createElement(CloseBtn$b, {
      onClick: closeModal
    }),
    actionCancelLabel: t(actionCancelLabel),
    actionCancelOnSubmit: actionCancelOnSubmit,
    actionSaveLabel: t(actionSaveLabel),
    actionSaveOnSubmit: actionSaveOnSubmit,
    formId: "modal-action"
  }, /*#__PURE__*/React$1.createElement(ConfirmationQuestion$2, {
    t: t,
    title: surveyTitle
  }));
};

const filterQuestion = question => {
  if (!question) return;
  if (question.type !== "Multiple Choice" || question.type !== "Check Boxes") {
    delete question.options;
  }
  return {
    ...question,
    type: answerTypeEnum[question.type]
  };
};
const TypeAnswerEnum = {
  SHORT_ANSWER_TYPE: "Short Answer",
  LONG_ANSWER_TYPE: "Paragraph",
  MULTIPLE_ANSWER_TYPE: "Multiple Choice",
  CHECKBOX_ANSWER_TYPE: "Check Boxes",
  DATE_ANSWER_TYPE: "Date",
  TIME_ANSWER_TYPE: "Time"
};
const SurveyDetails = ({
  location,
  match
}) => {
  let isMobile = window.Digit.Utils.browser.isMobile();
  const {
    id
  } = useParams();
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const [isFormPartiallyEnabled, setFormPartiallyEnabled] = useState(false);
  const [displayMenu, setDisplayMenu] = useState(false);
  const [userAction, setUserAction] = useState(undefined);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const tenantIdForInboxSearch = window.Digit.SessionStorage.get("CITIZENSURVEY.INBOX").searchForm.tenantIds.code;
  const {
    isLoading,
    data: surveyData
  } = Digit.Hooks.survey.useSearch({
    tenantIds: tenantIdForInboxSearch,
    uuid: id
  }, {
    select: data => {
      var _data$Surveys;
      const surveyObj = data === null || data === void 0 ? void 0 : (_data$Surveys = data.Surveys) === null || _data$Surveys === void 0 ? void 0 : _data$Surveys[0];
      return {
        uuid: surveyObj.uuid,
        title: surveyObj.title,
        description: surveyObj.description,
        collectCitizenInfo: {
          code: surveyObj.collectCitizenInfo
        },
        fromDate: format(new Date(surveyObj.startDate), "yyyy-MM-dd"),
        toDate: format(new Date(surveyObj.endDate), "yyyy-MM-dd"),
        fromTime: format(new Date(surveyObj.startDate), "hh:mm"),
        toTime: format(new Date(surveyObj.endDate), "hh:mm"),
        questions: surveyObj.questions.map(({
          questionStatement,
          type,
          required,
          options,
          uuid,
          surveyId
        }) => ({
          questionStatement,
          type: TypeAnswerEnum[type],
          required,
          options,
          uuid,
          surveyId
        })),
        status: surveyObj.status
      };
    }
  });
  const isSurveyActive = useMemo(() => {
    const surveyStartTime = new Date(`${surveyData === null || surveyData === void 0 ? void 0 : surveyData.fromDate} ${surveyData === null || surveyData === void 0 ? void 0 : surveyData.fromTime}`).getTime();
    const surveyEndTime = new Date(`${surveyData === null || surveyData === void 0 ? void 0 : surveyData.toDate} ${surveyData === null || surveyData === void 0 ? void 0 : surveyData.toTime}`).getTime();
    const currentTime = new Date().getTime();
    if (surveyStartTime < currentTime && currentTime < surveyEndTime) {
      return true;
    }
    return false;
  }, [surveyData === null || surveyData === void 0 ? void 0 : surveyData.fromDate, surveyData === null || surveyData === void 0 ? void 0 : surveyData.fromTime, surveyData === null || surveyData === void 0 ? void 0 : surveyData.toDate, surveyData === null || surveyData === void 0 ? void 0 : surveyData.toTime]);
  function onActionSelect(action) {
    if (action === "EDIT") {
      if (isSurveyActive) {
        setFormPartiallyEnabled(!isFormPartiallyEnabled);
      } else {
        setIsFormDisabled(!isFormDisabled);
      }
      setUserAction("EDIT");
    }
    if (action === "INACTIVE") {
      setShowModal(true);
      setUserAction("INACTIVE");
    }
    if (action === "ACTIVE") {
      setShowModal(true);
      setUserAction("ACTIVE");
    }
    if (action === "DELETE") {
      setShowModal(true);
      setUserAction("DELETE");
    }
    setDisplayMenu(false);
  }
  const onEdit = data => {
    var _tenantIds$;
    const {
      collectCitizenInfo,
      title,
      description,
      tenantIds,
      fromDate,
      toDate,
      fromTime,
      toTime,
      questions
    } = data;
    const mappedQuestions = mapQuestions(questions);
    const details = {
      SurveyEntity: {
        uuid: surveyData.uuid,
        tenantId: (_tenantIds$ = tenantIds[0]) === null || _tenantIds$ === void 0 ? void 0 : _tenantIds$.code,
        title,
        description,
        collectCitizenInfo: collectCitizenInfo.code,
        startDate: new Date(`${fromDate} ${fromTime}`).getTime(),
        endDate: new Date(`${toDate} ${toTime}`).getTime(),
        questions: mappedQuestions,
        status: isSurveyActive ? "ACTIVE" : "INACTIVE"
      }
    };
    history.push("/digit-ui/employee/engagement/surveys/update-response", details);
  };
  const handleDelete = () => {
    const details = {
      SurveyEntity: {
        ...surveyData,
        collectCitizenInfo: surveyData.collectCitizenInfo.code
      }
    };
    history.push("/digit-ui/employee/engagement/surveys/delete-response", details);
  };
  const handleMarkActive = data => {
    const {
      fromDate,
      toDate,
      fromTime,
      toTime
    } = data;
    const details = {
      SurveyEntity: {
        ...surveyData,
        status: "ACTIVE",
        startDate: new Date(`${fromDate} ${fromTime}`).getTime(),
        endDate: new Date(`${toDate} ${toTime}`).getTime(),
        collectCitizenInfo: surveyData.collectCitizenInfo.code,
        questions: surveyData.questions.map(filterQuestion),
        tenantId
      }
    };
    history.push("/digit-ui/employee/engagement/surveys/update-response", details);
  };
  const handleMarkInactive = () => {
    const details = {
      SurveyEntity: {
        ...surveyData,
        questions: surveyData.questions.map(filterQuestion),
        status: "INACTIVE",
        collectCitizenInfo: surveyData.collectCitizenInfo.code
      }
    };
    history.push("/digit-ui/employee/engagement/surveys/update-response", details);
  };
  const actionMenuOptions = useMemo(() => {
    const options = ["EDIT", "DELETE"];
    if (isSurveyActive && (surveyData === null || surveyData === void 0 ? void 0 : surveyData.status) === "ACTIVE") {
      options.splice(1, 0, "INACTIVE");
    } else if (!isSurveyActive) {
      options.splice(1, 0, "ACTIVE");
    }
    return options;
  }, [isSurveyActive, surveyData === null || surveyData === void 0 ? void 0 : surveyData.status]);
  if (isLoading) return /*#__PURE__*/React$1.createElement(Loader, null);
  return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(Header, null, t("CS_COMMON_SURVEYS")), /*#__PURE__*/React$1.createElement(EditSurveyForms, {
    t: t,
    onEdit: onEdit,
    menuOptions: actionMenuOptions,
    displayMenu: displayMenu,
    isFormDisabled: isFormDisabled,
    isPartiallyEnabled: isFormPartiallyEnabled,
    setDisplayMenu: setDisplayMenu,
    onActionSelect: onActionSelect,
    initialSurveysConfig: surveyData,
    isSurveyActive: isSurveyActive,
    formDisabled: isFormDisabled
  }), showModal && userAction === "DELETE" && /*#__PURE__*/React$1.createElement(DeleteModal, {
    t: t,
    heading: "CONFIRM_DELETE_SURVEY",
    surveyTitle: surveyData.title,
    closeModal: () => setShowModal(false),
    actionCancelLabel: "CS_COMMON_CANCEL",
    actionCancelOnSubmit: () => setShowModal(false),
    actionSaveLabel: "ES_COMMON_DEL",
    actionSaveOnSubmit: handleDelete
  }), showModal && userAction === "ACTIVE" && /*#__PURE__*/React$1.createElement(MarkActiveModal, {
    t: t,
    heading: "CONFIRM_MARKACTIVE_SURVEY",
    initialValues: surveyData,
    closeModal: () => setShowModal(false),
    actionCancelLabel: "CS_COMMON_CANCEL",
    actionCancelOnSubmit: () => setShowModal(false),
    actionSaveLabel: "ES_COMMON_SAVE",
    actionSaveOnSubmit: handleMarkActive,
    onSubmit: handleMarkActive,
    surveyTitle: surveyData.title
  }), showModal && userAction === "INACTIVE" && /*#__PURE__*/React$1.createElement(MarkInActiveModal, {
    t: t,
    heading: "CONFIRM_MARKINACTIVE_SURVEY",
    surveyTitle: surveyData.title,
    closeModal: () => setShowModal(false),
    actionCancelLabel: "CS_COMMON_CANCEL",
    actionCancelOnSubmit: () => setShowModal(false),
    actionSaveLabel: "ES_COMMON_Y_MARKINACTIVE",
    actionSaveOnSubmit: handleMarkInactive
  }));
};

const CitizenSurveyQuestion = ({
  t,
  question,
  control,
  register,
  values,
  formState,
  formDisabled
}) => {
  const formErrors = formState === null || formState === void 0 ? void 0 : formState.errors;
  if (!question) return;
  const displayAnswerField = answerType => {
    var _formErrors$question$, _formErrors$question$2, _formErrors$question$3, _formErrors$question$4, _formErrors$question$5, _formErrors$question$6, _formErrors$question$7, _formErrors$question$8;
    switch (answerType) {
      case "SHORT_ANSWER_TYPE":
        return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(TextInput, {
          name: question.uuid,
          disabled: formDisabled,
          type: "text",
          inputRef: register({
            maxLength: {
              value: 200,
              message: t("EXCEEDS_200_CHAR_LIMIT")
            },
            required: question.required
          })
        }), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors[question.uuid]) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$question$ = formErrors[question.uuid]) === null || _formErrors$question$ === void 0 ? void 0 : _formErrors$question$.type) === "required" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`CS_COMMON_REQUIRED`)), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors[question.uuid]) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$question$2 = formErrors[question.uuid]) === null || _formErrors$question$2 === void 0 ? void 0 : _formErrors$question$2.type) === "maxLength" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EXCEEDS_200_CHAR_LIMIT`)));
      case "LONG_ANSWER_TYPE":
        return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(TextArea, {
          name: question.uuid,
          disabled: formDisabled,
          inputRef: register({
            maxLength: {
              value: 500,
              message: t("EXCEEDS_500_CHAR_LIMIT")
            },
            required: question.required
          })
        }), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors[question.uuid]) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$question$3 = formErrors[question.uuid]) === null || _formErrors$question$3 === void 0 ? void 0 : _formErrors$question$3.type) === "required" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`CS_COMMON_REQUIRED`)), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors[question.uuid]) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$question$4 = formErrors[question.uuid]) === null || _formErrors$question$4 === void 0 ? void 0 : _formErrors$question$4.type) === "maxLength" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EXCEEDS_500_CHAR_LIMIT`)));
      case "MULTIPLE_ANSWER_TYPE":
        return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(Controller, {
          control: control,
          name: question.uuid,
          rules: {
            required: question.required
          },
          render: ({
            onChange,
            value
          }) => /*#__PURE__*/React$1.createElement(RadioButtons, {
            disabled: formDisabled,
            onSelect: onChange,
            selectedOption: value,
            optionsKey: "",
            options: [...question.options]
          })
        }), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors[question.uuid]) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$question$5 = formErrors[question.uuid]) === null || _formErrors$question$5 === void 0 ? void 0 : _formErrors$question$5.type) === "required" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_REQUIRED`)));
      case "CHECKBOX_ANSWER_TYPE":
        return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(Controller, {
          control: control,
          name: question.uuid,
          render: ({
            onChange,
            value
          }) => /*#__PURE__*/React$1.createElement("div", {
            className: "align-columns"
          }, question.options.map(option => {
            return /*#__PURE__*/React$1.createElement(CheckBox, {
              disabled: formDisabled,
              key: option,
              onChange: e => {
                if (e.target.checked) {
                  onChange([option, ...(value ? value : [])]);
                } else {
                  value && onChange(value.filter(item => item !== option));
                }
              },
              checked: !!(value !== null && value !== void 0 && value.find(e => e === option)),
              label: option
            });
          }))
        }), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors[question.uuid]) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$question$6 = formErrors[question.uuid]) === null || _formErrors$question$6 === void 0 ? void 0 : _formErrors$question$6.type) === "required" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`CS_COMMON_REQUIRED`)));
      case "DATE_ANSWER_TYPE":
        return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(Controller, {
          control: control,
          name: question.uuid,
          rules: {
            required: question.required
          },
          render: ({
            onChange,
            value
          }) => /*#__PURE__*/React$1.createElement(TextInput, {
            disabled: formDisabled,
            type: "date",
            onChange: onChange,
            defaultValue: value
          })
        }), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors[question.uuid]) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$question$7 = formErrors[question.uuid]) === null || _formErrors$question$7 === void 0 ? void 0 : _formErrors$question$7.type) === "required" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_REQUIRED`)));
      case "TIME_ANSWER_TYPE":
        return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(Controller, {
          control: control,
          name: question.uuid,
          rules: {
            required: question.required
          },
          render: ({
            onChange,
            value
          }) => /*#__PURE__*/React$1.createElement(TextInput, {
            type: "time",
            disabled: formDisabled,
            onChange: onChange,
            defaultValue: value
          })
        }), formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors[question.uuid]) && (formErrors === null || formErrors === void 0 ? void 0 : (_formErrors$question$8 = formErrors[question.uuid]) === null || _formErrors$question$8 === void 0 ? void 0 : _formErrors$question$8.type) === "required" && /*#__PURE__*/React$1.createElement(CardLabelError$1, null, t(`EVENTS_TO_DATE_ERROR_REQUIRED`)));
      default:
        return /*#__PURE__*/React$1.createElement(TextInput, {
          name: question.uuid,
          disabled: formDisabled,
          type: "text",
          inputRef: register({
            maxLength: {
              value: 60,
              message: t("EXCEEDS_60_CHAR_LIMIT")
            },
            required: question.required
          })
        });
    }
  };
  return /*#__PURE__*/React$1.createElement(Card, null, /*#__PURE__*/React$1.createElement("div", {
    className: "surveyQuestion-wrapper"
  }, /*#__PURE__*/React$1.createElement("span", {
    className: "question-title"
  }, question.questionStatement), /*#__PURE__*/React$1.createElement("span", null, displayAnswerField(question.type))));
};

const CitizenSurveyForm = ({
  surveyData,
  onFormSubmit,
  submitDisabled,
  formDisabled,
  formDefaultValues
}) => {
  var _surveyData$title;
  const {
    register: registerRef,
    control: controlSurveyForm,
    handleSubmit: handleSurveyFormSubmit,
    setValue: setSurveyFormValue,
    getValues: getSurveyFormValues,
    reset: resetSurveyForm,
    formState: surveyFormState,
    clearErrors: clearSurveyFormsErrors
  } = useForm({
    defaultValues: formDefaultValues
  });
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement("div", {
    className: "citizenSurvey-wrapper"
  }, /*#__PURE__*/React$1.createElement(Header, null, surveyData === null || surveyData === void 0 ? void 0 : (_surveyData$title = surveyData.title) === null || _surveyData$title === void 0 ? void 0 : _surveyData$title.toUpperCase()), /*#__PURE__*/React$1.createElement("form", {
    onSubmit: handleSurveyFormSubmit(onFormSubmit)
  }, surveyData.questions.length ? surveyData.questions.map((config, index) => /*#__PURE__*/React$1.createElement(CitizenSurveyQuestion, {
    key: index,
    t: t,
    question: config,
    control: controlSurveyForm,
    register: registerRef,
    values: getSurveyFormValues,
    formState: surveyFormState,
    formDisabled: formDisabled
  })) : null, /*#__PURE__*/React$1.createElement(ActionBar, null, !submitDisabled && /*#__PURE__*/React$1.createElement(SubmitBar, {
    label: t("CS_SUBMIT_SURVEY"),
    submit: "submit"
  }))));
};

const bindQuesWithAns = (ques, ans) => {
  let data = [];
  ques.map(ques => {
    let obj = {};
    if (ques.type === "Check Boxes") {
      obj["type"] = ques.type;
      obj["questionStatement"] = ques.questionStatement;
      obj["options"] = ques.options;
      obj["answers"] = [];
      ans.map(ans => {
        if (ques.uuid === ans.questionId) {
          obj["answers"] = [...obj["answers"], ans.answer];
        }
      });
    } else {
      const type = ques.type;
      obj["type"] = type;
      obj["questionStatement"] = ques.questionStatement;
      obj["options"] = ques.options;
      ans.map(ans => {
        if (ques.uuid === ans.questionId) {
          const answers = obj["answers"];
          if (answers) answers.push(ans.answer[0]);
          obj["answers"] = answers ? answers : [ans.answer[0]];
        }
      });
    }
    data.push(obj);
  });
  return data;
};

const WhoHasResponded = ({
  t,
  userInfo
}) => {
  const data = Object.entries(userInfo);
  return /*#__PURE__*/React$1.createElement("div", {
    style: {
      "margin": "30px"
    }
  }, /*#__PURE__*/React$1.createElement("header", {
    style: {
      "fontSize": "30px",
      "fontWeight": "bold"
    }
  }, t("WHO_RESPONDED")), /*#__PURE__*/React$1.createElement("div", {
    style: {
      "display": "flex",
      "padding": "8px 4px",
      "background-color": "#FAFAFA",
      "border": "1px solid #D6D5D4",
      "boxSizing": "borderBox",
      "borderRadius": "4px",
      "marginTop": "20px",
      "marginBottom": "20px"
    }
  }, /*#__PURE__*/React$1.createElement("div", {
    style: {
      "flex": "50%",
      "padding": "10px"
    }
  }, /*#__PURE__*/React$1.createElement("header", {
    style: {
      "fontWeight": "bold",
      "fontSize": "25px"
    }
  }, "Email"), data.map(user => /*#__PURE__*/React$1.createElement("p", {
    style: {
      "margin": "10px 0px 10px 0px"
    }
  }, user[1]))), /*#__PURE__*/React$1.createElement("div", {
    style: {
      "flex": "50%",
      "padding": "10px"
    }
  }, /*#__PURE__*/React$1.createElement("header", {
    style: {
      "fontWeight": "bold",
      "fontSize": "25px"
    }
  }, "Phone Number"), data.map(user => /*#__PURE__*/React$1.createElement("p", {
    style: {
      "margin": "10px 0px 10px 0px"
    }
  }, user[0])))));
};

const SurveyDetailsView = ({
  surveyTitle,
  surveyDesc,
  t
}) => {
  const ulbs = Digit.SessionStorage.get("ENGAGEMENT_TENANTS");
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const userInfo = Digit.UserService.getUser().info;
  const userUlbs = ulbs.filter(ulb => {
    var _userInfo$roles;
    return userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$roles = userInfo.roles) === null || _userInfo$roles === void 0 ? void 0 : _userInfo$roles.some(role => (role === null || role === void 0 ? void 0 : role.tenantId) === (ulb === null || ulb === void 0 ? void 0 : ulb.code));
  });
  const selectedTenat = useMemo(() => {
    const filtered = ulbs.filter(item => item.code === tenantId);
    return filtered;
  }, [ulbs]);
  return /*#__PURE__*/React$1.createElement("div", {
    className: "surveydetailsform-wrapper"
  }, /*#__PURE__*/React$1.createElement("span", {
    className: "surveyformfield"
  }, /*#__PURE__*/React$1.createElement("label", null, `${t("LABEL_FOR_ULB")} * :`), /*#__PURE__*/React$1.createElement("div", {
    style: {
      display: "grid",
      gridAutoFlow: "row"
    }
  }, /*#__PURE__*/React$1.createElement(Dropdown, {
    allowMultiselect: true,
    optionKey: "i18nKey",
    option: userUlbs,
    selected: selectedTenat,
    keepNull: true,
    disable: true,
    t: t
  }), /*#__PURE__*/React$1.createElement(RemoveableTag, {
    key: "tag",
    text: userUlbs[0].name
  }))), /*#__PURE__*/React$1.createElement("span", {
    className: "surveyformfield"
  }, /*#__PURE__*/React$1.createElement("label", null, t("CS_SURVEY_NAME")), /*#__PURE__*/React$1.createElement(TextInput, {
    name: "title",
    type: "text",
    disable: true,
    value: surveyTitle
  })), /*#__PURE__*/React$1.createElement("span", {
    className: "surveyformfield"
  }, /*#__PURE__*/React$1.createElement("label", null, t("CS_SURVEY_DESCRIPTION")), /*#__PURE__*/React$1.createElement(TextInput, {
    name: "description",
    type: "text",
    disable: true,
    value: surveyDesc
  })));
};

const getData = data => {
  const options = data.options;
  const answers = data.answers;
  const processedData = [];
  options.map(option => processedData.push({
    name: option,
    value: 0
  }));
  answers.map((ans, index) => {
    processedData.map((element, i) => {
      if (element.name === ans) processedData[i].value = processedData[i].value + 1;
    });
  });
  return processedData;
};
const COLORS = ["#8E29BF", "#FBC02D", "#048BD0", "#EA8A3B", "#0BABDE", "#800080", "#ee82ee", "#616161", "#3cb371", "#6a5acd"];
const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  return /*#__PURE__*/React$1.createElement("text", {
    x: x,
    y: y,
    fill: "white",
    textAnchor: x > cx ? "start" : "end",
    dominantBaseline: "central"
  }, `${(percent * 100).toFixed(0)}%`);
};
const renderLegend = props => {
  const {
    payload
  } = props;
  return /*#__PURE__*/React$1.createElement("ul", {
    style: {
      "listStyle": "disc"
    }
  }, payload.map((entry, index) => /*#__PURE__*/React$1.createElement("li", {
    key: `item-${index}`,
    style: {
      "display": "list-item",
      "color": entry.color,
      "fontSize": "19px"
    }
  }, entry.value)));
};
const McqChart = props => {
  const data = getData(props.data);
  return /*#__PURE__*/React$1.createElement(PieChart, {
    width: 400,
    height: 400
  }, /*#__PURE__*/React$1.createElement(Pie, {
    data: data,
    cx: 200,
    cy: 200,
    labelLine: false,
    label: renderCustomizedLabel,
    outerRadius: 120,
    fill: "#8884d8",
    dataKey: "value"
  }, data.map((entry, index) => /*#__PURE__*/React$1.createElement(Cell, {
    key: `cell-${index}`,
    fill: COLORS[index % COLORS.length]
  }))), /*#__PURE__*/React$1.createElement(Tooltip, null), /*#__PURE__*/React$1.createElement(Legend, {
    content: renderLegend,
    width: 100,
    align: "right",
    wrapperStyle: {
      top: 40,
      right: 20,
      left: 500,
      backgroundColor: '#FAFAFA',
      borderRadius: 3,
      lineHeight: '40px'
    }
  }));
};

const formObj = data => {
  const checkBoxData = [];
  const options = data.options;
  const answers = data.answers;
  options.map(option => {
    const obj = {};
    obj["name"] = option;
    obj["value"] = 0;
    answers.map(ans => {
      ans.map(el => {
        if (el === option) {
          obj["value"] = obj["value"] + 1;
        }
      });
    });
    checkBoxData.push(obj);
  });
  return checkBoxData;
};
const CheckBoxChart = props => {
  const datav1 = formObj(props.data);
  return /*#__PURE__*/React$1.createElement("div", {
    style: {
      "padding": "10px",
      "width": "700px",
      "height": "260px",
      "backgroundColor": "#fafafa"
    }
  }, /*#__PURE__*/React$1.createElement(ResponsiveContainer, null, /*#__PURE__*/React$1.createElement(BarChart, {
    data: datav1,
    layout: "vertical",
    margin: {
      top: 0,
      right: 50,
      left: 0,
      bottom: 0
    },
    barCategoryGap: 8
  }, /*#__PURE__*/React$1.createElement(CartesianGrid, {
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React$1.createElement(XAxis, {
    type: "number"
  }), /*#__PURE__*/React$1.createElement(YAxis, {
    type: "category",
    width: 150,
    padding: {
      left: 20
    },
    dataKey: "name"
  }), /*#__PURE__*/React$1.createElement(Bar, {
    dataKey: "value",
    fill: "#048BD0"
  }), /*#__PURE__*/React$1.createElement(Tooltip, null))));
};

const transformDate = date => {
  const split = date.split('-');
  const month = split[1];
  const year = split[0];
  const day = split[2];
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  return {
    day,
    date: `${monthNames[month - 1]} ${year}`
  };
};
function transformTime(time) {
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
  if (time.length > 1) {
    time = time.slice(1);
    time[5] = +time[0] < 12 ? ' AM' : ' PM';
    time[0] = +time[0] % 12 || 12;
  }
  return time.join('');
}
const getUserData = data => {
  const obj = {};
  data.map(ans => {
    obj[ans.mobileNumber] = ans.emailId;
  });
  return obj;
};
const displayResult = (ques, ans, type, resCount) => {
  switch (type) {
    case "Short Answer":
      return (
        /*#__PURE__*/
        React$1.createElement("div", {
          style: {
            "margin": "30px"
          }
        }, /*#__PURE__*/React$1.createElement(CardSectionHeader, null, ques.questionStatement), /*#__PURE__*/React$1.createElement("header", {
          style: {
            "fontWeight": "bold"
          }
        }, `${resCount} Responses`), /*#__PURE__*/React$1.createElement("div", {
          className: "responses-container"
        }, ans.map(el => /*#__PURE__*/React$1.createElement("div", {
          className: "response-result responses-container-line"
        }, el, /*#__PURE__*/React$1.createElement(BreakLine, {
          style: {
            "marginTop": "10px"
          }
        })))))
      );
    case "Date":
      return /*#__PURE__*/React$1.createElement("div", {
        style: {
          "margin": "30px"
        }
      }, /*#__PURE__*/React$1.createElement(CardSectionHeader, null, ques.questionStatement), /*#__PURE__*/React$1.createElement("header", {
        style: {
          "fontWeight": "bold"
        }
      }, `${resCount} Responses`), /*#__PURE__*/React$1.createElement("div", {
        className: "date-container"
      }, ans.map(el => /*#__PURE__*/React$1.createElement("div", {
        className: "date-response"
      }, /*#__PURE__*/React$1.createElement("div", null, transformDate(el).date), /*#__PURE__*/React$1.createElement("div", {
        className: "divide"
      }), /*#__PURE__*/React$1.createElement("div", null, transformDate(el).day)))));
    case "Time":
      return /*#__PURE__*/React$1.createElement("div", {
        style: {
          "margin": "30px"
        }
      }, /*#__PURE__*/React$1.createElement(CardSectionHeader, null, ques.questionStatement), /*#__PURE__*/React$1.createElement("header", {
        style: {
          "fontWeight": "bold"
        }
      }, `${resCount} Responses`), /*#__PURE__*/React$1.createElement("div", {
        className: "date-container"
      }, ans.map(el => /*#__PURE__*/React$1.createElement("div", {
        className: "date-response"
      }, /*#__PURE__*/React$1.createElement("div", null, el), /*#__PURE__*/React$1.createElement("div", {
        className: "divide"
      }), /*#__PURE__*/React$1.createElement("div", null, transformTime(el))))));
    case "Paragraph":
      return (
        /*#__PURE__*/
        React$1.createElement("div", {
          style: {
            "margin": "30px"
          }
        }, /*#__PURE__*/React$1.createElement(CardSectionHeader, null, ques.questionStatement), /*#__PURE__*/React$1.createElement("header", {
          style: {
            "fontWeight": "bold"
          }
        }, `${resCount} Responses`), /*#__PURE__*/React$1.createElement("div", {
          className: "responses-container"
        }, ans.map(el => /*#__PURE__*/React$1.createElement("div", {
          className: "response-result responses-container-line"
        }, el, /*#__PURE__*/React$1.createElement(BreakLine, {
          style: {
            "marginTop": "10px"
          }
        })))))
      );
    case "Check Boxes":
      return (
        /*#__PURE__*/
        React$1.createElement("div", {
          style: {
            "margin": "30px"
          }
        }, /*#__PURE__*/React$1.createElement(CardSectionHeader, null, ques.questionStatement), /*#__PURE__*/React$1.createElement("header", {
          style: {
            "fontWeight": "bold"
          }
        }, `${resCount} Responses`), /*#__PURE__*/React$1.createElement("div", {
          className: "responses-container",
          style: {
            "padding": "30px"
          }
        }, /*#__PURE__*/React$1.createElement(CheckBoxChart, {
          data: ques
        })))
      );
    case "Multiple Choice":
      return /*#__PURE__*/React$1.createElement("div", {
        style: {
          "margin": "30px"
        }
      }, /*#__PURE__*/React$1.createElement(CardSectionHeader, null, ques.questionStatement), /*#__PURE__*/React$1.createElement("header", {
        style: {
          "fontWeight": "bold"
        }
      }, `${resCount} Responses`), /*#__PURE__*/React$1.createElement("div", {
        className: "responses-container"
      }, /*#__PURE__*/React$1.createElement(McqChart, {
        data: ques
      })));
  }
};
const SurveyResultsView = ({
  surveyInfo,
  responsesInfoMutation
}) => {
  const {
    t
  } = useTranslation();
  const [data, setData] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  useEffect(() => {
    if (responsesInfoMutation.isSuccess) {
      const dp = bindQuesWithAns(surveyInfo === null || surveyInfo === void 0 ? void 0 : surveyInfo.questions, responsesInfoMutation.data.answers);
      setData(dp);
      const ue = getUserData(responsesInfoMutation.data.answers);
      setUserInfo(ue);
    }
  }, [responsesInfoMutation]);
  if (!data) return /*#__PURE__*/React$1.createElement(Loader, null);
  return /*#__PURE__*/React$1.createElement(Card, null, /*#__PURE__*/React$1.createElement(CardHeader, null, "Surveys"), /*#__PURE__*/React$1.createElement("div", {
    style: {
      "margin": "30px"
    }
  }, /*#__PURE__*/React$1.createElement(SurveyDetailsView, {
    surveyTitle: surveyInfo.title,
    surveyDesc: surveyInfo.description,
    t: t
  })), /*#__PURE__*/React$1.createElement(WhoHasResponded, {
    t: t,
    userInfo: userInfo
  }), data.map(element => displayResult(element, element.answers, element.type, element.answers.length)));
};

const TypeAnswerEnum$1 = {
  SHORT_ANSWER_TYPE: "Short Answer",
  LONG_ANSWER_TYPE: "Paragraph",
  MULTIPLE_ANSWER_TYPE: "Multiple Choice",
  CHECKBOX_ANSWER_TYPE: "Check Boxes",
  DATE_ANSWER_TYPE: "Date",
  TIME_ANSWER_TYPE: "Time"
};
const SurveyResults = () => {
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const params = useParams();
  const mutation = Digit.Hooks.survey.useShowResults();
  const queryClient = useQueryClient();
  useEffect(() => {
    const onSuccess = () => {
      queryClient.clear();
    };
    mutation.mutate({
      surveyId: params.id
    }, {
      onSuccess
    });
  }, []);
  const {
    isLoading,
    data: surveyData
  } = Digit.Hooks.survey.useSearch({
    tenantIds: tenantId,
    uuid: params.id
  }, {
    select: data => {
      var _data$Surveys;
      const surveyObj = data === null || data === void 0 ? void 0 : (_data$Surveys = data.Surveys) === null || _data$Surveys === void 0 ? void 0 : _data$Surveys[0];
      return {
        uuid: surveyObj.uuid,
        title: surveyObj.title,
        description: surveyObj.description,
        collectCitizenInfo: {
          code: surveyObj.collectCitizenInfo
        },
        fromDate: format(new Date(surveyObj.startDate), "yyyy-MM-dd"),
        toDate: format(new Date(surveyObj.endDate), "yyyy-MM-dd"),
        fromTime: format(new Date(surveyObj.startDate), "hh:mm"),
        toTime: format(new Date(surveyObj.endDate), "hh:mm"),
        questions: surveyObj.questions.map(({
          questionStatement,
          type,
          required,
          options,
          uuid,
          surveyId
        }) => ({
          questionStatement,
          type: TypeAnswerEnum$1[type],
          required,
          options,
          uuid,
          surveyId
        })),
        status: surveyObj.status,
        answersCount: surveyObj.answersCount
      };
    }
  });
  if (isLoading) return /*#__PURE__*/React$1.createElement(Loader, null);
  return /*#__PURE__*/React$1.createElement(SurveyResultsView, {
    surveyInfo: surveyData,
    responsesInfoMutation: mutation
  });
};

const Surveys = ({
  match: {
    path
  } = {},
  tenants,
  parentRoute
}) => {
  return /*#__PURE__*/React$1.createElement(Switch, null, /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/inbox/create`,
    component: props => /*#__PURE__*/React$1.createElement(NewSurveys, props)
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/create`,
    component: props => /*#__PURE__*/React$1.createElement(NewSurveys, props)
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/inbox/details/:id`,
    component: props => /*#__PURE__*/React$1.createElement(SurveyDetails, props)
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/inbox/results/:id`,
    component: props => /*#__PURE__*/React$1.createElement(SurveyResults, props)
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/inbox`,
    component: props => /*#__PURE__*/React$1.createElement(Inbox$3, Object.assign({}, props, {
      tenants: tenants,
      parentRoute: parentRoute
    }))
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/create-response`,
    component: props => /*#__PURE__*/React$1.createElement(Acknowledgement$1, props)
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/update-response`,
    component: props => /*#__PURE__*/React$1.createElement(Response$5, props)
  }), /*#__PURE__*/React$1.createElement(PrivateRoute, {
    path: `${path}/delete-response`,
    component: props => /*#__PURE__*/React$1.createElement(Response$6, props)
  }));
};

const transformSurveyResponseData = data => {
  if (!data) return;
  const questions = [];
  for (const key in data) {
    questions.push({
      questionId: key,
      answer: [data[key]]
    });
  }
  return questions;
};
const FillSurvey = ({
  location
}) => {
  const surveyData = location === null || location === void 0 ? void 0 : location.state;
  const history = useHistory();
  const onSubmit = data => {
    const details = {
      AnswerEntity: {
        surveyId: surveyData.uuid,
        answers: transformSurveyResponseData(data),
        surveyTitle: surveyData.title,
        hasResponded: surveyData.hasResponded
      }
    };
    history.push("/digit-ui/citizen/engagement/surveys/submit-response", details);
  };
  return /*#__PURE__*/React$1.createElement(CitizenSurveyForm, {
    surveyData: surveyData,
    onFormSubmit: onSubmit,
    formDisabled: false
  });
};

const ShowSurvey = ({
  location
}) => {
  var _mutation$data;
  const surveyData = location === null || location === void 0 ? void 0 : location.state;
  const tenantIds = Digit.ULBService.getCitizenCurrentTenant();
  const mutation = Digit.Hooks.survey.useShowResults();
  const queryClient = useQueryClient();
  useEffect(() => {
    const onSuccess = () => {
      queryClient.clear();
    };
    mutation.mutate({
      surveyId: surveyData.uuid
    }, {
      onSuccess
    });
  }, []);
  if (mutation.isLoading && !mutation.isIdle) {
    return /*#__PURE__*/React$1.createElement(Loader, null);
  }
  if (mutation.isError) return /*#__PURE__*/React$1.createElement("div", null, "An error occured...");
  const answers = mutation === null || mutation === void 0 ? void 0 : (_mutation$data = mutation.data) === null || _mutation$data === void 0 ? void 0 : _mutation$data.answers;
  const formDefaultValues = {};
  answers === null || answers === void 0 ? void 0 : answers.map(ans => {
    if ((ans === null || ans === void 0 ? void 0 : ans.answer.length) === 1) formDefaultValues[ans === null || ans === void 0 ? void 0 : ans.questionId] = ans === null || ans === void 0 ? void 0 : ans.answer[0];else formDefaultValues[ans === null || ans === void 0 ? void 0 : ans.questionId] = ans === null || ans === void 0 ? void 0 : ans.answer;
  });
  return /*#__PURE__*/React$1.createElement(CitizenSurveyForm, {
    surveyData: surveyData,
    submitDisabled: true,
    formDisabled: true,
    formDefaultValues: formDefaultValues
  });
};

const EventsBreadCrumb = ({
  location
}) => {
  const {
    t
  } = useTranslation();
  const crumbs = [{
    path: "/digit-ui/employee",
    content: t("ES_COMMON_HOME"),
    show: true
  }, {
    path: "/digit-ui/employee/engagement/event/inbox",
    content: t("ES_EVENT_INBOX"),
    show: location.pathname.includes("event/inbox") ? true : false
  }, {
    path: "/digit-ui/employee/event/new-event",
    content: t("ES_EVENT_NEW_EVENT"),
    show: location.pathname.includes("event/new-event") ? true : false
  }, {
    path: "/digit-ui/employee/event/inbox/new-event",
    content: t("ES_EVENT_NEW_EVENT"),
    show: location.pathname.includes("event/inbox/new-event") ? true : false
  }, {
    path: "/digit-ui/employee/event/inbox/event-details",
    content: t("ES_EVENT_EVENT_DETAILS"),
    show: location.pathname.includes("event-details") ? true : false
  }, {
    path: "/digit-ui/employee/engagement/event/edit-event",
    content: t("ES_EVENT_EDIT_EVENT"),
    show: location.pathname.includes("event/edit-event") ? true : false
  }, {
    path: "/digit-ui/employee/event/response",
    content: t("ES_EVENT_NEW_EVENT_RESPONSE"),
    show: location.pathname.includes("event/response") ? true : false
  }, {
    path: "/digit-ui/employee/engagement/documents/inbox",
    content: t("ES_EVENT_INBOX"),
    show: location.pathname.includes("/documents/inbox") ? true : false
  }, {
    path: "/digit-ui/employee/engagement/documents/new-doc",
    content: t("NEW_DOCUMENT_TEXT"),
    show: location.pathname.includes("/documents/new-doc") ? true : false
  }, {
    path: "/digit-ui/employee/engagement/documents/inbox/new-doc",
    content: t("NEW_DOCUMENT_TEXT"),
    show: location.pathname.includes("/documents/inbox/new-doc") ? true : false
  }, {
    path: "/digit-ui/employee/engagement/documents/response",
    content: t("ES_EVENT_NEW_EVENT_RESPONSE"),
    show: location.pathname.includes("/documents/response") ? true : false
  }, {
    path: "/digit-ui/employee/engagement/documents/delete-response",
    content: t("ES_EVENT_NEW_EVENT_RESPONSE"),
    show: location.pathname.includes("/documents/delete-response") ? true : false
  }, {
    path: "/digit-ui/employee/engagement/documents/update-response",
    content: t("ES_EVENT_NEW_EVENT_RESPONSE"),
    show: location.pathname.includes("/documents/update-response") ? true : false
  }, {
    path: "/digit-ui/employee/engagement/documents/inbox/details/:id",
    content: t("CE_DOCUMENT_DETAILS"),
    show: location.pathname.includes("/documents/inbox/details") ? true : false
  }, {
    path: "/digit-ui/employee/engagement/documents/inbox/update",
    content: t("DOCUMENTS_EDIT_HEADER"),
    show: location.pathname.includes("/documents/inbox/update") ? true : false
  }, {
    path: "/digit-ui/employee/engagement/messages/inbox",
    content: t("ES_EVENT_INBOX"),
    show: location.pathname.includes("/messages/inbox") ? true : false
  }, {
    path: "/digit-ui/employee/engagement/messages/create",
    content: t("NEW_PUBLIC_BRDCST"),
    show: location.pathname.includes("/messages/create") ? true : false
  }, {
    path: "/digit-ui/employee/engagement/messages/inbox/create",
    content: t("NEW_PUBLIC_BRDCST"),
    show: location.pathname.includes("/messages/inbox/create") ? true : false
  }, {
    path: "/digit-ui/employee/engagement/messages/inbox/details/:id",
    content: t("CS_HEADER_PUBLIC_BRDCST"),
    show: location.pathname.includes("/messages/inbox/details") ? true : false
  }, {
    path: "/digit-ui/employee/engagement/messages/inbox/edit/:id",
    content: t("EDIT_PUBLIC_BRDCST"),
    show: location.pathname.includes("/messages/inbox/edit") ? true : false
  }, {
    path: "/digit-ui/employee/engagement/messages/response",
    content: t("ES_EVENT_NEW_EVENT_RESPONSE"),
    show: location.pathname.includes("/messages/response") ? true : false
  }, {
    path: "/digit-ui/employee/engagement/messages/response?update=true",
    content: t("ES_EVENT_NEW_EVENT_RESPONSE"),
    show: location.pathname.includes("/messages/response?update=true") ? true : false
  }, {
    path: "/digit-ui/employee/engagement/messages/response?delete=true",
    content: t("ES_EVENT_NEW_EVENT_RESPONSE"),
    show: location.pathname.includes("/messages/response?delete=true") ? true : false
  }, {
    path: "/digit-ui/employee/engagement/surveys/inbox",
    content: t("ES_EVENT_INBOX"),
    show: location.pathname.includes("/surveys/inbox") ? true : false
  }, {
    path: "/digit-ui/employee/engagement/surveys/inbox/create",
    content: t("CS_COMMON_SURVEYS"),
    show: location.pathname.includes("/surveys/inbox/create") ? true : false
  }, {
    path: "/digit-ui/employee/engagement/surveys/create",
    content: t("CS_COMMON_SURVEYS"),
    show: location.pathname.includes("/surveys/create") ? true : false
  }, {
    path: "/digit-ui/employee/engagement/survey/create-response",
    content: t("ES_EVENT_NEW_EVENT_RESPONSE"),
    show: location.pathname.includes("/engagement/survey/create-response") ? true : false
  }];
  return /*#__PURE__*/React$1.createElement(BreadCrumb, {
    crumbs: crumbs
  });
};
const EmployeeApp = ({
  path,
  url,
  userType,
  tenants
}) => {
  const location = useLocation();
  return (
    /*#__PURE__*/
    React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(EventsBreadCrumb, {
      location: location
    }), /*#__PURE__*/React$1.createElement(Switch, null, /*#__PURE__*/React$1.createElement(Route, {
      path: `${path}/event/inbox`,
      exact: true
    }, /*#__PURE__*/React$1.createElement(Inbox, {
      tenants: tenants,
      parentRoute: path
    })), /*#__PURE__*/React$1.createElement(Route, {
      path: `${path}/event/response`,
      component: props => /*#__PURE__*/React$1.createElement(Response, props)
    }), /*#__PURE__*/React$1.createElement(Route, {
      path: `${path}/event/inbox/new-event`
    }, /*#__PURE__*/React$1.createElement(NewEvents, null)), /*#__PURE__*/React$1.createElement(Route, {
      path: `${path}/event/new-event`
    }, /*#__PURE__*/React$1.createElement(NewEvents, null)), /*#__PURE__*/React$1.createElement(Route, {
      path: `${path}/event/edit-event/:id`
    }, /*#__PURE__*/React$1.createElement(EditEvents, null)), /*#__PURE__*/React$1.createElement(Route, {
      path: `${path}/event/inbox/event-details/:id`
    }, /*#__PURE__*/React$1.createElement(EventDetails, null)), /*#__PURE__*/React$1.createElement(Route, {
      exact: true,
      path: `${path}/documents/inbox/update`,
      component: props => /*#__PURE__*/React$1.createElement(Documents$2, props)
    }), /*#__PURE__*/React$1.createElement(Route, {
      exact: true,
      path: `${path}/documents/inbox/new-doc`,
      component: () => /*#__PURE__*/React$1.createElement(Documents$1, {
        path
      })
    }), /*#__PURE__*/React$1.createElement(Route, {
      exact: true,
      path: `${path}/documents/new-doc`,
      component: () => /*#__PURE__*/React$1.createElement(Documents$1, {
        path
      })
    }), /*#__PURE__*/React$1.createElement(Route, {
      path: `${path}/documents/inbox/details/:id`,
      component: props => /*#__PURE__*/React$1.createElement(DocumentDetails$1, props)
    }), /*#__PURE__*/React$1.createElement(Route, {
      path: `${path}/documents/response`,
      component: props => /*#__PURE__*/React$1.createElement(Response$2, props)
    }), /*#__PURE__*/React$1.createElement(Route, {
      path: `${path}/documents/update-response`,
      component: props => /*#__PURE__*/React$1.createElement(Response$3, props)
    }), /*#__PURE__*/React$1.createElement(Route, {
      path: `${path}/documents/delete-response`,
      component: props => /*#__PURE__*/React$1.createElement(Response$4, props)
    }), /*#__PURE__*/React$1.createElement(Route, {
      path: `${path}/documents/inbox`,
      component: props => /*#__PURE__*/React$1.createElement(Inbox$2, {
        tenants: tenants
      })
    }), /*#__PURE__*/React$1.createElement(Route, {
      path: `${path}/messages`,
      component: props => /*#__PURE__*/React$1.createElement(Messages, Object.assign({}, props, {
        tenants: tenants,
        parentRoute: path
      }))
    }), /*#__PURE__*/React$1.createElement(Route, {
      path: `${path}/surveys`,
      component: props => /*#__PURE__*/React$1.createElement(Surveys, Object.assign({}, props, {
        tenants: tenants,
        parentRoute: path
      }))
    })))
  );
};
const EngagementModule = ({
  stateCode,
  userType,
  tenants
}) => {
  const moduleCode = "Engagement";
  const {
    path,
    url
  } = useRouteMatch();
  const language = Digit.StoreData.getCurrentLanguage();
  const {
    isLoading,
    data: store
  } = Digit.Services.useStore({
    stateCode,
    moduleCode,
    language
  });
  if (isLoading) {
    return /*#__PURE__*/React$1.createElement(Loader, null);
  }
  Digit.SessionStorage.set("ENGAGEMENT_TENANTS", tenants);
  if (userType === "citizen") {
    return /*#__PURE__*/React$1.createElement(CitizenApp, {
      path: path,
      url: url,
      userType: userType,
      tenants: tenants
    });
  } else {
    return /*#__PURE__*/React$1.createElement(EmployeeApp, {
      path: path,
      url: url,
      userType: userType,
      tenants: tenants
    });
  }
};
const componentsToRegister = {
  EngagementModule,
  EngagementDocSelectULB: SelectULB,
  EngagementULBDropdown: ULBDropdown,
  EnagementDocName: DocumentName,
  EngagementDocCategory: SelectCategory,
  EngagementDocDescription: SelectULB$1,
  EngagementDocUploadDocument,
  NotificationsAndWhatsNew,
  EventsListOnGround,
  EventDetails: EventDetails$1,
  EventForm,
  MessageForm,
  DocumentList,
  SelectEventGeolocation: SelectGeolocation,
  SelectToDate,
  SurveyList,
  FillSurvey,
  CitizenSurveyForm,
  ShowSurvey,
  SurveyResults
};
const initEngagementComponents = () => {
  Object.entries(componentsToRegister).forEach(([key, value]) => {
    Digit.ComponentRegistryService.setComponent(key, value);
  });
};

export { initEngagementComponents };
//# sourceMappingURL=index.modern.js.map
